/* tslint:disable */
/* eslint-disable */
// @generated
// * ! This file was automatically generated and should not be edited manually.
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Json: any;
};

export type AcceptAllSuggestions = {
  __typename?: 'AcceptAllSuggestions';
  message?: Maybe<Scalars['String']>;
  suggestions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Activity = {
  __typename?: 'Activity';
  _count: ActivityCountOutputType;
  createdAt: Scalars['DateTime'];
  fields: Array<Maybe<ActivityFields>>;
  id: Scalars['String'];
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  subActivities: Array<Maybe<SubActivityFields>>;
  updatedAt: Scalars['DateTime'];
};


export type ActivityFieldsArgs = {
  cursor?: InputMaybe<ActivityFieldsWhereUniqueInput>;
  distinct?: InputMaybe<ActivityFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<ActivityFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ActivityFieldsWhereInput>;
};


export type ActivitySubActivitiesArgs = {
  cursor?: InputMaybe<SubActivityFieldsWhereUniqueInput>;
  distinct?: InputMaybe<SubActivityFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<SubActivityFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SubActivityFieldsWhereInput>;
};

export type ActivityCountAggregateOutputType = {
  __typename?: 'ActivityCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  pending: Scalars['Int'];
  published: Scalars['Int'];
  reference: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ActivityCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ActivityCountOutputType = {
  __typename?: 'ActivityCountOutputType';
  fields: Scalars['Int'];
  subActivities: Scalars['Int'];
};

export type ActivityCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<ActivityFieldsCreateNestedManyWithoutActivityInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  subActivities?: InputMaybe<SubActivityFieldsCreateNestedManyWithoutActivitiesInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ActivityCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ActivityCreateNestedManyWithoutSubActivitiesInput = {
  connect?: InputMaybe<Array<ActivityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActivityCreateOrConnectWithoutSubActivitiesInput>>;
  create?: InputMaybe<Array<ActivityCreateWithoutSubActivitiesInput>>;
};

export type ActivityCreateNestedOneWithoutFieldsInput = {
  connect?: InputMaybe<ActivityWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ActivityCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<ActivityUncheckedCreateWithoutFieldsInput>;
};

export type ActivityCreateOrConnectWithoutFieldsInput = {
  create: ActivityUncheckedCreateWithoutFieldsInput;
  where: ActivityWhereUniqueInput;
};

export type ActivityCreateOrConnectWithoutSubActivitiesInput = {
  create: ActivityUncheckedCreateWithoutSubActivitiesInput;
  where: ActivityWhereUniqueInput;
};

export type ActivityCreateWithoutFieldsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  subActivities?: InputMaybe<SubActivityFieldsCreateNestedManyWithoutActivitiesInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ActivityCreateWithoutSubActivitiesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<ActivityFieldsCreateNestedManyWithoutActivityInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ActivityFields = {
  __typename?: 'ActivityFields';
  _count: ActivityFieldsCountOutputType;
  activity?: Maybe<Activity>;
  activityId?: Maybe<Scalars['String']>;
  cmsId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  locations: Array<Maybe<Location>>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  subProducts: Array<Maybe<SubProduct>>;
  updatedAt: Scalars['DateTime'];
};


export type ActivityFieldsLocationsArgs = {
  cursor?: InputMaybe<LocationWhereUniqueInput>;
  distinct?: InputMaybe<LocationScalarFieldEnum>;
  orderBy?: InputMaybe<LocationOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationWhereInput>;
};


export type ActivityFieldsSubProductsArgs = {
  cursor?: InputMaybe<SubProductWhereUniqueInput>;
  distinct?: InputMaybe<SubProductScalarFieldEnum>;
  orderBy?: InputMaybe<SubProductOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SubProductWhereInput>;
};

export type ActivityFieldsAvgAggregateOutputType = {
  __typename?: 'ActivityFieldsAvgAggregateOutputType';
  order?: Maybe<Scalars['Float']>;
};

export type ActivityFieldsAvgOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type ActivityFieldsCountAggregateOutputType = {
  __typename?: 'ActivityFieldsCountAggregateOutputType';
  _all: Scalars['Int'];
  activityId: Scalars['Int'];
  cmsId: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  order: Scalars['Int'];
  pending: Scalars['Int'];
  published: Scalars['Int'];
  stack: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ActivityFieldsCountOrderByAggregateInput = {
  activityId?: InputMaybe<SortOrder>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ActivityFieldsCountOutputType = {
  __typename?: 'ActivityFieldsCountOutputType';
  locations: Scalars['Int'];
  subProducts: Scalars['Int'];
};

export type ActivityFieldsCreateInput = {
  activity?: InputMaybe<ActivityCreateNestedOneWithoutFieldsInput>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutActivitiesInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  subProducts?: InputMaybe<SubProductCreateNestedManyWithoutActivitiesInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ActivityFieldsCreateManyActivityInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ActivityFieldsCreateManyActivityInputEnvelope = {
  data: Array<ActivityFieldsCreateManyActivityInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ActivityFieldsCreateManyInput = {
  activityId?: InputMaybe<Scalars['String']>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ActivityFieldsCreateNestedManyWithoutActivityInput = {
  connect?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActivityFieldsCreateOrConnectWithoutActivityInput>>;
  create?: InputMaybe<Array<ActivityFieldsCreateWithoutActivityInput>>;
  createMany?: InputMaybe<ActivityFieldsCreateManyActivityInputEnvelope>;
};

export type ActivityFieldsCreateNestedManyWithoutLocationsInput = {
  connect?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActivityFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<ActivityFieldsCreateWithoutLocationsInput>>;
};

export type ActivityFieldsCreateNestedManyWithoutSubProductsInput = {
  connect?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActivityFieldsCreateOrConnectWithoutSubProductsInput>>;
  create?: InputMaybe<Array<ActivityFieldsCreateWithoutSubProductsInput>>;
};

export type ActivityFieldsCreateOrConnectWithoutActivityInput = {
  create: ActivityFieldsUncheckedCreateWithoutActivityInput;
  where: ActivityFieldsWhereUniqueInput;
};

export type ActivityFieldsCreateOrConnectWithoutLocationsInput = {
  create: ActivityFieldsUncheckedCreateWithoutLocationsInput;
  where: ActivityFieldsWhereUniqueInput;
};

export type ActivityFieldsCreateOrConnectWithoutSubProductsInput = {
  create: ActivityFieldsUncheckedCreateWithoutSubProductsInput;
  where: ActivityFieldsWhereUniqueInput;
};

export type ActivityFieldsCreateWithoutActivityInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutActivitiesInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  subProducts?: InputMaybe<SubProductCreateNestedManyWithoutActivitiesInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ActivityFieldsCreateWithoutLocationsInput = {
  activity?: InputMaybe<ActivityCreateNestedOneWithoutFieldsInput>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  subProducts?: InputMaybe<SubProductCreateNestedManyWithoutActivitiesInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ActivityFieldsCreateWithoutSubProductsInput = {
  activity?: InputMaybe<ActivityCreateNestedOneWithoutFieldsInput>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutActivitiesInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ActivityFieldsListRelationFilter = {
  every?: InputMaybe<ActivityFieldsWhereInput>;
  none?: InputMaybe<ActivityFieldsWhereInput>;
  some?: InputMaybe<ActivityFieldsWhereInput>;
};

export type ActivityFieldsMaxAggregateOutputType = {
  __typename?: 'ActivityFieldsMaxAggregateOutputType';
  activityId?: Maybe<Scalars['String']>;
  cmsId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  stack?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActivityFieldsMaxOrderByAggregateInput = {
  activityId?: InputMaybe<SortOrder>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ActivityFieldsMinAggregateOutputType = {
  __typename?: 'ActivityFieldsMinAggregateOutputType';
  activityId?: Maybe<Scalars['String']>;
  cmsId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  stack?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActivityFieldsMinOrderByAggregateInput = {
  activityId?: InputMaybe<SortOrder>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ActivityFieldsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ActivityFieldsOrderByWithAggregationInput = {
  _avg?: InputMaybe<ActivityFieldsAvgOrderByAggregateInput>;
  _count?: InputMaybe<ActivityFieldsCountOrderByAggregateInput>;
  _max?: InputMaybe<ActivityFieldsMaxOrderByAggregateInput>;
  _min?: InputMaybe<ActivityFieldsMinOrderByAggregateInput>;
  _sum?: InputMaybe<ActivityFieldsSumOrderByAggregateInput>;
  activityId?: InputMaybe<SortOrderInput>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrderInput>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ActivityFieldsOrderByWithRelationInput = {
  activity?: InputMaybe<ActivityOrderByWithRelationInput>;
  activityId?: InputMaybe<SortOrderInput>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  locations?: InputMaybe<LocationOrderByRelationAggregateInput>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrderInput>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  stack?: InputMaybe<SortOrder>;
  subProducts?: InputMaybe<SubProductOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ActivityFieldsScalarFieldEnum {
  ActivityId = 'activityId',
  CmsId = 'cmsId',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Name = 'name',
  Order = 'order',
  Pending = 'pending',
  Published = 'published',
  Stack = 'stack',
  UpdatedAt = 'updatedAt'
}

export type ActivityFieldsScalarWhereInput = {
  AND?: InputMaybe<Array<ActivityFieldsScalarWhereInput>>;
  NOT?: InputMaybe<Array<ActivityFieldsScalarWhereInput>>;
  OR?: InputMaybe<Array<ActivityFieldsScalarWhereInput>>;
  activityId?: InputMaybe<StringNullableFilter>;
  cmsId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  stack?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ActivityFieldsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ActivityFieldsScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ActivityFieldsScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ActivityFieldsScalarWhereWithAggregatesInput>>;
  activityId?: InputMaybe<StringNullableWithAggregatesFilter>;
  cmsId?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  order?: InputMaybe<IntNullableWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  stack?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ActivityFieldsSumAggregateOutputType = {
  __typename?: 'ActivityFieldsSumAggregateOutputType';
  order?: Maybe<Scalars['Int']>;
};

export type ActivityFieldsSumOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type ActivityFieldsUncheckedCreateInput = {
  activityId?: InputMaybe<Scalars['String']>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationUncheckedCreateNestedManyWithoutActivitiesInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  subProducts?: InputMaybe<SubProductUncheckedCreateNestedManyWithoutActivitiesInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ActivityFieldsUncheckedCreateNestedManyWithoutActivityInput = {
  connect?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActivityFieldsCreateOrConnectWithoutActivityInput>>;
  create?: InputMaybe<Array<ActivityFieldsCreateWithoutActivityInput>>;
  createMany?: InputMaybe<ActivityFieldsCreateManyActivityInputEnvelope>;
};

export type ActivityFieldsUncheckedCreateNestedManyWithoutLocationsInput = {
  connect?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActivityFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<ActivityFieldsCreateWithoutLocationsInput>>;
};

export type ActivityFieldsUncheckedCreateNestedManyWithoutSubProductsInput = {
  connect?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActivityFieldsCreateOrConnectWithoutSubProductsInput>>;
  create?: InputMaybe<Array<ActivityFieldsCreateWithoutSubProductsInput>>;
};

export type ActivityFieldsUncheckedCreateWithoutActivityInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationUncheckedCreateNestedManyWithoutActivitiesInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  subProducts?: InputMaybe<SubProductUncheckedCreateNestedManyWithoutActivitiesInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ActivityFieldsUncheckedCreateWithoutLocationsInput = {
  activityId?: InputMaybe<Scalars['String']>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  subProducts?: InputMaybe<SubProductUncheckedCreateNestedManyWithoutActivitiesInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ActivityFieldsUncheckedCreateWithoutSubProductsInput = {
  activityId?: InputMaybe<Scalars['String']>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationUncheckedCreateNestedManyWithoutActivitiesInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ActivityFieldsUncheckedUpdateInput = {
  activityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUncheckedUpdateManyWithoutActivitiesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  subProducts?: InputMaybe<SubProductUncheckedUpdateManyWithoutActivitiesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ActivityFieldsUncheckedUpdateManyInput = {
  activityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ActivityFieldsUncheckedUpdateManyWithoutActivitiesInput = {
  activityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ActivityFieldsUncheckedUpdateManyWithoutActivityNestedInput = {
  connect?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActivityFieldsCreateOrConnectWithoutActivityInput>>;
  create?: InputMaybe<Array<ActivityFieldsCreateWithoutActivityInput>>;
  createMany?: InputMaybe<ActivityFieldsCreateManyActivityInputEnvelope>;
  delete?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ActivityFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<ActivityFieldsUpdateWithWhereUniqueWithoutActivityInput>>;
  updateMany?: InputMaybe<Array<ActivityFieldsUpdateManyWithWhereWithoutActivityInput>>;
  upsert?: InputMaybe<Array<ActivityFieldsUpsertWithWhereUniqueWithoutActivityInput>>;
};

export type ActivityFieldsUncheckedUpdateManyWithoutFieldsInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ActivityFieldsUncheckedUpdateManyWithoutLocationsNestedInput = {
  connect?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActivityFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<ActivityFieldsCreateWithoutLocationsInput>>;
  delete?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ActivityFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<ActivityFieldsUpdateWithWhereUniqueWithoutLocationsInput>>;
  updateMany?: InputMaybe<Array<ActivityFieldsUpdateManyWithWhereWithoutLocationsInput>>;
  upsert?: InputMaybe<Array<ActivityFieldsUpsertWithWhereUniqueWithoutLocationsInput>>;
};

export type ActivityFieldsUncheckedUpdateManyWithoutSubProductsNestedInput = {
  connect?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActivityFieldsCreateOrConnectWithoutSubProductsInput>>;
  create?: InputMaybe<Array<ActivityFieldsCreateWithoutSubProductsInput>>;
  delete?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ActivityFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<ActivityFieldsUpdateWithWhereUniqueWithoutSubProductsInput>>;
  updateMany?: InputMaybe<Array<ActivityFieldsUpdateManyWithWhereWithoutSubProductsInput>>;
  upsert?: InputMaybe<Array<ActivityFieldsUpsertWithWhereUniqueWithoutSubProductsInput>>;
};

export type ActivityFieldsUncheckedUpdateWithoutActivityInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUncheckedUpdateManyWithoutActivitiesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  subProducts?: InputMaybe<SubProductUncheckedUpdateManyWithoutActivitiesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ActivityFieldsUncheckedUpdateWithoutLocationsInput = {
  activityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  subProducts?: InputMaybe<SubProductUncheckedUpdateManyWithoutActivitiesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ActivityFieldsUncheckedUpdateWithoutSubProductsInput = {
  activityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUncheckedUpdateManyWithoutActivitiesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ActivityFieldsUpdateInput = {
  activity?: InputMaybe<ActivityUpdateOneWithoutFieldsNestedInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutActivitiesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  subProducts?: InputMaybe<SubProductUpdateManyWithoutActivitiesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ActivityFieldsUpdateManyMutationInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ActivityFieldsUpdateManyWithWhereWithoutActivityInput = {
  data: ActivityFieldsUncheckedUpdateManyWithoutFieldsInput;
  where: ActivityFieldsScalarWhereInput;
};

export type ActivityFieldsUpdateManyWithWhereWithoutLocationsInput = {
  data: ActivityFieldsUncheckedUpdateManyWithoutActivitiesInput;
  where: ActivityFieldsScalarWhereInput;
};

export type ActivityFieldsUpdateManyWithWhereWithoutSubProductsInput = {
  data: ActivityFieldsUncheckedUpdateManyWithoutActivitiesInput;
  where: ActivityFieldsScalarWhereInput;
};

export type ActivityFieldsUpdateManyWithoutActivityNestedInput = {
  connect?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActivityFieldsCreateOrConnectWithoutActivityInput>>;
  create?: InputMaybe<Array<ActivityFieldsCreateWithoutActivityInput>>;
  createMany?: InputMaybe<ActivityFieldsCreateManyActivityInputEnvelope>;
  delete?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ActivityFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<ActivityFieldsUpdateWithWhereUniqueWithoutActivityInput>>;
  updateMany?: InputMaybe<Array<ActivityFieldsUpdateManyWithWhereWithoutActivityInput>>;
  upsert?: InputMaybe<Array<ActivityFieldsUpsertWithWhereUniqueWithoutActivityInput>>;
};

export type ActivityFieldsUpdateManyWithoutLocationsNestedInput = {
  connect?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActivityFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<ActivityFieldsCreateWithoutLocationsInput>>;
  delete?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ActivityFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<ActivityFieldsUpdateWithWhereUniqueWithoutLocationsInput>>;
  updateMany?: InputMaybe<Array<ActivityFieldsUpdateManyWithWhereWithoutLocationsInput>>;
  upsert?: InputMaybe<Array<ActivityFieldsUpsertWithWhereUniqueWithoutLocationsInput>>;
};

export type ActivityFieldsUpdateManyWithoutSubProductsNestedInput = {
  connect?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActivityFieldsCreateOrConnectWithoutSubProductsInput>>;
  create?: InputMaybe<Array<ActivityFieldsCreateWithoutSubProductsInput>>;
  delete?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ActivityFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<ActivityFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<ActivityFieldsUpdateWithWhereUniqueWithoutSubProductsInput>>;
  updateMany?: InputMaybe<Array<ActivityFieldsUpdateManyWithWhereWithoutSubProductsInput>>;
  upsert?: InputMaybe<Array<ActivityFieldsUpsertWithWhereUniqueWithoutSubProductsInput>>;
};

export type ActivityFieldsUpdateWithWhereUniqueWithoutActivityInput = {
  data: ActivityFieldsUncheckedUpdateWithoutActivityInput;
  where: ActivityFieldsWhereUniqueInput;
};

export type ActivityFieldsUpdateWithWhereUniqueWithoutLocationsInput = {
  data: ActivityFieldsUncheckedUpdateWithoutLocationsInput;
  where: ActivityFieldsWhereUniqueInput;
};

export type ActivityFieldsUpdateWithWhereUniqueWithoutSubProductsInput = {
  data: ActivityFieldsUncheckedUpdateWithoutSubProductsInput;
  where: ActivityFieldsWhereUniqueInput;
};

export type ActivityFieldsUpdateWithoutActivityInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutActivitiesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  subProducts?: InputMaybe<SubProductUpdateManyWithoutActivitiesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ActivityFieldsUpdateWithoutLocationsInput = {
  activity?: InputMaybe<ActivityUpdateOneWithoutFieldsNestedInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  subProducts?: InputMaybe<SubProductUpdateManyWithoutActivitiesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ActivityFieldsUpdateWithoutSubProductsInput = {
  activity?: InputMaybe<ActivityUpdateOneWithoutFieldsNestedInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutActivitiesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ActivityFieldsUpsertWithWhereUniqueWithoutActivityInput = {
  create: ActivityFieldsUncheckedCreateWithoutActivityInput;
  update: ActivityFieldsUncheckedUpdateWithoutActivityInput;
  where: ActivityFieldsWhereUniqueInput;
};

export type ActivityFieldsUpsertWithWhereUniqueWithoutLocationsInput = {
  create: ActivityFieldsUncheckedCreateWithoutLocationsInput;
  update: ActivityFieldsUncheckedUpdateWithoutLocationsInput;
  where: ActivityFieldsWhereUniqueInput;
};

export type ActivityFieldsUpsertWithWhereUniqueWithoutSubProductsInput = {
  create: ActivityFieldsUncheckedCreateWithoutSubProductsInput;
  update: ActivityFieldsUncheckedUpdateWithoutSubProductsInput;
  where: ActivityFieldsWhereUniqueInput;
};

export type ActivityFieldsWhereInput = {
  AND?: InputMaybe<Array<ActivityFieldsWhereInput>>;
  NOT?: InputMaybe<Array<ActivityFieldsWhereInput>>;
  OR?: InputMaybe<Array<ActivityFieldsWhereInput>>;
  activity?: InputMaybe<ActivityWhereInput>;
  activityId?: InputMaybe<StringNullableFilter>;
  cmsId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  locations?: InputMaybe<LocationListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  stack?: InputMaybe<StringFilter>;
  subProducts?: InputMaybe<SubProductListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ActivityFieldsWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ActivityListRelationFilter = {
  every?: InputMaybe<ActivityWhereInput>;
  none?: InputMaybe<ActivityWhereInput>;
  some?: InputMaybe<ActivityWhereInput>;
};

export type ActivityMaxAggregateOutputType = {
  __typename?: 'ActivityMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActivityMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ActivityMinAggregateOutputType = {
  __typename?: 'ActivityMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActivityMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ActivityOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ActivityOrderByWithAggregationInput = {
  _count?: InputMaybe<ActivityCountOrderByAggregateInput>;
  _max?: InputMaybe<ActivityMaxOrderByAggregateInput>;
  _min?: InputMaybe<ActivityMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ActivityOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  fields?: InputMaybe<ActivityFieldsOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrder>;
  subActivities?: InputMaybe<SubActivityFieldsOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ActivityRelationFilter = {
  is?: InputMaybe<ActivityWhereInput>;
  isNot?: InputMaybe<ActivityWhereInput>;
};

export enum ActivityScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Pending = 'pending',
  Published = 'published',
  Reference = 'reference',
  UpdatedAt = 'updatedAt'
}

export type ActivityScalarWhereInput = {
  AND?: InputMaybe<Array<ActivityScalarWhereInput>>;
  NOT?: InputMaybe<Array<ActivityScalarWhereInput>>;
  OR?: InputMaybe<Array<ActivityScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  reference?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ActivityScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ActivityScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ActivityScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ActivityScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  reference?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ActivityUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<ActivityFieldsUncheckedCreateNestedManyWithoutActivityInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  subActivities?: InputMaybe<SubActivityFieldsUncheckedCreateNestedManyWithoutActivitiesInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ActivityUncheckedCreateNestedManyWithoutSubActivitiesInput = {
  connect?: InputMaybe<Array<ActivityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActivityCreateOrConnectWithoutSubActivitiesInput>>;
  create?: InputMaybe<Array<ActivityCreateWithoutSubActivitiesInput>>;
};

export type ActivityUncheckedCreateWithoutFieldsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  subActivities?: InputMaybe<SubActivityFieldsUncheckedCreateNestedManyWithoutActivitiesInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ActivityUncheckedCreateWithoutSubActivitiesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<ActivityFieldsUncheckedCreateNestedManyWithoutActivityInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ActivityUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<ActivityFieldsUncheckedUpdateManyWithoutActivityNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  subActivities?: InputMaybe<SubActivityFieldsUncheckedUpdateManyWithoutActivitiesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ActivityUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ActivityUncheckedUpdateManyWithoutActivitiesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ActivityUncheckedUpdateManyWithoutSubActivitiesNestedInput = {
  connect?: InputMaybe<Array<ActivityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActivityCreateOrConnectWithoutSubActivitiesInput>>;
  create?: InputMaybe<Array<ActivityCreateWithoutSubActivitiesInput>>;
  delete?: InputMaybe<Array<ActivityWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ActivityScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ActivityWhereUniqueInput>>;
  set?: InputMaybe<Array<ActivityWhereUniqueInput>>;
  update?: InputMaybe<Array<ActivityUpdateWithWhereUniqueWithoutSubActivitiesInput>>;
  updateMany?: InputMaybe<Array<ActivityUpdateManyWithWhereWithoutSubActivitiesInput>>;
  upsert?: InputMaybe<Array<ActivityUpsertWithWhereUniqueWithoutSubActivitiesInput>>;
};

export type ActivityUncheckedUpdateWithoutFieldsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  subActivities?: InputMaybe<SubActivityFieldsUncheckedUpdateManyWithoutActivitiesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ActivityUncheckedUpdateWithoutSubActivitiesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<ActivityFieldsUncheckedUpdateManyWithoutActivityNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ActivityUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<ActivityFieldsUpdateManyWithoutActivityNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  subActivities?: InputMaybe<SubActivityFieldsUpdateManyWithoutActivitiesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ActivityUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ActivityUpdateManyWithWhereWithoutSubActivitiesInput = {
  data: ActivityUncheckedUpdateManyWithoutActivitiesInput;
  where: ActivityScalarWhereInput;
};

export type ActivityUpdateManyWithoutSubActivitiesNestedInput = {
  connect?: InputMaybe<Array<ActivityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActivityCreateOrConnectWithoutSubActivitiesInput>>;
  create?: InputMaybe<Array<ActivityCreateWithoutSubActivitiesInput>>;
  delete?: InputMaybe<Array<ActivityWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ActivityScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ActivityWhereUniqueInput>>;
  set?: InputMaybe<Array<ActivityWhereUniqueInput>>;
  update?: InputMaybe<Array<ActivityUpdateWithWhereUniqueWithoutSubActivitiesInput>>;
  updateMany?: InputMaybe<Array<ActivityUpdateManyWithWhereWithoutSubActivitiesInput>>;
  upsert?: InputMaybe<Array<ActivityUpsertWithWhereUniqueWithoutSubActivitiesInput>>;
};

export type ActivityUpdateOneWithoutFieldsNestedInput = {
  connect?: InputMaybe<ActivityWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ActivityCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<ActivityUncheckedCreateWithoutFieldsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ActivityUncheckedUpdateWithoutFieldsInput>;
  upsert?: InputMaybe<ActivityUpsertWithoutFieldsInput>;
};

export type ActivityUpdateWithWhereUniqueWithoutSubActivitiesInput = {
  data: ActivityUncheckedUpdateWithoutSubActivitiesInput;
  where: ActivityWhereUniqueInput;
};

export type ActivityUpdateWithoutFieldsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  subActivities?: InputMaybe<SubActivityFieldsUpdateManyWithoutActivitiesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ActivityUpdateWithoutSubActivitiesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<ActivityFieldsUpdateManyWithoutActivityNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ActivityUpsertWithWhereUniqueWithoutSubActivitiesInput = {
  create: ActivityUncheckedCreateWithoutSubActivitiesInput;
  update: ActivityUncheckedUpdateWithoutSubActivitiesInput;
  where: ActivityWhereUniqueInput;
};

export type ActivityUpsertWithoutFieldsInput = {
  create: ActivityUncheckedCreateWithoutFieldsInput;
  update: ActivityUncheckedUpdateWithoutFieldsInput;
};

export type ActivityWhereInput = {
  AND?: InputMaybe<Array<ActivityWhereInput>>;
  NOT?: InputMaybe<Array<ActivityWhereInput>>;
  OR?: InputMaybe<Array<ActivityWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fields?: InputMaybe<ActivityFieldsListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  reference?: InputMaybe<StringFilter>;
  subActivities?: InputMaybe<SubActivityFieldsListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ActivityWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type AggregateActivity = {
  __typename?: 'AggregateActivity';
  _count?: Maybe<ActivityCountAggregateOutputType>;
  _max?: Maybe<ActivityMaxAggregateOutputType>;
  _min?: Maybe<ActivityMinAggregateOutputType>;
};

export type AggregateActivityFields = {
  __typename?: 'AggregateActivityFields';
  _avg?: Maybe<ActivityFieldsAvgAggregateOutputType>;
  _count?: Maybe<ActivityFieldsCountAggregateOutputType>;
  _max?: Maybe<ActivityFieldsMaxAggregateOutputType>;
  _min?: Maybe<ActivityFieldsMinAggregateOutputType>;
  _sum?: Maybe<ActivityFieldsSumAggregateOutputType>;
};

export type AggregateAudit = {
  __typename?: 'AggregateAudit';
  _count?: Maybe<AuditCountAggregateOutputType>;
  _max?: Maybe<AuditMaxAggregateOutputType>;
  _min?: Maybe<AuditMinAggregateOutputType>;
  count: Scalars['Int'];
};

export type AggregateAuditUser = {
  __typename?: 'AggregateAuditUser';
  count: Scalars['Int'];
};

export type AggregateBusinessUnit = {
  __typename?: 'AggregateBusinessUnit';
  _count?: Maybe<BusinessUnitCountAggregateOutputType>;
  _max?: Maybe<BusinessUnitMaxAggregateOutputType>;
  _min?: Maybe<BusinessUnitMinAggregateOutputType>;
};

export type AggregateBusinessUnitFields = {
  __typename?: 'AggregateBusinessUnitFields';
  _avg?: Maybe<BusinessUnitFieldsAvgAggregateOutputType>;
  _count?: Maybe<BusinessUnitFieldsCountAggregateOutputType>;
  _max?: Maybe<BusinessUnitFieldsMaxAggregateOutputType>;
  _min?: Maybe<BusinessUnitFieldsMinAggregateOutputType>;
  _sum?: Maybe<BusinessUnitFieldsSumAggregateOutputType>;
};

export type AggregateCategory = {
  __typename?: 'AggregateCategory';
  _count?: Maybe<CategoryCountAggregateOutputType>;
  _max?: Maybe<CategoryMaxAggregateOutputType>;
  _min?: Maybe<CategoryMinAggregateOutputType>;
};

export type AggregateCategoryFields = {
  __typename?: 'AggregateCategoryFields';
  _avg?: Maybe<CategoryFieldsAvgAggregateOutputType>;
  _count?: Maybe<CategoryFieldsCountAggregateOutputType>;
  _max?: Maybe<CategoryFieldsMaxAggregateOutputType>;
  _min?: Maybe<CategoryFieldsMinAggregateOutputType>;
  _sum?: Maybe<CategoryFieldsSumAggregateOutputType>;
};

export type AggregateClientType = {
  __typename?: 'AggregateClientType';
  _count?: Maybe<ClientTypeCountAggregateOutputType>;
  _max?: Maybe<ClientTypeMaxAggregateOutputType>;
  _min?: Maybe<ClientTypeMinAggregateOutputType>;
};

export type AggregateClientTypeFields = {
  __typename?: 'AggregateClientTypeFields';
  _avg?: Maybe<ClientTypeFieldsAvgAggregateOutputType>;
  _count?: Maybe<ClientTypeFieldsCountAggregateOutputType>;
  _max?: Maybe<ClientTypeFieldsMaxAggregateOutputType>;
  _min?: Maybe<ClientTypeFieldsMinAggregateOutputType>;
  _sum?: Maybe<ClientTypeFieldsSumAggregateOutputType>;
};

export type AggregateCycle = {
  __typename?: 'AggregateCycle';
  _count?: Maybe<CycleCountAggregateOutputType>;
  _max?: Maybe<CycleMaxAggregateOutputType>;
  _min?: Maybe<CycleMinAggregateOutputType>;
  count: Scalars['Int'];
};

export type AggregateDataImport = {
  __typename?: 'AggregateDataImport';
  _count?: Maybe<DataImportCountAggregateOutputType>;
  _max?: Maybe<DataImportMaxAggregateOutputType>;
  _min?: Maybe<DataImportMinAggregateOutputType>;
  count: Scalars['Int'];
};

export type AggregateDataImportFile = {
  __typename?: 'AggregateDataImportFile';
  _count?: Maybe<DataImportFileCountAggregateOutputType>;
  _max?: Maybe<DataImportFileMaxAggregateOutputType>;
  _min?: Maybe<DataImportFileMinAggregateOutputType>;
  count: Scalars['Int'];
};

export type AggregateDataImportMasterFileLocation = {
  __typename?: 'AggregateDataImportMasterFileLocation';
  count: Scalars['Int'];
};

export type AggregateDataImportOwner = {
  __typename?: 'AggregateDataImportOwner';
  count: Scalars['Int'];
};

export type AggregateDataImportProgressSummary = {
  __typename?: 'AggregateDataImportProgressSummary';
  _count?: Maybe<DataImportProgressSummaryCountAggregateOutputType>;
  _max?: Maybe<DataImportProgressSummaryMaxAggregateOutputType>;
  _min?: Maybe<DataImportProgressSummaryMinAggregateOutputType>;
};

export type AggregateDataImportValidation = {
  __typename?: 'AggregateDataImportValidation';
  _count?: Maybe<DataImportValidationCountAggregateOutputType>;
  _max?: Maybe<DataImportValidationMaxAggregateOutputType>;
  _min?: Maybe<DataImportValidationMinAggregateOutputType>;
};

export type AggregateDataImportValidationAudit = {
  __typename?: 'AggregateDataImportValidationAudit';
  _avg?: Maybe<DataImportValidationAuditAvgAggregateOutputType>;
  _count?: Maybe<DataImportValidationAuditCountAggregateOutputType>;
  _max?: Maybe<DataImportValidationAuditMaxAggregateOutputType>;
  _min?: Maybe<DataImportValidationAuditMinAggregateOutputType>;
  _sum?: Maybe<DataImportValidationAuditSumAggregateOutputType>;
};

export type AggregateDefinition = {
  __typename?: 'AggregateDefinition';
  _count?: Maybe<DefinitionCountAggregateOutputType>;
  _max?: Maybe<DefinitionMaxAggregateOutputType>;
  _min?: Maybe<DefinitionMinAggregateOutputType>;
};

export type AggregateDefinitionFields = {
  __typename?: 'AggregateDefinitionFields';
  _count?: Maybe<DefinitionFieldsCountAggregateOutputType>;
  _max?: Maybe<DefinitionFieldsMaxAggregateOutputType>;
  _min?: Maybe<DefinitionFieldsMinAggregateOutputType>;
  count: Scalars['Int'];
};

export type AggregateDocument = {
  __typename?: 'AggregateDocument';
  _count?: Maybe<DocumentCountAggregateOutputType>;
  _max?: Maybe<DocumentMaxAggregateOutputType>;
  _min?: Maybe<DocumentMinAggregateOutputType>;
  count: Scalars['Int'];
};

export type AggregateDocumentCycle = {
  __typename?: 'AggregateDocumentCycle';
  _count?: Maybe<DocumentCycleCountAggregateOutputType>;
  _max?: Maybe<DocumentCycleMaxAggregateOutputType>;
  _min?: Maybe<DocumentCycleMinAggregateOutputType>;
  count: Scalars['Int'];
};

export type AggregateDocumentCycleOwner = {
  __typename?: 'AggregateDocumentCycleOwner';
  count: Scalars['Int'];
};

export type AggregateDocumentOwner = {
  __typename?: 'AggregateDocumentOwner';
  count: Scalars['Int'];
};

export type AggregateEntity = {
  __typename?: 'AggregateEntity';
  _count?: Maybe<EntityCountAggregateOutputType>;
  _max?: Maybe<EntityMaxAggregateOutputType>;
  _min?: Maybe<EntityMinAggregateOutputType>;
};

export type AggregateEntityFields = {
  __typename?: 'AggregateEntityFields';
  _avg?: Maybe<EntityFieldsAvgAggregateOutputType>;
  _count?: Maybe<EntityFieldsCountAggregateOutputType>;
  _max?: Maybe<EntityFieldsMaxAggregateOutputType>;
  _min?: Maybe<EntityFieldsMinAggregateOutputType>;
  _sum?: Maybe<EntityFieldsSumAggregateOutputType>;
};

export type AggregateLocation = {
  __typename?: 'AggregateLocation';
  _count?: Maybe<LocationCountAggregateOutputType>;
  _max?: Maybe<LocationMaxAggregateOutputType>;
  _min?: Maybe<LocationMinAggregateOutputType>;
  count: Scalars['Int'];
};

export type AggregateLocationFields = {
  __typename?: 'AggregateLocationFields';
  _avg?: Maybe<LocationFieldsAvgAggregateOutputType>;
  _count?: Maybe<LocationFieldsCountAggregateOutputType>;
  _max?: Maybe<LocationFieldsMaxAggregateOutputType>;
  _min?: Maybe<LocationFieldsMinAggregateOutputType>;
  _sum?: Maybe<LocationFieldsSumAggregateOutputType>;
  count: Scalars['Int'];
};

export type AggregateLocationFields_Permissions = {
  __typename?: 'AggregateLocationFields_permissions';
  _avg?: Maybe<LocationFields_PermissionsAvgAggregateOutputType>;
  _count?: Maybe<LocationFields_PermissionsCountAggregateOutputType>;
  _max?: Maybe<LocationFields_PermissionsMaxAggregateOutputType>;
  _min?: Maybe<LocationFields_PermissionsMinAggregateOutputType>;
  _sum?: Maybe<LocationFields_PermissionsSumAggregateOutputType>;
};

export type AggregateMethodForActivity = {
  __typename?: 'AggregateMethodForActivity';
  _count?: Maybe<MethodForActivityCountAggregateOutputType>;
  _max?: Maybe<MethodForActivityMaxAggregateOutputType>;
  _min?: Maybe<MethodForActivityMinAggregateOutputType>;
};

export type AggregateMethodForActivityFields = {
  __typename?: 'AggregateMethodForActivityFields';
  _avg?: Maybe<MethodForActivityFieldsAvgAggregateOutputType>;
  _count?: Maybe<MethodForActivityFieldsCountAggregateOutputType>;
  _max?: Maybe<MethodForActivityFieldsMaxAggregateOutputType>;
  _min?: Maybe<MethodForActivityFieldsMinAggregateOutputType>;
  _sum?: Maybe<MethodForActivityFieldsSumAggregateOutputType>;
};

export type AggregatePredefinedResponse = {
  __typename?: 'AggregatePredefinedResponse';
  _count?: Maybe<PredefinedResponseCountAggregateOutputType>;
  _max?: Maybe<PredefinedResponseMaxAggregateOutputType>;
  _min?: Maybe<PredefinedResponseMinAggregateOutputType>;
};

export type AggregatePredefinedResponseFields = {
  __typename?: 'AggregatePredefinedResponseFields';
  _count?: Maybe<PredefinedResponseFieldsCountAggregateOutputType>;
  _max?: Maybe<PredefinedResponseFieldsMaxAggregateOutputType>;
  _min?: Maybe<PredefinedResponseFieldsMinAggregateOutputType>;
};

export type AggregateProduct = {
  __typename?: 'AggregateProduct';
  _count?: Maybe<ProductCountAggregateOutputType>;
  _max?: Maybe<ProductMaxAggregateOutputType>;
  _min?: Maybe<ProductMinAggregateOutputType>;
};

export type AggregateProductFields = {
  __typename?: 'AggregateProductFields';
  _avg?: Maybe<ProductFieldsAvgAggregateOutputType>;
  _count?: Maybe<ProductFieldsCountAggregateOutputType>;
  _max?: Maybe<ProductFieldsMaxAggregateOutputType>;
  _min?: Maybe<ProductFieldsMinAggregateOutputType>;
  _sum?: Maybe<ProductFieldsSumAggregateOutputType>;
};

export type AggregateReverseEnquiry = {
  __typename?: 'AggregateReverseEnquiry';
  _count?: Maybe<ReverseEnquiryCountAggregateOutputType>;
  _max?: Maybe<ReverseEnquiryMaxAggregateOutputType>;
  _min?: Maybe<ReverseEnquiryMinAggregateOutputType>;
};

export type AggregateReverseEnquiryFields = {
  __typename?: 'AggregateReverseEnquiryFields';
  _avg?: Maybe<ReverseEnquiryFieldsAvgAggregateOutputType>;
  _count?: Maybe<ReverseEnquiryFieldsCountAggregateOutputType>;
  _max?: Maybe<ReverseEnquiryFieldsMaxAggregateOutputType>;
  _min?: Maybe<ReverseEnquiryFieldsMinAggregateOutputType>;
  _sum?: Maybe<ReverseEnquiryFieldsSumAggregateOutputType>;
};

export type AggregateReviewGuidance = {
  __typename?: 'AggregateReviewGuidance';
  _count?: Maybe<ReviewGuidanceCountAggregateOutputType>;
  _max?: Maybe<ReviewGuidanceMaxAggregateOutputType>;
  _min?: Maybe<ReviewGuidanceMinAggregateOutputType>;
};

export type AggregateReviewGuidanceFields = {
  __typename?: 'AggregateReviewGuidanceFields';
  _count?: Maybe<ReviewGuidanceFieldsCountAggregateOutputType>;
  _max?: Maybe<ReviewGuidanceFieldsMaxAggregateOutputType>;
  _min?: Maybe<ReviewGuidanceFieldsMinAggregateOutputType>;
};

export type AggregateStatus = {
  __typename?: 'AggregateStatus';
  _count?: Maybe<StatusCountAggregateOutputType>;
  _max?: Maybe<StatusMaxAggregateOutputType>;
  _min?: Maybe<StatusMinAggregateOutputType>;
};

export type AggregateStatusFields = {
  __typename?: 'AggregateStatusFields';
  _count?: Maybe<StatusFieldsCountAggregateOutputType>;
  _max?: Maybe<StatusFieldsMaxAggregateOutputType>;
  _min?: Maybe<StatusFieldsMinAggregateOutputType>;
  count: Scalars['Int'];
};

export type AggregateSubActivity = {
  __typename?: 'AggregateSubActivity';
  _count?: Maybe<SubActivityCountAggregateOutputType>;
  _max?: Maybe<SubActivityMaxAggregateOutputType>;
  _min?: Maybe<SubActivityMinAggregateOutputType>;
};

export type AggregateSubActivityFields = {
  __typename?: 'AggregateSubActivityFields';
  _avg?: Maybe<SubActivityFieldsAvgAggregateOutputType>;
  _count?: Maybe<SubActivityFieldsCountAggregateOutputType>;
  _max?: Maybe<SubActivityFieldsMaxAggregateOutputType>;
  _min?: Maybe<SubActivityFieldsMinAggregateOutputType>;
  _sum?: Maybe<SubActivityFieldsSumAggregateOutputType>;
};

export type AggregateSubProduct = {
  __typename?: 'AggregateSubProduct';
  _count?: Maybe<SubProductCountAggregateOutputType>;
  _max?: Maybe<SubProductMaxAggregateOutputType>;
  _min?: Maybe<SubProductMinAggregateOutputType>;
};

export type AggregateSubProductFields = {
  __typename?: 'AggregateSubProductFields';
  _avg?: Maybe<SubProductFieldsAvgAggregateOutputType>;
  _count?: Maybe<SubProductFieldsCountAggregateOutputType>;
  _max?: Maybe<SubProductFieldsMaxAggregateOutputType>;
  _min?: Maybe<SubProductFieldsMinAggregateOutputType>;
  _sum?: Maybe<SubProductFieldsSumAggregateOutputType>;
};

export type AggregateVersion = {
  __typename?: 'AggregateVersion';
  _count?: Maybe<VersionCountAggregateOutputType>;
  _max?: Maybe<VersionMaxAggregateOutputType>;
  _min?: Maybe<VersionMinAggregateOutputType>;
  count: Scalars['Int'];
};

export type Audit = {
  __typename?: 'Audit';
  action: AuditAction;
  archived?: Maybe<Scalars['Boolean']>;
  content?: Maybe<Scalars['Json']>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  type: AuditType;
  updatedAt: Scalars['DateTime'];
  version?: Maybe<Version>;
  versionId?: Maybe<Scalars['String']>;
};

export enum AuditAction {
  Accepted = 'ACCEPTED',
  Added = 'ADDED',
  Failed = 'FAILED',
  Open = 'OPEN',
  Rejected = 'REJECTED',
  Removed = 'REMOVED',
  Restored = 'RESTORED',
  Updated = 'UPDATED'
}

export type AuditConnection = {
  __typename?: 'AuditConnection';
  aggregate: AggregateAudit;
  edges: Array<Maybe<AuditEdge>>;
  pageInfo: PageInfo;
};

export type AuditCountAggregateOutputType = {
  __typename?: 'AuditCountAggregateOutputType';
  _all: Scalars['Int'];
  action: Scalars['Int'];
  archived: Scalars['Int'];
  content: Scalars['Int'];
  createdAt: Scalars['Int'];
  createdBy: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
  versionId: Scalars['Int'];
};

export type AuditCountOrderByAggregateInput = {
  action?: InputMaybe<SortOrder>;
  archived?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  versionId?: InputMaybe<SortOrder>;
};

export type AuditCreateInput = {
  action: AuditAction;
  archived?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  type: AuditType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  version?: InputMaybe<VersionCreateNestedOneWithoutAuditsInput>;
};

export type AuditCreateManyInput = {
  action: AuditAction;
  archived?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  type: AuditType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versionId?: InputMaybe<Scalars['String']>;
};

export type AuditCreateManyVersionInput = {
  action: AuditAction;
  archived?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  type: AuditType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AuditCreateManyVersionInputEnvelope = {
  data: Array<AuditCreateManyVersionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AuditCreateNestedManyWithoutVersionInput = {
  connect?: InputMaybe<Array<AuditWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AuditCreateOrConnectWithoutVersionInput>>;
  create?: InputMaybe<Array<AuditCreateWithoutVersionInput>>;
  createMany?: InputMaybe<AuditCreateManyVersionInputEnvelope>;
};

export type AuditCreateOrConnectWithoutVersionInput = {
  create: AuditUncheckedCreateWithoutVersionInput;
  where: AuditWhereUniqueInput;
};

export type AuditCreateWithoutVersionInput = {
  action: AuditAction;
  archived?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  type: AuditType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AuditEdge = {
  __typename?: 'AuditEdge';
  cursor: Scalars['String'];
  node: Audit;
};

export type AuditFilteredByContentWhere = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type AuditListRelationFilter = {
  every?: InputMaybe<AuditWhereInput>;
  none?: InputMaybe<AuditWhereInput>;
  some?: InputMaybe<AuditWhereInput>;
};

export type AuditMaxAggregateOutputType = {
  __typename?: 'AuditMaxAggregateOutputType';
  action?: Maybe<AuditAction>;
  archived?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<AuditType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['String']>;
};

export type AuditMaxOrderByAggregateInput = {
  action?: InputMaybe<SortOrder>;
  archived?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  versionId?: InputMaybe<SortOrder>;
};

export type AuditMinAggregateOutputType = {
  __typename?: 'AuditMinAggregateOutputType';
  action?: Maybe<AuditAction>;
  archived?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<AuditType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['String']>;
};

export type AuditMinOrderByAggregateInput = {
  action?: InputMaybe<SortOrder>;
  archived?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  versionId?: InputMaybe<SortOrder>;
};

export type AuditOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AuditOrderByWithAggregationInput = {
  _count?: InputMaybe<AuditCountOrderByAggregateInput>;
  _max?: InputMaybe<AuditMaxOrderByAggregateInput>;
  _min?: InputMaybe<AuditMinOrderByAggregateInput>;
  action?: InputMaybe<SortOrder>;
  archived?: InputMaybe<SortOrderInput>;
  content?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  versionId?: InputMaybe<SortOrderInput>;
};

export type AuditOrderByWithRelationInput = {
  action?: InputMaybe<SortOrder>;
  archived?: InputMaybe<SortOrderInput>;
  content?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  version?: InputMaybe<VersionOrderByWithRelationInput>;
  versionId?: InputMaybe<SortOrderInput>;
};

export enum AuditScalarFieldEnum {
  Action = 'action',
  Archived = 'archived',
  Content = 'content',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  Id = 'id',
  Name = 'name',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  VersionId = 'versionId'
}

export type AuditScalarWhereInput = {
  AND?: InputMaybe<Array<AuditScalarWhereInput>>;
  NOT?: InputMaybe<Array<AuditScalarWhereInput>>;
  OR?: InputMaybe<Array<AuditScalarWhereInput>>;
  action?: InputMaybe<EnumAuditActionFilter>;
  archived?: InputMaybe<BoolNullableFilter>;
  content?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumAuditTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  versionId?: InputMaybe<StringNullableFilter>;
};

export type AuditScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<AuditScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<AuditScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<AuditScalarWhereWithAggregatesInput>>;
  action?: InputMaybe<EnumAuditActionWithAggregatesFilter>;
  archived?: InputMaybe<BoolNullableWithAggregatesFilter>;
  content?: InputMaybe<JsonNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  createdBy?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  type?: InputMaybe<EnumAuditTypeWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  versionId?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export enum AuditType {
  Activity = 'ACTIVITY',
  Businessunit = 'BUSINESSUNIT',
  Category = 'CATEGORY',
  Clienttype = 'CLIENTTYPE',
  Comment = 'COMMENT',
  Cycle = 'CYCLE',
  Definition = 'DEFINITION',
  Document = 'DOCUMENT',
  Entity = 'ENTITY',
  Location = 'LOCATION',
  Methodforactivity = 'METHODFORACTIVITY',
  Notification = 'NOTIFICATION',
  Product = 'PRODUCT',
  Reverseenquiry = 'REVERSEENQUIRY',
  State = 'STATE',
  Subactivity = 'SUBACTIVITY',
  Subproduct = 'SUBPRODUCT',
  Suggestion = 'SUGGESTION',
  Version = 'VERSION'
}

export type AuditUncheckedCreateInput = {
  action: AuditAction;
  archived?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  type: AuditType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versionId?: InputMaybe<Scalars['String']>;
};

export type AuditUncheckedCreateNestedManyWithoutVersionInput = {
  connect?: InputMaybe<Array<AuditWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AuditCreateOrConnectWithoutVersionInput>>;
  create?: InputMaybe<Array<AuditCreateWithoutVersionInput>>;
  createMany?: InputMaybe<AuditCreateManyVersionInputEnvelope>;
};

export type AuditUncheckedCreateWithoutVersionInput = {
  action: AuditAction;
  archived?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  type: AuditType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AuditUncheckedUpdateInput = {
  action?: InputMaybe<EnumAuditActionFieldUpdateOperationsInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  content?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumAuditTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  versionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type AuditUncheckedUpdateManyInput = {
  action?: InputMaybe<EnumAuditActionFieldUpdateOperationsInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  content?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumAuditTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  versionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type AuditUncheckedUpdateManyWithoutAuditsInput = {
  action?: InputMaybe<EnumAuditActionFieldUpdateOperationsInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  content?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumAuditTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AuditUncheckedUpdateManyWithoutVersionNestedInput = {
  connect?: InputMaybe<Array<AuditWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AuditCreateOrConnectWithoutVersionInput>>;
  create?: InputMaybe<Array<AuditCreateWithoutVersionInput>>;
  createMany?: InputMaybe<AuditCreateManyVersionInputEnvelope>;
  delete?: InputMaybe<Array<AuditWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AuditScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AuditWhereUniqueInput>>;
  set?: InputMaybe<Array<AuditWhereUniqueInput>>;
  update?: InputMaybe<Array<AuditUpdateWithWhereUniqueWithoutVersionInput>>;
  updateMany?: InputMaybe<Array<AuditUpdateManyWithWhereWithoutVersionInput>>;
  upsert?: InputMaybe<Array<AuditUpsertWithWhereUniqueWithoutVersionInput>>;
};

export type AuditUncheckedUpdateWithoutVersionInput = {
  action?: InputMaybe<EnumAuditActionFieldUpdateOperationsInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  content?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumAuditTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AuditUpdateInput = {
  action?: InputMaybe<EnumAuditActionFieldUpdateOperationsInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  content?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumAuditTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  version?: InputMaybe<VersionUpdateOneWithoutAuditsNestedInput>;
};

export type AuditUpdateManyMutationInput = {
  action?: InputMaybe<EnumAuditActionFieldUpdateOperationsInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  content?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumAuditTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AuditUpdateManyWithWhereWithoutVersionInput = {
  data: AuditUncheckedUpdateManyWithoutAuditsInput;
  where: AuditScalarWhereInput;
};

export type AuditUpdateManyWithoutVersionNestedInput = {
  connect?: InputMaybe<Array<AuditWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AuditCreateOrConnectWithoutVersionInput>>;
  create?: InputMaybe<Array<AuditCreateWithoutVersionInput>>;
  createMany?: InputMaybe<AuditCreateManyVersionInputEnvelope>;
  delete?: InputMaybe<Array<AuditWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AuditScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AuditWhereUniqueInput>>;
  set?: InputMaybe<Array<AuditWhereUniqueInput>>;
  update?: InputMaybe<Array<AuditUpdateWithWhereUniqueWithoutVersionInput>>;
  updateMany?: InputMaybe<Array<AuditUpdateManyWithWhereWithoutVersionInput>>;
  upsert?: InputMaybe<Array<AuditUpsertWithWhereUniqueWithoutVersionInput>>;
};

export type AuditUpdateWithWhereUniqueWithoutVersionInput = {
  data: AuditUncheckedUpdateWithoutVersionInput;
  where: AuditWhereUniqueInput;
};

export type AuditUpdateWithoutVersionInput = {
  action?: InputMaybe<EnumAuditActionFieldUpdateOperationsInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  content?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumAuditTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AuditUpsertWithWhereUniqueWithoutVersionInput = {
  create: AuditUncheckedCreateWithoutVersionInput;
  update: AuditUncheckedUpdateWithoutVersionInput;
  where: AuditWhereUniqueInput;
};

export type AuditUser = {
  __typename?: 'AuditUser';
  action: AuditAction;
  content?: Maybe<Scalars['Json']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  id: Scalars['ID'];
  name: Scalars['String'];
  type: AuditType;
  updatedAt: Scalars['DateTime'];
  version?: Maybe<Version>;
};

export type AuditUserConnection = {
  __typename?: 'AuditUserConnection';
  aggregate: AggregateAuditUser;
  edges: Array<Maybe<AuditUserEdge>>;
  pageInfo: PageInfo;
};

export type AuditUserEdge = {
  __typename?: 'AuditUserEdge';
  cursor: Scalars['String'];
  node: AuditUser;
};

export type AuditUserOrderByWithRelationInput = {
  action?: InputMaybe<SortOrder>;
  archived?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  version?: InputMaybe<VersionOrderByWithRelationInput>;
  versionId?: InputMaybe<SortOrder>;
};

export type AuditUserWhereInput = {
  AND?: InputMaybe<Array<AuditUserWhereInput>>;
  NOT?: InputMaybe<Array<AuditUserWhereInput>>;
  OR?: InputMaybe<Array<AuditUserWhereInput>>;
  action?: InputMaybe<EnumAuditActionFilter>;
  archived?: InputMaybe<BoolNullableFilter>;
  content?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumAuditTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  version?: InputMaybe<VersionWhereInput>;
  versionId?: InputMaybe<StringNullableFilter>;
};

export type AuditWhereInput = {
  AND?: InputMaybe<Array<AuditWhereInput>>;
  NOT?: InputMaybe<Array<AuditWhereInput>>;
  OR?: InputMaybe<Array<AuditWhereInput>>;
  action?: InputMaybe<EnumAuditActionFilter>;
  archived?: InputMaybe<BoolNullableFilter>;
  content?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumAuditTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  version?: InputMaybe<VersionWhereInput>;
  versionId?: InputMaybe<StringNullableFilter>;
};

export type AuditWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type BatchPayload = {
  __typename?: 'BatchPayload';
  count: Scalars['Int'];
};

export type BoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type BoolNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedBoolNullableFilter>;
  _min?: InputMaybe<NestedBoolNullableFilter>;
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolNullableWithAggregatesFilter>;
};

export type BoolWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedBoolFilter>;
  _min?: InputMaybe<NestedBoolFilter>;
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolWithAggregatesFilter>;
};

export type BusinessUnit = {
  __typename?: 'BusinessUnit';
  _count: BusinessUnitCountOutputType;
  createdAt: Scalars['DateTime'];
  fields: Array<Maybe<BusinessUnitFields>>;
  id: Scalars['String'];
  pending?: Maybe<Scalars['Boolean']>;
  products: Array<Maybe<ProductFields>>;
  published?: Maybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type BusinessUnitFieldsArgs = {
  cursor?: InputMaybe<BusinessUnitFieldsWhereUniqueInput>;
  distinct?: InputMaybe<BusinessUnitFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<BusinessUnitFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BusinessUnitFieldsWhereInput>;
};


export type BusinessUnitProductsArgs = {
  cursor?: InputMaybe<ProductFieldsWhereUniqueInput>;
  distinct?: InputMaybe<ProductFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<ProductFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductFieldsWhereInput>;
};

export type BusinessUnitCountAggregateOutputType = {
  __typename?: 'BusinessUnitCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  pending: Scalars['Int'];
  published: Scalars['Int'];
  reference: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type BusinessUnitCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type BusinessUnitCountOutputType = {
  __typename?: 'BusinessUnitCountOutputType';
  fields: Scalars['Int'];
  products: Scalars['Int'];
};

export type BusinessUnitCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<BusinessUnitFieldsCreateNestedManyWithoutBusinessUnitInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductFieldsCreateNestedManyWithoutBusinessUnitsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type BusinessUnitCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type BusinessUnitCreateNestedManyWithoutProductsInput = {
  connect?: InputMaybe<Array<BusinessUnitWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BusinessUnitCreateOrConnectWithoutProductsInput>>;
  create?: InputMaybe<Array<BusinessUnitCreateWithoutProductsInput>>;
};

export type BusinessUnitCreateNestedOneWithoutFieldsInput = {
  connect?: InputMaybe<BusinessUnitWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BusinessUnitCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<BusinessUnitUncheckedCreateWithoutFieldsInput>;
};

export type BusinessUnitCreateOrConnectWithoutFieldsInput = {
  create: BusinessUnitUncheckedCreateWithoutFieldsInput;
  where: BusinessUnitWhereUniqueInput;
};

export type BusinessUnitCreateOrConnectWithoutProductsInput = {
  create: BusinessUnitUncheckedCreateWithoutProductsInput;
  where: BusinessUnitWhereUniqueInput;
};

export type BusinessUnitCreateWithoutFieldsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductFieldsCreateNestedManyWithoutBusinessUnitsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type BusinessUnitCreateWithoutProductsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<BusinessUnitFieldsCreateNestedManyWithoutBusinessUnitInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type BusinessUnitFields = {
  __typename?: 'BusinessUnitFields';
  _count: BusinessUnitFieldsCountOutputType;
  businessUnit?: Maybe<BusinessUnit>;
  businessUnitId?: Maybe<Scalars['String']>;
  cmsId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  locations: Array<Maybe<Location>>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type BusinessUnitFieldsLocationsArgs = {
  cursor?: InputMaybe<LocationWhereUniqueInput>;
  distinct?: InputMaybe<LocationScalarFieldEnum>;
  orderBy?: InputMaybe<LocationOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationWhereInput>;
};

export type BusinessUnitFieldsAvgAggregateOutputType = {
  __typename?: 'BusinessUnitFieldsAvgAggregateOutputType';
  order?: Maybe<Scalars['Float']>;
};

export type BusinessUnitFieldsAvgOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type BusinessUnitFieldsCountAggregateOutputType = {
  __typename?: 'BusinessUnitFieldsCountAggregateOutputType';
  _all: Scalars['Int'];
  businessUnitId: Scalars['Int'];
  cmsId: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  order: Scalars['Int'];
  pending: Scalars['Int'];
  published: Scalars['Int'];
  stack: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type BusinessUnitFieldsCountOrderByAggregateInput = {
  businessUnitId?: InputMaybe<SortOrder>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type BusinessUnitFieldsCountOutputType = {
  __typename?: 'BusinessUnitFieldsCountOutputType';
  locations: Scalars['Int'];
};

export type BusinessUnitFieldsCreateInput = {
  businessUnit?: InputMaybe<BusinessUnitCreateNestedOneWithoutFieldsInput>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutBusinessUnitsInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type BusinessUnitFieldsCreateManyBusinessUnitInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type BusinessUnitFieldsCreateManyBusinessUnitInputEnvelope = {
  data: Array<BusinessUnitFieldsCreateManyBusinessUnitInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type BusinessUnitFieldsCreateManyInput = {
  businessUnitId?: InputMaybe<Scalars['String']>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type BusinessUnitFieldsCreateNestedManyWithoutBusinessUnitInput = {
  connect?: InputMaybe<Array<BusinessUnitFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BusinessUnitFieldsCreateOrConnectWithoutBusinessUnitInput>>;
  create?: InputMaybe<Array<BusinessUnitFieldsCreateWithoutBusinessUnitInput>>;
  createMany?: InputMaybe<BusinessUnitFieldsCreateManyBusinessUnitInputEnvelope>;
};

export type BusinessUnitFieldsCreateNestedManyWithoutLocationsInput = {
  connect?: InputMaybe<Array<BusinessUnitFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BusinessUnitFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<BusinessUnitFieldsCreateWithoutLocationsInput>>;
};

export type BusinessUnitFieldsCreateOrConnectWithoutBusinessUnitInput = {
  create: BusinessUnitFieldsUncheckedCreateWithoutBusinessUnitInput;
  where: BusinessUnitFieldsWhereUniqueInput;
};

export type BusinessUnitFieldsCreateOrConnectWithoutLocationsInput = {
  create: BusinessUnitFieldsUncheckedCreateWithoutLocationsInput;
  where: BusinessUnitFieldsWhereUniqueInput;
};

export type BusinessUnitFieldsCreateWithoutBusinessUnitInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutBusinessUnitsInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type BusinessUnitFieldsCreateWithoutLocationsInput = {
  businessUnit?: InputMaybe<BusinessUnitCreateNestedOneWithoutFieldsInput>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type BusinessUnitFieldsListRelationFilter = {
  every?: InputMaybe<BusinessUnitFieldsWhereInput>;
  none?: InputMaybe<BusinessUnitFieldsWhereInput>;
  some?: InputMaybe<BusinessUnitFieldsWhereInput>;
};

export type BusinessUnitFieldsMaxAggregateOutputType = {
  __typename?: 'BusinessUnitFieldsMaxAggregateOutputType';
  businessUnitId?: Maybe<Scalars['String']>;
  cmsId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  stack?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BusinessUnitFieldsMaxOrderByAggregateInput = {
  businessUnitId?: InputMaybe<SortOrder>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type BusinessUnitFieldsMinAggregateOutputType = {
  __typename?: 'BusinessUnitFieldsMinAggregateOutputType';
  businessUnitId?: Maybe<Scalars['String']>;
  cmsId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  stack?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BusinessUnitFieldsMinOrderByAggregateInput = {
  businessUnitId?: InputMaybe<SortOrder>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type BusinessUnitFieldsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BusinessUnitFieldsOrderByWithAggregationInput = {
  _avg?: InputMaybe<BusinessUnitFieldsAvgOrderByAggregateInput>;
  _count?: InputMaybe<BusinessUnitFieldsCountOrderByAggregateInput>;
  _max?: InputMaybe<BusinessUnitFieldsMaxOrderByAggregateInput>;
  _min?: InputMaybe<BusinessUnitFieldsMinOrderByAggregateInput>;
  _sum?: InputMaybe<BusinessUnitFieldsSumOrderByAggregateInput>;
  businessUnitId?: InputMaybe<SortOrderInput>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrderInput>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type BusinessUnitFieldsOrderByWithRelationInput = {
  businessUnit?: InputMaybe<BusinessUnitOrderByWithRelationInput>;
  businessUnitId?: InputMaybe<SortOrderInput>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  locations?: InputMaybe<LocationOrderByRelationAggregateInput>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrderInput>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum BusinessUnitFieldsScalarFieldEnum {
  BusinessUnitId = 'businessUnitId',
  CmsId = 'cmsId',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Name = 'name',
  Order = 'order',
  Pending = 'pending',
  Published = 'published',
  Stack = 'stack',
  UpdatedAt = 'updatedAt'
}

export type BusinessUnitFieldsScalarWhereInput = {
  AND?: InputMaybe<Array<BusinessUnitFieldsScalarWhereInput>>;
  NOT?: InputMaybe<Array<BusinessUnitFieldsScalarWhereInput>>;
  OR?: InputMaybe<Array<BusinessUnitFieldsScalarWhereInput>>;
  businessUnitId?: InputMaybe<StringNullableFilter>;
  cmsId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  stack?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type BusinessUnitFieldsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<BusinessUnitFieldsScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<BusinessUnitFieldsScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<BusinessUnitFieldsScalarWhereWithAggregatesInput>>;
  businessUnitId?: InputMaybe<StringNullableWithAggregatesFilter>;
  cmsId?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  order?: InputMaybe<IntNullableWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  stack?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type BusinessUnitFieldsSumAggregateOutputType = {
  __typename?: 'BusinessUnitFieldsSumAggregateOutputType';
  order?: Maybe<Scalars['Int']>;
};

export type BusinessUnitFieldsSumOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type BusinessUnitFieldsUncheckedCreateInput = {
  businessUnitId?: InputMaybe<Scalars['String']>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationUncheckedCreateNestedManyWithoutBusinessUnitsInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type BusinessUnitFieldsUncheckedCreateNestedManyWithoutBusinessUnitInput = {
  connect?: InputMaybe<Array<BusinessUnitFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BusinessUnitFieldsCreateOrConnectWithoutBusinessUnitInput>>;
  create?: InputMaybe<Array<BusinessUnitFieldsCreateWithoutBusinessUnitInput>>;
  createMany?: InputMaybe<BusinessUnitFieldsCreateManyBusinessUnitInputEnvelope>;
};

export type BusinessUnitFieldsUncheckedCreateNestedManyWithoutLocationsInput = {
  connect?: InputMaybe<Array<BusinessUnitFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BusinessUnitFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<BusinessUnitFieldsCreateWithoutLocationsInput>>;
};

export type BusinessUnitFieldsUncheckedCreateWithoutBusinessUnitInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationUncheckedCreateNestedManyWithoutBusinessUnitsInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type BusinessUnitFieldsUncheckedCreateWithoutLocationsInput = {
  businessUnitId?: InputMaybe<Scalars['String']>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type BusinessUnitFieldsUncheckedUpdateInput = {
  businessUnitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUncheckedUpdateManyWithoutBusinessUnitsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BusinessUnitFieldsUncheckedUpdateManyInput = {
  businessUnitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BusinessUnitFieldsUncheckedUpdateManyWithoutBusinessUnitNestedInput = {
  connect?: InputMaybe<Array<BusinessUnitFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BusinessUnitFieldsCreateOrConnectWithoutBusinessUnitInput>>;
  create?: InputMaybe<Array<BusinessUnitFieldsCreateWithoutBusinessUnitInput>>;
  createMany?: InputMaybe<BusinessUnitFieldsCreateManyBusinessUnitInputEnvelope>;
  delete?: InputMaybe<Array<BusinessUnitFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BusinessUnitFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BusinessUnitFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<BusinessUnitFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<BusinessUnitFieldsUpdateWithWhereUniqueWithoutBusinessUnitInput>>;
  updateMany?: InputMaybe<Array<BusinessUnitFieldsUpdateManyWithWhereWithoutBusinessUnitInput>>;
  upsert?: InputMaybe<Array<BusinessUnitFieldsUpsertWithWhereUniqueWithoutBusinessUnitInput>>;
};

export type BusinessUnitFieldsUncheckedUpdateManyWithoutBusinessUnitsInput = {
  businessUnitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BusinessUnitFieldsUncheckedUpdateManyWithoutFieldsInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BusinessUnitFieldsUncheckedUpdateManyWithoutLocationsNestedInput = {
  connect?: InputMaybe<Array<BusinessUnitFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BusinessUnitFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<BusinessUnitFieldsCreateWithoutLocationsInput>>;
  delete?: InputMaybe<Array<BusinessUnitFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BusinessUnitFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BusinessUnitFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<BusinessUnitFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<BusinessUnitFieldsUpdateWithWhereUniqueWithoutLocationsInput>>;
  updateMany?: InputMaybe<Array<BusinessUnitFieldsUpdateManyWithWhereWithoutLocationsInput>>;
  upsert?: InputMaybe<Array<BusinessUnitFieldsUpsertWithWhereUniqueWithoutLocationsInput>>;
};

export type BusinessUnitFieldsUncheckedUpdateWithoutBusinessUnitInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUncheckedUpdateManyWithoutBusinessUnitsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BusinessUnitFieldsUncheckedUpdateWithoutLocationsInput = {
  businessUnitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BusinessUnitFieldsUpdateInput = {
  businessUnit?: InputMaybe<BusinessUnitUpdateOneWithoutFieldsNestedInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutBusinessUnitsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BusinessUnitFieldsUpdateManyMutationInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BusinessUnitFieldsUpdateManyWithWhereWithoutBusinessUnitInput = {
  data: BusinessUnitFieldsUncheckedUpdateManyWithoutFieldsInput;
  where: BusinessUnitFieldsScalarWhereInput;
};

export type BusinessUnitFieldsUpdateManyWithWhereWithoutLocationsInput = {
  data: BusinessUnitFieldsUncheckedUpdateManyWithoutBusinessUnitsInput;
  where: BusinessUnitFieldsScalarWhereInput;
};

export type BusinessUnitFieldsUpdateManyWithoutBusinessUnitNestedInput = {
  connect?: InputMaybe<Array<BusinessUnitFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BusinessUnitFieldsCreateOrConnectWithoutBusinessUnitInput>>;
  create?: InputMaybe<Array<BusinessUnitFieldsCreateWithoutBusinessUnitInput>>;
  createMany?: InputMaybe<BusinessUnitFieldsCreateManyBusinessUnitInputEnvelope>;
  delete?: InputMaybe<Array<BusinessUnitFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BusinessUnitFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BusinessUnitFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<BusinessUnitFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<BusinessUnitFieldsUpdateWithWhereUniqueWithoutBusinessUnitInput>>;
  updateMany?: InputMaybe<Array<BusinessUnitFieldsUpdateManyWithWhereWithoutBusinessUnitInput>>;
  upsert?: InputMaybe<Array<BusinessUnitFieldsUpsertWithWhereUniqueWithoutBusinessUnitInput>>;
};

export type BusinessUnitFieldsUpdateManyWithoutLocationsNestedInput = {
  connect?: InputMaybe<Array<BusinessUnitFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BusinessUnitFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<BusinessUnitFieldsCreateWithoutLocationsInput>>;
  delete?: InputMaybe<Array<BusinessUnitFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BusinessUnitFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BusinessUnitFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<BusinessUnitFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<BusinessUnitFieldsUpdateWithWhereUniqueWithoutLocationsInput>>;
  updateMany?: InputMaybe<Array<BusinessUnitFieldsUpdateManyWithWhereWithoutLocationsInput>>;
  upsert?: InputMaybe<Array<BusinessUnitFieldsUpsertWithWhereUniqueWithoutLocationsInput>>;
};

export type BusinessUnitFieldsUpdateWithWhereUniqueWithoutBusinessUnitInput = {
  data: BusinessUnitFieldsUncheckedUpdateWithoutBusinessUnitInput;
  where: BusinessUnitFieldsWhereUniqueInput;
};

export type BusinessUnitFieldsUpdateWithWhereUniqueWithoutLocationsInput = {
  data: BusinessUnitFieldsUncheckedUpdateWithoutLocationsInput;
  where: BusinessUnitFieldsWhereUniqueInput;
};

export type BusinessUnitFieldsUpdateWithoutBusinessUnitInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutBusinessUnitsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BusinessUnitFieldsUpdateWithoutLocationsInput = {
  businessUnit?: InputMaybe<BusinessUnitUpdateOneWithoutFieldsNestedInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BusinessUnitFieldsUpsertWithWhereUniqueWithoutBusinessUnitInput = {
  create: BusinessUnitFieldsUncheckedCreateWithoutBusinessUnitInput;
  update: BusinessUnitFieldsUncheckedUpdateWithoutBusinessUnitInput;
  where: BusinessUnitFieldsWhereUniqueInput;
};

export type BusinessUnitFieldsUpsertWithWhereUniqueWithoutLocationsInput = {
  create: BusinessUnitFieldsUncheckedCreateWithoutLocationsInput;
  update: BusinessUnitFieldsUncheckedUpdateWithoutLocationsInput;
  where: BusinessUnitFieldsWhereUniqueInput;
};

export type BusinessUnitFieldsWhereInput = {
  AND?: InputMaybe<Array<BusinessUnitFieldsWhereInput>>;
  NOT?: InputMaybe<Array<BusinessUnitFieldsWhereInput>>;
  OR?: InputMaybe<Array<BusinessUnitFieldsWhereInput>>;
  businessUnit?: InputMaybe<BusinessUnitWhereInput>;
  businessUnitId?: InputMaybe<StringNullableFilter>;
  cmsId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  locations?: InputMaybe<LocationListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  stack?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type BusinessUnitFieldsWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type BusinessUnitListRelationFilter = {
  every?: InputMaybe<BusinessUnitWhereInput>;
  none?: InputMaybe<BusinessUnitWhereInput>;
  some?: InputMaybe<BusinessUnitWhereInput>;
};

export type BusinessUnitMaxAggregateOutputType = {
  __typename?: 'BusinessUnitMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BusinessUnitMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type BusinessUnitMinAggregateOutputType = {
  __typename?: 'BusinessUnitMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BusinessUnitMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type BusinessUnitOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BusinessUnitOrderByWithAggregationInput = {
  _count?: InputMaybe<BusinessUnitCountOrderByAggregateInput>;
  _max?: InputMaybe<BusinessUnitMaxOrderByAggregateInput>;
  _min?: InputMaybe<BusinessUnitMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type BusinessUnitOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  fields?: InputMaybe<BusinessUnitFieldsOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  products?: InputMaybe<ProductFieldsOrderByRelationAggregateInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type BusinessUnitRelationFilter = {
  is?: InputMaybe<BusinessUnitWhereInput>;
  isNot?: InputMaybe<BusinessUnitWhereInput>;
};

export enum BusinessUnitScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Pending = 'pending',
  Published = 'published',
  Reference = 'reference',
  UpdatedAt = 'updatedAt'
}

export type BusinessUnitScalarWhereInput = {
  AND?: InputMaybe<Array<BusinessUnitScalarWhereInput>>;
  NOT?: InputMaybe<Array<BusinessUnitScalarWhereInput>>;
  OR?: InputMaybe<Array<BusinessUnitScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  reference?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type BusinessUnitScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<BusinessUnitScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<BusinessUnitScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<BusinessUnitScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  reference?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type BusinessUnitUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<BusinessUnitFieldsUncheckedCreateNestedManyWithoutBusinessUnitInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductFieldsUncheckedCreateNestedManyWithoutBusinessUnitsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type BusinessUnitUncheckedCreateNestedManyWithoutProductsInput = {
  connect?: InputMaybe<Array<BusinessUnitWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BusinessUnitCreateOrConnectWithoutProductsInput>>;
  create?: InputMaybe<Array<BusinessUnitCreateWithoutProductsInput>>;
};

export type BusinessUnitUncheckedCreateWithoutFieldsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductFieldsUncheckedCreateNestedManyWithoutBusinessUnitsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type BusinessUnitUncheckedCreateWithoutProductsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<BusinessUnitFieldsUncheckedCreateNestedManyWithoutBusinessUnitInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type BusinessUnitUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<BusinessUnitFieldsUncheckedUpdateManyWithoutBusinessUnitNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductFieldsUncheckedUpdateManyWithoutBusinessUnitsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BusinessUnitUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BusinessUnitUncheckedUpdateManyWithoutBusinessUnitsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BusinessUnitUncheckedUpdateManyWithoutProductsNestedInput = {
  connect?: InputMaybe<Array<BusinessUnitWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BusinessUnitCreateOrConnectWithoutProductsInput>>;
  create?: InputMaybe<Array<BusinessUnitCreateWithoutProductsInput>>;
  delete?: InputMaybe<Array<BusinessUnitWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BusinessUnitScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BusinessUnitWhereUniqueInput>>;
  set?: InputMaybe<Array<BusinessUnitWhereUniqueInput>>;
  update?: InputMaybe<Array<BusinessUnitUpdateWithWhereUniqueWithoutProductsInput>>;
  updateMany?: InputMaybe<Array<BusinessUnitUpdateManyWithWhereWithoutProductsInput>>;
  upsert?: InputMaybe<Array<BusinessUnitUpsertWithWhereUniqueWithoutProductsInput>>;
};

export type BusinessUnitUncheckedUpdateWithoutFieldsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductFieldsUncheckedUpdateManyWithoutBusinessUnitsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BusinessUnitUncheckedUpdateWithoutProductsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<BusinessUnitFieldsUncheckedUpdateManyWithoutBusinessUnitNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BusinessUnitUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<BusinessUnitFieldsUpdateManyWithoutBusinessUnitNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductFieldsUpdateManyWithoutBusinessUnitsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BusinessUnitUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BusinessUnitUpdateManyWithWhereWithoutProductsInput = {
  data: BusinessUnitUncheckedUpdateManyWithoutBusinessUnitsInput;
  where: BusinessUnitScalarWhereInput;
};

export type BusinessUnitUpdateManyWithoutProductsNestedInput = {
  connect?: InputMaybe<Array<BusinessUnitWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BusinessUnitCreateOrConnectWithoutProductsInput>>;
  create?: InputMaybe<Array<BusinessUnitCreateWithoutProductsInput>>;
  delete?: InputMaybe<Array<BusinessUnitWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BusinessUnitScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BusinessUnitWhereUniqueInput>>;
  set?: InputMaybe<Array<BusinessUnitWhereUniqueInput>>;
  update?: InputMaybe<Array<BusinessUnitUpdateWithWhereUniqueWithoutProductsInput>>;
  updateMany?: InputMaybe<Array<BusinessUnitUpdateManyWithWhereWithoutProductsInput>>;
  upsert?: InputMaybe<Array<BusinessUnitUpsertWithWhereUniqueWithoutProductsInput>>;
};

export type BusinessUnitUpdateOneWithoutFieldsNestedInput = {
  connect?: InputMaybe<BusinessUnitWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BusinessUnitCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<BusinessUnitUncheckedCreateWithoutFieldsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<BusinessUnitUncheckedUpdateWithoutFieldsInput>;
  upsert?: InputMaybe<BusinessUnitUpsertWithoutFieldsInput>;
};

export type BusinessUnitUpdateWithWhereUniqueWithoutProductsInput = {
  data: BusinessUnitUncheckedUpdateWithoutProductsInput;
  where: BusinessUnitWhereUniqueInput;
};

export type BusinessUnitUpdateWithoutFieldsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductFieldsUpdateManyWithoutBusinessUnitsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BusinessUnitUpdateWithoutProductsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<BusinessUnitFieldsUpdateManyWithoutBusinessUnitNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BusinessUnitUpsertWithWhereUniqueWithoutProductsInput = {
  create: BusinessUnitUncheckedCreateWithoutProductsInput;
  update: BusinessUnitUncheckedUpdateWithoutProductsInput;
  where: BusinessUnitWhereUniqueInput;
};

export type BusinessUnitUpsertWithoutFieldsInput = {
  create: BusinessUnitUncheckedCreateWithoutFieldsInput;
  update: BusinessUnitUncheckedUpdateWithoutFieldsInput;
};

export type BusinessUnitWhereInput = {
  AND?: InputMaybe<Array<BusinessUnitWhereInput>>;
  NOT?: InputMaybe<Array<BusinessUnitWhereInput>>;
  OR?: InputMaybe<Array<BusinessUnitWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fields?: InputMaybe<BusinessUnitFieldsListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  products?: InputMaybe<ProductFieldsListRelationFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  reference?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type BusinessUnitWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type Category = {
  __typename?: 'Category';
  _count: CategoryCountOutputType;
  createdAt: Scalars['DateTime'];
  fields: Array<Maybe<CategoryFields>>;
  id: Scalars['String'];
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type CategoryFieldsArgs = {
  cursor?: InputMaybe<CategoryFieldsWhereUniqueInput>;
  distinct?: InputMaybe<CategoryFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<CategoryFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CategoryFieldsWhereInput>;
};

export type CategoryCountAggregateOutputType = {
  __typename?: 'CategoryCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  pending: Scalars['Int'];
  published: Scalars['Int'];
  reference: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CategoryCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CategoryCountOutputType = {
  __typename?: 'CategoryCountOutputType';
  fields: Scalars['Int'];
};

export type CategoryCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<CategoryFieldsCreateNestedManyWithoutCategoryInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CategoryCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CategoryCreateNestedOneWithoutFieldsInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<CategoryUncheckedCreateWithoutFieldsInput>;
};

export type CategoryCreateOrConnectWithoutFieldsInput = {
  create: CategoryUncheckedCreateWithoutFieldsInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryCreateWithoutFieldsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CategoryFields = {
  __typename?: 'CategoryFields';
  _count: CategoryFieldsCountOutputType;
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['String']>;
  clientTypes: Array<Maybe<ClientType>>;
  cmsId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type CategoryFieldsClientTypesArgs = {
  cursor?: InputMaybe<ClientTypeWhereUniqueInput>;
  distinct?: InputMaybe<ClientTypeScalarFieldEnum>;
  orderBy?: InputMaybe<ClientTypeOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ClientTypeWhereInput>;
};

export type CategoryFieldsAvgAggregateOutputType = {
  __typename?: 'CategoryFieldsAvgAggregateOutputType';
  order?: Maybe<Scalars['Float']>;
};

export type CategoryFieldsAvgOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type CategoryFieldsCountAggregateOutputType = {
  __typename?: 'CategoryFieldsCountAggregateOutputType';
  _all: Scalars['Int'];
  categoryId: Scalars['Int'];
  cmsId: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  order: Scalars['Int'];
  pending: Scalars['Int'];
  published: Scalars['Int'];
  stack: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CategoryFieldsCountOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CategoryFieldsCountOutputType = {
  __typename?: 'CategoryFieldsCountOutputType';
  clientTypes: Scalars['Int'];
};

export type CategoryFieldsCreateInput = {
  category?: InputMaybe<CategoryCreateNestedOneWithoutFieldsInput>;
  clientTypes?: InputMaybe<ClientTypeCreateNestedManyWithoutCategoriesInput>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CategoryFieldsCreateManyCategoryInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CategoryFieldsCreateManyCategoryInputEnvelope = {
  data: Array<CategoryFieldsCreateManyCategoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CategoryFieldsCreateManyInput = {
  categoryId?: InputMaybe<Scalars['String']>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CategoryFieldsCreateNestedManyWithoutCategoryInput = {
  connect?: InputMaybe<Array<CategoryFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryFieldsCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<CategoryFieldsCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<CategoryFieldsCreateManyCategoryInputEnvelope>;
};

export type CategoryFieldsCreateNestedManyWithoutClientTypesInput = {
  connect?: InputMaybe<Array<CategoryFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryFieldsCreateOrConnectWithoutClientTypesInput>>;
  create?: InputMaybe<Array<CategoryFieldsCreateWithoutClientTypesInput>>;
};

export type CategoryFieldsCreateOrConnectWithoutCategoryInput = {
  create: CategoryFieldsUncheckedCreateWithoutCategoryInput;
  where: CategoryFieldsWhereUniqueInput;
};

export type CategoryFieldsCreateOrConnectWithoutClientTypesInput = {
  create: CategoryFieldsUncheckedCreateWithoutClientTypesInput;
  where: CategoryFieldsWhereUniqueInput;
};

export type CategoryFieldsCreateWithoutCategoryInput = {
  clientTypes?: InputMaybe<ClientTypeCreateNestedManyWithoutCategoriesInput>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CategoryFieldsCreateWithoutClientTypesInput = {
  category?: InputMaybe<CategoryCreateNestedOneWithoutFieldsInput>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CategoryFieldsListRelationFilter = {
  every?: InputMaybe<CategoryFieldsWhereInput>;
  none?: InputMaybe<CategoryFieldsWhereInput>;
  some?: InputMaybe<CategoryFieldsWhereInput>;
};

export type CategoryFieldsMaxAggregateOutputType = {
  __typename?: 'CategoryFieldsMaxAggregateOutputType';
  categoryId?: Maybe<Scalars['String']>;
  cmsId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  stack?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CategoryFieldsMaxOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CategoryFieldsMinAggregateOutputType = {
  __typename?: 'CategoryFieldsMinAggregateOutputType';
  categoryId?: Maybe<Scalars['String']>;
  cmsId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  stack?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CategoryFieldsMinOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CategoryFieldsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CategoryFieldsOrderByWithAggregationInput = {
  _avg?: InputMaybe<CategoryFieldsAvgOrderByAggregateInput>;
  _count?: InputMaybe<CategoryFieldsCountOrderByAggregateInput>;
  _max?: InputMaybe<CategoryFieldsMaxOrderByAggregateInput>;
  _min?: InputMaybe<CategoryFieldsMinOrderByAggregateInput>;
  _sum?: InputMaybe<CategoryFieldsSumOrderByAggregateInput>;
  categoryId?: InputMaybe<SortOrderInput>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrderInput>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CategoryFieldsOrderByWithRelationInput = {
  category?: InputMaybe<CategoryOrderByWithRelationInput>;
  categoryId?: InputMaybe<SortOrderInput>;
  clientTypes?: InputMaybe<ClientTypeOrderByRelationAggregateInput>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrderInput>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum CategoryFieldsScalarFieldEnum {
  CategoryId = 'categoryId',
  CmsId = 'cmsId',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Name = 'name',
  Order = 'order',
  Pending = 'pending',
  Published = 'published',
  Stack = 'stack',
  UpdatedAt = 'updatedAt'
}

export type CategoryFieldsScalarWhereInput = {
  AND?: InputMaybe<Array<CategoryFieldsScalarWhereInput>>;
  NOT?: InputMaybe<Array<CategoryFieldsScalarWhereInput>>;
  OR?: InputMaybe<Array<CategoryFieldsScalarWhereInput>>;
  categoryId?: InputMaybe<StringNullableFilter>;
  cmsId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  stack?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CategoryFieldsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<CategoryFieldsScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<CategoryFieldsScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CategoryFieldsScalarWhereWithAggregatesInput>>;
  categoryId?: InputMaybe<StringNullableWithAggregatesFilter>;
  cmsId?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  order?: InputMaybe<IntNullableWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  stack?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type CategoryFieldsSumAggregateOutputType = {
  __typename?: 'CategoryFieldsSumAggregateOutputType';
  order?: Maybe<Scalars['Int']>;
};

export type CategoryFieldsSumOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type CategoryFieldsUncheckedCreateInput = {
  categoryId?: InputMaybe<Scalars['String']>;
  clientTypes?: InputMaybe<ClientTypeUncheckedCreateNestedManyWithoutCategoriesInput>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CategoryFieldsUncheckedCreateNestedManyWithoutCategoryInput = {
  connect?: InputMaybe<Array<CategoryFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryFieldsCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<CategoryFieldsCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<CategoryFieldsCreateManyCategoryInputEnvelope>;
};

export type CategoryFieldsUncheckedCreateNestedManyWithoutClientTypesInput = {
  connect?: InputMaybe<Array<CategoryFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryFieldsCreateOrConnectWithoutClientTypesInput>>;
  create?: InputMaybe<Array<CategoryFieldsCreateWithoutClientTypesInput>>;
};

export type CategoryFieldsUncheckedCreateWithoutCategoryInput = {
  clientTypes?: InputMaybe<ClientTypeUncheckedCreateNestedManyWithoutCategoriesInput>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CategoryFieldsUncheckedCreateWithoutClientTypesInput = {
  categoryId?: InputMaybe<Scalars['String']>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CategoryFieldsUncheckedUpdateInput = {
  categoryId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clientTypes?: InputMaybe<ClientTypeUncheckedUpdateManyWithoutCategoriesNestedInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CategoryFieldsUncheckedUpdateManyInput = {
  categoryId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CategoryFieldsUncheckedUpdateManyWithoutCategoriesInput = {
  categoryId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CategoryFieldsUncheckedUpdateManyWithoutCategoryNestedInput = {
  connect?: InputMaybe<Array<CategoryFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryFieldsCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<CategoryFieldsCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<CategoryFieldsCreateManyCategoryInputEnvelope>;
  delete?: InputMaybe<Array<CategoryFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CategoryFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CategoryFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<CategoryFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<CategoryFieldsUpdateWithWhereUniqueWithoutCategoryInput>>;
  updateMany?: InputMaybe<Array<CategoryFieldsUpdateManyWithWhereWithoutCategoryInput>>;
  upsert?: InputMaybe<Array<CategoryFieldsUpsertWithWhereUniqueWithoutCategoryInput>>;
};

export type CategoryFieldsUncheckedUpdateManyWithoutClientTypesNestedInput = {
  connect?: InputMaybe<Array<CategoryFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryFieldsCreateOrConnectWithoutClientTypesInput>>;
  create?: InputMaybe<Array<CategoryFieldsCreateWithoutClientTypesInput>>;
  delete?: InputMaybe<Array<CategoryFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CategoryFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CategoryFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<CategoryFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<CategoryFieldsUpdateWithWhereUniqueWithoutClientTypesInput>>;
  updateMany?: InputMaybe<Array<CategoryFieldsUpdateManyWithWhereWithoutClientTypesInput>>;
  upsert?: InputMaybe<Array<CategoryFieldsUpsertWithWhereUniqueWithoutClientTypesInput>>;
};

export type CategoryFieldsUncheckedUpdateManyWithoutFieldsInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CategoryFieldsUncheckedUpdateWithoutCategoryInput = {
  clientTypes?: InputMaybe<ClientTypeUncheckedUpdateManyWithoutCategoriesNestedInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CategoryFieldsUncheckedUpdateWithoutClientTypesInput = {
  categoryId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CategoryFieldsUpdateInput = {
  category?: InputMaybe<CategoryUpdateOneWithoutFieldsNestedInput>;
  clientTypes?: InputMaybe<ClientTypeUpdateManyWithoutCategoriesNestedInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CategoryFieldsUpdateManyMutationInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CategoryFieldsUpdateManyWithWhereWithoutCategoryInput = {
  data: CategoryFieldsUncheckedUpdateManyWithoutFieldsInput;
  where: CategoryFieldsScalarWhereInput;
};

export type CategoryFieldsUpdateManyWithWhereWithoutClientTypesInput = {
  data: CategoryFieldsUncheckedUpdateManyWithoutCategoriesInput;
  where: CategoryFieldsScalarWhereInput;
};

export type CategoryFieldsUpdateManyWithoutCategoryNestedInput = {
  connect?: InputMaybe<Array<CategoryFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryFieldsCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<CategoryFieldsCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<CategoryFieldsCreateManyCategoryInputEnvelope>;
  delete?: InputMaybe<Array<CategoryFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CategoryFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CategoryFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<CategoryFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<CategoryFieldsUpdateWithWhereUniqueWithoutCategoryInput>>;
  updateMany?: InputMaybe<Array<CategoryFieldsUpdateManyWithWhereWithoutCategoryInput>>;
  upsert?: InputMaybe<Array<CategoryFieldsUpsertWithWhereUniqueWithoutCategoryInput>>;
};

export type CategoryFieldsUpdateManyWithoutClientTypesNestedInput = {
  connect?: InputMaybe<Array<CategoryFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryFieldsCreateOrConnectWithoutClientTypesInput>>;
  create?: InputMaybe<Array<CategoryFieldsCreateWithoutClientTypesInput>>;
  delete?: InputMaybe<Array<CategoryFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CategoryFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CategoryFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<CategoryFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<CategoryFieldsUpdateWithWhereUniqueWithoutClientTypesInput>>;
  updateMany?: InputMaybe<Array<CategoryFieldsUpdateManyWithWhereWithoutClientTypesInput>>;
  upsert?: InputMaybe<Array<CategoryFieldsUpsertWithWhereUniqueWithoutClientTypesInput>>;
};

export type CategoryFieldsUpdateWithWhereUniqueWithoutCategoryInput = {
  data: CategoryFieldsUncheckedUpdateWithoutCategoryInput;
  where: CategoryFieldsWhereUniqueInput;
};

export type CategoryFieldsUpdateWithWhereUniqueWithoutClientTypesInput = {
  data: CategoryFieldsUncheckedUpdateWithoutClientTypesInput;
  where: CategoryFieldsWhereUniqueInput;
};

export type CategoryFieldsUpdateWithoutCategoryInput = {
  clientTypes?: InputMaybe<ClientTypeUpdateManyWithoutCategoriesNestedInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CategoryFieldsUpdateWithoutClientTypesInput = {
  category?: InputMaybe<CategoryUpdateOneWithoutFieldsNestedInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CategoryFieldsUpsertWithWhereUniqueWithoutCategoryInput = {
  create: CategoryFieldsUncheckedCreateWithoutCategoryInput;
  update: CategoryFieldsUncheckedUpdateWithoutCategoryInput;
  where: CategoryFieldsWhereUniqueInput;
};

export type CategoryFieldsUpsertWithWhereUniqueWithoutClientTypesInput = {
  create: CategoryFieldsUncheckedCreateWithoutClientTypesInput;
  update: CategoryFieldsUncheckedUpdateWithoutClientTypesInput;
  where: CategoryFieldsWhereUniqueInput;
};

export type CategoryFieldsWhereInput = {
  AND?: InputMaybe<Array<CategoryFieldsWhereInput>>;
  NOT?: InputMaybe<Array<CategoryFieldsWhereInput>>;
  OR?: InputMaybe<Array<CategoryFieldsWhereInput>>;
  category?: InputMaybe<CategoryWhereInput>;
  categoryId?: InputMaybe<StringNullableFilter>;
  clientTypes?: InputMaybe<ClientTypeListRelationFilter>;
  cmsId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  stack?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CategoryFieldsWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type CategoryMaxAggregateOutputType = {
  __typename?: 'CategoryMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CategoryMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CategoryMinAggregateOutputType = {
  __typename?: 'CategoryMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CategoryMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CategoryOrderByWithAggregationInput = {
  _count?: InputMaybe<CategoryCountOrderByAggregateInput>;
  _max?: InputMaybe<CategoryMaxOrderByAggregateInput>;
  _min?: InputMaybe<CategoryMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CategoryOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  fields?: InputMaybe<CategoryFieldsOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CategoryRelationFilter = {
  is?: InputMaybe<CategoryWhereInput>;
  isNot?: InputMaybe<CategoryWhereInput>;
};

export enum CategoryScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Pending = 'pending',
  Published = 'published',
  Reference = 'reference',
  UpdatedAt = 'updatedAt'
}

export type CategoryScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<CategoryScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<CategoryScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CategoryScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  reference?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type CategoryUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<CategoryFieldsUncheckedCreateNestedManyWithoutCategoryInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CategoryUncheckedCreateWithoutFieldsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CategoryUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<CategoryFieldsUncheckedUpdateManyWithoutCategoryNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CategoryUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CategoryUncheckedUpdateWithoutFieldsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CategoryUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<CategoryFieldsUpdateManyWithoutCategoryNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CategoryUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CategoryUpdateOneWithoutFieldsNestedInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<CategoryUncheckedCreateWithoutFieldsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CategoryUncheckedUpdateWithoutFieldsInput>;
  upsert?: InputMaybe<CategoryUpsertWithoutFieldsInput>;
};

export type CategoryUpdateWithoutFieldsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CategoryUpsertWithoutFieldsInput = {
  create: CategoryUncheckedCreateWithoutFieldsInput;
  update: CategoryUncheckedUpdateWithoutFieldsInput;
};

export type CategoryWhereInput = {
  AND?: InputMaybe<Array<CategoryWhereInput>>;
  NOT?: InputMaybe<Array<CategoryWhereInput>>;
  OR?: InputMaybe<Array<CategoryWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fields?: InputMaybe<CategoryFieldsListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  reference?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CategoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ClientType = {
  __typename?: 'ClientType';
  _count: ClientTypeCountOutputType;
  categories: Array<Maybe<CategoryFields>>;
  createdAt: Scalars['DateTime'];
  fields: Array<Maybe<ClientTypeFields>>;
  id: Scalars['String'];
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type ClientTypeCategoriesArgs = {
  cursor?: InputMaybe<CategoryFieldsWhereUniqueInput>;
  distinct?: InputMaybe<CategoryFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<CategoryFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CategoryFieldsWhereInput>;
};


export type ClientTypeFieldsArgs = {
  cursor?: InputMaybe<ClientTypeFieldsWhereUniqueInput>;
  distinct?: InputMaybe<ClientTypeFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<ClientTypeFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ClientTypeFieldsWhereInput>;
};

export type ClientTypeCountAggregateOutputType = {
  __typename?: 'ClientTypeCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  pending: Scalars['Int'];
  published: Scalars['Int'];
  reference: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ClientTypeCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ClientTypeCountOutputType = {
  __typename?: 'ClientTypeCountOutputType';
  categories: Scalars['Int'];
  fields: Scalars['Int'];
};

export type ClientTypeCreateInput = {
  categories?: InputMaybe<CategoryFieldsCreateNestedManyWithoutClientTypesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<ClientTypeFieldsCreateNestedManyWithoutClientTypeInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ClientTypeCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ClientTypeCreateNestedManyWithoutCategoriesInput = {
  connect?: InputMaybe<Array<ClientTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClientTypeCreateOrConnectWithoutCategoriesInput>>;
  create?: InputMaybe<Array<ClientTypeCreateWithoutCategoriesInput>>;
};

export type ClientTypeCreateNestedOneWithoutFieldsInput = {
  connect?: InputMaybe<ClientTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ClientTypeCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<ClientTypeUncheckedCreateWithoutFieldsInput>;
};

export type ClientTypeCreateOrConnectWithoutCategoriesInput = {
  create: ClientTypeUncheckedCreateWithoutCategoriesInput;
  where: ClientTypeWhereUniqueInput;
};

export type ClientTypeCreateOrConnectWithoutFieldsInput = {
  create: ClientTypeUncheckedCreateWithoutFieldsInput;
  where: ClientTypeWhereUniqueInput;
};

export type ClientTypeCreateWithoutCategoriesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<ClientTypeFieldsCreateNestedManyWithoutClientTypeInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ClientTypeCreateWithoutFieldsInput = {
  categories?: InputMaybe<CategoryFieldsCreateNestedManyWithoutClientTypesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ClientTypeFields = {
  __typename?: 'ClientTypeFields';
  _count: ClientTypeFieldsCountOutputType;
  clientType?: Maybe<ClientType>;
  clientTypeId?: Maybe<Scalars['String']>;
  cmsId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  locations: Array<Maybe<Location>>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type ClientTypeFieldsLocationsArgs = {
  cursor?: InputMaybe<LocationWhereUniqueInput>;
  distinct?: InputMaybe<LocationScalarFieldEnum>;
  orderBy?: InputMaybe<LocationOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationWhereInput>;
};

export type ClientTypeFieldsAvgAggregateOutputType = {
  __typename?: 'ClientTypeFieldsAvgAggregateOutputType';
  order?: Maybe<Scalars['Float']>;
};

export type ClientTypeFieldsAvgOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type ClientTypeFieldsCountAggregateOutputType = {
  __typename?: 'ClientTypeFieldsCountAggregateOutputType';
  _all: Scalars['Int'];
  clientTypeId: Scalars['Int'];
  cmsId: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  order: Scalars['Int'];
  pending: Scalars['Int'];
  published: Scalars['Int'];
  stack: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ClientTypeFieldsCountOrderByAggregateInput = {
  clientTypeId?: InputMaybe<SortOrder>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ClientTypeFieldsCountOutputType = {
  __typename?: 'ClientTypeFieldsCountOutputType';
  locations: Scalars['Int'];
};

export type ClientTypeFieldsCreateInput = {
  clientType?: InputMaybe<ClientTypeCreateNestedOneWithoutFieldsInput>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutClientTypesInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ClientTypeFieldsCreateManyClientTypeInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ClientTypeFieldsCreateManyClientTypeInputEnvelope = {
  data: Array<ClientTypeFieldsCreateManyClientTypeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ClientTypeFieldsCreateManyInput = {
  clientTypeId?: InputMaybe<Scalars['String']>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ClientTypeFieldsCreateNestedManyWithoutClientTypeInput = {
  connect?: InputMaybe<Array<ClientTypeFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClientTypeFieldsCreateOrConnectWithoutClientTypeInput>>;
  create?: InputMaybe<Array<ClientTypeFieldsCreateWithoutClientTypeInput>>;
  createMany?: InputMaybe<ClientTypeFieldsCreateManyClientTypeInputEnvelope>;
};

export type ClientTypeFieldsCreateNestedManyWithoutLocationsInput = {
  connect?: InputMaybe<Array<ClientTypeFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClientTypeFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<ClientTypeFieldsCreateWithoutLocationsInput>>;
};

export type ClientTypeFieldsCreateOrConnectWithoutClientTypeInput = {
  create: ClientTypeFieldsUncheckedCreateWithoutClientTypeInput;
  where: ClientTypeFieldsWhereUniqueInput;
};

export type ClientTypeFieldsCreateOrConnectWithoutLocationsInput = {
  create: ClientTypeFieldsUncheckedCreateWithoutLocationsInput;
  where: ClientTypeFieldsWhereUniqueInput;
};

export type ClientTypeFieldsCreateWithoutClientTypeInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutClientTypesInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ClientTypeFieldsCreateWithoutLocationsInput = {
  clientType?: InputMaybe<ClientTypeCreateNestedOneWithoutFieldsInput>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ClientTypeFieldsListRelationFilter = {
  every?: InputMaybe<ClientTypeFieldsWhereInput>;
  none?: InputMaybe<ClientTypeFieldsWhereInput>;
  some?: InputMaybe<ClientTypeFieldsWhereInput>;
};

export type ClientTypeFieldsMaxAggregateOutputType = {
  __typename?: 'ClientTypeFieldsMaxAggregateOutputType';
  clientTypeId?: Maybe<Scalars['String']>;
  cmsId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  stack?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClientTypeFieldsMaxOrderByAggregateInput = {
  clientTypeId?: InputMaybe<SortOrder>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ClientTypeFieldsMinAggregateOutputType = {
  __typename?: 'ClientTypeFieldsMinAggregateOutputType';
  clientTypeId?: Maybe<Scalars['String']>;
  cmsId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  stack?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClientTypeFieldsMinOrderByAggregateInput = {
  clientTypeId?: InputMaybe<SortOrder>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ClientTypeFieldsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ClientTypeFieldsOrderByWithAggregationInput = {
  _avg?: InputMaybe<ClientTypeFieldsAvgOrderByAggregateInput>;
  _count?: InputMaybe<ClientTypeFieldsCountOrderByAggregateInput>;
  _max?: InputMaybe<ClientTypeFieldsMaxOrderByAggregateInput>;
  _min?: InputMaybe<ClientTypeFieldsMinOrderByAggregateInput>;
  _sum?: InputMaybe<ClientTypeFieldsSumOrderByAggregateInput>;
  clientTypeId?: InputMaybe<SortOrderInput>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrderInput>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ClientTypeFieldsOrderByWithRelationInput = {
  clientType?: InputMaybe<ClientTypeOrderByWithRelationInput>;
  clientTypeId?: InputMaybe<SortOrderInput>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  locations?: InputMaybe<LocationOrderByRelationAggregateInput>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrderInput>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ClientTypeFieldsScalarFieldEnum {
  ClientTypeId = 'clientTypeId',
  CmsId = 'cmsId',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Name = 'name',
  Order = 'order',
  Pending = 'pending',
  Published = 'published',
  Stack = 'stack',
  UpdatedAt = 'updatedAt'
}

export type ClientTypeFieldsScalarWhereInput = {
  AND?: InputMaybe<Array<ClientTypeFieldsScalarWhereInput>>;
  NOT?: InputMaybe<Array<ClientTypeFieldsScalarWhereInput>>;
  OR?: InputMaybe<Array<ClientTypeFieldsScalarWhereInput>>;
  clientTypeId?: InputMaybe<StringNullableFilter>;
  cmsId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  stack?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ClientTypeFieldsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ClientTypeFieldsScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ClientTypeFieldsScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ClientTypeFieldsScalarWhereWithAggregatesInput>>;
  clientTypeId?: InputMaybe<StringNullableWithAggregatesFilter>;
  cmsId?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  order?: InputMaybe<IntNullableWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  stack?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ClientTypeFieldsSumAggregateOutputType = {
  __typename?: 'ClientTypeFieldsSumAggregateOutputType';
  order?: Maybe<Scalars['Int']>;
};

export type ClientTypeFieldsSumOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type ClientTypeFieldsUncheckedCreateInput = {
  clientTypeId?: InputMaybe<Scalars['String']>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationUncheckedCreateNestedManyWithoutClientTypesInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ClientTypeFieldsUncheckedCreateNestedManyWithoutClientTypeInput = {
  connect?: InputMaybe<Array<ClientTypeFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClientTypeFieldsCreateOrConnectWithoutClientTypeInput>>;
  create?: InputMaybe<Array<ClientTypeFieldsCreateWithoutClientTypeInput>>;
  createMany?: InputMaybe<ClientTypeFieldsCreateManyClientTypeInputEnvelope>;
};

export type ClientTypeFieldsUncheckedCreateNestedManyWithoutLocationsInput = {
  connect?: InputMaybe<Array<ClientTypeFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClientTypeFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<ClientTypeFieldsCreateWithoutLocationsInput>>;
};

export type ClientTypeFieldsUncheckedCreateWithoutClientTypeInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationUncheckedCreateNestedManyWithoutClientTypesInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ClientTypeFieldsUncheckedCreateWithoutLocationsInput = {
  clientTypeId?: InputMaybe<Scalars['String']>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ClientTypeFieldsUncheckedUpdateInput = {
  clientTypeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUncheckedUpdateManyWithoutClientTypesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientTypeFieldsUncheckedUpdateManyInput = {
  clientTypeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientTypeFieldsUncheckedUpdateManyWithoutClientTypeNestedInput = {
  connect?: InputMaybe<Array<ClientTypeFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClientTypeFieldsCreateOrConnectWithoutClientTypeInput>>;
  create?: InputMaybe<Array<ClientTypeFieldsCreateWithoutClientTypeInput>>;
  createMany?: InputMaybe<ClientTypeFieldsCreateManyClientTypeInputEnvelope>;
  delete?: InputMaybe<Array<ClientTypeFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ClientTypeFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ClientTypeFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<ClientTypeFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<ClientTypeFieldsUpdateWithWhereUniqueWithoutClientTypeInput>>;
  updateMany?: InputMaybe<Array<ClientTypeFieldsUpdateManyWithWhereWithoutClientTypeInput>>;
  upsert?: InputMaybe<Array<ClientTypeFieldsUpsertWithWhereUniqueWithoutClientTypeInput>>;
};

export type ClientTypeFieldsUncheckedUpdateManyWithoutClientTypesInput = {
  clientTypeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientTypeFieldsUncheckedUpdateManyWithoutFieldsInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientTypeFieldsUncheckedUpdateManyWithoutLocationsNestedInput = {
  connect?: InputMaybe<Array<ClientTypeFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClientTypeFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<ClientTypeFieldsCreateWithoutLocationsInput>>;
  delete?: InputMaybe<Array<ClientTypeFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ClientTypeFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ClientTypeFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<ClientTypeFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<ClientTypeFieldsUpdateWithWhereUniqueWithoutLocationsInput>>;
  updateMany?: InputMaybe<Array<ClientTypeFieldsUpdateManyWithWhereWithoutLocationsInput>>;
  upsert?: InputMaybe<Array<ClientTypeFieldsUpsertWithWhereUniqueWithoutLocationsInput>>;
};

export type ClientTypeFieldsUncheckedUpdateWithoutClientTypeInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUncheckedUpdateManyWithoutClientTypesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientTypeFieldsUncheckedUpdateWithoutLocationsInput = {
  clientTypeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientTypeFieldsUpdateInput = {
  clientType?: InputMaybe<ClientTypeUpdateOneWithoutFieldsNestedInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutClientTypesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientTypeFieldsUpdateManyMutationInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientTypeFieldsUpdateManyWithWhereWithoutClientTypeInput = {
  data: ClientTypeFieldsUncheckedUpdateManyWithoutFieldsInput;
  where: ClientTypeFieldsScalarWhereInput;
};

export type ClientTypeFieldsUpdateManyWithWhereWithoutLocationsInput = {
  data: ClientTypeFieldsUncheckedUpdateManyWithoutClientTypesInput;
  where: ClientTypeFieldsScalarWhereInput;
};

export type ClientTypeFieldsUpdateManyWithoutClientTypeNestedInput = {
  connect?: InputMaybe<Array<ClientTypeFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClientTypeFieldsCreateOrConnectWithoutClientTypeInput>>;
  create?: InputMaybe<Array<ClientTypeFieldsCreateWithoutClientTypeInput>>;
  createMany?: InputMaybe<ClientTypeFieldsCreateManyClientTypeInputEnvelope>;
  delete?: InputMaybe<Array<ClientTypeFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ClientTypeFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ClientTypeFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<ClientTypeFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<ClientTypeFieldsUpdateWithWhereUniqueWithoutClientTypeInput>>;
  updateMany?: InputMaybe<Array<ClientTypeFieldsUpdateManyWithWhereWithoutClientTypeInput>>;
  upsert?: InputMaybe<Array<ClientTypeFieldsUpsertWithWhereUniqueWithoutClientTypeInput>>;
};

export type ClientTypeFieldsUpdateManyWithoutLocationsNestedInput = {
  connect?: InputMaybe<Array<ClientTypeFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClientTypeFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<ClientTypeFieldsCreateWithoutLocationsInput>>;
  delete?: InputMaybe<Array<ClientTypeFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ClientTypeFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ClientTypeFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<ClientTypeFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<ClientTypeFieldsUpdateWithWhereUniqueWithoutLocationsInput>>;
  updateMany?: InputMaybe<Array<ClientTypeFieldsUpdateManyWithWhereWithoutLocationsInput>>;
  upsert?: InputMaybe<Array<ClientTypeFieldsUpsertWithWhereUniqueWithoutLocationsInput>>;
};

export type ClientTypeFieldsUpdateWithWhereUniqueWithoutClientTypeInput = {
  data: ClientTypeFieldsUncheckedUpdateWithoutClientTypeInput;
  where: ClientTypeFieldsWhereUniqueInput;
};

export type ClientTypeFieldsUpdateWithWhereUniqueWithoutLocationsInput = {
  data: ClientTypeFieldsUncheckedUpdateWithoutLocationsInput;
  where: ClientTypeFieldsWhereUniqueInput;
};

export type ClientTypeFieldsUpdateWithoutClientTypeInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutClientTypesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientTypeFieldsUpdateWithoutLocationsInput = {
  clientType?: InputMaybe<ClientTypeUpdateOneWithoutFieldsNestedInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientTypeFieldsUpsertWithWhereUniqueWithoutClientTypeInput = {
  create: ClientTypeFieldsUncheckedCreateWithoutClientTypeInput;
  update: ClientTypeFieldsUncheckedUpdateWithoutClientTypeInput;
  where: ClientTypeFieldsWhereUniqueInput;
};

export type ClientTypeFieldsUpsertWithWhereUniqueWithoutLocationsInput = {
  create: ClientTypeFieldsUncheckedCreateWithoutLocationsInput;
  update: ClientTypeFieldsUncheckedUpdateWithoutLocationsInput;
  where: ClientTypeFieldsWhereUniqueInput;
};

export type ClientTypeFieldsWhereInput = {
  AND?: InputMaybe<Array<ClientTypeFieldsWhereInput>>;
  NOT?: InputMaybe<Array<ClientTypeFieldsWhereInput>>;
  OR?: InputMaybe<Array<ClientTypeFieldsWhereInput>>;
  clientType?: InputMaybe<ClientTypeWhereInput>;
  clientTypeId?: InputMaybe<StringNullableFilter>;
  cmsId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  locations?: InputMaybe<LocationListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  stack?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ClientTypeFieldsWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ClientTypeListRelationFilter = {
  every?: InputMaybe<ClientTypeWhereInput>;
  none?: InputMaybe<ClientTypeWhereInput>;
  some?: InputMaybe<ClientTypeWhereInput>;
};

export type ClientTypeMaxAggregateOutputType = {
  __typename?: 'ClientTypeMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClientTypeMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ClientTypeMinAggregateOutputType = {
  __typename?: 'ClientTypeMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClientTypeMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ClientTypeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ClientTypeOrderByWithAggregationInput = {
  _count?: InputMaybe<ClientTypeCountOrderByAggregateInput>;
  _max?: InputMaybe<ClientTypeMaxOrderByAggregateInput>;
  _min?: InputMaybe<ClientTypeMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ClientTypeOrderByWithRelationInput = {
  categories?: InputMaybe<CategoryFieldsOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  fields?: InputMaybe<ClientTypeFieldsOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ClientTypeRelationFilter = {
  is?: InputMaybe<ClientTypeWhereInput>;
  isNot?: InputMaybe<ClientTypeWhereInput>;
};

export enum ClientTypeScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Pending = 'pending',
  Published = 'published',
  Reference = 'reference',
  UpdatedAt = 'updatedAt'
}

export type ClientTypeScalarWhereInput = {
  AND?: InputMaybe<Array<ClientTypeScalarWhereInput>>;
  NOT?: InputMaybe<Array<ClientTypeScalarWhereInput>>;
  OR?: InputMaybe<Array<ClientTypeScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  reference?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ClientTypeScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ClientTypeScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ClientTypeScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ClientTypeScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  reference?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ClientTypeUncheckedCreateInput = {
  categories?: InputMaybe<CategoryFieldsUncheckedCreateNestedManyWithoutClientTypesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<ClientTypeFieldsUncheckedCreateNestedManyWithoutClientTypeInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ClientTypeUncheckedCreateNestedManyWithoutCategoriesInput = {
  connect?: InputMaybe<Array<ClientTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClientTypeCreateOrConnectWithoutCategoriesInput>>;
  create?: InputMaybe<Array<ClientTypeCreateWithoutCategoriesInput>>;
};

export type ClientTypeUncheckedCreateWithoutCategoriesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<ClientTypeFieldsUncheckedCreateNestedManyWithoutClientTypeInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ClientTypeUncheckedCreateWithoutFieldsInput = {
  categories?: InputMaybe<CategoryFieldsUncheckedCreateNestedManyWithoutClientTypesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ClientTypeUncheckedUpdateInput = {
  categories?: InputMaybe<CategoryFieldsUncheckedUpdateManyWithoutClientTypesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<ClientTypeFieldsUncheckedUpdateManyWithoutClientTypeNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientTypeUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientTypeUncheckedUpdateManyWithoutCategoriesNestedInput = {
  connect?: InputMaybe<Array<ClientTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClientTypeCreateOrConnectWithoutCategoriesInput>>;
  create?: InputMaybe<Array<ClientTypeCreateWithoutCategoriesInput>>;
  delete?: InputMaybe<Array<ClientTypeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ClientTypeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ClientTypeWhereUniqueInput>>;
  set?: InputMaybe<Array<ClientTypeWhereUniqueInput>>;
  update?: InputMaybe<Array<ClientTypeUpdateWithWhereUniqueWithoutCategoriesInput>>;
  updateMany?: InputMaybe<Array<ClientTypeUpdateManyWithWhereWithoutCategoriesInput>>;
  upsert?: InputMaybe<Array<ClientTypeUpsertWithWhereUniqueWithoutCategoriesInput>>;
};

export type ClientTypeUncheckedUpdateManyWithoutClientTypesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientTypeUncheckedUpdateWithoutCategoriesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<ClientTypeFieldsUncheckedUpdateManyWithoutClientTypeNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientTypeUncheckedUpdateWithoutFieldsInput = {
  categories?: InputMaybe<CategoryFieldsUncheckedUpdateManyWithoutClientTypesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientTypeUpdateInput = {
  categories?: InputMaybe<CategoryFieldsUpdateManyWithoutClientTypesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<ClientTypeFieldsUpdateManyWithoutClientTypeNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientTypeUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientTypeUpdateManyWithWhereWithoutCategoriesInput = {
  data: ClientTypeUncheckedUpdateManyWithoutClientTypesInput;
  where: ClientTypeScalarWhereInput;
};

export type ClientTypeUpdateManyWithoutCategoriesNestedInput = {
  connect?: InputMaybe<Array<ClientTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClientTypeCreateOrConnectWithoutCategoriesInput>>;
  create?: InputMaybe<Array<ClientTypeCreateWithoutCategoriesInput>>;
  delete?: InputMaybe<Array<ClientTypeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ClientTypeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ClientTypeWhereUniqueInput>>;
  set?: InputMaybe<Array<ClientTypeWhereUniqueInput>>;
  update?: InputMaybe<Array<ClientTypeUpdateWithWhereUniqueWithoutCategoriesInput>>;
  updateMany?: InputMaybe<Array<ClientTypeUpdateManyWithWhereWithoutCategoriesInput>>;
  upsert?: InputMaybe<Array<ClientTypeUpsertWithWhereUniqueWithoutCategoriesInput>>;
};

export type ClientTypeUpdateOneWithoutFieldsNestedInput = {
  connect?: InputMaybe<ClientTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ClientTypeCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<ClientTypeUncheckedCreateWithoutFieldsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ClientTypeUncheckedUpdateWithoutFieldsInput>;
  upsert?: InputMaybe<ClientTypeUpsertWithoutFieldsInput>;
};

export type ClientTypeUpdateWithWhereUniqueWithoutCategoriesInput = {
  data: ClientTypeUncheckedUpdateWithoutCategoriesInput;
  where: ClientTypeWhereUniqueInput;
};

export type ClientTypeUpdateWithoutCategoriesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<ClientTypeFieldsUpdateManyWithoutClientTypeNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientTypeUpdateWithoutFieldsInput = {
  categories?: InputMaybe<CategoryFieldsUpdateManyWithoutClientTypesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ClientTypeUpsertWithWhereUniqueWithoutCategoriesInput = {
  create: ClientTypeUncheckedCreateWithoutCategoriesInput;
  update: ClientTypeUncheckedUpdateWithoutCategoriesInput;
  where: ClientTypeWhereUniqueInput;
};

export type ClientTypeUpsertWithoutFieldsInput = {
  create: ClientTypeUncheckedCreateWithoutFieldsInput;
  update: ClientTypeUncheckedUpdateWithoutFieldsInput;
};

export type ClientTypeWhereInput = {
  AND?: InputMaybe<Array<ClientTypeWhereInput>>;
  NOT?: InputMaybe<Array<ClientTypeWhereInput>>;
  OR?: InputMaybe<Array<ClientTypeWhereInput>>;
  categories?: InputMaybe<CategoryFieldsListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fields?: InputMaybe<ClientTypeFieldsListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  reference?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ClientTypeWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type Cycle = {
  __typename?: 'Cycle';
  _count: CycleCountOutputType;
  createdAt: Scalars['DateTime'];
  documents: Array<Maybe<DocumentCycle>>;
  id: Scalars['String'];
  name: Scalars['String'];
  startDate: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};


export type CycleDocumentsArgs = {
  cursor?: InputMaybe<DocumentCycleWhereUniqueInput>;
  distinct?: InputMaybe<DocumentCycleScalarFieldEnum>;
  orderBy?: InputMaybe<DocumentCycleOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DocumentCycleWhereInput>;
};

export type CycleAndDocumentsCreateInput = {
  documentCycles: Array<InputMaybe<DocumentCyclesByTaxonomyInput>>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  startDate: Scalars['DateTime'];
};

export type CycleConnection = {
  __typename?: 'CycleConnection';
  aggregate: AggregateCycle;
  edges: Array<Maybe<CycleEdge>>;
  pageInfo: PageInfo;
};

export type CycleCountAggregateOutputType = {
  __typename?: 'CycleCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  startDate: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CycleCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CycleCountOutputType = {
  __typename?: 'CycleCountOutputType';
  documents: Scalars['Int'];
};

export type CycleCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCycleCreateNestedManyWithoutCycleInput>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  startDate: Scalars['DateTime'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CycleCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  startDate: Scalars['DateTime'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CycleCreateNestedOneWithoutDocumentsInput = {
  connect?: InputMaybe<CycleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CycleCreateOrConnectWithoutDocumentsInput>;
  create?: InputMaybe<CycleUncheckedCreateWithoutDocumentsInput>;
};

export type CycleCreateOrConnectWithoutDocumentsInput = {
  create: CycleUncheckedCreateWithoutDocumentsInput;
  where: CycleWhereUniqueInput;
};

export type CycleCreateWithoutDocumentsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  startDate: Scalars['DateTime'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CycleEdge = {
  __typename?: 'CycleEdge';
  cursor: Scalars['String'];
  node: Cycle;
};

export type CycleMaxAggregateOutputType = {
  __typename?: 'CycleMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CycleMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CycleMinAggregateOutputType = {
  __typename?: 'CycleMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CycleMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CycleOrderByWithAggregationInput = {
  _count?: InputMaybe<CycleCountOrderByAggregateInput>;
  _max?: InputMaybe<CycleMaxOrderByAggregateInput>;
  _min?: InputMaybe<CycleMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CycleOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  documents?: InputMaybe<DocumentCycleOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CycleRelationFilter = {
  is?: InputMaybe<CycleWhereInput>;
  isNot?: InputMaybe<CycleWhereInput>;
};

export enum CycleScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  StartDate = 'startDate',
  UpdatedAt = 'updatedAt'
}

export type CycleScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<CycleScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<CycleScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CycleScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  startDate?: InputMaybe<DateTimeWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type CycleUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCycleUncheckedCreateNestedManyWithoutCycleInput>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  startDate: Scalars['DateTime'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CycleUncheckedCreateWithoutDocumentsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  startDate: Scalars['DateTime'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CycleUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  documents?: InputMaybe<DocumentCycleUncheckedUpdateManyWithoutCycleNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CycleUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CycleUncheckedUpdateWithoutDocumentsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CycleUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  documents?: InputMaybe<DocumentCycleUpdateManyWithoutCycleNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CycleUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CycleUpdateOneWithoutDocumentsNestedInput = {
  connect?: InputMaybe<CycleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CycleCreateOrConnectWithoutDocumentsInput>;
  create?: InputMaybe<CycleUncheckedCreateWithoutDocumentsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CycleUncheckedUpdateWithoutDocumentsInput>;
  upsert?: InputMaybe<CycleUpsertWithoutDocumentsInput>;
};

export type CycleUpdateWithoutDocumentsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CycleUpsertWithoutDocumentsInput = {
  create: CycleUncheckedCreateWithoutDocumentsInput;
  update: CycleUncheckedUpdateWithoutDocumentsInput;
};

export type CycleWhereInput = {
  AND?: InputMaybe<Array<CycleWhereInput>>;
  NOT?: InputMaybe<Array<CycleWhereInput>>;
  OR?: InputMaybe<Array<CycleWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documents?: InputMaybe<DocumentCycleListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CycleWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type DataImport = {
  __typename?: 'DataImport';
  _count: DataImportCountOutputType;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  files: Array<Maybe<DataImportFile>>;
  id: Scalars['String'];
  reference: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type DataImportFilesArgs = {
  cursor?: InputMaybe<DataImportFileWhereUniqueInput>;
  distinct?: InputMaybe<DataImportFileScalarFieldEnum>;
  orderBy?: InputMaybe<DataImportFileOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DataImportFileWhereInput>;
};

export type DataImportConnection = {
  __typename?: 'DataImportConnection';
  aggregate: AggregateDataImport;
  edges: Array<Maybe<DataImportEdge>>;
  pageInfo: PageInfo;
};

export type DataImportCountAggregateOutputType = {
  __typename?: 'DataImportCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  createdBy: Scalars['Int'];
  id: Scalars['Int'];
  reference: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type DataImportCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DataImportCountOutputType = {
  __typename?: 'DataImportCountOutputType';
  files: Scalars['Int'];
};

export type DataImportCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  files?: InputMaybe<DataImportFileCreateNestedManyWithoutDataImportInput>;
  id?: InputMaybe<Scalars['String']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DataImportCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DataImportCreateNestedOneWithoutFilesInput = {
  connect?: InputMaybe<DataImportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DataImportCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<DataImportUncheckedCreateWithoutFilesInput>;
};

export type DataImportCreateOrConnectWithoutFilesInput = {
  create: DataImportUncheckedCreateWithoutFilesInput;
  where: DataImportWhereUniqueInput;
};

export type DataImportCreateWithoutFilesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DataImportEdge = {
  __typename?: 'DataImportEdge';
  cursor: Scalars['String'];
  node: DataImport;
};

export enum DataImportEnvironment {
  Authoring = 'AUTHORING',
  Primary = 'PRIMARY',
  Unknown = 'UNKNOWN'
}

export type DataImportFile = {
  __typename?: 'DataImportFile';
  authoringPublishStatus?: Maybe<DataImportPublishStatus>;
  authoringValidationStatus?: Maybe<DataImportValidationStatus>;
  createdAt: Scalars['DateTime'];
  dataImport?: Maybe<DataImport>;
  dataImportId?: Maybe<Scalars['String']>;
  derivedJurisdiction?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileType: DataImportFileType;
  id: Scalars['String'];
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']>;
  progressSummary?: Maybe<DataImportProgressSummary>;
  progressSummaryId?: Maybe<Scalars['String']>;
  publishDate?: Maybe<Scalars['DateTime']>;
  publishStatus?: Maybe<DataImportPublishStatus>;
  updatedAt: Scalars['DateTime'];
  validation?: Maybe<DataImportValidation>;
  validationId?: Maybe<Scalars['String']>;
  validationStatus?: Maybe<DataImportValidationStatus>;
};

export type DataImportFileConnection = {
  __typename?: 'DataImportFileConnection';
  aggregate: AggregateDataImportFile;
  edges: Array<Maybe<DataImportFileEdge>>;
  pageInfo: PageInfo;
};

export type DataImportFileCountAggregateOutputType = {
  __typename?: 'DataImportFileCountAggregateOutputType';
  _all: Scalars['Int'];
  authoringPublishStatus: Scalars['Int'];
  authoringValidationStatus: Scalars['Int'];
  createdAt: Scalars['Int'];
  dataImportId: Scalars['Int'];
  derivedJurisdiction: Scalars['Int'];
  fileName: Scalars['Int'];
  fileType: Scalars['Int'];
  id: Scalars['Int'];
  locationId: Scalars['Int'];
  progressSummaryId: Scalars['Int'];
  publishDate: Scalars['Int'];
  publishStatus: Scalars['Int'];
  updatedAt: Scalars['Int'];
  validationId: Scalars['Int'];
  validationStatus: Scalars['Int'];
};

export type DataImportFileCountOrderByAggregateInput = {
  authoringPublishStatus?: InputMaybe<SortOrder>;
  authoringValidationStatus?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dataImportId?: InputMaybe<SortOrder>;
  derivedJurisdiction?: InputMaybe<SortOrder>;
  fileName?: InputMaybe<SortOrder>;
  fileType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  progressSummaryId?: InputMaybe<SortOrder>;
  publishDate?: InputMaybe<SortOrder>;
  publishStatus?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  validationId?: InputMaybe<SortOrder>;
  validationStatus?: InputMaybe<SortOrder>;
};

export type DataImportFileCreateInput = {
  authoringPublishStatus?: InputMaybe<DataImportPublishStatus>;
  authoringValidationStatus?: InputMaybe<DataImportValidationStatus>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImport?: InputMaybe<DataImportCreateNestedOneWithoutFilesInput>;
  derivedJurisdiction?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileType: DataImportFileType;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationCreateNestedOneWithoutDataImportFilesInput>;
  progressSummary?: InputMaybe<DataImportProgressSummaryCreateNestedOneWithoutDataImportFilesInput>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  publishStatus?: InputMaybe<DataImportPublishStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  validation?: InputMaybe<DataImportValidationCreateNestedOneWithoutDataImportFilesInput>;
  validationStatus?: InputMaybe<DataImportValidationStatus>;
};

export type DataImportFileCreateManyDataImportInput = {
  authoringPublishStatus?: InputMaybe<DataImportPublishStatus>;
  authoringValidationStatus?: InputMaybe<DataImportValidationStatus>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  derivedJurisdiction?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileType: DataImportFileType;
  id?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  progressSummaryId?: InputMaybe<Scalars['String']>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  publishStatus?: InputMaybe<DataImportPublishStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  validationId?: InputMaybe<Scalars['String']>;
  validationStatus?: InputMaybe<DataImportValidationStatus>;
};

export type DataImportFileCreateManyDataImportInputEnvelope = {
  data: Array<DataImportFileCreateManyDataImportInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DataImportFileCreateManyInput = {
  authoringPublishStatus?: InputMaybe<DataImportPublishStatus>;
  authoringValidationStatus?: InputMaybe<DataImportValidationStatus>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportId?: InputMaybe<Scalars['String']>;
  derivedJurisdiction?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileType: DataImportFileType;
  id?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  progressSummaryId?: InputMaybe<Scalars['String']>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  publishStatus?: InputMaybe<DataImportPublishStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  validationId?: InputMaybe<Scalars['String']>;
  validationStatus?: InputMaybe<DataImportValidationStatus>;
};

export type DataImportFileCreateManyLocationInput = {
  authoringPublishStatus?: InputMaybe<DataImportPublishStatus>;
  authoringValidationStatus?: InputMaybe<DataImportValidationStatus>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportId?: InputMaybe<Scalars['String']>;
  derivedJurisdiction?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileType: DataImportFileType;
  id?: InputMaybe<Scalars['String']>;
  progressSummaryId?: InputMaybe<Scalars['String']>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  publishStatus?: InputMaybe<DataImportPublishStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  validationId?: InputMaybe<Scalars['String']>;
  validationStatus?: InputMaybe<DataImportValidationStatus>;
};

export type DataImportFileCreateManyLocationInputEnvelope = {
  data: Array<DataImportFileCreateManyLocationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DataImportFileCreateManyProgressSummaryInput = {
  authoringPublishStatus?: InputMaybe<DataImportPublishStatus>;
  authoringValidationStatus?: InputMaybe<DataImportValidationStatus>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportId?: InputMaybe<Scalars['String']>;
  derivedJurisdiction?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileType: DataImportFileType;
  id?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  publishStatus?: InputMaybe<DataImportPublishStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  validationId?: InputMaybe<Scalars['String']>;
  validationStatus?: InputMaybe<DataImportValidationStatus>;
};

export type DataImportFileCreateManyProgressSummaryInputEnvelope = {
  data: Array<DataImportFileCreateManyProgressSummaryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DataImportFileCreateManyValidationInput = {
  authoringPublishStatus?: InputMaybe<DataImportPublishStatus>;
  authoringValidationStatus?: InputMaybe<DataImportValidationStatus>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportId?: InputMaybe<Scalars['String']>;
  derivedJurisdiction?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileType: DataImportFileType;
  id?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  progressSummaryId?: InputMaybe<Scalars['String']>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  publishStatus?: InputMaybe<DataImportPublishStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  validationStatus?: InputMaybe<DataImportValidationStatus>;
};

export type DataImportFileCreateManyValidationInputEnvelope = {
  data: Array<DataImportFileCreateManyValidationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DataImportFileCreateNestedManyWithoutDataImportInput = {
  connect?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataImportFileCreateOrConnectWithoutDataImportInput>>;
  create?: InputMaybe<Array<DataImportFileCreateWithoutDataImportInput>>;
  createMany?: InputMaybe<DataImportFileCreateManyDataImportInputEnvelope>;
};

export type DataImportFileCreateNestedManyWithoutLocationInput = {
  connect?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataImportFileCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<DataImportFileCreateWithoutLocationInput>>;
  createMany?: InputMaybe<DataImportFileCreateManyLocationInputEnvelope>;
};

export type DataImportFileCreateNestedManyWithoutProgressSummaryInput = {
  connect?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataImportFileCreateOrConnectWithoutProgressSummaryInput>>;
  create?: InputMaybe<Array<DataImportFileCreateWithoutProgressSummaryInput>>;
  createMany?: InputMaybe<DataImportFileCreateManyProgressSummaryInputEnvelope>;
};

export type DataImportFileCreateNestedManyWithoutValidationInput = {
  connect?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataImportFileCreateOrConnectWithoutValidationInput>>;
  create?: InputMaybe<Array<DataImportFileCreateWithoutValidationInput>>;
  createMany?: InputMaybe<DataImportFileCreateManyValidationInputEnvelope>;
};

export type DataImportFileCreateOrConnectWithoutDataImportInput = {
  create: DataImportFileUncheckedCreateWithoutDataImportInput;
  where: DataImportFileWhereUniqueInput;
};

export type DataImportFileCreateOrConnectWithoutLocationInput = {
  create: DataImportFileUncheckedCreateWithoutLocationInput;
  where: DataImportFileWhereUniqueInput;
};

export type DataImportFileCreateOrConnectWithoutProgressSummaryInput = {
  create: DataImportFileUncheckedCreateWithoutProgressSummaryInput;
  where: DataImportFileWhereUniqueInput;
};

export type DataImportFileCreateOrConnectWithoutValidationInput = {
  create: DataImportFileUncheckedCreateWithoutValidationInput;
  where: DataImportFileWhereUniqueInput;
};

export type DataImportFileCreateWithoutDataImportInput = {
  authoringPublishStatus?: InputMaybe<DataImportPublishStatus>;
  authoringValidationStatus?: InputMaybe<DataImportValidationStatus>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  derivedJurisdiction?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileType: DataImportFileType;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationCreateNestedOneWithoutDataImportFilesInput>;
  progressSummary?: InputMaybe<DataImportProgressSummaryCreateNestedOneWithoutDataImportFilesInput>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  publishStatus?: InputMaybe<DataImportPublishStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  validation?: InputMaybe<DataImportValidationCreateNestedOneWithoutDataImportFilesInput>;
  validationStatus?: InputMaybe<DataImportValidationStatus>;
};

export type DataImportFileCreateWithoutLocationInput = {
  authoringPublishStatus?: InputMaybe<DataImportPublishStatus>;
  authoringValidationStatus?: InputMaybe<DataImportValidationStatus>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImport?: InputMaybe<DataImportCreateNestedOneWithoutFilesInput>;
  derivedJurisdiction?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileType: DataImportFileType;
  id?: InputMaybe<Scalars['String']>;
  progressSummary?: InputMaybe<DataImportProgressSummaryCreateNestedOneWithoutDataImportFilesInput>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  publishStatus?: InputMaybe<DataImportPublishStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  validation?: InputMaybe<DataImportValidationCreateNestedOneWithoutDataImportFilesInput>;
  validationStatus?: InputMaybe<DataImportValidationStatus>;
};

export type DataImportFileCreateWithoutProgressSummaryInput = {
  authoringPublishStatus?: InputMaybe<DataImportPublishStatus>;
  authoringValidationStatus?: InputMaybe<DataImportValidationStatus>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImport?: InputMaybe<DataImportCreateNestedOneWithoutFilesInput>;
  derivedJurisdiction?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileType: DataImportFileType;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationCreateNestedOneWithoutDataImportFilesInput>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  publishStatus?: InputMaybe<DataImportPublishStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  validation?: InputMaybe<DataImportValidationCreateNestedOneWithoutDataImportFilesInput>;
  validationStatus?: InputMaybe<DataImportValidationStatus>;
};

export type DataImportFileCreateWithoutValidationInput = {
  authoringPublishStatus?: InputMaybe<DataImportPublishStatus>;
  authoringValidationStatus?: InputMaybe<DataImportValidationStatus>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImport?: InputMaybe<DataImportCreateNestedOneWithoutFilesInput>;
  derivedJurisdiction?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileType: DataImportFileType;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationCreateNestedOneWithoutDataImportFilesInput>;
  progressSummary?: InputMaybe<DataImportProgressSummaryCreateNestedOneWithoutDataImportFilesInput>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  publishStatus?: InputMaybe<DataImportPublishStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  validationStatus?: InputMaybe<DataImportValidationStatus>;
};

export type DataImportFileEdge = {
  __typename?: 'DataImportFileEdge';
  cursor: Scalars['String'];
  node: DataImportFile;
};

export type DataImportFileListRelationFilter = {
  every?: InputMaybe<DataImportFileWhereInput>;
  none?: InputMaybe<DataImportFileWhereInput>;
  some?: InputMaybe<DataImportFileWhereInput>;
};

export type DataImportFileMaxAggregateOutputType = {
  __typename?: 'DataImportFileMaxAggregateOutputType';
  authoringPublishStatus?: Maybe<DataImportPublishStatus>;
  authoringValidationStatus?: Maybe<DataImportValidationStatus>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataImportId?: Maybe<Scalars['String']>;
  derivedJurisdiction?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<DataImportFileType>;
  id?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  progressSummaryId?: Maybe<Scalars['String']>;
  publishDate?: Maybe<Scalars['DateTime']>;
  publishStatus?: Maybe<DataImportPublishStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validationId?: Maybe<Scalars['String']>;
  validationStatus?: Maybe<DataImportValidationStatus>;
};

export type DataImportFileMaxOrderByAggregateInput = {
  authoringPublishStatus?: InputMaybe<SortOrder>;
  authoringValidationStatus?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dataImportId?: InputMaybe<SortOrder>;
  derivedJurisdiction?: InputMaybe<SortOrder>;
  fileName?: InputMaybe<SortOrder>;
  fileType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  progressSummaryId?: InputMaybe<SortOrder>;
  publishDate?: InputMaybe<SortOrder>;
  publishStatus?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  validationId?: InputMaybe<SortOrder>;
  validationStatus?: InputMaybe<SortOrder>;
};

export type DataImportFileMinAggregateOutputType = {
  __typename?: 'DataImportFileMinAggregateOutputType';
  authoringPublishStatus?: Maybe<DataImportPublishStatus>;
  authoringValidationStatus?: Maybe<DataImportValidationStatus>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataImportId?: Maybe<Scalars['String']>;
  derivedJurisdiction?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<DataImportFileType>;
  id?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  progressSummaryId?: Maybe<Scalars['String']>;
  publishDate?: Maybe<Scalars['DateTime']>;
  publishStatus?: Maybe<DataImportPublishStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validationId?: Maybe<Scalars['String']>;
  validationStatus?: Maybe<DataImportValidationStatus>;
};

export type DataImportFileMinOrderByAggregateInput = {
  authoringPublishStatus?: InputMaybe<SortOrder>;
  authoringValidationStatus?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dataImportId?: InputMaybe<SortOrder>;
  derivedJurisdiction?: InputMaybe<SortOrder>;
  fileName?: InputMaybe<SortOrder>;
  fileType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  progressSummaryId?: InputMaybe<SortOrder>;
  publishDate?: InputMaybe<SortOrder>;
  publishStatus?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  validationId?: InputMaybe<SortOrder>;
  validationStatus?: InputMaybe<SortOrder>;
};

export type DataImportFileOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DataImportFileOrderByWithAggregationInput = {
  _count?: InputMaybe<DataImportFileCountOrderByAggregateInput>;
  _max?: InputMaybe<DataImportFileMaxOrderByAggregateInput>;
  _min?: InputMaybe<DataImportFileMinOrderByAggregateInput>;
  authoringPublishStatus?: InputMaybe<SortOrderInput>;
  authoringValidationStatus?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  dataImportId?: InputMaybe<SortOrderInput>;
  derivedJurisdiction?: InputMaybe<SortOrderInput>;
  fileName?: InputMaybe<SortOrder>;
  fileType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrderInput>;
  progressSummaryId?: InputMaybe<SortOrderInput>;
  publishDate?: InputMaybe<SortOrderInput>;
  publishStatus?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  validationId?: InputMaybe<SortOrderInput>;
  validationStatus?: InputMaybe<SortOrderInput>;
};

export type DataImportFileOrderByWithRelationInput = {
  authoringPublishStatus?: InputMaybe<SortOrderInput>;
  authoringValidationStatus?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  dataImport?: InputMaybe<DataImportOrderByWithRelationInput>;
  dataImportId?: InputMaybe<SortOrderInput>;
  derivedJurisdiction?: InputMaybe<SortOrderInput>;
  fileName?: InputMaybe<SortOrder>;
  fileType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  location?: InputMaybe<LocationOrderByWithRelationInput>;
  locationId?: InputMaybe<SortOrderInput>;
  progressSummary?: InputMaybe<DataImportProgressSummaryOrderByWithRelationInput>;
  progressSummaryId?: InputMaybe<SortOrderInput>;
  publishDate?: InputMaybe<SortOrderInput>;
  publishStatus?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  validation?: InputMaybe<DataImportValidationOrderByWithRelationInput>;
  validationId?: InputMaybe<SortOrderInput>;
  validationStatus?: InputMaybe<SortOrderInput>;
};

export enum DataImportFileScalarFieldEnum {
  AuthoringPublishStatus = 'authoringPublishStatus',
  AuthoringValidationStatus = 'authoringValidationStatus',
  CreatedAt = 'createdAt',
  DataImportId = 'dataImportId',
  DerivedJurisdiction = 'derivedJurisdiction',
  FileName = 'fileName',
  FileType = 'fileType',
  Id = 'id',
  LocationId = 'locationId',
  ProgressSummaryId = 'progressSummaryId',
  PublishDate = 'publishDate',
  PublishStatus = 'publishStatus',
  UpdatedAt = 'updatedAt',
  ValidationId = 'validationId',
  ValidationStatus = 'validationStatus'
}

export type DataImportFileScalarWhereInput = {
  AND?: InputMaybe<Array<DataImportFileScalarWhereInput>>;
  NOT?: InputMaybe<Array<DataImportFileScalarWhereInput>>;
  OR?: InputMaybe<Array<DataImportFileScalarWhereInput>>;
  authoringPublishStatus?: InputMaybe<EnumDataImportPublishStatusNullableFilter>;
  authoringValidationStatus?: InputMaybe<EnumDataImportValidationStatusNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dataImportId?: InputMaybe<StringNullableFilter>;
  derivedJurisdiction?: InputMaybe<StringNullableFilter>;
  fileName?: InputMaybe<StringFilter>;
  fileType?: InputMaybe<EnumDataImportFileTypeFilter>;
  id?: InputMaybe<StringFilter>;
  locationId?: InputMaybe<StringNullableFilter>;
  progressSummaryId?: InputMaybe<StringNullableFilter>;
  publishDate?: InputMaybe<DateTimeNullableFilter>;
  publishStatus?: InputMaybe<EnumDataImportPublishStatusNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  validationId?: InputMaybe<StringNullableFilter>;
  validationStatus?: InputMaybe<EnumDataImportValidationStatusNullableFilter>;
};

export type DataImportFileScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DataImportFileScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DataImportFileScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DataImportFileScalarWhereWithAggregatesInput>>;
  authoringPublishStatus?: InputMaybe<EnumDataImportPublishStatusNullableWithAggregatesFilter>;
  authoringValidationStatus?: InputMaybe<EnumDataImportValidationStatusNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  dataImportId?: InputMaybe<StringNullableWithAggregatesFilter>;
  derivedJurisdiction?: InputMaybe<StringNullableWithAggregatesFilter>;
  fileName?: InputMaybe<StringWithAggregatesFilter>;
  fileType?: InputMaybe<EnumDataImportFileTypeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  locationId?: InputMaybe<StringNullableWithAggregatesFilter>;
  progressSummaryId?: InputMaybe<StringNullableWithAggregatesFilter>;
  publishDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  publishStatus?: InputMaybe<EnumDataImportPublishStatusNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  validationId?: InputMaybe<StringNullableWithAggregatesFilter>;
  validationStatus?: InputMaybe<EnumDataImportValidationStatusNullableWithAggregatesFilter>;
};

export enum DataImportFileType {
  Definitions = 'DEFINITIONS',
  Legends = 'LEGENDS',
  Responses = 'RESPONSES',
  Status = 'STATUS',
  Unknown = 'UNKNOWN'
}

export type DataImportFileUncheckedCreateInput = {
  authoringPublishStatus?: InputMaybe<DataImportPublishStatus>;
  authoringValidationStatus?: InputMaybe<DataImportValidationStatus>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportId?: InputMaybe<Scalars['String']>;
  derivedJurisdiction?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileType: DataImportFileType;
  id?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  progressSummaryId?: InputMaybe<Scalars['String']>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  publishStatus?: InputMaybe<DataImportPublishStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  validationId?: InputMaybe<Scalars['String']>;
  validationStatus?: InputMaybe<DataImportValidationStatus>;
};

export type DataImportFileUncheckedCreateNestedManyWithoutDataImportInput = {
  connect?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataImportFileCreateOrConnectWithoutDataImportInput>>;
  create?: InputMaybe<Array<DataImportFileCreateWithoutDataImportInput>>;
  createMany?: InputMaybe<DataImportFileCreateManyDataImportInputEnvelope>;
};

export type DataImportFileUncheckedCreateNestedManyWithoutLocationInput = {
  connect?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataImportFileCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<DataImportFileCreateWithoutLocationInput>>;
  createMany?: InputMaybe<DataImportFileCreateManyLocationInputEnvelope>;
};

export type DataImportFileUncheckedCreateNestedManyWithoutProgressSummaryInput = {
  connect?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataImportFileCreateOrConnectWithoutProgressSummaryInput>>;
  create?: InputMaybe<Array<DataImportFileCreateWithoutProgressSummaryInput>>;
  createMany?: InputMaybe<DataImportFileCreateManyProgressSummaryInputEnvelope>;
};

export type DataImportFileUncheckedCreateNestedManyWithoutValidationInput = {
  connect?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataImportFileCreateOrConnectWithoutValidationInput>>;
  create?: InputMaybe<Array<DataImportFileCreateWithoutValidationInput>>;
  createMany?: InputMaybe<DataImportFileCreateManyValidationInputEnvelope>;
};

export type DataImportFileUncheckedCreateWithoutDataImportInput = {
  authoringPublishStatus?: InputMaybe<DataImportPublishStatus>;
  authoringValidationStatus?: InputMaybe<DataImportValidationStatus>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  derivedJurisdiction?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileType: DataImportFileType;
  id?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  progressSummaryId?: InputMaybe<Scalars['String']>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  publishStatus?: InputMaybe<DataImportPublishStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  validationId?: InputMaybe<Scalars['String']>;
  validationStatus?: InputMaybe<DataImportValidationStatus>;
};

export type DataImportFileUncheckedCreateWithoutLocationInput = {
  authoringPublishStatus?: InputMaybe<DataImportPublishStatus>;
  authoringValidationStatus?: InputMaybe<DataImportValidationStatus>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportId?: InputMaybe<Scalars['String']>;
  derivedJurisdiction?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileType: DataImportFileType;
  id?: InputMaybe<Scalars['String']>;
  progressSummaryId?: InputMaybe<Scalars['String']>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  publishStatus?: InputMaybe<DataImportPublishStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  validationId?: InputMaybe<Scalars['String']>;
  validationStatus?: InputMaybe<DataImportValidationStatus>;
};

export type DataImportFileUncheckedCreateWithoutProgressSummaryInput = {
  authoringPublishStatus?: InputMaybe<DataImportPublishStatus>;
  authoringValidationStatus?: InputMaybe<DataImportValidationStatus>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportId?: InputMaybe<Scalars['String']>;
  derivedJurisdiction?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileType: DataImportFileType;
  id?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  publishStatus?: InputMaybe<DataImportPublishStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  validationId?: InputMaybe<Scalars['String']>;
  validationStatus?: InputMaybe<DataImportValidationStatus>;
};

export type DataImportFileUncheckedCreateWithoutValidationInput = {
  authoringPublishStatus?: InputMaybe<DataImportPublishStatus>;
  authoringValidationStatus?: InputMaybe<DataImportValidationStatus>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportId?: InputMaybe<Scalars['String']>;
  derivedJurisdiction?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileType: DataImportFileType;
  id?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  progressSummaryId?: InputMaybe<Scalars['String']>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  publishStatus?: InputMaybe<DataImportPublishStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  validationStatus?: InputMaybe<DataImportValidationStatus>;
};

export type DataImportFileUncheckedUpdateInput = {
  authoringPublishStatus?: InputMaybe<NullableEnumDataImportPublishStatusFieldUpdateOperationsInput>;
  authoringValidationStatus?: InputMaybe<NullableEnumDataImportValidationStatusFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  derivedJurisdiction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileType?: InputMaybe<EnumDataImportFileTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  progressSummaryId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  publishStatus?: InputMaybe<NullableEnumDataImportPublishStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  validationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  validationStatus?: InputMaybe<NullableEnumDataImportValidationStatusFieldUpdateOperationsInput>;
};

export type DataImportFileUncheckedUpdateManyInput = {
  authoringPublishStatus?: InputMaybe<NullableEnumDataImportPublishStatusFieldUpdateOperationsInput>;
  authoringValidationStatus?: InputMaybe<NullableEnumDataImportValidationStatusFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  derivedJurisdiction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileType?: InputMaybe<EnumDataImportFileTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  progressSummaryId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  publishStatus?: InputMaybe<NullableEnumDataImportPublishStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  validationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  validationStatus?: InputMaybe<NullableEnumDataImportValidationStatusFieldUpdateOperationsInput>;
};

export type DataImportFileUncheckedUpdateManyWithoutDataImportFilesInput = {
  authoringPublishStatus?: InputMaybe<NullableEnumDataImportPublishStatusFieldUpdateOperationsInput>;
  authoringValidationStatus?: InputMaybe<NullableEnumDataImportValidationStatusFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  derivedJurisdiction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileType?: InputMaybe<EnumDataImportFileTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  progressSummaryId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  publishStatus?: InputMaybe<NullableEnumDataImportPublishStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  validationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  validationStatus?: InputMaybe<NullableEnumDataImportValidationStatusFieldUpdateOperationsInput>;
};

export type DataImportFileUncheckedUpdateManyWithoutDataImportNestedInput = {
  connect?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataImportFileCreateOrConnectWithoutDataImportInput>>;
  create?: InputMaybe<Array<DataImportFileCreateWithoutDataImportInput>>;
  createMany?: InputMaybe<DataImportFileCreateManyDataImportInputEnvelope>;
  delete?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DataImportFileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  set?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  update?: InputMaybe<Array<DataImportFileUpdateWithWhereUniqueWithoutDataImportInput>>;
  updateMany?: InputMaybe<Array<DataImportFileUpdateManyWithWhereWithoutDataImportInput>>;
  upsert?: InputMaybe<Array<DataImportFileUpsertWithWhereUniqueWithoutDataImportInput>>;
};

export type DataImportFileUncheckedUpdateManyWithoutFilesInput = {
  authoringPublishStatus?: InputMaybe<NullableEnumDataImportPublishStatusFieldUpdateOperationsInput>;
  authoringValidationStatus?: InputMaybe<NullableEnumDataImportValidationStatusFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  derivedJurisdiction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileType?: InputMaybe<EnumDataImportFileTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  progressSummaryId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  publishStatus?: InputMaybe<NullableEnumDataImportPublishStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  validationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  validationStatus?: InputMaybe<NullableEnumDataImportValidationStatusFieldUpdateOperationsInput>;
};

export type DataImportFileUncheckedUpdateManyWithoutLocationNestedInput = {
  connect?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataImportFileCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<DataImportFileCreateWithoutLocationInput>>;
  createMany?: InputMaybe<DataImportFileCreateManyLocationInputEnvelope>;
  delete?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DataImportFileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  set?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  update?: InputMaybe<Array<DataImportFileUpdateWithWhereUniqueWithoutLocationInput>>;
  updateMany?: InputMaybe<Array<DataImportFileUpdateManyWithWhereWithoutLocationInput>>;
  upsert?: InputMaybe<Array<DataImportFileUpsertWithWhereUniqueWithoutLocationInput>>;
};

export type DataImportFileUncheckedUpdateManyWithoutProgressSummaryNestedInput = {
  connect?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataImportFileCreateOrConnectWithoutProgressSummaryInput>>;
  create?: InputMaybe<Array<DataImportFileCreateWithoutProgressSummaryInput>>;
  createMany?: InputMaybe<DataImportFileCreateManyProgressSummaryInputEnvelope>;
  delete?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DataImportFileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  set?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  update?: InputMaybe<Array<DataImportFileUpdateWithWhereUniqueWithoutProgressSummaryInput>>;
  updateMany?: InputMaybe<Array<DataImportFileUpdateManyWithWhereWithoutProgressSummaryInput>>;
  upsert?: InputMaybe<Array<DataImportFileUpsertWithWhereUniqueWithoutProgressSummaryInput>>;
};

export type DataImportFileUncheckedUpdateManyWithoutValidationNestedInput = {
  connect?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataImportFileCreateOrConnectWithoutValidationInput>>;
  create?: InputMaybe<Array<DataImportFileCreateWithoutValidationInput>>;
  createMany?: InputMaybe<DataImportFileCreateManyValidationInputEnvelope>;
  delete?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DataImportFileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  set?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  update?: InputMaybe<Array<DataImportFileUpdateWithWhereUniqueWithoutValidationInput>>;
  updateMany?: InputMaybe<Array<DataImportFileUpdateManyWithWhereWithoutValidationInput>>;
  upsert?: InputMaybe<Array<DataImportFileUpsertWithWhereUniqueWithoutValidationInput>>;
};

export type DataImportFileUncheckedUpdateWithoutDataImportInput = {
  authoringPublishStatus?: InputMaybe<NullableEnumDataImportPublishStatusFieldUpdateOperationsInput>;
  authoringValidationStatus?: InputMaybe<NullableEnumDataImportValidationStatusFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  derivedJurisdiction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileType?: InputMaybe<EnumDataImportFileTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  progressSummaryId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  publishStatus?: InputMaybe<NullableEnumDataImportPublishStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  validationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  validationStatus?: InputMaybe<NullableEnumDataImportValidationStatusFieldUpdateOperationsInput>;
};

export type DataImportFileUncheckedUpdateWithoutLocationInput = {
  authoringPublishStatus?: InputMaybe<NullableEnumDataImportPublishStatusFieldUpdateOperationsInput>;
  authoringValidationStatus?: InputMaybe<NullableEnumDataImportValidationStatusFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  derivedJurisdiction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileType?: InputMaybe<EnumDataImportFileTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  progressSummaryId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  publishStatus?: InputMaybe<NullableEnumDataImportPublishStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  validationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  validationStatus?: InputMaybe<NullableEnumDataImportValidationStatusFieldUpdateOperationsInput>;
};

export type DataImportFileUncheckedUpdateWithoutProgressSummaryInput = {
  authoringPublishStatus?: InputMaybe<NullableEnumDataImportPublishStatusFieldUpdateOperationsInput>;
  authoringValidationStatus?: InputMaybe<NullableEnumDataImportValidationStatusFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  derivedJurisdiction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileType?: InputMaybe<EnumDataImportFileTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  publishStatus?: InputMaybe<NullableEnumDataImportPublishStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  validationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  validationStatus?: InputMaybe<NullableEnumDataImportValidationStatusFieldUpdateOperationsInput>;
};

export type DataImportFileUncheckedUpdateWithoutValidationInput = {
  authoringPublishStatus?: InputMaybe<NullableEnumDataImportPublishStatusFieldUpdateOperationsInput>;
  authoringValidationStatus?: InputMaybe<NullableEnumDataImportValidationStatusFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  derivedJurisdiction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileType?: InputMaybe<EnumDataImportFileTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  progressSummaryId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  publishStatus?: InputMaybe<NullableEnumDataImportPublishStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  validationStatus?: InputMaybe<NullableEnumDataImportValidationStatusFieldUpdateOperationsInput>;
};

export type DataImportFileUpdateInput = {
  authoringPublishStatus?: InputMaybe<NullableEnumDataImportPublishStatusFieldUpdateOperationsInput>;
  authoringValidationStatus?: InputMaybe<NullableEnumDataImportValidationStatusFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImport?: InputMaybe<DataImportUpdateOneWithoutFilesNestedInput>;
  derivedJurisdiction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileType?: InputMaybe<EnumDataImportFileTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneWithoutDataImportFilesNestedInput>;
  progressSummary?: InputMaybe<DataImportProgressSummaryUpdateOneWithoutDataImportFilesNestedInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  publishStatus?: InputMaybe<NullableEnumDataImportPublishStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  validation?: InputMaybe<DataImportValidationUpdateOneWithoutDataImportFilesNestedInput>;
  validationStatus?: InputMaybe<NullableEnumDataImportValidationStatusFieldUpdateOperationsInput>;
};

export type DataImportFileUpdateManyMutationInput = {
  authoringPublishStatus?: InputMaybe<NullableEnumDataImportPublishStatusFieldUpdateOperationsInput>;
  authoringValidationStatus?: InputMaybe<NullableEnumDataImportValidationStatusFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  derivedJurisdiction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileType?: InputMaybe<EnumDataImportFileTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  publishStatus?: InputMaybe<NullableEnumDataImportPublishStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  validationStatus?: InputMaybe<NullableEnumDataImportValidationStatusFieldUpdateOperationsInput>;
};

export type DataImportFileUpdateManyWithWhereWithoutDataImportInput = {
  data: DataImportFileUncheckedUpdateManyWithoutFilesInput;
  where: DataImportFileScalarWhereInput;
};

export type DataImportFileUpdateManyWithWhereWithoutLocationInput = {
  data: DataImportFileUncheckedUpdateManyWithoutDataImportFilesInput;
  where: DataImportFileScalarWhereInput;
};

export type DataImportFileUpdateManyWithWhereWithoutProgressSummaryInput = {
  data: DataImportFileUncheckedUpdateManyWithoutDataImportFilesInput;
  where: DataImportFileScalarWhereInput;
};

export type DataImportFileUpdateManyWithWhereWithoutValidationInput = {
  data: DataImportFileUncheckedUpdateManyWithoutDataImportFilesInput;
  where: DataImportFileScalarWhereInput;
};

export type DataImportFileUpdateManyWithoutDataImportNestedInput = {
  connect?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataImportFileCreateOrConnectWithoutDataImportInput>>;
  create?: InputMaybe<Array<DataImportFileCreateWithoutDataImportInput>>;
  createMany?: InputMaybe<DataImportFileCreateManyDataImportInputEnvelope>;
  delete?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DataImportFileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  set?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  update?: InputMaybe<Array<DataImportFileUpdateWithWhereUniqueWithoutDataImportInput>>;
  updateMany?: InputMaybe<Array<DataImportFileUpdateManyWithWhereWithoutDataImportInput>>;
  upsert?: InputMaybe<Array<DataImportFileUpsertWithWhereUniqueWithoutDataImportInput>>;
};

export type DataImportFileUpdateManyWithoutLocationNestedInput = {
  connect?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataImportFileCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<DataImportFileCreateWithoutLocationInput>>;
  createMany?: InputMaybe<DataImportFileCreateManyLocationInputEnvelope>;
  delete?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DataImportFileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  set?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  update?: InputMaybe<Array<DataImportFileUpdateWithWhereUniqueWithoutLocationInput>>;
  updateMany?: InputMaybe<Array<DataImportFileUpdateManyWithWhereWithoutLocationInput>>;
  upsert?: InputMaybe<Array<DataImportFileUpsertWithWhereUniqueWithoutLocationInput>>;
};

export type DataImportFileUpdateManyWithoutProgressSummaryNestedInput = {
  connect?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataImportFileCreateOrConnectWithoutProgressSummaryInput>>;
  create?: InputMaybe<Array<DataImportFileCreateWithoutProgressSummaryInput>>;
  createMany?: InputMaybe<DataImportFileCreateManyProgressSummaryInputEnvelope>;
  delete?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DataImportFileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  set?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  update?: InputMaybe<Array<DataImportFileUpdateWithWhereUniqueWithoutProgressSummaryInput>>;
  updateMany?: InputMaybe<Array<DataImportFileUpdateManyWithWhereWithoutProgressSummaryInput>>;
  upsert?: InputMaybe<Array<DataImportFileUpsertWithWhereUniqueWithoutProgressSummaryInput>>;
};

export type DataImportFileUpdateManyWithoutValidationNestedInput = {
  connect?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataImportFileCreateOrConnectWithoutValidationInput>>;
  create?: InputMaybe<Array<DataImportFileCreateWithoutValidationInput>>;
  createMany?: InputMaybe<DataImportFileCreateManyValidationInputEnvelope>;
  delete?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DataImportFileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  set?: InputMaybe<Array<DataImportFileWhereUniqueInput>>;
  update?: InputMaybe<Array<DataImportFileUpdateWithWhereUniqueWithoutValidationInput>>;
  updateMany?: InputMaybe<Array<DataImportFileUpdateManyWithWhereWithoutValidationInput>>;
  upsert?: InputMaybe<Array<DataImportFileUpsertWithWhereUniqueWithoutValidationInput>>;
};

export type DataImportFileUpdateWithWhereUniqueWithoutDataImportInput = {
  data: DataImportFileUncheckedUpdateWithoutDataImportInput;
  where: DataImportFileWhereUniqueInput;
};

export type DataImportFileUpdateWithWhereUniqueWithoutLocationInput = {
  data: DataImportFileUncheckedUpdateWithoutLocationInput;
  where: DataImportFileWhereUniqueInput;
};

export type DataImportFileUpdateWithWhereUniqueWithoutProgressSummaryInput = {
  data: DataImportFileUncheckedUpdateWithoutProgressSummaryInput;
  where: DataImportFileWhereUniqueInput;
};

export type DataImportFileUpdateWithWhereUniqueWithoutValidationInput = {
  data: DataImportFileUncheckedUpdateWithoutValidationInput;
  where: DataImportFileWhereUniqueInput;
};

export type DataImportFileUpdateWithoutDataImportInput = {
  authoringPublishStatus?: InputMaybe<NullableEnumDataImportPublishStatusFieldUpdateOperationsInput>;
  authoringValidationStatus?: InputMaybe<NullableEnumDataImportValidationStatusFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  derivedJurisdiction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileType?: InputMaybe<EnumDataImportFileTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneWithoutDataImportFilesNestedInput>;
  progressSummary?: InputMaybe<DataImportProgressSummaryUpdateOneWithoutDataImportFilesNestedInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  publishStatus?: InputMaybe<NullableEnumDataImportPublishStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  validation?: InputMaybe<DataImportValidationUpdateOneWithoutDataImportFilesNestedInput>;
  validationStatus?: InputMaybe<NullableEnumDataImportValidationStatusFieldUpdateOperationsInput>;
};

export type DataImportFileUpdateWithoutLocationInput = {
  authoringPublishStatus?: InputMaybe<NullableEnumDataImportPublishStatusFieldUpdateOperationsInput>;
  authoringValidationStatus?: InputMaybe<NullableEnumDataImportValidationStatusFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImport?: InputMaybe<DataImportUpdateOneWithoutFilesNestedInput>;
  derivedJurisdiction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileType?: InputMaybe<EnumDataImportFileTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  progressSummary?: InputMaybe<DataImportProgressSummaryUpdateOneWithoutDataImportFilesNestedInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  publishStatus?: InputMaybe<NullableEnumDataImportPublishStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  validation?: InputMaybe<DataImportValidationUpdateOneWithoutDataImportFilesNestedInput>;
  validationStatus?: InputMaybe<NullableEnumDataImportValidationStatusFieldUpdateOperationsInput>;
};

export type DataImportFileUpdateWithoutProgressSummaryInput = {
  authoringPublishStatus?: InputMaybe<NullableEnumDataImportPublishStatusFieldUpdateOperationsInput>;
  authoringValidationStatus?: InputMaybe<NullableEnumDataImportValidationStatusFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImport?: InputMaybe<DataImportUpdateOneWithoutFilesNestedInput>;
  derivedJurisdiction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileType?: InputMaybe<EnumDataImportFileTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneWithoutDataImportFilesNestedInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  publishStatus?: InputMaybe<NullableEnumDataImportPublishStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  validation?: InputMaybe<DataImportValidationUpdateOneWithoutDataImportFilesNestedInput>;
  validationStatus?: InputMaybe<NullableEnumDataImportValidationStatusFieldUpdateOperationsInput>;
};

export type DataImportFileUpdateWithoutValidationInput = {
  authoringPublishStatus?: InputMaybe<NullableEnumDataImportPublishStatusFieldUpdateOperationsInput>;
  authoringValidationStatus?: InputMaybe<NullableEnumDataImportValidationStatusFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImport?: InputMaybe<DataImportUpdateOneWithoutFilesNestedInput>;
  derivedJurisdiction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileType?: InputMaybe<EnumDataImportFileTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneWithoutDataImportFilesNestedInput>;
  progressSummary?: InputMaybe<DataImportProgressSummaryUpdateOneWithoutDataImportFilesNestedInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  publishStatus?: InputMaybe<NullableEnumDataImportPublishStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  validationStatus?: InputMaybe<NullableEnumDataImportValidationStatusFieldUpdateOperationsInput>;
};

export type DataImportFileUpsertWithWhereUniqueWithoutDataImportInput = {
  create: DataImportFileUncheckedCreateWithoutDataImportInput;
  update: DataImportFileUncheckedUpdateWithoutDataImportInput;
  where: DataImportFileWhereUniqueInput;
};

export type DataImportFileUpsertWithWhereUniqueWithoutLocationInput = {
  create: DataImportFileUncheckedCreateWithoutLocationInput;
  update: DataImportFileUncheckedUpdateWithoutLocationInput;
  where: DataImportFileWhereUniqueInput;
};

export type DataImportFileUpsertWithWhereUniqueWithoutProgressSummaryInput = {
  create: DataImportFileUncheckedCreateWithoutProgressSummaryInput;
  update: DataImportFileUncheckedUpdateWithoutProgressSummaryInput;
  where: DataImportFileWhereUniqueInput;
};

export type DataImportFileUpsertWithWhereUniqueWithoutValidationInput = {
  create: DataImportFileUncheckedCreateWithoutValidationInput;
  update: DataImportFileUncheckedUpdateWithoutValidationInput;
  where: DataImportFileWhereUniqueInput;
};

export type DataImportFileWhereInput = {
  AND?: InputMaybe<Array<DataImportFileWhereInput>>;
  NOT?: InputMaybe<Array<DataImportFileWhereInput>>;
  OR?: InputMaybe<Array<DataImportFileWhereInput>>;
  authoringPublishStatus?: InputMaybe<EnumDataImportPublishStatusNullableFilter>;
  authoringValidationStatus?: InputMaybe<EnumDataImportValidationStatusNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dataImport?: InputMaybe<DataImportWhereInput>;
  dataImportId?: InputMaybe<StringNullableFilter>;
  derivedJurisdiction?: InputMaybe<StringNullableFilter>;
  fileName?: InputMaybe<StringFilter>;
  fileType?: InputMaybe<EnumDataImportFileTypeFilter>;
  id?: InputMaybe<StringFilter>;
  location?: InputMaybe<LocationWhereInput>;
  locationId?: InputMaybe<StringNullableFilter>;
  progressSummary?: InputMaybe<DataImportProgressSummaryWhereInput>;
  progressSummaryId?: InputMaybe<StringNullableFilter>;
  publishDate?: InputMaybe<DateTimeNullableFilter>;
  publishStatus?: InputMaybe<EnumDataImportPublishStatusNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  validation?: InputMaybe<DataImportValidationWhereInput>;
  validationId?: InputMaybe<StringNullableFilter>;
  validationStatus?: InputMaybe<EnumDataImportValidationStatusNullableFilter>;
};

export type DataImportFileWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type DataImportMasterFile = {
  __typename?: 'DataImportMasterFile';
  metadata?: Maybe<Scalars['Json']>;
  type: DataImportMasterFileType;
  url: Scalars['String'];
};

export type DataImportMasterFileLocation = {
  __typename?: 'DataImportMasterFileLocation';
  masterFiles?: Maybe<Array<DataImportMasterFile>>;
  name: Scalars['String'];
};

export type DataImportMasterFileLocationConnection = {
  __typename?: 'DataImportMasterFileLocationConnection';
  aggregate: AggregateDataImportMasterFileLocation;
  edges: Array<Maybe<DataImportMasterFileLocationEdge>>;
  pageInfo: PageInfo;
};

export type DataImportMasterFileLocationEdge = {
  __typename?: 'DataImportMasterFileLocationEdge';
  cursor: Scalars['String'];
  node: DataImportMasterFileLocation;
};

export type DataImportMasterFileLocationOrderByWithRelationInput = {
  name?: InputMaybe<SortOrder>;
};

export type DataImportMasterFileLocationWhereInput = {
  name?: InputMaybe<StringFilter>;
};

export type DataImportMasterFileOrderByWithRelationInput = {
  type?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export enum DataImportMasterFileType {
  Definition = 'Definition',
  Response = 'Response'
}

export type DataImportMaxAggregateOutputType = {
  __typename?: 'DataImportMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DataImportMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DataImportMinAggregateOutputType = {
  __typename?: 'DataImportMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DataImportMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DataImportOrderByWithAggregationInput = {
  _count?: InputMaybe<DataImportCountOrderByAggregateInput>;
  _max?: InputMaybe<DataImportMaxOrderByAggregateInput>;
  _min?: InputMaybe<DataImportMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DataImportOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  files?: InputMaybe<DataImportFileOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DataImportOwner = {
  __typename?: 'DataImportOwner';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  files?: Maybe<Array<Maybe<DataImportFile>>>;
  id: Scalars['ID'];
  reference: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type DataImportOwnerFilesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DataImportFileOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DataImportFileWhereInput>;
};

export type DataImportOwnerConnection = {
  __typename?: 'DataImportOwnerConnection';
  aggregate: AggregateDataImportOwner;
  edges: Array<Maybe<DataImportOwnerEdge>>;
  pageInfo: PageInfo;
};

export type DataImportOwnerEdge = {
  __typename?: 'DataImportOwnerEdge';
  cursor: Scalars['String'];
  node: DataImportOwner;
};

export type DataImportOwnerOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  files?: InputMaybe<DataImportFileOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DataImportOwnerWhereInput = {
  AND?: InputMaybe<Array<DataImportOwnerWhereInput>>;
  NOT?: InputMaybe<Array<DataImportOwnerWhereInput>>;
  OR?: InputMaybe<Array<DataImportOwnerWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringNullableFilter>;
  files?: InputMaybe<DataImportFileListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  reference?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum DataImportProgressStatus {
  Abandoned = 'ABANDONED',
  Awaiting = 'AWAITING',
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Notapplicable = 'NOTAPPLICABLE',
  Processing = 'PROCESSING'
}

export type DataImportProgressSummary = {
  __typename?: 'DataImportProgressSummary';
  _count: DataImportProgressSummaryCountOutputType;
  authoringImport?: Maybe<DataImportProgressStatus>;
  authoringMasterFileUpdate?: Maybe<DataImportProgressStatus>;
  authoringPublish?: Maybe<DataImportProgressStatus>;
  createdAt: Scalars['DateTime'];
  dataImportFiles: Array<Maybe<DataImportFile>>;
  id: Scalars['String'];
  linker?: Maybe<DataImportProgressStatus>;
  primaryImport?: Maybe<DataImportProgressStatus>;
  primaryMasterFileUpdate?: Maybe<DataImportProgressStatus>;
  primaryPublish?: Maybe<DataImportProgressStatus>;
  updatedAt: Scalars['DateTime'];
  upload?: Maybe<DataImportProgressStatus>;
};


export type DataImportProgressSummaryDataImportFilesArgs = {
  cursor?: InputMaybe<DataImportFileWhereUniqueInput>;
  distinct?: InputMaybe<DataImportFileScalarFieldEnum>;
  orderBy?: InputMaybe<DataImportFileOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DataImportFileWhereInput>;
};

export type DataImportProgressSummaryCountAggregateOutputType = {
  __typename?: 'DataImportProgressSummaryCountAggregateOutputType';
  _all: Scalars['Int'];
  authoringImport: Scalars['Int'];
  authoringMasterFileUpdate: Scalars['Int'];
  authoringPublish: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  linker: Scalars['Int'];
  primaryImport: Scalars['Int'];
  primaryMasterFileUpdate: Scalars['Int'];
  primaryPublish: Scalars['Int'];
  updatedAt: Scalars['Int'];
  upload: Scalars['Int'];
};

export type DataImportProgressSummaryCountOrderByAggregateInput = {
  authoringImport?: InputMaybe<SortOrder>;
  authoringMasterFileUpdate?: InputMaybe<SortOrder>;
  authoringPublish?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  linker?: InputMaybe<SortOrder>;
  primaryImport?: InputMaybe<SortOrder>;
  primaryMasterFileUpdate?: InputMaybe<SortOrder>;
  primaryPublish?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  upload?: InputMaybe<SortOrder>;
};

export type DataImportProgressSummaryCountOutputType = {
  __typename?: 'DataImportProgressSummaryCountOutputType';
  dataImportFiles: Scalars['Int'];
};

export type DataImportProgressSummaryCreateInput = {
  authoringImport?: InputMaybe<DataImportProgressStatus>;
  authoringMasterFileUpdate?: InputMaybe<DataImportProgressStatus>;
  authoringPublish?: InputMaybe<DataImportProgressStatus>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileCreateNestedManyWithoutProgressSummaryInput>;
  id?: InputMaybe<Scalars['String']>;
  linker?: InputMaybe<DataImportProgressStatus>;
  primaryImport?: InputMaybe<DataImportProgressStatus>;
  primaryMasterFileUpdate?: InputMaybe<DataImportProgressStatus>;
  primaryPublish?: InputMaybe<DataImportProgressStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  upload?: InputMaybe<DataImportProgressStatus>;
};

export type DataImportProgressSummaryCreateManyInput = {
  authoringImport?: InputMaybe<DataImportProgressStatus>;
  authoringMasterFileUpdate?: InputMaybe<DataImportProgressStatus>;
  authoringPublish?: InputMaybe<DataImportProgressStatus>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  linker?: InputMaybe<DataImportProgressStatus>;
  primaryImport?: InputMaybe<DataImportProgressStatus>;
  primaryMasterFileUpdate?: InputMaybe<DataImportProgressStatus>;
  primaryPublish?: InputMaybe<DataImportProgressStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  upload?: InputMaybe<DataImportProgressStatus>;
};

export type DataImportProgressSummaryCreateNestedOneWithoutDataImportFilesInput = {
  connect?: InputMaybe<DataImportProgressSummaryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DataImportProgressSummaryCreateOrConnectWithoutDataImportFilesInput>;
  create?: InputMaybe<DataImportProgressSummaryUncheckedCreateWithoutDataImportFilesInput>;
};

export type DataImportProgressSummaryCreateOrConnectWithoutDataImportFilesInput = {
  create: DataImportProgressSummaryUncheckedCreateWithoutDataImportFilesInput;
  where: DataImportProgressSummaryWhereUniqueInput;
};

export type DataImportProgressSummaryCreateWithoutDataImportFilesInput = {
  authoringImport?: InputMaybe<DataImportProgressStatus>;
  authoringMasterFileUpdate?: InputMaybe<DataImportProgressStatus>;
  authoringPublish?: InputMaybe<DataImportProgressStatus>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  linker?: InputMaybe<DataImportProgressStatus>;
  primaryImport?: InputMaybe<DataImportProgressStatus>;
  primaryMasterFileUpdate?: InputMaybe<DataImportProgressStatus>;
  primaryPublish?: InputMaybe<DataImportProgressStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  upload?: InputMaybe<DataImportProgressStatus>;
};

export type DataImportProgressSummaryMaxAggregateOutputType = {
  __typename?: 'DataImportProgressSummaryMaxAggregateOutputType';
  authoringImport?: Maybe<DataImportProgressStatus>;
  authoringMasterFileUpdate?: Maybe<DataImportProgressStatus>;
  authoringPublish?: Maybe<DataImportProgressStatus>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  linker?: Maybe<DataImportProgressStatus>;
  primaryImport?: Maybe<DataImportProgressStatus>;
  primaryMasterFileUpdate?: Maybe<DataImportProgressStatus>;
  primaryPublish?: Maybe<DataImportProgressStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  upload?: Maybe<DataImportProgressStatus>;
};

export type DataImportProgressSummaryMaxOrderByAggregateInput = {
  authoringImport?: InputMaybe<SortOrder>;
  authoringMasterFileUpdate?: InputMaybe<SortOrder>;
  authoringPublish?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  linker?: InputMaybe<SortOrder>;
  primaryImport?: InputMaybe<SortOrder>;
  primaryMasterFileUpdate?: InputMaybe<SortOrder>;
  primaryPublish?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  upload?: InputMaybe<SortOrder>;
};

export type DataImportProgressSummaryMinAggregateOutputType = {
  __typename?: 'DataImportProgressSummaryMinAggregateOutputType';
  authoringImport?: Maybe<DataImportProgressStatus>;
  authoringMasterFileUpdate?: Maybe<DataImportProgressStatus>;
  authoringPublish?: Maybe<DataImportProgressStatus>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  linker?: Maybe<DataImportProgressStatus>;
  primaryImport?: Maybe<DataImportProgressStatus>;
  primaryMasterFileUpdate?: Maybe<DataImportProgressStatus>;
  primaryPublish?: Maybe<DataImportProgressStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  upload?: Maybe<DataImportProgressStatus>;
};

export type DataImportProgressSummaryMinOrderByAggregateInput = {
  authoringImport?: InputMaybe<SortOrder>;
  authoringMasterFileUpdate?: InputMaybe<SortOrder>;
  authoringPublish?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  linker?: InputMaybe<SortOrder>;
  primaryImport?: InputMaybe<SortOrder>;
  primaryMasterFileUpdate?: InputMaybe<SortOrder>;
  primaryPublish?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  upload?: InputMaybe<SortOrder>;
};

export type DataImportProgressSummaryOrderByWithAggregationInput = {
  _count?: InputMaybe<DataImportProgressSummaryCountOrderByAggregateInput>;
  _max?: InputMaybe<DataImportProgressSummaryMaxOrderByAggregateInput>;
  _min?: InputMaybe<DataImportProgressSummaryMinOrderByAggregateInput>;
  authoringImport?: InputMaybe<SortOrderInput>;
  authoringMasterFileUpdate?: InputMaybe<SortOrderInput>;
  authoringPublish?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  linker?: InputMaybe<SortOrderInput>;
  primaryImport?: InputMaybe<SortOrderInput>;
  primaryMasterFileUpdate?: InputMaybe<SortOrderInput>;
  primaryPublish?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  upload?: InputMaybe<SortOrderInput>;
};

export type DataImportProgressSummaryOrderByWithRelationInput = {
  authoringImport?: InputMaybe<SortOrderInput>;
  authoringMasterFileUpdate?: InputMaybe<SortOrderInput>;
  authoringPublish?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  dataImportFiles?: InputMaybe<DataImportFileOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  linker?: InputMaybe<SortOrderInput>;
  primaryImport?: InputMaybe<SortOrderInput>;
  primaryMasterFileUpdate?: InputMaybe<SortOrderInput>;
  primaryPublish?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  upload?: InputMaybe<SortOrderInput>;
};

export type DataImportProgressSummaryRelationFilter = {
  is?: InputMaybe<DataImportProgressSummaryWhereInput>;
  isNot?: InputMaybe<DataImportProgressSummaryWhereInput>;
};

export enum DataImportProgressSummaryScalarFieldEnum {
  AuthoringImport = 'authoringImport',
  AuthoringMasterFileUpdate = 'authoringMasterFileUpdate',
  AuthoringPublish = 'authoringPublish',
  CreatedAt = 'createdAt',
  Id = 'id',
  Linker = 'linker',
  PrimaryImport = 'primaryImport',
  PrimaryMasterFileUpdate = 'primaryMasterFileUpdate',
  PrimaryPublish = 'primaryPublish',
  UpdatedAt = 'updatedAt',
  Upload = 'upload'
}

export type DataImportProgressSummaryScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DataImportProgressSummaryScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DataImportProgressSummaryScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DataImportProgressSummaryScalarWhereWithAggregatesInput>>;
  authoringImport?: InputMaybe<EnumDataImportProgressStatusNullableWithAggregatesFilter>;
  authoringMasterFileUpdate?: InputMaybe<EnumDataImportProgressStatusNullableWithAggregatesFilter>;
  authoringPublish?: InputMaybe<EnumDataImportProgressStatusNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  linker?: InputMaybe<EnumDataImportProgressStatusNullableWithAggregatesFilter>;
  primaryImport?: InputMaybe<EnumDataImportProgressStatusNullableWithAggregatesFilter>;
  primaryMasterFileUpdate?: InputMaybe<EnumDataImportProgressStatusNullableWithAggregatesFilter>;
  primaryPublish?: InputMaybe<EnumDataImportProgressStatusNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  upload?: InputMaybe<EnumDataImportProgressStatusNullableWithAggregatesFilter>;
};

export type DataImportProgressSummaryUncheckedCreateInput = {
  authoringImport?: InputMaybe<DataImportProgressStatus>;
  authoringMasterFileUpdate?: InputMaybe<DataImportProgressStatus>;
  authoringPublish?: InputMaybe<DataImportProgressStatus>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedCreateNestedManyWithoutProgressSummaryInput>;
  id?: InputMaybe<Scalars['String']>;
  linker?: InputMaybe<DataImportProgressStatus>;
  primaryImport?: InputMaybe<DataImportProgressStatus>;
  primaryMasterFileUpdate?: InputMaybe<DataImportProgressStatus>;
  primaryPublish?: InputMaybe<DataImportProgressStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  upload?: InputMaybe<DataImportProgressStatus>;
};

export type DataImportProgressSummaryUncheckedCreateWithoutDataImportFilesInput = {
  authoringImport?: InputMaybe<DataImportProgressStatus>;
  authoringMasterFileUpdate?: InputMaybe<DataImportProgressStatus>;
  authoringPublish?: InputMaybe<DataImportProgressStatus>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  linker?: InputMaybe<DataImportProgressStatus>;
  primaryImport?: InputMaybe<DataImportProgressStatus>;
  primaryMasterFileUpdate?: InputMaybe<DataImportProgressStatus>;
  primaryPublish?: InputMaybe<DataImportProgressStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  upload?: InputMaybe<DataImportProgressStatus>;
};

export type DataImportProgressSummaryUncheckedUpdateInput = {
  authoringImport?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  authoringMasterFileUpdate?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  authoringPublish?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedUpdateManyWithoutProgressSummaryNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  linker?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  primaryImport?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  primaryMasterFileUpdate?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  primaryPublish?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  upload?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
};

export type DataImportProgressSummaryUncheckedUpdateManyInput = {
  authoringImport?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  authoringMasterFileUpdate?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  authoringPublish?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  linker?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  primaryImport?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  primaryMasterFileUpdate?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  primaryPublish?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  upload?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
};

export type DataImportProgressSummaryUncheckedUpdateWithoutDataImportFilesInput = {
  authoringImport?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  authoringMasterFileUpdate?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  authoringPublish?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  linker?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  primaryImport?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  primaryMasterFileUpdate?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  primaryPublish?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  upload?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
};

export type DataImportProgressSummaryUpdateInput = {
  authoringImport?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  authoringMasterFileUpdate?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  authoringPublish?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUpdateManyWithoutProgressSummaryNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  linker?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  primaryImport?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  primaryMasterFileUpdate?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  primaryPublish?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  upload?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
};

export type DataImportProgressSummaryUpdateManyMutationInput = {
  authoringImport?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  authoringMasterFileUpdate?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  authoringPublish?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  linker?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  primaryImport?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  primaryMasterFileUpdate?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  primaryPublish?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  upload?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
};

export type DataImportProgressSummaryUpdateOneWithoutDataImportFilesNestedInput = {
  connect?: InputMaybe<DataImportProgressSummaryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DataImportProgressSummaryCreateOrConnectWithoutDataImportFilesInput>;
  create?: InputMaybe<DataImportProgressSummaryUncheckedCreateWithoutDataImportFilesInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<DataImportProgressSummaryUncheckedUpdateWithoutDataImportFilesInput>;
  upsert?: InputMaybe<DataImportProgressSummaryUpsertWithoutDataImportFilesInput>;
};

export type DataImportProgressSummaryUpdateWithoutDataImportFilesInput = {
  authoringImport?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  authoringMasterFileUpdate?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  authoringPublish?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  linker?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  primaryImport?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  primaryMasterFileUpdate?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  primaryPublish?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  upload?: InputMaybe<NullableEnumDataImportProgressStatusFieldUpdateOperationsInput>;
};

export type DataImportProgressSummaryUpsertWithoutDataImportFilesInput = {
  create: DataImportProgressSummaryUncheckedCreateWithoutDataImportFilesInput;
  update: DataImportProgressSummaryUncheckedUpdateWithoutDataImportFilesInput;
};

export type DataImportProgressSummaryWhereInput = {
  AND?: InputMaybe<Array<DataImportProgressSummaryWhereInput>>;
  NOT?: InputMaybe<Array<DataImportProgressSummaryWhereInput>>;
  OR?: InputMaybe<Array<DataImportProgressSummaryWhereInput>>;
  authoringImport?: InputMaybe<EnumDataImportProgressStatusNullableFilter>;
  authoringMasterFileUpdate?: InputMaybe<EnumDataImportProgressStatusNullableFilter>;
  authoringPublish?: InputMaybe<EnumDataImportProgressStatusNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dataImportFiles?: InputMaybe<DataImportFileListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  linker?: InputMaybe<EnumDataImportProgressStatusNullableFilter>;
  primaryImport?: InputMaybe<EnumDataImportProgressStatusNullableFilter>;
  primaryMasterFileUpdate?: InputMaybe<EnumDataImportProgressStatusNullableFilter>;
  primaryPublish?: InputMaybe<EnumDataImportProgressStatusNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  upload?: InputMaybe<EnumDataImportProgressStatusNullableFilter>;
};

export type DataImportProgressSummaryWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export enum DataImportPublishStatus {
  Abandoned = 'ABANDONED',
  Failed = 'FAILED',
  Notpublished = 'NOTPUBLISHED',
  Processing = 'PROCESSING',
  Published = 'PUBLISHED'
}

export type DataImportRelationFilter = {
  is?: InputMaybe<DataImportWhereInput>;
  isNot?: InputMaybe<DataImportWhereInput>;
};

export enum DataImportScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  Id = 'id',
  Reference = 'reference',
  UpdatedAt = 'updatedAt'
}

export type DataImportScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DataImportScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DataImportScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DataImportScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  createdBy?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  reference?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type DataImportUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  files?: InputMaybe<DataImportFileUncheckedCreateNestedManyWithoutDataImportInput>;
  id?: InputMaybe<Scalars['String']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DataImportUncheckedCreateWithoutFilesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DataImportUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  files?: InputMaybe<DataImportFileUncheckedUpdateManyWithoutDataImportNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DataImportUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DataImportUncheckedUpdateWithoutFilesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DataImportUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  files?: InputMaybe<DataImportFileUpdateManyWithoutDataImportNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DataImportUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DataImportUpdateOneWithoutFilesNestedInput = {
  connect?: InputMaybe<DataImportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DataImportCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<DataImportUncheckedCreateWithoutFilesInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<DataImportUncheckedUpdateWithoutFilesInput>;
  upsert?: InputMaybe<DataImportUpsertWithoutFilesInput>;
};

export type DataImportUpdateWithoutFilesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DataImportUpsertWithoutFilesInput = {
  create: DataImportUncheckedCreateWithoutFilesInput;
  update: DataImportUncheckedUpdateWithoutFilesInput;
};

export type DataImportValidation = {
  __typename?: 'DataImportValidation';
  _count: DataImportValidationCountOutputType;
  authoringReport?: Maybe<Scalars['Json']>;
  createdAt: Scalars['DateTime'];
  dataImportFiles: Array<Maybe<DataImportFile>>;
  dataImportValidationAudits: Array<Maybe<DataImportValidationAudit>>;
  id: Scalars['String'];
  report?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
};


export type DataImportValidationDataImportFilesArgs = {
  cursor?: InputMaybe<DataImportFileWhereUniqueInput>;
  distinct?: InputMaybe<DataImportFileScalarFieldEnum>;
  orderBy?: InputMaybe<DataImportFileOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DataImportFileWhereInput>;
};


export type DataImportValidationDataImportValidationAuditsArgs = {
  cursor?: InputMaybe<DataImportValidationAuditWhereUniqueInput>;
  distinct?: InputMaybe<DataImportValidationAuditScalarFieldEnum>;
  orderBy?: InputMaybe<DataImportValidationAuditOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DataImportValidationAuditWhereInput>;
};

export type DataImportValidationAudit = {
  __typename?: 'DataImportValidationAudit';
  create?: Maybe<Scalars['Int']>;
  createRecords?: Maybe<Scalars['Json']>;
  createdAt: Scalars['DateTime'];
  dataImportValidation?: Maybe<DataImportValidation>;
  dataImportValidationId?: Maybe<Scalars['String']>;
  delete?: Maybe<Scalars['Int']>;
  deleteRecords?: Maybe<Scalars['Json']>;
  environment: DataImportEnvironment;
  id: Scalars['String'];
  total?: Maybe<Scalars['Int']>;
  type: DataImportValidationAuditType;
  update?: Maybe<Scalars['Int']>;
  updateRecords?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
};

export type DataImportValidationAuditAvgAggregateOutputType = {
  __typename?: 'DataImportValidationAuditAvgAggregateOutputType';
  create?: Maybe<Scalars['Float']>;
  delete?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  update?: Maybe<Scalars['Float']>;
};

export type DataImportValidationAuditAvgOrderByAggregateInput = {
  create?: InputMaybe<SortOrder>;
  delete?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
  update?: InputMaybe<SortOrder>;
};

export type DataImportValidationAuditCountAggregateOutputType = {
  __typename?: 'DataImportValidationAuditCountAggregateOutputType';
  _all: Scalars['Int'];
  create: Scalars['Int'];
  createRecords: Scalars['Int'];
  createdAt: Scalars['Int'];
  dataImportValidationId: Scalars['Int'];
  delete: Scalars['Int'];
  deleteRecords: Scalars['Int'];
  environment: Scalars['Int'];
  id: Scalars['Int'];
  total: Scalars['Int'];
  type: Scalars['Int'];
  update: Scalars['Int'];
  updateRecords: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type DataImportValidationAuditCountOrderByAggregateInput = {
  create?: InputMaybe<SortOrder>;
  createRecords?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dataImportValidationId?: InputMaybe<SortOrder>;
  delete?: InputMaybe<SortOrder>;
  deleteRecords?: InputMaybe<SortOrder>;
  environment?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  update?: InputMaybe<SortOrder>;
  updateRecords?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DataImportValidationAuditCreateInput = {
  create?: InputMaybe<Scalars['Int']>;
  createRecords?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportValidation?: InputMaybe<DataImportValidationCreateNestedOneWithoutDataImportValidationAuditsInput>;
  delete?: InputMaybe<Scalars['Int']>;
  deleteRecords?: InputMaybe<Scalars['Json']>;
  environment?: InputMaybe<DataImportEnvironment>;
  id?: InputMaybe<Scalars['String']>;
  total?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<DataImportValidationAuditType>;
  update?: InputMaybe<Scalars['Int']>;
  updateRecords?: InputMaybe<Scalars['Json']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DataImportValidationAuditCreateManyDataImportValidationInput = {
  create?: InputMaybe<Scalars['Int']>;
  createRecords?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  delete?: InputMaybe<Scalars['Int']>;
  deleteRecords?: InputMaybe<Scalars['Json']>;
  environment?: InputMaybe<DataImportEnvironment>;
  id?: InputMaybe<Scalars['String']>;
  total?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<DataImportValidationAuditType>;
  update?: InputMaybe<Scalars['Int']>;
  updateRecords?: InputMaybe<Scalars['Json']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DataImportValidationAuditCreateManyDataImportValidationInputEnvelope = {
  data: Array<DataImportValidationAuditCreateManyDataImportValidationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DataImportValidationAuditCreateManyInput = {
  create?: InputMaybe<Scalars['Int']>;
  createRecords?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportValidationId?: InputMaybe<Scalars['String']>;
  delete?: InputMaybe<Scalars['Int']>;
  deleteRecords?: InputMaybe<Scalars['Json']>;
  environment?: InputMaybe<DataImportEnvironment>;
  id?: InputMaybe<Scalars['String']>;
  total?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<DataImportValidationAuditType>;
  update?: InputMaybe<Scalars['Int']>;
  updateRecords?: InputMaybe<Scalars['Json']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DataImportValidationAuditCreateNestedManyWithoutDataImportValidationInput = {
  connect?: InputMaybe<Array<DataImportValidationAuditWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataImportValidationAuditCreateOrConnectWithoutDataImportValidationInput>>;
  create?: InputMaybe<Array<DataImportValidationAuditCreateWithoutDataImportValidationInput>>;
  createMany?: InputMaybe<DataImportValidationAuditCreateManyDataImportValidationInputEnvelope>;
};

export type DataImportValidationAuditCreateOrConnectWithoutDataImportValidationInput = {
  create: DataImportValidationAuditUncheckedCreateWithoutDataImportValidationInput;
  where: DataImportValidationAuditWhereUniqueInput;
};

export type DataImportValidationAuditCreateWithoutDataImportValidationInput = {
  create?: InputMaybe<Scalars['Int']>;
  createRecords?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  delete?: InputMaybe<Scalars['Int']>;
  deleteRecords?: InputMaybe<Scalars['Json']>;
  environment?: InputMaybe<DataImportEnvironment>;
  id?: InputMaybe<Scalars['String']>;
  total?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<DataImportValidationAuditType>;
  update?: InputMaybe<Scalars['Int']>;
  updateRecords?: InputMaybe<Scalars['Json']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DataImportValidationAuditListRelationFilter = {
  every?: InputMaybe<DataImportValidationAuditWhereInput>;
  none?: InputMaybe<DataImportValidationAuditWhereInput>;
  some?: InputMaybe<DataImportValidationAuditWhereInput>;
};

export type DataImportValidationAuditMaxAggregateOutputType = {
  __typename?: 'DataImportValidationAuditMaxAggregateOutputType';
  create?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataImportValidationId?: Maybe<Scalars['String']>;
  delete?: Maybe<Scalars['Int']>;
  environment?: Maybe<DataImportEnvironment>;
  id?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  type?: Maybe<DataImportValidationAuditType>;
  update?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DataImportValidationAuditMaxOrderByAggregateInput = {
  create?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dataImportValidationId?: InputMaybe<SortOrder>;
  delete?: InputMaybe<SortOrder>;
  environment?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  update?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DataImportValidationAuditMinAggregateOutputType = {
  __typename?: 'DataImportValidationAuditMinAggregateOutputType';
  create?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataImportValidationId?: Maybe<Scalars['String']>;
  delete?: Maybe<Scalars['Int']>;
  environment?: Maybe<DataImportEnvironment>;
  id?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  type?: Maybe<DataImportValidationAuditType>;
  update?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DataImportValidationAuditMinOrderByAggregateInput = {
  create?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dataImportValidationId?: InputMaybe<SortOrder>;
  delete?: InputMaybe<SortOrder>;
  environment?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  update?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DataImportValidationAuditOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DataImportValidationAuditOrderByWithAggregationInput = {
  _avg?: InputMaybe<DataImportValidationAuditAvgOrderByAggregateInput>;
  _count?: InputMaybe<DataImportValidationAuditCountOrderByAggregateInput>;
  _max?: InputMaybe<DataImportValidationAuditMaxOrderByAggregateInput>;
  _min?: InputMaybe<DataImportValidationAuditMinOrderByAggregateInput>;
  _sum?: InputMaybe<DataImportValidationAuditSumOrderByAggregateInput>;
  create?: InputMaybe<SortOrderInput>;
  createRecords?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  dataImportValidationId?: InputMaybe<SortOrderInput>;
  delete?: InputMaybe<SortOrderInput>;
  deleteRecords?: InputMaybe<SortOrderInput>;
  environment?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
  update?: InputMaybe<SortOrderInput>;
  updateRecords?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DataImportValidationAuditOrderByWithRelationInput = {
  create?: InputMaybe<SortOrderInput>;
  createRecords?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  dataImportValidation?: InputMaybe<DataImportValidationOrderByWithRelationInput>;
  dataImportValidationId?: InputMaybe<SortOrderInput>;
  delete?: InputMaybe<SortOrderInput>;
  deleteRecords?: InputMaybe<SortOrderInput>;
  environment?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
  update?: InputMaybe<SortOrderInput>;
  updateRecords?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum DataImportValidationAuditScalarFieldEnum {
  Create = 'create',
  CreateRecords = 'createRecords',
  CreatedAt = 'createdAt',
  DataImportValidationId = 'dataImportValidationId',
  Delete = 'delete',
  DeleteRecords = 'deleteRecords',
  Environment = 'environment',
  Id = 'id',
  Total = 'total',
  Type = 'type',
  Update = 'update',
  UpdateRecords = 'updateRecords',
  UpdatedAt = 'updatedAt'
}

export type DataImportValidationAuditScalarWhereInput = {
  AND?: InputMaybe<Array<DataImportValidationAuditScalarWhereInput>>;
  NOT?: InputMaybe<Array<DataImportValidationAuditScalarWhereInput>>;
  OR?: InputMaybe<Array<DataImportValidationAuditScalarWhereInput>>;
  create?: InputMaybe<IntNullableFilter>;
  createRecords?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dataImportValidationId?: InputMaybe<StringNullableFilter>;
  delete?: InputMaybe<IntNullableFilter>;
  deleteRecords?: InputMaybe<JsonNullableFilter>;
  environment?: InputMaybe<EnumDataImportEnvironmentFilter>;
  id?: InputMaybe<StringFilter>;
  total?: InputMaybe<IntNullableFilter>;
  type?: InputMaybe<EnumDataImportValidationAuditTypeFilter>;
  update?: InputMaybe<IntNullableFilter>;
  updateRecords?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DataImportValidationAuditScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DataImportValidationAuditScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DataImportValidationAuditScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DataImportValidationAuditScalarWhereWithAggregatesInput>>;
  create?: InputMaybe<IntNullableWithAggregatesFilter>;
  createRecords?: InputMaybe<JsonNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  dataImportValidationId?: InputMaybe<StringNullableWithAggregatesFilter>;
  delete?: InputMaybe<IntNullableWithAggregatesFilter>;
  deleteRecords?: InputMaybe<JsonNullableWithAggregatesFilter>;
  environment?: InputMaybe<EnumDataImportEnvironmentWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  total?: InputMaybe<IntNullableWithAggregatesFilter>;
  type?: InputMaybe<EnumDataImportValidationAuditTypeWithAggregatesFilter>;
  update?: InputMaybe<IntNullableWithAggregatesFilter>;
  updateRecords?: InputMaybe<JsonNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type DataImportValidationAuditSumAggregateOutputType = {
  __typename?: 'DataImportValidationAuditSumAggregateOutputType';
  create?: Maybe<Scalars['Int']>;
  delete?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  update?: Maybe<Scalars['Int']>;
};

export type DataImportValidationAuditSumOrderByAggregateInput = {
  create?: InputMaybe<SortOrder>;
  delete?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
  update?: InputMaybe<SortOrder>;
};

export enum DataImportValidationAuditType {
  Postaudit = 'POSTAUDIT',
  Preaudit = 'PREAUDIT',
  Unknown = 'UNKNOWN'
}

export type DataImportValidationAuditUncheckedCreateInput = {
  create?: InputMaybe<Scalars['Int']>;
  createRecords?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportValidationId?: InputMaybe<Scalars['String']>;
  delete?: InputMaybe<Scalars['Int']>;
  deleteRecords?: InputMaybe<Scalars['Json']>;
  environment?: InputMaybe<DataImportEnvironment>;
  id?: InputMaybe<Scalars['String']>;
  total?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<DataImportValidationAuditType>;
  update?: InputMaybe<Scalars['Int']>;
  updateRecords?: InputMaybe<Scalars['Json']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DataImportValidationAuditUncheckedCreateNestedManyWithoutDataImportValidationInput = {
  connect?: InputMaybe<Array<DataImportValidationAuditWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataImportValidationAuditCreateOrConnectWithoutDataImportValidationInput>>;
  create?: InputMaybe<Array<DataImportValidationAuditCreateWithoutDataImportValidationInput>>;
  createMany?: InputMaybe<DataImportValidationAuditCreateManyDataImportValidationInputEnvelope>;
};

export type DataImportValidationAuditUncheckedCreateWithoutDataImportValidationInput = {
  create?: InputMaybe<Scalars['Int']>;
  createRecords?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  delete?: InputMaybe<Scalars['Int']>;
  deleteRecords?: InputMaybe<Scalars['Json']>;
  environment?: InputMaybe<DataImportEnvironment>;
  id?: InputMaybe<Scalars['String']>;
  total?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<DataImportValidationAuditType>;
  update?: InputMaybe<Scalars['Int']>;
  updateRecords?: InputMaybe<Scalars['Json']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DataImportValidationAuditUncheckedUpdateInput = {
  create?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createRecords?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportValidationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  delete?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deleteRecords?: InputMaybe<Scalars['Json']>;
  environment?: InputMaybe<EnumDataImportEnvironmentFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  total?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDataImportValidationAuditTypeFieldUpdateOperationsInput>;
  update?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updateRecords?: InputMaybe<Scalars['Json']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DataImportValidationAuditUncheckedUpdateManyInput = {
  create?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createRecords?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportValidationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  delete?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deleteRecords?: InputMaybe<Scalars['Json']>;
  environment?: InputMaybe<EnumDataImportEnvironmentFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  total?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDataImportValidationAuditTypeFieldUpdateOperationsInput>;
  update?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updateRecords?: InputMaybe<Scalars['Json']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DataImportValidationAuditUncheckedUpdateManyWithoutDataImportValidationAuditsInput = {
  create?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createRecords?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deleteRecords?: InputMaybe<Scalars['Json']>;
  environment?: InputMaybe<EnumDataImportEnvironmentFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  total?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDataImportValidationAuditTypeFieldUpdateOperationsInput>;
  update?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updateRecords?: InputMaybe<Scalars['Json']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DataImportValidationAuditUncheckedUpdateManyWithoutDataImportValidationNestedInput = {
  connect?: InputMaybe<Array<DataImportValidationAuditWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataImportValidationAuditCreateOrConnectWithoutDataImportValidationInput>>;
  create?: InputMaybe<Array<DataImportValidationAuditCreateWithoutDataImportValidationInput>>;
  createMany?: InputMaybe<DataImportValidationAuditCreateManyDataImportValidationInputEnvelope>;
  delete?: InputMaybe<Array<DataImportValidationAuditWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DataImportValidationAuditScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DataImportValidationAuditWhereUniqueInput>>;
  set?: InputMaybe<Array<DataImportValidationAuditWhereUniqueInput>>;
  update?: InputMaybe<Array<DataImportValidationAuditUpdateWithWhereUniqueWithoutDataImportValidationInput>>;
  updateMany?: InputMaybe<Array<DataImportValidationAuditUpdateManyWithWhereWithoutDataImportValidationInput>>;
  upsert?: InputMaybe<Array<DataImportValidationAuditUpsertWithWhereUniqueWithoutDataImportValidationInput>>;
};

export type DataImportValidationAuditUncheckedUpdateWithoutDataImportValidationInput = {
  create?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createRecords?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deleteRecords?: InputMaybe<Scalars['Json']>;
  environment?: InputMaybe<EnumDataImportEnvironmentFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  total?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDataImportValidationAuditTypeFieldUpdateOperationsInput>;
  update?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updateRecords?: InputMaybe<Scalars['Json']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DataImportValidationAuditUpdateInput = {
  create?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createRecords?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportValidation?: InputMaybe<DataImportValidationUpdateOneWithoutDataImportValidationAuditsNestedInput>;
  delete?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deleteRecords?: InputMaybe<Scalars['Json']>;
  environment?: InputMaybe<EnumDataImportEnvironmentFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  total?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDataImportValidationAuditTypeFieldUpdateOperationsInput>;
  update?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updateRecords?: InputMaybe<Scalars['Json']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DataImportValidationAuditUpdateManyMutationInput = {
  create?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createRecords?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deleteRecords?: InputMaybe<Scalars['Json']>;
  environment?: InputMaybe<EnumDataImportEnvironmentFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  total?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDataImportValidationAuditTypeFieldUpdateOperationsInput>;
  update?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updateRecords?: InputMaybe<Scalars['Json']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DataImportValidationAuditUpdateManyWithWhereWithoutDataImportValidationInput = {
  data: DataImportValidationAuditUncheckedUpdateManyWithoutDataImportValidationAuditsInput;
  where: DataImportValidationAuditScalarWhereInput;
};

export type DataImportValidationAuditUpdateManyWithoutDataImportValidationNestedInput = {
  connect?: InputMaybe<Array<DataImportValidationAuditWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataImportValidationAuditCreateOrConnectWithoutDataImportValidationInput>>;
  create?: InputMaybe<Array<DataImportValidationAuditCreateWithoutDataImportValidationInput>>;
  createMany?: InputMaybe<DataImportValidationAuditCreateManyDataImportValidationInputEnvelope>;
  delete?: InputMaybe<Array<DataImportValidationAuditWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DataImportValidationAuditScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DataImportValidationAuditWhereUniqueInput>>;
  set?: InputMaybe<Array<DataImportValidationAuditWhereUniqueInput>>;
  update?: InputMaybe<Array<DataImportValidationAuditUpdateWithWhereUniqueWithoutDataImportValidationInput>>;
  updateMany?: InputMaybe<Array<DataImportValidationAuditUpdateManyWithWhereWithoutDataImportValidationInput>>;
  upsert?: InputMaybe<Array<DataImportValidationAuditUpsertWithWhereUniqueWithoutDataImportValidationInput>>;
};

export type DataImportValidationAuditUpdateWithWhereUniqueWithoutDataImportValidationInput = {
  data: DataImportValidationAuditUncheckedUpdateWithoutDataImportValidationInput;
  where: DataImportValidationAuditWhereUniqueInput;
};

export type DataImportValidationAuditUpdateWithoutDataImportValidationInput = {
  create?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createRecords?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deleteRecords?: InputMaybe<Scalars['Json']>;
  environment?: InputMaybe<EnumDataImportEnvironmentFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  total?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDataImportValidationAuditTypeFieldUpdateOperationsInput>;
  update?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updateRecords?: InputMaybe<Scalars['Json']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DataImportValidationAuditUpsertWithWhereUniqueWithoutDataImportValidationInput = {
  create: DataImportValidationAuditUncheckedCreateWithoutDataImportValidationInput;
  update: DataImportValidationAuditUncheckedUpdateWithoutDataImportValidationInput;
  where: DataImportValidationAuditWhereUniqueInput;
};

export type DataImportValidationAuditWhereInput = {
  AND?: InputMaybe<Array<DataImportValidationAuditWhereInput>>;
  NOT?: InputMaybe<Array<DataImportValidationAuditWhereInput>>;
  OR?: InputMaybe<Array<DataImportValidationAuditWhereInput>>;
  create?: InputMaybe<IntNullableFilter>;
  createRecords?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dataImportValidation?: InputMaybe<DataImportValidationWhereInput>;
  dataImportValidationId?: InputMaybe<StringNullableFilter>;
  delete?: InputMaybe<IntNullableFilter>;
  deleteRecords?: InputMaybe<JsonNullableFilter>;
  environment?: InputMaybe<EnumDataImportEnvironmentFilter>;
  id?: InputMaybe<StringFilter>;
  total?: InputMaybe<IntNullableFilter>;
  type?: InputMaybe<EnumDataImportValidationAuditTypeFilter>;
  update?: InputMaybe<IntNullableFilter>;
  updateRecords?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DataImportValidationAuditWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type DataImportValidationCountAggregateOutputType = {
  __typename?: 'DataImportValidationCountAggregateOutputType';
  _all: Scalars['Int'];
  authoringReport: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  report: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type DataImportValidationCountOrderByAggregateInput = {
  authoringReport?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  report?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DataImportValidationCountOutputType = {
  __typename?: 'DataImportValidationCountOutputType';
  dataImportFiles: Scalars['Int'];
  dataImportValidationAudits: Scalars['Int'];
};

export type DataImportValidationCreateInput = {
  authoringReport?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileCreateNestedManyWithoutValidationInput>;
  dataImportValidationAudits?: InputMaybe<DataImportValidationAuditCreateNestedManyWithoutDataImportValidationInput>;
  id?: InputMaybe<Scalars['String']>;
  report?: InputMaybe<Scalars['Json']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DataImportValidationCreateManyInput = {
  authoringReport?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  report?: InputMaybe<Scalars['Json']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DataImportValidationCreateNestedOneWithoutDataImportFilesInput = {
  connect?: InputMaybe<DataImportValidationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DataImportValidationCreateOrConnectWithoutDataImportFilesInput>;
  create?: InputMaybe<DataImportValidationUncheckedCreateWithoutDataImportFilesInput>;
};

export type DataImportValidationCreateNestedOneWithoutDataImportValidationAuditsInput = {
  connect?: InputMaybe<DataImportValidationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DataImportValidationCreateOrConnectWithoutDataImportValidationAuditsInput>;
  create?: InputMaybe<DataImportValidationUncheckedCreateWithoutDataImportValidationAuditsInput>;
};

export type DataImportValidationCreateOrConnectWithoutDataImportFilesInput = {
  create: DataImportValidationUncheckedCreateWithoutDataImportFilesInput;
  where: DataImportValidationWhereUniqueInput;
};

export type DataImportValidationCreateOrConnectWithoutDataImportValidationAuditsInput = {
  create: DataImportValidationUncheckedCreateWithoutDataImportValidationAuditsInput;
  where: DataImportValidationWhereUniqueInput;
};

export type DataImportValidationCreateWithoutDataImportFilesInput = {
  authoringReport?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportValidationAudits?: InputMaybe<DataImportValidationAuditCreateNestedManyWithoutDataImportValidationInput>;
  id?: InputMaybe<Scalars['String']>;
  report?: InputMaybe<Scalars['Json']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DataImportValidationCreateWithoutDataImportValidationAuditsInput = {
  authoringReport?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileCreateNestedManyWithoutValidationInput>;
  id?: InputMaybe<Scalars['String']>;
  report?: InputMaybe<Scalars['Json']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DataImportValidationMaxAggregateOutputType = {
  __typename?: 'DataImportValidationMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DataImportValidationMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DataImportValidationMinAggregateOutputType = {
  __typename?: 'DataImportValidationMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DataImportValidationMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DataImportValidationOrderByWithAggregationInput = {
  _count?: InputMaybe<DataImportValidationCountOrderByAggregateInput>;
  _max?: InputMaybe<DataImportValidationMaxOrderByAggregateInput>;
  _min?: InputMaybe<DataImportValidationMinOrderByAggregateInput>;
  authoringReport?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  report?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DataImportValidationOrderByWithRelationInput = {
  authoringReport?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  dataImportFiles?: InputMaybe<DataImportFileOrderByRelationAggregateInput>;
  dataImportValidationAudits?: InputMaybe<DataImportValidationAuditOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  report?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DataImportValidationRelationFilter = {
  is?: InputMaybe<DataImportValidationWhereInput>;
  isNot?: InputMaybe<DataImportValidationWhereInput>;
};

export enum DataImportValidationScalarFieldEnum {
  AuthoringReport = 'authoringReport',
  CreatedAt = 'createdAt',
  Id = 'id',
  Report = 'report',
  UpdatedAt = 'updatedAt'
}

export type DataImportValidationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DataImportValidationScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DataImportValidationScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DataImportValidationScalarWhereWithAggregatesInput>>;
  authoringReport?: InputMaybe<JsonNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  report?: InputMaybe<JsonNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export enum DataImportValidationStatus {
  Invalid = 'INVALID',
  Notvalidated = 'NOTVALIDATED',
  Processing = 'PROCESSING',
  Valid = 'VALID'
}

export type DataImportValidationUncheckedCreateInput = {
  authoringReport?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedCreateNestedManyWithoutValidationInput>;
  dataImportValidationAudits?: InputMaybe<DataImportValidationAuditUncheckedCreateNestedManyWithoutDataImportValidationInput>;
  id?: InputMaybe<Scalars['String']>;
  report?: InputMaybe<Scalars['Json']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DataImportValidationUncheckedCreateWithoutDataImportFilesInput = {
  authoringReport?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportValidationAudits?: InputMaybe<DataImportValidationAuditUncheckedCreateNestedManyWithoutDataImportValidationInput>;
  id?: InputMaybe<Scalars['String']>;
  report?: InputMaybe<Scalars['Json']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DataImportValidationUncheckedCreateWithoutDataImportValidationAuditsInput = {
  authoringReport?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedCreateNestedManyWithoutValidationInput>;
  id?: InputMaybe<Scalars['String']>;
  report?: InputMaybe<Scalars['Json']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DataImportValidationUncheckedUpdateInput = {
  authoringReport?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedUpdateManyWithoutValidationNestedInput>;
  dataImportValidationAudits?: InputMaybe<DataImportValidationAuditUncheckedUpdateManyWithoutDataImportValidationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  report?: InputMaybe<Scalars['Json']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DataImportValidationUncheckedUpdateManyInput = {
  authoringReport?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  report?: InputMaybe<Scalars['Json']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DataImportValidationUncheckedUpdateWithoutDataImportFilesInput = {
  authoringReport?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportValidationAudits?: InputMaybe<DataImportValidationAuditUncheckedUpdateManyWithoutDataImportValidationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  report?: InputMaybe<Scalars['Json']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DataImportValidationUncheckedUpdateWithoutDataImportValidationAuditsInput = {
  authoringReport?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedUpdateManyWithoutValidationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  report?: InputMaybe<Scalars['Json']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DataImportValidationUpdateInput = {
  authoringReport?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUpdateManyWithoutValidationNestedInput>;
  dataImportValidationAudits?: InputMaybe<DataImportValidationAuditUpdateManyWithoutDataImportValidationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  report?: InputMaybe<Scalars['Json']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DataImportValidationUpdateManyMutationInput = {
  authoringReport?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  report?: InputMaybe<Scalars['Json']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DataImportValidationUpdateOneWithoutDataImportFilesNestedInput = {
  connect?: InputMaybe<DataImportValidationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DataImportValidationCreateOrConnectWithoutDataImportFilesInput>;
  create?: InputMaybe<DataImportValidationUncheckedCreateWithoutDataImportFilesInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<DataImportValidationUncheckedUpdateWithoutDataImportFilesInput>;
  upsert?: InputMaybe<DataImportValidationUpsertWithoutDataImportFilesInput>;
};

export type DataImportValidationUpdateOneWithoutDataImportValidationAuditsNestedInput = {
  connect?: InputMaybe<DataImportValidationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DataImportValidationCreateOrConnectWithoutDataImportValidationAuditsInput>;
  create?: InputMaybe<DataImportValidationUncheckedCreateWithoutDataImportValidationAuditsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<DataImportValidationUncheckedUpdateWithoutDataImportValidationAuditsInput>;
  upsert?: InputMaybe<DataImportValidationUpsertWithoutDataImportValidationAuditsInput>;
};

export type DataImportValidationUpdateWithoutDataImportFilesInput = {
  authoringReport?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportValidationAudits?: InputMaybe<DataImportValidationAuditUpdateManyWithoutDataImportValidationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  report?: InputMaybe<Scalars['Json']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DataImportValidationUpdateWithoutDataImportValidationAuditsInput = {
  authoringReport?: InputMaybe<Scalars['Json']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUpdateManyWithoutValidationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  report?: InputMaybe<Scalars['Json']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DataImportValidationUpsertWithoutDataImportFilesInput = {
  create: DataImportValidationUncheckedCreateWithoutDataImportFilesInput;
  update: DataImportValidationUncheckedUpdateWithoutDataImportFilesInput;
};

export type DataImportValidationUpsertWithoutDataImportValidationAuditsInput = {
  create: DataImportValidationUncheckedCreateWithoutDataImportValidationAuditsInput;
  update: DataImportValidationUncheckedUpdateWithoutDataImportValidationAuditsInput;
};

export type DataImportValidationWhereInput = {
  AND?: InputMaybe<Array<DataImportValidationWhereInput>>;
  NOT?: InputMaybe<Array<DataImportValidationWhereInput>>;
  OR?: InputMaybe<Array<DataImportValidationWhereInput>>;
  authoringReport?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dataImportFiles?: InputMaybe<DataImportFileListRelationFilter>;
  dataImportValidationAudits?: InputMaybe<DataImportValidationAuditListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  report?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DataImportValidationWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type DataImportWhereInput = {
  AND?: InputMaybe<Array<DataImportWhereInput>>;
  NOT?: InputMaybe<Array<DataImportWhereInput>>;
  OR?: InputMaybe<Array<DataImportWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  files?: InputMaybe<DataImportFileListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  reference?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DataImportWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DateTimeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedDateTimeNullableFilter>;
  _min?: InputMaybe<NestedDateTimeNullableFilter>;
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type Definition = {
  __typename?: 'Definition';
  _count: DefinitionCountOutputType;
  createdAt: Scalars['DateTime'];
  fields: Array<Maybe<DefinitionFields>>;
  id: Scalars['String'];
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type DefinitionFieldsArgs = {
  cursor?: InputMaybe<DefinitionFieldsWhereUniqueInput>;
  distinct?: InputMaybe<DefinitionFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<DefinitionFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DefinitionFieldsWhereInput>;
};

export type DefinitionCountAggregateOutputType = {
  __typename?: 'DefinitionCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  pending: Scalars['Int'];
  published: Scalars['Int'];
  reference: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type DefinitionCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DefinitionCountOutputType = {
  __typename?: 'DefinitionCountOutputType';
  fields: Scalars['Int'];
};

export type DefinitionCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<DefinitionFieldsCreateNestedManyWithoutDefinitionInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DefinitionCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DefinitionCreateNestedOneWithoutFieldsInput = {
  connect?: InputMaybe<DefinitionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DefinitionCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<DefinitionUncheckedCreateWithoutFieldsInput>;
};

export type DefinitionCreateOrConnectWithoutFieldsInput = {
  create: DefinitionUncheckedCreateWithoutFieldsInput;
  where: DefinitionWhereUniqueInput;
};

export type DefinitionCreateWithoutFieldsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DefinitionFields = {
  __typename?: 'DefinitionFields';
  _count: DefinitionFieldsCountOutputType;
  active?: Maybe<Scalars['Boolean']>;
  cmsId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  dateCreated?: Maybe<Scalars['String']>;
  definition?: Maybe<Definition>;
  definitionId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isEEA?: Maybe<Scalars['Boolean']>;
  location: Array<Maybe<Location>>;
  pending?: Maybe<Scalars['Boolean']>;
  publishDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  stack?: Maybe<Scalars['String']>;
  term: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type DefinitionFieldsLocationArgs = {
  cursor?: InputMaybe<LocationWhereUniqueInput>;
  distinct?: InputMaybe<LocationScalarFieldEnum>;
  orderBy?: InputMaybe<LocationOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationWhereInput>;
};

export type DefinitionFieldsConnection = {
  __typename?: 'DefinitionFieldsConnection';
  aggregate: AggregateDefinitionFields;
  edges: Array<Maybe<DefinitionFieldsEdge>>;
  pageInfo: PageInfo;
};

export type DefinitionFieldsCountAggregateOutputType = {
  __typename?: 'DefinitionFieldsCountAggregateOutputType';
  _all: Scalars['Int'];
  active: Scalars['Int'];
  cmsId: Scalars['Int'];
  createdAt: Scalars['Int'];
  dateCreated: Scalars['Int'];
  definitionId: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  isEEA: Scalars['Int'];
  pending: Scalars['Int'];
  publishDate: Scalars['Int'];
  published: Scalars['Int'];
  stack: Scalars['Int'];
  term: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type DefinitionFieldsCountOrderByAggregateInput = {
  active?: InputMaybe<SortOrder>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dateCreated?: InputMaybe<SortOrder>;
  definitionId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isEEA?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  publishDate?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  term?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DefinitionFieldsCountOutputType = {
  __typename?: 'DefinitionFieldsCountOutputType';
  location: Scalars['Int'];
};

export type DefinitionFieldsCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  cmsId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dateCreated?: InputMaybe<Scalars['String']>;
  definition?: InputMaybe<DefinitionCreateNestedOneWithoutFieldsInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isEEA?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<LocationCreateNestedManyWithoutDefinitionInput>;
  pending?: InputMaybe<Scalars['Boolean']>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack?: InputMaybe<Scalars['String']>;
  term: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DefinitionFieldsCreateManyDefinitionInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  cmsId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dateCreated?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isEEA?: InputMaybe<Scalars['Boolean']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack?: InputMaybe<Scalars['String']>;
  term: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DefinitionFieldsCreateManyDefinitionInputEnvelope = {
  data: Array<DefinitionFieldsCreateManyDefinitionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DefinitionFieldsCreateManyInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  cmsId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dateCreated?: InputMaybe<Scalars['String']>;
  definitionId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isEEA?: InputMaybe<Scalars['Boolean']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack?: InputMaybe<Scalars['String']>;
  term: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DefinitionFieldsCreateNestedManyWithoutDefinitionInput = {
  connect?: InputMaybe<Array<DefinitionFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DefinitionFieldsCreateOrConnectWithoutDefinitionInput>>;
  create?: InputMaybe<Array<DefinitionFieldsCreateWithoutDefinitionInput>>;
  createMany?: InputMaybe<DefinitionFieldsCreateManyDefinitionInputEnvelope>;
};

export type DefinitionFieldsCreateNestedManyWithoutLocationInput = {
  connect?: InputMaybe<Array<DefinitionFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DefinitionFieldsCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<DefinitionFieldsCreateWithoutLocationInput>>;
};

export type DefinitionFieldsCreateOrConnectWithoutDefinitionInput = {
  create: DefinitionFieldsUncheckedCreateWithoutDefinitionInput;
  where: DefinitionFieldsWhereUniqueInput;
};

export type DefinitionFieldsCreateOrConnectWithoutLocationInput = {
  create: DefinitionFieldsUncheckedCreateWithoutLocationInput;
  where: DefinitionFieldsWhereUniqueInput;
};

export type DefinitionFieldsCreateWithoutDefinitionInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  cmsId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dateCreated?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isEEA?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<LocationCreateNestedManyWithoutDefinitionInput>;
  pending?: InputMaybe<Scalars['Boolean']>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack?: InputMaybe<Scalars['String']>;
  term: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DefinitionFieldsCreateWithoutLocationInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  cmsId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dateCreated?: InputMaybe<Scalars['String']>;
  definition?: InputMaybe<DefinitionCreateNestedOneWithoutFieldsInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isEEA?: InputMaybe<Scalars['Boolean']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack?: InputMaybe<Scalars['String']>;
  term: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DefinitionFieldsEdge = {
  __typename?: 'DefinitionFieldsEdge';
  cursor: Scalars['String'];
  node: DefinitionFields;
};

export type DefinitionFieldsListRelationFilter = {
  every?: InputMaybe<DefinitionFieldsWhereInput>;
  none?: InputMaybe<DefinitionFieldsWhereInput>;
  some?: InputMaybe<DefinitionFieldsWhereInput>;
};

export type DefinitionFieldsMaxAggregateOutputType = {
  __typename?: 'DefinitionFieldsMaxAggregateOutputType';
  active?: Maybe<Scalars['Boolean']>;
  cmsId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateCreated?: Maybe<Scalars['String']>;
  definitionId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isEEA?: Maybe<Scalars['Boolean']>;
  pending?: Maybe<Scalars['Boolean']>;
  publishDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  stack?: Maybe<Scalars['String']>;
  term?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DefinitionFieldsMaxOrderByAggregateInput = {
  active?: InputMaybe<SortOrder>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dateCreated?: InputMaybe<SortOrder>;
  definitionId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isEEA?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  publishDate?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  term?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DefinitionFieldsMinAggregateOutputType = {
  __typename?: 'DefinitionFieldsMinAggregateOutputType';
  active?: Maybe<Scalars['Boolean']>;
  cmsId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateCreated?: Maybe<Scalars['String']>;
  definitionId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isEEA?: Maybe<Scalars['Boolean']>;
  pending?: Maybe<Scalars['Boolean']>;
  publishDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  stack?: Maybe<Scalars['String']>;
  term?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DefinitionFieldsMinOrderByAggregateInput = {
  active?: InputMaybe<SortOrder>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dateCreated?: InputMaybe<SortOrder>;
  definitionId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isEEA?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  publishDate?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  term?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DefinitionFieldsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DefinitionFieldsOrderByWithAggregationInput = {
  _count?: InputMaybe<DefinitionFieldsCountOrderByAggregateInput>;
  _max?: InputMaybe<DefinitionFieldsMaxOrderByAggregateInput>;
  _min?: InputMaybe<DefinitionFieldsMinOrderByAggregateInput>;
  active?: InputMaybe<SortOrderInput>;
  cmsId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  dateCreated?: InputMaybe<SortOrderInput>;
  definitionId?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isEEA?: InputMaybe<SortOrderInput>;
  pending?: InputMaybe<SortOrderInput>;
  publishDate?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  stack?: InputMaybe<SortOrderInput>;
  term?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DefinitionFieldsOrderByWithRelationInput = {
  active?: InputMaybe<SortOrderInput>;
  cmsId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  dateCreated?: InputMaybe<SortOrderInput>;
  definition?: InputMaybe<DefinitionOrderByWithRelationInput>;
  definitionId?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isEEA?: InputMaybe<SortOrderInput>;
  location?: InputMaybe<LocationOrderByRelationAggregateInput>;
  pending?: InputMaybe<SortOrderInput>;
  publishDate?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  stack?: InputMaybe<SortOrderInput>;
  term?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum DefinitionFieldsScalarFieldEnum {
  Active = 'active',
  CmsId = 'cmsId',
  CreatedAt = 'createdAt',
  DateCreated = 'dateCreated',
  DefinitionId = 'definitionId',
  Description = 'description',
  Id = 'id',
  IsEea = 'isEEA',
  Pending = 'pending',
  PublishDate = 'publishDate',
  Published = 'published',
  Stack = 'stack',
  Term = 'term',
  UpdatedAt = 'updatedAt'
}

export type DefinitionFieldsScalarWhereInput = {
  AND?: InputMaybe<Array<DefinitionFieldsScalarWhereInput>>;
  NOT?: InputMaybe<Array<DefinitionFieldsScalarWhereInput>>;
  OR?: InputMaybe<Array<DefinitionFieldsScalarWhereInput>>;
  active?: InputMaybe<BoolNullableFilter>;
  cmsId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateCreated?: InputMaybe<StringNullableFilter>;
  definitionId?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isEEA?: InputMaybe<BoolNullableFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  publishDate?: InputMaybe<DateTimeNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  stack?: InputMaybe<StringNullableFilter>;
  term?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DefinitionFieldsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DefinitionFieldsScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DefinitionFieldsScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DefinitionFieldsScalarWhereWithAggregatesInput>>;
  active?: InputMaybe<BoolNullableWithAggregatesFilter>;
  cmsId?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  dateCreated?: InputMaybe<StringNullableWithAggregatesFilter>;
  definitionId?: InputMaybe<StringNullableWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isEEA?: InputMaybe<BoolNullableWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  publishDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  stack?: InputMaybe<StringNullableWithAggregatesFilter>;
  term?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type DefinitionFieldsUncheckedCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  cmsId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dateCreated?: InputMaybe<Scalars['String']>;
  definitionId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isEEA?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<LocationUncheckedCreateNestedManyWithoutDefinitionInput>;
  pending?: InputMaybe<Scalars['Boolean']>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack?: InputMaybe<Scalars['String']>;
  term: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DefinitionFieldsUncheckedCreateNestedManyWithoutDefinitionInput = {
  connect?: InputMaybe<Array<DefinitionFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DefinitionFieldsCreateOrConnectWithoutDefinitionInput>>;
  create?: InputMaybe<Array<DefinitionFieldsCreateWithoutDefinitionInput>>;
  createMany?: InputMaybe<DefinitionFieldsCreateManyDefinitionInputEnvelope>;
};

export type DefinitionFieldsUncheckedCreateNestedManyWithoutLocationInput = {
  connect?: InputMaybe<Array<DefinitionFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DefinitionFieldsCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<DefinitionFieldsCreateWithoutLocationInput>>;
};

export type DefinitionFieldsUncheckedCreateWithoutDefinitionInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  cmsId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dateCreated?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isEEA?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<LocationUncheckedCreateNestedManyWithoutDefinitionInput>;
  pending?: InputMaybe<Scalars['Boolean']>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack?: InputMaybe<Scalars['String']>;
  term: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DefinitionFieldsUncheckedCreateWithoutLocationInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  cmsId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dateCreated?: InputMaybe<Scalars['String']>;
  definitionId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isEEA?: InputMaybe<Scalars['Boolean']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack?: InputMaybe<Scalars['String']>;
  term: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DefinitionFieldsUncheckedUpdateInput = {
  active?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateCreated?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  definitionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEEA?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUncheckedUpdateManyWithoutDefinitionNestedInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  term?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DefinitionFieldsUncheckedUpdateManyInput = {
  active?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateCreated?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  definitionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEEA?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  term?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DefinitionFieldsUncheckedUpdateManyWithoutDefinitionInput = {
  active?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateCreated?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  definitionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEEA?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  term?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DefinitionFieldsUncheckedUpdateManyWithoutDefinitionNestedInput = {
  connect?: InputMaybe<Array<DefinitionFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DefinitionFieldsCreateOrConnectWithoutDefinitionInput>>;
  create?: InputMaybe<Array<DefinitionFieldsCreateWithoutDefinitionInput>>;
  createMany?: InputMaybe<DefinitionFieldsCreateManyDefinitionInputEnvelope>;
  delete?: InputMaybe<Array<DefinitionFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DefinitionFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DefinitionFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<DefinitionFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<DefinitionFieldsUpdateWithWhereUniqueWithoutDefinitionInput>>;
  updateMany?: InputMaybe<Array<DefinitionFieldsUpdateManyWithWhereWithoutDefinitionInput>>;
  upsert?: InputMaybe<Array<DefinitionFieldsUpsertWithWhereUniqueWithoutDefinitionInput>>;
};

export type DefinitionFieldsUncheckedUpdateManyWithoutFieldsInput = {
  active?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateCreated?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEEA?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  term?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DefinitionFieldsUncheckedUpdateManyWithoutLocationNestedInput = {
  connect?: InputMaybe<Array<DefinitionFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DefinitionFieldsCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<DefinitionFieldsCreateWithoutLocationInput>>;
  delete?: InputMaybe<Array<DefinitionFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DefinitionFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DefinitionFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<DefinitionFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<DefinitionFieldsUpdateWithWhereUniqueWithoutLocationInput>>;
  updateMany?: InputMaybe<Array<DefinitionFieldsUpdateManyWithWhereWithoutLocationInput>>;
  upsert?: InputMaybe<Array<DefinitionFieldsUpsertWithWhereUniqueWithoutLocationInput>>;
};

export type DefinitionFieldsUncheckedUpdateWithoutDefinitionInput = {
  active?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateCreated?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEEA?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUncheckedUpdateManyWithoutDefinitionNestedInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  term?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DefinitionFieldsUncheckedUpdateWithoutLocationInput = {
  active?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateCreated?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  definitionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEEA?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  term?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DefinitionFieldsUpdateInput = {
  active?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateCreated?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  definition?: InputMaybe<DefinitionUpdateOneWithoutFieldsNestedInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEEA?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateManyWithoutDefinitionNestedInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  term?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DefinitionFieldsUpdateManyMutationInput = {
  active?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateCreated?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  documentCycleId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEEA?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  term?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DefinitionFieldsUpdateManyWithWhereWithoutDefinitionInput = {
  data: DefinitionFieldsUncheckedUpdateManyWithoutFieldsInput;
  where: DefinitionFieldsScalarWhereInput;
};

export type DefinitionFieldsUpdateManyWithWhereWithoutLocationInput = {
  data: DefinitionFieldsUncheckedUpdateManyWithoutDefinitionInput;
  where: DefinitionFieldsScalarWhereInput;
};

export type DefinitionFieldsUpdateManyWithoutDefinitionNestedInput = {
  connect?: InputMaybe<Array<DefinitionFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DefinitionFieldsCreateOrConnectWithoutDefinitionInput>>;
  create?: InputMaybe<Array<DefinitionFieldsCreateWithoutDefinitionInput>>;
  createMany?: InputMaybe<DefinitionFieldsCreateManyDefinitionInputEnvelope>;
  delete?: InputMaybe<Array<DefinitionFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DefinitionFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DefinitionFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<DefinitionFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<DefinitionFieldsUpdateWithWhereUniqueWithoutDefinitionInput>>;
  updateMany?: InputMaybe<Array<DefinitionFieldsUpdateManyWithWhereWithoutDefinitionInput>>;
  upsert?: InputMaybe<Array<DefinitionFieldsUpsertWithWhereUniqueWithoutDefinitionInput>>;
};

export type DefinitionFieldsUpdateManyWithoutLocationNestedInput = {
  connect?: InputMaybe<Array<DefinitionFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DefinitionFieldsCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<DefinitionFieldsCreateWithoutLocationInput>>;
  delete?: InputMaybe<Array<DefinitionFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DefinitionFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DefinitionFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<DefinitionFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<DefinitionFieldsUpdateWithWhereUniqueWithoutLocationInput>>;
  updateMany?: InputMaybe<Array<DefinitionFieldsUpdateManyWithWhereWithoutLocationInput>>;
  upsert?: InputMaybe<Array<DefinitionFieldsUpsertWithWhereUniqueWithoutLocationInput>>;
};

export type DefinitionFieldsUpdateWithWhereUniqueWithoutDefinitionInput = {
  data: DefinitionFieldsUncheckedUpdateWithoutDefinitionInput;
  where: DefinitionFieldsWhereUniqueInput;
};

export type DefinitionFieldsUpdateWithWhereUniqueWithoutLocationInput = {
  data: DefinitionFieldsUncheckedUpdateWithoutLocationInput;
  where: DefinitionFieldsWhereUniqueInput;
};

export type DefinitionFieldsUpdateWithoutDefinitionInput = {
  active?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateCreated?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEEA?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateManyWithoutDefinitionNestedInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  term?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DefinitionFieldsUpdateWithoutLocationInput = {
  active?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateCreated?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  definition?: InputMaybe<DefinitionUpdateOneWithoutFieldsNestedInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEEA?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  term?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DefinitionFieldsUpsertWithWhereUniqueWithoutDefinitionInput = {
  create: DefinitionFieldsUncheckedCreateWithoutDefinitionInput;
  update: DefinitionFieldsUncheckedUpdateWithoutDefinitionInput;
  where: DefinitionFieldsWhereUniqueInput;
};

export type DefinitionFieldsUpsertWithWhereUniqueWithoutLocationInput = {
  create: DefinitionFieldsUncheckedCreateWithoutLocationInput;
  update: DefinitionFieldsUncheckedUpdateWithoutLocationInput;
  where: DefinitionFieldsWhereUniqueInput;
};

export type DefinitionFieldsWhereInput = {
  AND?: InputMaybe<Array<DefinitionFieldsWhereInput>>;
  NOT?: InputMaybe<Array<DefinitionFieldsWhereInput>>;
  OR?: InputMaybe<Array<DefinitionFieldsWhereInput>>;
  active?: InputMaybe<BoolNullableFilter>;
  cmsId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateCreated?: InputMaybe<StringNullableFilter>;
  definition?: InputMaybe<DefinitionWhereInput>;
  definitionId?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isEEA?: InputMaybe<BoolNullableFilter>;
  location?: InputMaybe<LocationListRelationFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  publishDate?: InputMaybe<DateTimeNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  stack?: InputMaybe<StringNullableFilter>;
  term?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DefinitionFieldsWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type DefinitionMaxAggregateOutputType = {
  __typename?: 'DefinitionMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DefinitionMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DefinitionMinAggregateOutputType = {
  __typename?: 'DefinitionMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DefinitionMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DefinitionOrderByWithAggregationInput = {
  _count?: InputMaybe<DefinitionCountOrderByAggregateInput>;
  _max?: InputMaybe<DefinitionMaxOrderByAggregateInput>;
  _min?: InputMaybe<DefinitionMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DefinitionOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  fields?: InputMaybe<DefinitionFieldsOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DefinitionRelationFilter = {
  is?: InputMaybe<DefinitionWhereInput>;
  isNot?: InputMaybe<DefinitionWhereInput>;
};

export enum DefinitionScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Pending = 'pending',
  Published = 'published',
  Reference = 'reference',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

export type DefinitionScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DefinitionScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DefinitionScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DefinitionScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  reference?: InputMaybe<StringNullableWithAggregatesFilter>;
  title?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type DefinitionUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<DefinitionFieldsUncheckedCreateNestedManyWithoutDefinitionInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DefinitionUncheckedCreateWithoutFieldsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DefinitionUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<DefinitionFieldsUncheckedUpdateManyWithoutDefinitionNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DefinitionUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DefinitionUncheckedUpdateWithoutFieldsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DefinitionUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<DefinitionFieldsUpdateManyWithoutDefinitionNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DefinitionUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DefinitionUpdateOneWithoutFieldsNestedInput = {
  connect?: InputMaybe<DefinitionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DefinitionCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<DefinitionUncheckedCreateWithoutFieldsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<DefinitionUncheckedUpdateWithoutFieldsInput>;
  upsert?: InputMaybe<DefinitionUpsertWithoutFieldsInput>;
};

export type DefinitionUpdateWithoutFieldsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DefinitionUpsertWithoutFieldsInput = {
  create: DefinitionUncheckedCreateWithoutFieldsInput;
  update: DefinitionUncheckedUpdateWithoutFieldsInput;
};

export type DefinitionWhereInput = {
  AND?: InputMaybe<Array<DefinitionWhereInput>>;
  NOT?: InputMaybe<Array<DefinitionWhereInput>>;
  OR?: InputMaybe<Array<DefinitionWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fields?: InputMaybe<DefinitionFieldsListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  reference?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DefinitionWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type Document = {
  __typename?: 'Document';
  _count: DocumentCountOutputType;
  createdAt: Scalars['DateTime'];
  documentCycles: Array<Maybe<DocumentCycle>>;
  id: Scalars['String'];
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type DocumentDocumentCyclesArgs = {
  cursor?: InputMaybe<DocumentCycleWhereUniqueInput>;
  distinct?: InputMaybe<DocumentCycleScalarFieldEnum>;
  orderBy?: InputMaybe<DocumentCycleOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DocumentCycleWhereInput>;
};

export type DocumentConnection = {
  __typename?: 'DocumentConnection';
  aggregate: AggregateDocument;
  edges: Array<Maybe<DocumentEdge>>;
  pageInfo: PageInfo;
};

export type DocumentCountAggregateOutputType = {
  __typename?: 'DocumentCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  locationId: Scalars['Int'];
  name: Scalars['Int'];
  owner: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type DocumentCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  owner?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DocumentCountOutputType = {
  __typename?: 'DocumentCountOutputType';
  documentCycles: Scalars['Int'];
};

export type DocumentCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  documentCycles?: InputMaybe<DocumentCycleCreateNestedManyWithoutDocumentInput>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationCreateNestedOneWithoutDocumentsInput>;
  name: Scalars['String'];
  owner?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DocumentCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  owner?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DocumentCreateManyLocationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  owner?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DocumentCreateManyLocationInputEnvelope = {
  data: Array<DocumentCreateManyLocationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DocumentCreateNestedManyWithoutLocationInput = {
  connect?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<DocumentCreateWithoutLocationInput>>;
  createMany?: InputMaybe<DocumentCreateManyLocationInputEnvelope>;
};

export type DocumentCreateNestedOneWithoutDocumentCyclesInput = {
  connect?: InputMaybe<DocumentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentCreateOrConnectWithoutDocumentCyclesInput>;
  create?: InputMaybe<DocumentUncheckedCreateWithoutDocumentCyclesInput>;
};

export type DocumentCreateOrConnectWithoutDocumentCyclesInput = {
  create: DocumentUncheckedCreateWithoutDocumentCyclesInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentCreateOrConnectWithoutLocationInput = {
  create: DocumentUncheckedCreateWithoutLocationInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentCreateWithoutDocumentCyclesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationCreateNestedOneWithoutDocumentsInput>;
  name: Scalars['String'];
  owner?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DocumentCreateWithoutLocationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  documentCycles?: InputMaybe<DocumentCycleCreateNestedManyWithoutDocumentInput>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  owner?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DocumentCycle = {
  __typename?: 'DocumentCycle';
  _count: DocumentCycleCountOutputType;
  createdAt: Scalars['DateTime'];
  cycle?: Maybe<Cycle>;
  cycleId?: Maybe<Scalars['String']>;
  document?: Maybe<Document>;
  documentId?: Maybe<Scalars['String']>;
  dueDate: Scalars['DateTime'];
  id: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  processing?: Maybe<Scalars['Boolean']>;
  progressStatus?: Maybe<ProgressStatus>;
  publishStatus?: Maybe<PublishStatus>;
  scheduledDate?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  versions: Array<Maybe<Version>>;
};


export type DocumentCycleVersionsArgs = {
  cursor?: InputMaybe<VersionWhereUniqueInput>;
  distinct?: InputMaybe<VersionScalarFieldEnum>;
  orderBy?: InputMaybe<VersionOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VersionWhereInput>;
};

export type DocumentCycleConnection = {
  __typename?: 'DocumentCycleConnection';
  aggregate: AggregateDocumentCycle;
  edges: Array<Maybe<DocumentCycleEdge>>;
  pageInfo: PageInfo;
};

export type DocumentCycleCountAggregateOutputType = {
  __typename?: 'DocumentCycleCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  cycleId: Scalars['Int'];
  documentId: Scalars['Int'];
  dueDate: Scalars['Int'];
  id: Scalars['Int'];
  owner: Scalars['Int'];
  processing: Scalars['Int'];
  progressStatus: Scalars['Int'];
  publishStatus: Scalars['Int'];
  scheduledDate: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type DocumentCycleCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  cycleId?: InputMaybe<SortOrder>;
  documentId?: InputMaybe<SortOrder>;
  dueDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  owner?: InputMaybe<SortOrder>;
  processing?: InputMaybe<SortOrder>;
  progressStatus?: InputMaybe<SortOrder>;
  publishStatus?: InputMaybe<SortOrder>;
  scheduledDate?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DocumentCycleCountOutputType = {
  __typename?: 'DocumentCycleCountOutputType';
  versions: Scalars['Int'];
};

export type DocumentCycleCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cycle?: InputMaybe<CycleCreateNestedOneWithoutDocumentsInput>;
  document?: InputMaybe<DocumentCreateNestedOneWithoutDocumentCyclesInput>;
  dueDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  processing?: InputMaybe<Scalars['Boolean']>;
  progressStatus?: InputMaybe<ProgressStatus>;
  publishStatus?: InputMaybe<PublishStatus>;
  scheduledDate?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<VersionCreateNestedManyWithoutDocumentCycleInput>;
};

export type DocumentCycleCreateManyCycleInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  documentId?: InputMaybe<Scalars['String']>;
  dueDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  processing?: InputMaybe<Scalars['Boolean']>;
  progressStatus?: InputMaybe<ProgressStatus>;
  publishStatus?: InputMaybe<PublishStatus>;
  scheduledDate?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DocumentCycleCreateManyCycleInputEnvelope = {
  data: Array<DocumentCycleCreateManyCycleInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DocumentCycleCreateManyDocumentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cycleId?: InputMaybe<Scalars['String']>;
  dueDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  processing?: InputMaybe<Scalars['Boolean']>;
  progressStatus?: InputMaybe<ProgressStatus>;
  publishStatus?: InputMaybe<PublishStatus>;
  scheduledDate?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DocumentCycleCreateManyDocumentInputEnvelope = {
  data: Array<DocumentCycleCreateManyDocumentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DocumentCycleCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cycleId?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['String']>;
  dueDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  processing?: InputMaybe<Scalars['Boolean']>;
  progressStatus?: InputMaybe<ProgressStatus>;
  publishStatus?: InputMaybe<PublishStatus>;
  scheduledDate?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DocumentCycleCreateNestedManyWithoutCycleInput = {
  connect?: InputMaybe<Array<DocumentCycleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCycleCreateOrConnectWithoutCycleInput>>;
  create?: InputMaybe<Array<DocumentCycleCreateWithoutCycleInput>>;
  createMany?: InputMaybe<DocumentCycleCreateManyCycleInputEnvelope>;
};

export type DocumentCycleCreateNestedManyWithoutDocumentInput = {
  connect?: InputMaybe<Array<DocumentCycleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCycleCreateOrConnectWithoutDocumentInput>>;
  create?: InputMaybe<Array<DocumentCycleCreateWithoutDocumentInput>>;
  createMany?: InputMaybe<DocumentCycleCreateManyDocumentInputEnvelope>;
};

export type DocumentCycleCreateNestedOneWithoutVersionsInput = {
  connect?: InputMaybe<DocumentCycleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentCycleCreateOrConnectWithoutVersionsInput>;
  create?: InputMaybe<DocumentCycleUncheckedCreateWithoutVersionsInput>;
};

export type DocumentCycleCreateOrConnectWithoutCycleInput = {
  create: DocumentCycleUncheckedCreateWithoutCycleInput;
  where: DocumentCycleWhereUniqueInput;
};

export type DocumentCycleCreateOrConnectWithoutDocumentInput = {
  create: DocumentCycleUncheckedCreateWithoutDocumentInput;
  where: DocumentCycleWhereUniqueInput;
};

export type DocumentCycleCreateOrConnectWithoutVersionsInput = {
  create: DocumentCycleUncheckedCreateWithoutVersionsInput;
  where: DocumentCycleWhereUniqueInput;
};

export type DocumentCycleCreateWithoutCycleInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  document?: InputMaybe<DocumentCreateNestedOneWithoutDocumentCyclesInput>;
  dueDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  processing?: InputMaybe<Scalars['Boolean']>;
  progressStatus?: InputMaybe<ProgressStatus>;
  publishStatus?: InputMaybe<PublishStatus>;
  scheduledDate?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<VersionCreateNestedManyWithoutDocumentCycleInput>;
};

export type DocumentCycleCreateWithoutDocumentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cycle?: InputMaybe<CycleCreateNestedOneWithoutDocumentsInput>;
  dueDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  processing?: InputMaybe<Scalars['Boolean']>;
  progressStatus?: InputMaybe<ProgressStatus>;
  publishStatus?: InputMaybe<PublishStatus>;
  scheduledDate?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<VersionCreateNestedManyWithoutDocumentCycleInput>;
};

export type DocumentCycleCreateWithoutVersionsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cycle?: InputMaybe<CycleCreateNestedOneWithoutDocumentsInput>;
  document?: InputMaybe<DocumentCreateNestedOneWithoutDocumentCyclesInput>;
  dueDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  processing?: InputMaybe<Scalars['Boolean']>;
  progressStatus?: InputMaybe<ProgressStatus>;
  publishStatus?: InputMaybe<PublishStatus>;
  scheduledDate?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DocumentCycleEdge = {
  __typename?: 'DocumentCycleEdge';
  cursor: Scalars['String'];
  node: DocumentCycle;
};

export type DocumentCycleListRelationFilter = {
  every?: InputMaybe<DocumentCycleWhereInput>;
  none?: InputMaybe<DocumentCycleWhereInput>;
  some?: InputMaybe<DocumentCycleWhereInput>;
};

export type DocumentCycleMaxAggregateOutputType = {
  __typename?: 'DocumentCycleMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  cycleId?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  processing?: Maybe<Scalars['Boolean']>;
  progressStatus?: Maybe<ProgressStatus>;
  publishStatus?: Maybe<PublishStatus>;
  scheduledDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentCycleMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  cycleId?: InputMaybe<SortOrder>;
  documentId?: InputMaybe<SortOrder>;
  dueDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  owner?: InputMaybe<SortOrder>;
  processing?: InputMaybe<SortOrder>;
  progressStatus?: InputMaybe<SortOrder>;
  publishStatus?: InputMaybe<SortOrder>;
  scheduledDate?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DocumentCycleMinAggregateOutputType = {
  __typename?: 'DocumentCycleMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  cycleId?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  processing?: Maybe<Scalars['Boolean']>;
  progressStatus?: Maybe<ProgressStatus>;
  publishStatus?: Maybe<PublishStatus>;
  scheduledDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentCycleMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  cycleId?: InputMaybe<SortOrder>;
  documentId?: InputMaybe<SortOrder>;
  dueDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  owner?: InputMaybe<SortOrder>;
  processing?: InputMaybe<SortOrder>;
  progressStatus?: InputMaybe<SortOrder>;
  publishStatus?: InputMaybe<SortOrder>;
  scheduledDate?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DocumentCycleOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DocumentCycleOrderByWithAggregationInput = {
  _count?: InputMaybe<DocumentCycleCountOrderByAggregateInput>;
  _max?: InputMaybe<DocumentCycleMaxOrderByAggregateInput>;
  _min?: InputMaybe<DocumentCycleMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  cycleId?: InputMaybe<SortOrderInput>;
  documentId?: InputMaybe<SortOrderInput>;
  dueDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  owner?: InputMaybe<SortOrderInput>;
  processing?: InputMaybe<SortOrderInput>;
  progressStatus?: InputMaybe<SortOrderInput>;
  publishStatus?: InputMaybe<SortOrderInput>;
  scheduledDate?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DocumentCycleOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  cycle?: InputMaybe<CycleOrderByWithRelationInput>;
  cycleId?: InputMaybe<SortOrderInput>;
  document?: InputMaybe<DocumentOrderByWithRelationInput>;
  documentId?: InputMaybe<SortOrderInput>;
  dueDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  owner?: InputMaybe<SortOrderInput>;
  processing?: InputMaybe<SortOrderInput>;
  progressStatus?: InputMaybe<SortOrderInput>;
  publishStatus?: InputMaybe<SortOrderInput>;
  scheduledDate?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  versions?: InputMaybe<VersionOrderByRelationAggregateInput>;
};

export type DocumentCycleOwner = {
  __typename?: 'DocumentCycleOwner';
  createdAt: Scalars['DateTime'];
  cycle: Cycle;
  document: Document;
  dueDate: Scalars['DateTime'];
  id: Scalars['ID'];
  owner?: Maybe<User>;
  processing?: Maybe<Scalars['Boolean']>;
  progressStatus?: Maybe<ProgressStatus>;
  publishStatus?: Maybe<PublishStatus>;
  scheduledDate?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  versions?: Maybe<Array<Maybe<Version>>>;
};


export type DocumentCycleOwnerVersionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<VersionOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VersionWhereInput>;
};

export type DocumentCycleOwnerConnection = {
  __typename?: 'DocumentCycleOwnerConnection';
  aggregate: AggregateDocumentCycleOwner;
  edges: Array<Maybe<DocumentCycleOwnerEdge>>;
  pageInfo: PageInfo;
};

export type DocumentCycleOwnerEdge = {
  __typename?: 'DocumentCycleOwnerEdge';
  cursor: Scalars['String'];
  node: DocumentCycleOwner;
};

export type DocumentCycleOwnerOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  cycle?: InputMaybe<CycleOrderByWithRelationInput>;
  cycleId?: InputMaybe<SortOrder>;
  document?: InputMaybe<DocumentOrderByWithRelationInput>;
  documentId?: InputMaybe<SortOrder>;
  dueDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  owner?: InputMaybe<SortOrder>;
  processing?: InputMaybe<SortOrder>;
  progressStatus?: InputMaybe<SortOrder>;
  publishStatus?: InputMaybe<SortOrder>;
  scheduledDate?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  versions?: InputMaybe<VersionOrderByRelationAggregateInput>;
};

export type DocumentCycleOwnerWhereInput = {
  AND?: InputMaybe<Array<DocumentCycleOwnerWhereInput>>;
  NOT?: InputMaybe<Array<DocumentCycleOwnerWhereInput>>;
  OR?: InputMaybe<Array<DocumentCycleOwnerWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  cycle?: InputMaybe<CycleWhereInput>;
  cycleId?: InputMaybe<StringNullableFilter>;
  document?: InputMaybe<DocumentWhereInput>;
  documentId?: InputMaybe<StringNullableFilter>;
  dueDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  owner?: InputMaybe<StringNullableFilter>;
  processing?: InputMaybe<BoolNullableFilter>;
  progressStatus?: InputMaybe<EnumProgressStatusNullableFilter>;
  publishStatus?: InputMaybe<EnumPublishStatusNullableFilter>;
  scheduledDate?: InputMaybe<DateTimeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  versions?: InputMaybe<VersionListRelationFilter>;
};

export type DocumentCycleRelationFilter = {
  is?: InputMaybe<DocumentCycleWhereInput>;
  isNot?: InputMaybe<DocumentCycleWhereInput>;
};

export enum DocumentCycleScalarFieldEnum {
  CreatedAt = 'createdAt',
  CycleId = 'cycleId',
  DocumentId = 'documentId',
  DueDate = 'dueDate',
  Id = 'id',
  Owner = 'owner',
  Processing = 'processing',
  ProgressStatus = 'progressStatus',
  PublishStatus = 'publishStatus',
  ScheduledDate = 'scheduledDate',
  UpdatedAt = 'updatedAt'
}

export type DocumentCycleScalarWhereInput = {
  AND?: InputMaybe<Array<DocumentCycleScalarWhereInput>>;
  NOT?: InputMaybe<Array<DocumentCycleScalarWhereInput>>;
  OR?: InputMaybe<Array<DocumentCycleScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  cycleId?: InputMaybe<StringNullableFilter>;
  documentId?: InputMaybe<StringNullableFilter>;
  dueDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  owner?: InputMaybe<StringNullableFilter>;
  processing?: InputMaybe<BoolNullableFilter>;
  progressStatus?: InputMaybe<EnumProgressStatusNullableFilter>;
  publishStatus?: InputMaybe<EnumPublishStatusNullableFilter>;
  scheduledDate?: InputMaybe<DateTimeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DocumentCycleScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DocumentCycleScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DocumentCycleScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DocumentCycleScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  cycleId?: InputMaybe<StringNullableWithAggregatesFilter>;
  documentId?: InputMaybe<StringNullableWithAggregatesFilter>;
  dueDate?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  owner?: InputMaybe<StringNullableWithAggregatesFilter>;
  processing?: InputMaybe<BoolNullableWithAggregatesFilter>;
  progressStatus?: InputMaybe<EnumProgressStatusNullableWithAggregatesFilter>;
  publishStatus?: InputMaybe<EnumPublishStatusNullableWithAggregatesFilter>;
  scheduledDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type DocumentCycleTaxonomyInput = {
  location: Scalars['String'];
};

export type DocumentCycleUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cycleId?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['String']>;
  dueDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  processing?: InputMaybe<Scalars['Boolean']>;
  progressStatus?: InputMaybe<ProgressStatus>;
  publishStatus?: InputMaybe<PublishStatus>;
  scheduledDate?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<VersionUncheckedCreateNestedManyWithoutDocumentCycleInput>;
};

export type DocumentCycleUncheckedCreateNestedManyWithoutCycleInput = {
  connect?: InputMaybe<Array<DocumentCycleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCycleCreateOrConnectWithoutCycleInput>>;
  create?: InputMaybe<Array<DocumentCycleCreateWithoutCycleInput>>;
  createMany?: InputMaybe<DocumentCycleCreateManyCycleInputEnvelope>;
};

export type DocumentCycleUncheckedCreateNestedManyWithoutDocumentInput = {
  connect?: InputMaybe<Array<DocumentCycleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCycleCreateOrConnectWithoutDocumentInput>>;
  create?: InputMaybe<Array<DocumentCycleCreateWithoutDocumentInput>>;
  createMany?: InputMaybe<DocumentCycleCreateManyDocumentInputEnvelope>;
};

export type DocumentCycleUncheckedCreateWithoutCycleInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  documentId?: InputMaybe<Scalars['String']>;
  dueDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  processing?: InputMaybe<Scalars['Boolean']>;
  progressStatus?: InputMaybe<ProgressStatus>;
  publishStatus?: InputMaybe<PublishStatus>;
  scheduledDate?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<VersionUncheckedCreateNestedManyWithoutDocumentCycleInput>;
};

export type DocumentCycleUncheckedCreateWithoutDocumentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cycleId?: InputMaybe<Scalars['String']>;
  dueDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  processing?: InputMaybe<Scalars['Boolean']>;
  progressStatus?: InputMaybe<ProgressStatus>;
  publishStatus?: InputMaybe<PublishStatus>;
  scheduledDate?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<VersionUncheckedCreateNestedManyWithoutDocumentCycleInput>;
};

export type DocumentCycleUncheckedCreateWithoutVersionsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cycleId?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['String']>;
  dueDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  processing?: InputMaybe<Scalars['Boolean']>;
  progressStatus?: InputMaybe<ProgressStatus>;
  publishStatus?: InputMaybe<PublishStatus>;
  scheduledDate?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DocumentCycleUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  cycleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  documentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dueDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  owner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  progressStatus?: InputMaybe<NullableEnumProgressStatusFieldUpdateOperationsInput>;
  publishStatus?: InputMaybe<NullableEnumPublishStatusFieldUpdateOperationsInput>;
  scheduledDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  versions?: InputMaybe<VersionUncheckedUpdateManyWithoutDocumentCycleNestedInput>;
};

export type DocumentCycleUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  cycleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  documentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dueDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  owner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  progressStatus?: InputMaybe<NullableEnumProgressStatusFieldUpdateOperationsInput>;
  publishStatus?: InputMaybe<NullableEnumPublishStatusFieldUpdateOperationsInput>;
  scheduledDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentCycleUncheckedUpdateManyWithoutCycleNestedInput = {
  connect?: InputMaybe<Array<DocumentCycleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCycleCreateOrConnectWithoutCycleInput>>;
  create?: InputMaybe<Array<DocumentCycleCreateWithoutCycleInput>>;
  createMany?: InputMaybe<DocumentCycleCreateManyCycleInputEnvelope>;
  delete?: InputMaybe<Array<DocumentCycleWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentCycleScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentCycleWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentCycleWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentCycleUpdateWithWhereUniqueWithoutCycleInput>>;
  updateMany?: InputMaybe<Array<DocumentCycleUpdateManyWithWhereWithoutCycleInput>>;
  upsert?: InputMaybe<Array<DocumentCycleUpsertWithWhereUniqueWithoutCycleInput>>;
};

export type DocumentCycleUncheckedUpdateManyWithoutDocumentCyclesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  cycleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dueDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  owner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  progressStatus?: InputMaybe<NullableEnumProgressStatusFieldUpdateOperationsInput>;
  publishStatus?: InputMaybe<NullableEnumPublishStatusFieldUpdateOperationsInput>;
  scheduledDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentCycleUncheckedUpdateManyWithoutDocumentNestedInput = {
  connect?: InputMaybe<Array<DocumentCycleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCycleCreateOrConnectWithoutDocumentInput>>;
  create?: InputMaybe<Array<DocumentCycleCreateWithoutDocumentInput>>;
  createMany?: InputMaybe<DocumentCycleCreateManyDocumentInputEnvelope>;
  delete?: InputMaybe<Array<DocumentCycleWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentCycleScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentCycleWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentCycleWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentCycleUpdateWithWhereUniqueWithoutDocumentInput>>;
  updateMany?: InputMaybe<Array<DocumentCycleUpdateManyWithWhereWithoutDocumentInput>>;
  upsert?: InputMaybe<Array<DocumentCycleUpsertWithWhereUniqueWithoutDocumentInput>>;
};

export type DocumentCycleUncheckedUpdateManyWithoutDocumentsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  documentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dueDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  owner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  progressStatus?: InputMaybe<NullableEnumProgressStatusFieldUpdateOperationsInput>;
  publishStatus?: InputMaybe<NullableEnumPublishStatusFieldUpdateOperationsInput>;
  scheduledDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentCycleUncheckedUpdateWithoutCycleInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  documentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dueDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  owner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  progressStatus?: InputMaybe<NullableEnumProgressStatusFieldUpdateOperationsInput>;
  publishStatus?: InputMaybe<NullableEnumPublishStatusFieldUpdateOperationsInput>;
  scheduledDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  versions?: InputMaybe<VersionUncheckedUpdateManyWithoutDocumentCycleNestedInput>;
};

export type DocumentCycleUncheckedUpdateWithoutDocumentInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  cycleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dueDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  owner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  progressStatus?: InputMaybe<NullableEnumProgressStatusFieldUpdateOperationsInput>;
  publishStatus?: InputMaybe<NullableEnumPublishStatusFieldUpdateOperationsInput>;
  scheduledDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  versions?: InputMaybe<VersionUncheckedUpdateManyWithoutDocumentCycleNestedInput>;
};

export type DocumentCycleUncheckedUpdateWithoutVersionsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  cycleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  documentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dueDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  owner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  progressStatus?: InputMaybe<NullableEnumProgressStatusFieldUpdateOperationsInput>;
  publishStatus?: InputMaybe<NullableEnumPublishStatusFieldUpdateOperationsInput>;
  scheduledDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentCycleUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  cycle?: InputMaybe<CycleUpdateOneWithoutDocumentsNestedInput>;
  document?: InputMaybe<DocumentUpdateOneWithoutDocumentCyclesNestedInput>;
  dueDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  owner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  progressStatus?: InputMaybe<NullableEnumProgressStatusFieldUpdateOperationsInput>;
  publishStatus?: InputMaybe<NullableEnumPublishStatusFieldUpdateOperationsInput>;
  scheduledDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  versions?: InputMaybe<VersionUpdateManyWithoutDocumentCycleNestedInput>;
};

export type DocumentCycleUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dueDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  owner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  progressStatus?: InputMaybe<NullableEnumProgressStatusFieldUpdateOperationsInput>;
  publishStatus?: InputMaybe<NullableEnumPublishStatusFieldUpdateOperationsInput>;
  scheduledDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentCycleUpdateManyWithWhereWithoutCycleInput = {
  data: DocumentCycleUncheckedUpdateManyWithoutDocumentsInput;
  where: DocumentCycleScalarWhereInput;
};

export type DocumentCycleUpdateManyWithWhereWithoutDocumentInput = {
  data: DocumentCycleUncheckedUpdateManyWithoutDocumentCyclesInput;
  where: DocumentCycleScalarWhereInput;
};

export type DocumentCycleUpdateManyWithoutCycleNestedInput = {
  connect?: InputMaybe<Array<DocumentCycleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCycleCreateOrConnectWithoutCycleInput>>;
  create?: InputMaybe<Array<DocumentCycleCreateWithoutCycleInput>>;
  createMany?: InputMaybe<DocumentCycleCreateManyCycleInputEnvelope>;
  delete?: InputMaybe<Array<DocumentCycleWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentCycleScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentCycleWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentCycleWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentCycleUpdateWithWhereUniqueWithoutCycleInput>>;
  updateMany?: InputMaybe<Array<DocumentCycleUpdateManyWithWhereWithoutCycleInput>>;
  upsert?: InputMaybe<Array<DocumentCycleUpsertWithWhereUniqueWithoutCycleInput>>;
};

export type DocumentCycleUpdateManyWithoutDocumentNestedInput = {
  connect?: InputMaybe<Array<DocumentCycleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCycleCreateOrConnectWithoutDocumentInput>>;
  create?: InputMaybe<Array<DocumentCycleCreateWithoutDocumentInput>>;
  createMany?: InputMaybe<DocumentCycleCreateManyDocumentInputEnvelope>;
  delete?: InputMaybe<Array<DocumentCycleWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentCycleScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentCycleWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentCycleWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentCycleUpdateWithWhereUniqueWithoutDocumentInput>>;
  updateMany?: InputMaybe<Array<DocumentCycleUpdateManyWithWhereWithoutDocumentInput>>;
  upsert?: InputMaybe<Array<DocumentCycleUpsertWithWhereUniqueWithoutDocumentInput>>;
};

export type DocumentCycleUpdateOneWithoutVersionsNestedInput = {
  connect?: InputMaybe<DocumentCycleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentCycleCreateOrConnectWithoutVersionsInput>;
  create?: InputMaybe<DocumentCycleUncheckedCreateWithoutVersionsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<DocumentCycleUncheckedUpdateWithoutVersionsInput>;
  upsert?: InputMaybe<DocumentCycleUpsertWithoutVersionsInput>;
};

export type DocumentCycleUpdateWithWhereUniqueWithoutCycleInput = {
  data: DocumentCycleUncheckedUpdateWithoutCycleInput;
  where: DocumentCycleWhereUniqueInput;
};

export type DocumentCycleUpdateWithWhereUniqueWithoutDocumentInput = {
  data: DocumentCycleUncheckedUpdateWithoutDocumentInput;
  where: DocumentCycleWhereUniqueInput;
};

export type DocumentCycleUpdateWithoutCycleInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  document?: InputMaybe<DocumentUpdateOneWithoutDocumentCyclesNestedInput>;
  dueDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  owner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  progressStatus?: InputMaybe<NullableEnumProgressStatusFieldUpdateOperationsInput>;
  publishStatus?: InputMaybe<NullableEnumPublishStatusFieldUpdateOperationsInput>;
  scheduledDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  versions?: InputMaybe<VersionUpdateManyWithoutDocumentCycleNestedInput>;
};

export type DocumentCycleUpdateWithoutDocumentInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  cycle?: InputMaybe<CycleUpdateOneWithoutDocumentsNestedInput>;
  dueDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  owner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  progressStatus?: InputMaybe<NullableEnumProgressStatusFieldUpdateOperationsInput>;
  publishStatus?: InputMaybe<NullableEnumPublishStatusFieldUpdateOperationsInput>;
  scheduledDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  versions?: InputMaybe<VersionUpdateManyWithoutDocumentCycleNestedInput>;
};

export type DocumentCycleUpdateWithoutVersionsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  cycle?: InputMaybe<CycleUpdateOneWithoutDocumentsNestedInput>;
  document?: InputMaybe<DocumentUpdateOneWithoutDocumentCyclesNestedInput>;
  dueDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  owner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  progressStatus?: InputMaybe<NullableEnumProgressStatusFieldUpdateOperationsInput>;
  publishStatus?: InputMaybe<NullableEnumPublishStatusFieldUpdateOperationsInput>;
  scheduledDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentCycleUpsertWithWhereUniqueWithoutCycleInput = {
  create: DocumentCycleUncheckedCreateWithoutCycleInput;
  update: DocumentCycleUncheckedUpdateWithoutCycleInput;
  where: DocumentCycleWhereUniqueInput;
};

export type DocumentCycleUpsertWithWhereUniqueWithoutDocumentInput = {
  create: DocumentCycleUncheckedCreateWithoutDocumentInput;
  update: DocumentCycleUncheckedUpdateWithoutDocumentInput;
  where: DocumentCycleWhereUniqueInput;
};

export type DocumentCycleUpsertWithoutVersionsInput = {
  create: DocumentCycleUncheckedCreateWithoutVersionsInput;
  update: DocumentCycleUncheckedUpdateWithoutVersionsInput;
};

export type DocumentCycleWhereInput = {
  AND?: InputMaybe<Array<DocumentCycleWhereInput>>;
  NOT?: InputMaybe<Array<DocumentCycleWhereInput>>;
  OR?: InputMaybe<Array<DocumentCycleWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  cycle?: InputMaybe<CycleWhereInput>;
  cycleId?: InputMaybe<StringNullableFilter>;
  document?: InputMaybe<DocumentWhereInput>;
  documentId?: InputMaybe<StringNullableFilter>;
  dueDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  owner?: InputMaybe<StringNullableFilter>;
  processing?: InputMaybe<BoolNullableFilter>;
  progressStatus?: InputMaybe<EnumProgressStatusNullableFilter>;
  publishStatus?: InputMaybe<EnumPublishStatusNullableFilter>;
  scheduledDate?: InputMaybe<DateTimeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  versions?: InputMaybe<VersionListRelationFilter>;
};

export type DocumentCycleWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type DocumentCyclesByTaxonomyInput = {
  dueDate: Scalars['DateTime'];
  taxonomy: DocumentCycleTaxonomyInput;
};

export type DocumentEdge = {
  __typename?: 'DocumentEdge';
  cursor: Scalars['String'];
  node: Document;
};

export type DocumentListRelationFilter = {
  every?: InputMaybe<DocumentWhereInput>;
  none?: InputMaybe<DocumentWhereInput>;
  some?: InputMaybe<DocumentWhereInput>;
};

export type DocumentMaxAggregateOutputType = {
  __typename?: 'DocumentMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  owner?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DocumentMinAggregateOutputType = {
  __typename?: 'DocumentMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  owner?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DocumentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DocumentOrderByWithAggregationInput = {
  _count?: InputMaybe<DocumentCountOrderByAggregateInput>;
  _max?: InputMaybe<DocumentMaxOrderByAggregateInput>;
  _min?: InputMaybe<DocumentMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  owner?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DocumentOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  documentCycles?: InputMaybe<DocumentCycleOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  location?: InputMaybe<LocationOrderByWithRelationInput>;
  locationId?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  owner?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DocumentOwner = {
  __typename?: 'DocumentOwner';
  createdAt: Scalars['DateTime'];
  documentCycles?: Maybe<Array<Maybe<DocumentCycle>>>;
  id: Scalars['ID'];
  location: Location;
  name: Scalars['String'];
  owner?: Maybe<User>;
  updatedAt: Scalars['DateTime'];
};


export type DocumentOwnerDocumentCyclesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DocumentCycleOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DocumentCycleWhereInput>;
};

export type DocumentOwnerConnection = {
  __typename?: 'DocumentOwnerConnection';
  aggregate: AggregateDocumentOwner;
  edges: Array<Maybe<DocumentOwnerEdge>>;
  pageInfo: PageInfo;
};

export type DocumentOwnerEdge = {
  __typename?: 'DocumentOwnerEdge';
  cursor: Scalars['String'];
  node: DocumentOwner;
};

export type DocumentOwnerOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  documentCycles?: InputMaybe<DocumentCycleOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  location?: InputMaybe<LocationOrderByWithRelationInput>;
  locationId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  owner?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DocumentOwnerWhereInput = {
  AND?: InputMaybe<Array<DocumentOwnerWhereInput>>;
  NOT?: InputMaybe<Array<DocumentOwnerWhereInput>>;
  OR?: InputMaybe<Array<DocumentOwnerWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentCycles?: InputMaybe<DocumentCycleListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  location?: InputMaybe<LocationWhereInput>;
  locationId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  owner?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DocumentRelationFilter = {
  is?: InputMaybe<DocumentWhereInput>;
  isNot?: InputMaybe<DocumentWhereInput>;
};

export enum DocumentScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  LocationId = 'locationId',
  Name = 'name',
  Owner = 'owner',
  UpdatedAt = 'updatedAt'
}

export type DocumentScalarWhereInput = {
  AND?: InputMaybe<Array<DocumentScalarWhereInput>>;
  NOT?: InputMaybe<Array<DocumentScalarWhereInput>>;
  OR?: InputMaybe<Array<DocumentScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  locationId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  owner?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DocumentScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DocumentScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DocumentScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DocumentScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  locationId?: InputMaybe<StringNullableWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  owner?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type DocumentUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  documentCycles?: InputMaybe<DocumentCycleUncheckedCreateNestedManyWithoutDocumentInput>;
  id?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  owner?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DocumentUncheckedCreateNestedManyWithoutLocationInput = {
  connect?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<DocumentCreateWithoutLocationInput>>;
  createMany?: InputMaybe<DocumentCreateManyLocationInputEnvelope>;
};

export type DocumentUncheckedCreateWithoutDocumentCyclesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  owner?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DocumentUncheckedCreateWithoutLocationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  documentCycles?: InputMaybe<DocumentCycleUncheckedCreateNestedManyWithoutDocumentInput>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  owner?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DocumentUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  documentCycles?: InputMaybe<DocumentCycleUncheckedUpdateManyWithoutDocumentNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  owner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  owner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentUncheckedUpdateManyWithoutDocumentsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  owner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentUncheckedUpdateManyWithoutLocationNestedInput = {
  connect?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<DocumentCreateWithoutLocationInput>>;
  createMany?: InputMaybe<DocumentCreateManyLocationInputEnvelope>;
  delete?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentUpdateWithWhereUniqueWithoutLocationInput>>;
  updateMany?: InputMaybe<Array<DocumentUpdateManyWithWhereWithoutLocationInput>>;
  upsert?: InputMaybe<Array<DocumentUpsertWithWhereUniqueWithoutLocationInput>>;
};

export type DocumentUncheckedUpdateWithoutDocumentCyclesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  owner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentUncheckedUpdateWithoutLocationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  documentCycles?: InputMaybe<DocumentCycleUncheckedUpdateManyWithoutDocumentNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  owner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  documentCycles?: InputMaybe<DocumentCycleUpdateManyWithoutDocumentNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneWithoutDocumentsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  owner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  owner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentUpdateManyWithWhereWithoutLocationInput = {
  data: DocumentUncheckedUpdateManyWithoutDocumentsInput;
  where: DocumentScalarWhereInput;
};

export type DocumentUpdateManyWithoutLocationNestedInput = {
  connect?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<DocumentCreateWithoutLocationInput>>;
  createMany?: InputMaybe<DocumentCreateManyLocationInputEnvelope>;
  delete?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentUpdateWithWhereUniqueWithoutLocationInput>>;
  updateMany?: InputMaybe<Array<DocumentUpdateManyWithWhereWithoutLocationInput>>;
  upsert?: InputMaybe<Array<DocumentUpsertWithWhereUniqueWithoutLocationInput>>;
};

export type DocumentUpdateOneWithoutDocumentCyclesNestedInput = {
  connect?: InputMaybe<DocumentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentCreateOrConnectWithoutDocumentCyclesInput>;
  create?: InputMaybe<DocumentUncheckedCreateWithoutDocumentCyclesInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<DocumentUncheckedUpdateWithoutDocumentCyclesInput>;
  upsert?: InputMaybe<DocumentUpsertWithoutDocumentCyclesInput>;
};

export type DocumentUpdateWithWhereUniqueWithoutLocationInput = {
  data: DocumentUncheckedUpdateWithoutLocationInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentUpdateWithoutDocumentCyclesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneWithoutDocumentsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  owner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentUpdateWithoutLocationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  documentCycles?: InputMaybe<DocumentCycleUpdateManyWithoutDocumentNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  owner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentUpsertWithWhereUniqueWithoutLocationInput = {
  create: DocumentUncheckedCreateWithoutLocationInput;
  update: DocumentUncheckedUpdateWithoutLocationInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentUpsertWithoutDocumentCyclesInput = {
  create: DocumentUncheckedCreateWithoutDocumentCyclesInput;
  update: DocumentUncheckedUpdateWithoutDocumentCyclesInput;
};

export type DocumentWhereInput = {
  AND?: InputMaybe<Array<DocumentWhereInput>>;
  NOT?: InputMaybe<Array<DocumentWhereInput>>;
  OR?: InputMaybe<Array<DocumentWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentCycles?: InputMaybe<DocumentCycleListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  location?: InputMaybe<LocationWhereInput>;
  locationId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  owner?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DocumentWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type Entity = {
  __typename?: 'Entity';
  _count: EntityCountOutputType;
  createdAt: Scalars['DateTime'];
  fields: Array<Maybe<EntityFields>>;
  id: Scalars['String'];
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type EntityFieldsArgs = {
  cursor?: InputMaybe<EntityFieldsWhereUniqueInput>;
  distinct?: InputMaybe<EntityFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<EntityFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EntityFieldsWhereInput>;
};

export type EntityCountAggregateOutputType = {
  __typename?: 'EntityCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  pending: Scalars['Int'];
  published: Scalars['Int'];
  reference: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type EntityCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EntityCountOutputType = {
  __typename?: 'EntityCountOutputType';
  fields: Scalars['Int'];
};

export type EntityCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<EntityFieldsCreateNestedManyWithoutEntityInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type EntityCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type EntityCreateNestedOneWithoutFieldsInput = {
  connect?: InputMaybe<EntityWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EntityCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<EntityUncheckedCreateWithoutFieldsInput>;
};

export type EntityCreateOrConnectWithoutFieldsInput = {
  create: EntityUncheckedCreateWithoutFieldsInput;
  where: EntityWhereUniqueInput;
};

export type EntityCreateWithoutFieldsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type EntityFields = {
  __typename?: 'EntityFields';
  _count: EntityFieldsCountOutputType;
  cmsId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  entity?: Maybe<Entity>;
  entityId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  locations: Array<Maybe<Location>>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type EntityFieldsLocationsArgs = {
  cursor?: InputMaybe<LocationWhereUniqueInput>;
  distinct?: InputMaybe<LocationScalarFieldEnum>;
  orderBy?: InputMaybe<LocationOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationWhereInput>;
};

export type EntityFieldsAvgAggregateOutputType = {
  __typename?: 'EntityFieldsAvgAggregateOutputType';
  order?: Maybe<Scalars['Float']>;
};

export type EntityFieldsAvgOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type EntityFieldsCountAggregateOutputType = {
  __typename?: 'EntityFieldsCountAggregateOutputType';
  _all: Scalars['Int'];
  cmsId: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  entityId: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  order: Scalars['Int'];
  pending: Scalars['Int'];
  published: Scalars['Int'];
  stack: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type EntityFieldsCountOrderByAggregateInput = {
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  entityId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EntityFieldsCountOutputType = {
  __typename?: 'EntityFieldsCountOutputType';
  locations: Scalars['Int'];
};

export type EntityFieldsCreateInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  entity?: InputMaybe<EntityCreateNestedOneWithoutFieldsInput>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutEntitiesInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type EntityFieldsCreateManyEntityInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type EntityFieldsCreateManyEntityInputEnvelope = {
  data: Array<EntityFieldsCreateManyEntityInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type EntityFieldsCreateManyInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  entityId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type EntityFieldsCreateNestedManyWithoutEntityInput = {
  connect?: InputMaybe<Array<EntityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EntityFieldsCreateOrConnectWithoutEntityInput>>;
  create?: InputMaybe<Array<EntityFieldsCreateWithoutEntityInput>>;
  createMany?: InputMaybe<EntityFieldsCreateManyEntityInputEnvelope>;
};

export type EntityFieldsCreateNestedManyWithoutLocationsInput = {
  connect?: InputMaybe<Array<EntityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EntityFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<EntityFieldsCreateWithoutLocationsInput>>;
};

export type EntityFieldsCreateOrConnectWithoutEntityInput = {
  create: EntityFieldsUncheckedCreateWithoutEntityInput;
  where: EntityFieldsWhereUniqueInput;
};

export type EntityFieldsCreateOrConnectWithoutLocationsInput = {
  create: EntityFieldsUncheckedCreateWithoutLocationsInput;
  where: EntityFieldsWhereUniqueInput;
};

export type EntityFieldsCreateWithoutEntityInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutEntitiesInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type EntityFieldsCreateWithoutLocationsInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  entity?: InputMaybe<EntityCreateNestedOneWithoutFieldsInput>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type EntityFieldsListRelationFilter = {
  every?: InputMaybe<EntityFieldsWhereInput>;
  none?: InputMaybe<EntityFieldsWhereInput>;
  some?: InputMaybe<EntityFieldsWhereInput>;
};

export type EntityFieldsMaxAggregateOutputType = {
  __typename?: 'EntityFieldsMaxAggregateOutputType';
  cmsId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  stack?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EntityFieldsMaxOrderByAggregateInput = {
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  entityId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EntityFieldsMinAggregateOutputType = {
  __typename?: 'EntityFieldsMinAggregateOutputType';
  cmsId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  stack?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EntityFieldsMinOrderByAggregateInput = {
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  entityId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EntityFieldsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type EntityFieldsOrderByWithAggregationInput = {
  _avg?: InputMaybe<EntityFieldsAvgOrderByAggregateInput>;
  _count?: InputMaybe<EntityFieldsCountOrderByAggregateInput>;
  _max?: InputMaybe<EntityFieldsMaxOrderByAggregateInput>;
  _min?: InputMaybe<EntityFieldsMinOrderByAggregateInput>;
  _sum?: InputMaybe<EntityFieldsSumOrderByAggregateInput>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  entityId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrderInput>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EntityFieldsOrderByWithRelationInput = {
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  entity?: InputMaybe<EntityOrderByWithRelationInput>;
  entityId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  locations?: InputMaybe<LocationOrderByRelationAggregateInput>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrderInput>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum EntityFieldsScalarFieldEnum {
  CmsId = 'cmsId',
  CreatedAt = 'createdAt',
  Description = 'description',
  EntityId = 'entityId',
  Id = 'id',
  Name = 'name',
  Order = 'order',
  Pending = 'pending',
  Published = 'published',
  Stack = 'stack',
  UpdatedAt = 'updatedAt'
}

export type EntityFieldsScalarWhereInput = {
  AND?: InputMaybe<Array<EntityFieldsScalarWhereInput>>;
  NOT?: InputMaybe<Array<EntityFieldsScalarWhereInput>>;
  OR?: InputMaybe<Array<EntityFieldsScalarWhereInput>>;
  cmsId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  entityId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  stack?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EntityFieldsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<EntityFieldsScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<EntityFieldsScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<EntityFieldsScalarWhereWithAggregatesInput>>;
  cmsId?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  entityId?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  order?: InputMaybe<IntNullableWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  stack?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type EntityFieldsSumAggregateOutputType = {
  __typename?: 'EntityFieldsSumAggregateOutputType';
  order?: Maybe<Scalars['Int']>;
};

export type EntityFieldsSumOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type EntityFieldsUncheckedCreateInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  entityId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationUncheckedCreateNestedManyWithoutEntitiesInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type EntityFieldsUncheckedCreateNestedManyWithoutEntityInput = {
  connect?: InputMaybe<Array<EntityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EntityFieldsCreateOrConnectWithoutEntityInput>>;
  create?: InputMaybe<Array<EntityFieldsCreateWithoutEntityInput>>;
  createMany?: InputMaybe<EntityFieldsCreateManyEntityInputEnvelope>;
};

export type EntityFieldsUncheckedCreateNestedManyWithoutLocationsInput = {
  connect?: InputMaybe<Array<EntityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EntityFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<EntityFieldsCreateWithoutLocationsInput>>;
};

export type EntityFieldsUncheckedCreateWithoutEntityInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationUncheckedCreateNestedManyWithoutEntitiesInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type EntityFieldsUncheckedCreateWithoutLocationsInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  entityId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type EntityFieldsUncheckedUpdateInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  entityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUncheckedUpdateManyWithoutEntitiesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EntityFieldsUncheckedUpdateManyInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  entityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EntityFieldsUncheckedUpdateManyWithoutEntitiesInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  entityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EntityFieldsUncheckedUpdateManyWithoutEntityNestedInput = {
  connect?: InputMaybe<Array<EntityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EntityFieldsCreateOrConnectWithoutEntityInput>>;
  create?: InputMaybe<Array<EntityFieldsCreateWithoutEntityInput>>;
  createMany?: InputMaybe<EntityFieldsCreateManyEntityInputEnvelope>;
  delete?: InputMaybe<Array<EntityFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EntityFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EntityFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<EntityFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<EntityFieldsUpdateWithWhereUniqueWithoutEntityInput>>;
  updateMany?: InputMaybe<Array<EntityFieldsUpdateManyWithWhereWithoutEntityInput>>;
  upsert?: InputMaybe<Array<EntityFieldsUpsertWithWhereUniqueWithoutEntityInput>>;
};

export type EntityFieldsUncheckedUpdateManyWithoutFieldsInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EntityFieldsUncheckedUpdateManyWithoutLocationsNestedInput = {
  connect?: InputMaybe<Array<EntityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EntityFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<EntityFieldsCreateWithoutLocationsInput>>;
  delete?: InputMaybe<Array<EntityFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EntityFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EntityFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<EntityFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<EntityFieldsUpdateWithWhereUniqueWithoutLocationsInput>>;
  updateMany?: InputMaybe<Array<EntityFieldsUpdateManyWithWhereWithoutLocationsInput>>;
  upsert?: InputMaybe<Array<EntityFieldsUpsertWithWhereUniqueWithoutLocationsInput>>;
};

export type EntityFieldsUncheckedUpdateWithoutEntityInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUncheckedUpdateManyWithoutEntitiesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EntityFieldsUncheckedUpdateWithoutLocationsInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  entityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EntityFieldsUpdateInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  entity?: InputMaybe<EntityUpdateOneWithoutFieldsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutEntitiesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EntityFieldsUpdateManyMutationInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EntityFieldsUpdateManyWithWhereWithoutEntityInput = {
  data: EntityFieldsUncheckedUpdateManyWithoutFieldsInput;
  where: EntityFieldsScalarWhereInput;
};

export type EntityFieldsUpdateManyWithWhereWithoutLocationsInput = {
  data: EntityFieldsUncheckedUpdateManyWithoutEntitiesInput;
  where: EntityFieldsScalarWhereInput;
};

export type EntityFieldsUpdateManyWithoutEntityNestedInput = {
  connect?: InputMaybe<Array<EntityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EntityFieldsCreateOrConnectWithoutEntityInput>>;
  create?: InputMaybe<Array<EntityFieldsCreateWithoutEntityInput>>;
  createMany?: InputMaybe<EntityFieldsCreateManyEntityInputEnvelope>;
  delete?: InputMaybe<Array<EntityFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EntityFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EntityFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<EntityFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<EntityFieldsUpdateWithWhereUniqueWithoutEntityInput>>;
  updateMany?: InputMaybe<Array<EntityFieldsUpdateManyWithWhereWithoutEntityInput>>;
  upsert?: InputMaybe<Array<EntityFieldsUpsertWithWhereUniqueWithoutEntityInput>>;
};

export type EntityFieldsUpdateManyWithoutLocationsNestedInput = {
  connect?: InputMaybe<Array<EntityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EntityFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<EntityFieldsCreateWithoutLocationsInput>>;
  delete?: InputMaybe<Array<EntityFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EntityFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EntityFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<EntityFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<EntityFieldsUpdateWithWhereUniqueWithoutLocationsInput>>;
  updateMany?: InputMaybe<Array<EntityFieldsUpdateManyWithWhereWithoutLocationsInput>>;
  upsert?: InputMaybe<Array<EntityFieldsUpsertWithWhereUniqueWithoutLocationsInput>>;
};

export type EntityFieldsUpdateWithWhereUniqueWithoutEntityInput = {
  data: EntityFieldsUncheckedUpdateWithoutEntityInput;
  where: EntityFieldsWhereUniqueInput;
};

export type EntityFieldsUpdateWithWhereUniqueWithoutLocationsInput = {
  data: EntityFieldsUncheckedUpdateWithoutLocationsInput;
  where: EntityFieldsWhereUniqueInput;
};

export type EntityFieldsUpdateWithoutEntityInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutEntitiesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EntityFieldsUpdateWithoutLocationsInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  entity?: InputMaybe<EntityUpdateOneWithoutFieldsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EntityFieldsUpsertWithWhereUniqueWithoutEntityInput = {
  create: EntityFieldsUncheckedCreateWithoutEntityInput;
  update: EntityFieldsUncheckedUpdateWithoutEntityInput;
  where: EntityFieldsWhereUniqueInput;
};

export type EntityFieldsUpsertWithWhereUniqueWithoutLocationsInput = {
  create: EntityFieldsUncheckedCreateWithoutLocationsInput;
  update: EntityFieldsUncheckedUpdateWithoutLocationsInput;
  where: EntityFieldsWhereUniqueInput;
};

export type EntityFieldsWhereInput = {
  AND?: InputMaybe<Array<EntityFieldsWhereInput>>;
  NOT?: InputMaybe<Array<EntityFieldsWhereInput>>;
  OR?: InputMaybe<Array<EntityFieldsWhereInput>>;
  cmsId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  entity?: InputMaybe<EntityWhereInput>;
  entityId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  locations?: InputMaybe<LocationListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  stack?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EntityFieldsWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type EntityMaxAggregateOutputType = {
  __typename?: 'EntityMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EntityMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EntityMinAggregateOutputType = {
  __typename?: 'EntityMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EntityMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EntityOrderByWithAggregationInput = {
  _count?: InputMaybe<EntityCountOrderByAggregateInput>;
  _max?: InputMaybe<EntityMaxOrderByAggregateInput>;
  _min?: InputMaybe<EntityMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EntityOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  fields?: InputMaybe<EntityFieldsOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EntityRelationFilter = {
  is?: InputMaybe<EntityWhereInput>;
  isNot?: InputMaybe<EntityWhereInput>;
};

export enum EntityScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Pending = 'pending',
  Published = 'published',
  Reference = 'reference',
  UpdatedAt = 'updatedAt'
}

export type EntityScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<EntityScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<EntityScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<EntityScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  reference?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type EntityUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<EntityFieldsUncheckedCreateNestedManyWithoutEntityInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type EntityUncheckedCreateWithoutFieldsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type EntityUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<EntityFieldsUncheckedUpdateManyWithoutEntityNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EntityUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EntityUncheckedUpdateWithoutFieldsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EntityUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<EntityFieldsUpdateManyWithoutEntityNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EntityUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EntityUpdateOneWithoutFieldsNestedInput = {
  connect?: InputMaybe<EntityWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EntityCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<EntityUncheckedCreateWithoutFieldsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<EntityUncheckedUpdateWithoutFieldsInput>;
  upsert?: InputMaybe<EntityUpsertWithoutFieldsInput>;
};

export type EntityUpdateWithoutFieldsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EntityUpsertWithoutFieldsInput = {
  create: EntityUncheckedCreateWithoutFieldsInput;
  update: EntityUncheckedUpdateWithoutFieldsInput;
};

export type EntityWhereInput = {
  AND?: InputMaybe<Array<EntityWhereInput>>;
  NOT?: InputMaybe<Array<EntityWhereInput>>;
  OR?: InputMaybe<Array<EntityWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fields?: InputMaybe<EntityFieldsListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  reference?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EntityWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type EnumAuditActionFieldUpdateOperationsInput = {
  set?: InputMaybe<AuditAction>;
};

export type EnumAuditActionFilter = {
  equals?: InputMaybe<AuditAction>;
  in?: InputMaybe<Array<AuditAction>>;
  not?: InputMaybe<NestedEnumAuditActionFilter>;
  notIn?: InputMaybe<Array<AuditAction>>;
};

export type EnumAuditActionWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumAuditActionFilter>;
  _min?: InputMaybe<NestedEnumAuditActionFilter>;
  equals?: InputMaybe<AuditAction>;
  in?: InputMaybe<Array<AuditAction>>;
  not?: InputMaybe<NestedEnumAuditActionWithAggregatesFilter>;
  notIn?: InputMaybe<Array<AuditAction>>;
};

export type EnumAuditTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<AuditType>;
};

export type EnumAuditTypeFilter = {
  equals?: InputMaybe<AuditType>;
  in?: InputMaybe<Array<AuditType>>;
  not?: InputMaybe<NestedEnumAuditTypeFilter>;
  notIn?: InputMaybe<Array<AuditType>>;
};

export type EnumAuditTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumAuditTypeFilter>;
  _min?: InputMaybe<NestedEnumAuditTypeFilter>;
  equals?: InputMaybe<AuditType>;
  in?: InputMaybe<Array<AuditType>>;
  not?: InputMaybe<NestedEnumAuditTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<AuditType>>;
};

export type EnumDataImportEnvironmentFieldUpdateOperationsInput = {
  set?: InputMaybe<DataImportEnvironment>;
};

export type EnumDataImportEnvironmentFilter = {
  equals?: InputMaybe<DataImportEnvironment>;
  in?: InputMaybe<Array<DataImportEnvironment>>;
  not?: InputMaybe<NestedEnumDataImportEnvironmentFilter>;
  notIn?: InputMaybe<Array<DataImportEnvironment>>;
};

export type EnumDataImportEnvironmentWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDataImportEnvironmentFilter>;
  _min?: InputMaybe<NestedEnumDataImportEnvironmentFilter>;
  equals?: InputMaybe<DataImportEnvironment>;
  in?: InputMaybe<Array<DataImportEnvironment>>;
  not?: InputMaybe<NestedEnumDataImportEnvironmentWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DataImportEnvironment>>;
};

export type EnumDataImportFileTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<DataImportFileType>;
};

export type EnumDataImportFileTypeFilter = {
  equals?: InputMaybe<DataImportFileType>;
  in?: InputMaybe<Array<DataImportFileType>>;
  not?: InputMaybe<NestedEnumDataImportFileTypeFilter>;
  notIn?: InputMaybe<Array<DataImportFileType>>;
};

export type EnumDataImportFileTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDataImportFileTypeFilter>;
  _min?: InputMaybe<NestedEnumDataImportFileTypeFilter>;
  equals?: InputMaybe<DataImportFileType>;
  in?: InputMaybe<Array<DataImportFileType>>;
  not?: InputMaybe<NestedEnumDataImportFileTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DataImportFileType>>;
};

export type EnumDataImportProgressStatusNullableFilter = {
  equals?: InputMaybe<DataImportProgressStatus>;
  in?: InputMaybe<Array<DataImportProgressStatus>>;
  not?: InputMaybe<NestedEnumDataImportProgressStatusNullableFilter>;
  notIn?: InputMaybe<Array<DataImportProgressStatus>>;
};

export type EnumDataImportProgressStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDataImportProgressStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumDataImportProgressStatusNullableFilter>;
  equals?: InputMaybe<DataImportProgressStatus>;
  in?: InputMaybe<Array<DataImportProgressStatus>>;
  not?: InputMaybe<NestedEnumDataImportProgressStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DataImportProgressStatus>>;
};

export type EnumDataImportPublishStatusNullableFilter = {
  equals?: InputMaybe<DataImportPublishStatus>;
  in?: InputMaybe<Array<DataImportPublishStatus>>;
  not?: InputMaybe<NestedEnumDataImportPublishStatusNullableFilter>;
  notIn?: InputMaybe<Array<DataImportPublishStatus>>;
};

export type EnumDataImportPublishStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDataImportPublishStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumDataImportPublishStatusNullableFilter>;
  equals?: InputMaybe<DataImportPublishStatus>;
  in?: InputMaybe<Array<DataImportPublishStatus>>;
  not?: InputMaybe<NestedEnumDataImportPublishStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DataImportPublishStatus>>;
};

export type EnumDataImportValidationAuditTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<DataImportValidationAuditType>;
};

export type EnumDataImportValidationAuditTypeFilter = {
  equals?: InputMaybe<DataImportValidationAuditType>;
  in?: InputMaybe<Array<DataImportValidationAuditType>>;
  not?: InputMaybe<NestedEnumDataImportValidationAuditTypeFilter>;
  notIn?: InputMaybe<Array<DataImportValidationAuditType>>;
};

export type EnumDataImportValidationAuditTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDataImportValidationAuditTypeFilter>;
  _min?: InputMaybe<NestedEnumDataImportValidationAuditTypeFilter>;
  equals?: InputMaybe<DataImportValidationAuditType>;
  in?: InputMaybe<Array<DataImportValidationAuditType>>;
  not?: InputMaybe<NestedEnumDataImportValidationAuditTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DataImportValidationAuditType>>;
};

export type EnumDataImportValidationStatusNullableFilter = {
  equals?: InputMaybe<DataImportValidationStatus>;
  in?: InputMaybe<Array<DataImportValidationStatus>>;
  not?: InputMaybe<NestedEnumDataImportValidationStatusNullableFilter>;
  notIn?: InputMaybe<Array<DataImportValidationStatus>>;
};

export type EnumDataImportValidationStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDataImportValidationStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumDataImportValidationStatusNullableFilter>;
  equals?: InputMaybe<DataImportValidationStatus>;
  in?: InputMaybe<Array<DataImportValidationStatus>>;
  not?: InputMaybe<NestedEnumDataImportValidationStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DataImportValidationStatus>>;
};

export type EnumProgressStatusNullableFilter = {
  equals?: InputMaybe<ProgressStatus>;
  in?: InputMaybe<Array<ProgressStatus>>;
  not?: InputMaybe<NestedEnumProgressStatusNullableFilter>;
  notIn?: InputMaybe<Array<ProgressStatus>>;
};

export type EnumProgressStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumProgressStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumProgressStatusNullableFilter>;
  equals?: InputMaybe<ProgressStatus>;
  in?: InputMaybe<Array<ProgressStatus>>;
  not?: InputMaybe<NestedEnumProgressStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ProgressStatus>>;
};

export type EnumPublishStatusNullableFilter = {
  equals?: InputMaybe<PublishStatus>;
  in?: InputMaybe<Array<PublishStatus>>;
  not?: InputMaybe<NestedEnumPublishStatusNullableFilter>;
  notIn?: InputMaybe<Array<PublishStatus>>;
};

export type EnumPublishStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumPublishStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumPublishStatusNullableFilter>;
  equals?: InputMaybe<PublishStatus>;
  in?: InputMaybe<Array<PublishStatus>>;
  not?: InputMaybe<NestedEnumPublishStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PublishStatus>>;
};

export type HealthCheck = {
  __typename?: 'HealthCheck';
  latency?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  statusCode?: Maybe<Scalars['String']>;
};

export type IntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']>;
  divide?: InputMaybe<Scalars['Int']>;
  increment?: InputMaybe<Scalars['Int']>;
  multiply?: InputMaybe<Scalars['Int']>;
  set?: InputMaybe<Scalars['Int']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type IntNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedIntNullableFilter>;
  _min?: InputMaybe<NestedIntNullableFilter>;
  _sum?: InputMaybe<NestedIntNullableFilter>;
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type IntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedIntFilter>;
  _min?: InputMaybe<NestedIntFilter>;
  _sum?: InputMaybe<NestedIntFilter>;
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export enum JsonNullValueFilter {
  AnyNull = 'AnyNull',
  DbNull = 'DbNull',
  JsonNull = 'JsonNull'
}

export type JsonNullableFilter = {
  array_contains?: InputMaybe<Scalars['Json']>;
  array_ends_with?: InputMaybe<Scalars['Json']>;
  array_starts_with?: InputMaybe<Scalars['Json']>;
  equals?: InputMaybe<Scalars['Json']>;
  gt?: InputMaybe<Scalars['Json']>;
  gte?: InputMaybe<Scalars['Json']>;
  lt?: InputMaybe<Scalars['Json']>;
  lte?: InputMaybe<Scalars['Json']>;
  not?: InputMaybe<Scalars['Json']>;
  path?: InputMaybe<Scalars['String']>;
  string_contains?: InputMaybe<Scalars['String']>;
  string_ends_with?: InputMaybe<Scalars['String']>;
  string_starts_with?: InputMaybe<Scalars['String']>;
};

export type JsonNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedJsonNullableFilter>;
  _min?: InputMaybe<NestedJsonNullableFilter>;
  array_contains?: InputMaybe<Scalars['Json']>;
  array_ends_with?: InputMaybe<Scalars['Json']>;
  array_starts_with?: InputMaybe<Scalars['Json']>;
  equals?: InputMaybe<Scalars['Json']>;
  gt?: InputMaybe<Scalars['Json']>;
  gte?: InputMaybe<Scalars['Json']>;
  lt?: InputMaybe<Scalars['Json']>;
  lte?: InputMaybe<Scalars['Json']>;
  not?: InputMaybe<Scalars['Json']>;
  path?: InputMaybe<Scalars['String']>;
  string_contains?: InputMaybe<Scalars['String']>;
  string_ends_with?: InputMaybe<Scalars['String']>;
  string_starts_with?: InputMaybe<Scalars['String']>;
};

export type Location = {
  __typename?: 'Location';
  _count: LocationCountOutputType;
  activities: Array<Maybe<ActivityFields>>;
  businessUnits: Array<Maybe<BusinessUnitFields>>;
  clientTypes: Array<Maybe<ClientTypeFields>>;
  createdAt: Scalars['DateTime'];
  dataImportFiles: Array<Maybe<DataImportFile>>;
  definition: Array<Maybe<DefinitionFields>>;
  documents: Array<Maybe<Document>>;
  entities: Array<Maybe<EntityFields>>;
  fields: Array<Maybe<LocationFields>>;
  id: Scalars['String'];
  pending?: Maybe<Scalars['Boolean']>;
  products: Array<Maybe<ProductFields>>;
  published?: Maybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  statuses: Array<Maybe<StatusFields>>;
  subActivities: Array<Maybe<SubActivityFields>>;
  subProducts: Array<Maybe<SubProductFields>>;
  updatedAt: Scalars['DateTime'];
};


export type LocationActivitiesArgs = {
  cursor?: InputMaybe<ActivityFieldsWhereUniqueInput>;
  distinct?: InputMaybe<ActivityFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<ActivityFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ActivityFieldsWhereInput>;
};


export type LocationBusinessUnitsArgs = {
  cursor?: InputMaybe<BusinessUnitFieldsWhereUniqueInput>;
  distinct?: InputMaybe<BusinessUnitFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<BusinessUnitFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BusinessUnitFieldsWhereInput>;
};


export type LocationClientTypesArgs = {
  cursor?: InputMaybe<ClientTypeFieldsWhereUniqueInput>;
  distinct?: InputMaybe<ClientTypeFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<ClientTypeFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ClientTypeFieldsWhereInput>;
};


export type LocationDataImportFilesArgs = {
  cursor?: InputMaybe<DataImportFileWhereUniqueInput>;
  distinct?: InputMaybe<DataImportFileScalarFieldEnum>;
  orderBy?: InputMaybe<DataImportFileOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DataImportFileWhereInput>;
};


export type LocationDefinitionArgs = {
  cursor?: InputMaybe<DefinitionFieldsWhereUniqueInput>;
  distinct?: InputMaybe<DefinitionFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<DefinitionFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DefinitionFieldsWhereInput>;
};


export type LocationDocumentsArgs = {
  cursor?: InputMaybe<DocumentWhereUniqueInput>;
  distinct?: InputMaybe<DocumentScalarFieldEnum>;
  orderBy?: InputMaybe<DocumentOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DocumentWhereInput>;
};


export type LocationEntitiesArgs = {
  cursor?: InputMaybe<EntityFieldsWhereUniqueInput>;
  distinct?: InputMaybe<EntityFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<EntityFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EntityFieldsWhereInput>;
};


export type LocationFieldsArgs = {
  cursor?: InputMaybe<LocationFieldsWhereUniqueInput>;
  distinct?: InputMaybe<LocationFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<LocationFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationFieldsWhereInput>;
};


export type LocationProductsArgs = {
  cursor?: InputMaybe<ProductFieldsWhereUniqueInput>;
  distinct?: InputMaybe<ProductFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<ProductFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductFieldsWhereInput>;
};


export type LocationStatusesArgs = {
  cursor?: InputMaybe<StatusFieldsWhereUniqueInput>;
  distinct?: InputMaybe<StatusFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<StatusFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StatusFieldsWhereInput>;
};


export type LocationSubActivitiesArgs = {
  cursor?: InputMaybe<SubActivityFieldsWhereUniqueInput>;
  distinct?: InputMaybe<SubActivityFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<SubActivityFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SubActivityFieldsWhereInput>;
};


export type LocationSubProductsArgs = {
  cursor?: InputMaybe<SubProductFieldsWhereUniqueInput>;
  distinct?: InputMaybe<SubProductFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<SubProductFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SubProductFieldsWhereInput>;
};

export type LocationConnection = {
  __typename?: 'LocationConnection';
  aggregate: AggregateLocation;
  edges: Array<Maybe<LocationEdge>>;
  pageInfo: PageInfo;
};

export type LocationCountAggregateOutputType = {
  __typename?: 'LocationCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  pending: Scalars['Int'];
  published: Scalars['Int'];
  reference: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type LocationCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type LocationCountOutputType = {
  __typename?: 'LocationCountOutputType';
  activities: Scalars['Int'];
  businessUnits: Scalars['Int'];
  clientTypes: Scalars['Int'];
  dataImportFiles: Scalars['Int'];
  definition: Scalars['Int'];
  documents: Scalars['Int'];
  entities: Scalars['Int'];
  fields: Scalars['Int'];
  products: Scalars['Int'];
  statuses: Scalars['Int'];
  subActivities: Scalars['Int'];
  subProducts: Scalars['Int'];
};

export type LocationCreateInput = {
  activities?: InputMaybe<ActivityFieldsCreateNestedManyWithoutLocationsInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsCreateNestedManyWithoutLocationsInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsCreateNestedManyWithoutLocationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileCreateNestedManyWithoutLocationInput>;
  definition?: InputMaybe<DefinitionFieldsCreateNestedManyWithoutLocationInput>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutLocationInput>;
  entities?: InputMaybe<EntityFieldsCreateNestedManyWithoutLocationsInput>;
  fields?: InputMaybe<LocationFieldsCreateNestedManyWithoutLocationInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductFieldsCreateNestedManyWithoutLocationsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  statuses?: InputMaybe<StatusFieldsCreateNestedManyWithoutLocationsInput>;
  subActivities?: InputMaybe<SubActivityFieldsCreateNestedManyWithoutLocationsInput>;
  subProducts?: InputMaybe<SubProductFieldsCreateNestedManyWithoutLocationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationCreateNestedManyWithoutActivitiesInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutActivitiesInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutActivitiesInput>>;
};

export type LocationCreateNestedManyWithoutBusinessUnitsInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutBusinessUnitsInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutBusinessUnitsInput>>;
};

export type LocationCreateNestedManyWithoutClientTypesInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutClientTypesInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutClientTypesInput>>;
};

export type LocationCreateNestedManyWithoutDefinitionInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutDefinitionInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutDefinitionInput>>;
};

export type LocationCreateNestedManyWithoutEntitiesInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutEntitiesInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutEntitiesInput>>;
};

export type LocationCreateNestedManyWithoutProductsInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutProductsInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutProductsInput>>;
};

export type LocationCreateNestedManyWithoutStatusesInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutStatusesInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutStatusesInput>>;
};

export type LocationCreateNestedManyWithoutSubActivitiesInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutSubActivitiesInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutSubActivitiesInput>>;
};

export type LocationCreateNestedManyWithoutSubProductsInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutSubProductsInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutSubProductsInput>>;
};

export type LocationCreateNestedOneWithoutDataImportFilesInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutDataImportFilesInput>;
  create?: InputMaybe<LocationUncheckedCreateWithoutDataImportFilesInput>;
};

export type LocationCreateNestedOneWithoutDocumentsInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutDocumentsInput>;
  create?: InputMaybe<LocationUncheckedCreateWithoutDocumentsInput>;
};

export type LocationCreateNestedOneWithoutFieldsInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<LocationUncheckedCreateWithoutFieldsInput>;
};

export type LocationCreateOrConnectWithoutActivitiesInput = {
  create: LocationUncheckedCreateWithoutActivitiesInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutBusinessUnitsInput = {
  create: LocationUncheckedCreateWithoutBusinessUnitsInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutClientTypesInput = {
  create: LocationUncheckedCreateWithoutClientTypesInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutDataImportFilesInput = {
  create: LocationUncheckedCreateWithoutDataImportFilesInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutDefinitionInput = {
  create: LocationUncheckedCreateWithoutDefinitionInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutDocumentsInput = {
  create: LocationUncheckedCreateWithoutDocumentsInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutEntitiesInput = {
  create: LocationUncheckedCreateWithoutEntitiesInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutFieldsInput = {
  create: LocationUncheckedCreateWithoutFieldsInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutProductsInput = {
  create: LocationUncheckedCreateWithoutProductsInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutStatusesInput = {
  create: LocationUncheckedCreateWithoutStatusesInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutSubActivitiesInput = {
  create: LocationUncheckedCreateWithoutSubActivitiesInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutSubProductsInput = {
  create: LocationUncheckedCreateWithoutSubProductsInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateWithoutActivitiesInput = {
  businessUnits?: InputMaybe<BusinessUnitFieldsCreateNestedManyWithoutLocationsInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsCreateNestedManyWithoutLocationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileCreateNestedManyWithoutLocationInput>;
  definition?: InputMaybe<DefinitionFieldsCreateNestedManyWithoutLocationInput>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutLocationInput>;
  entities?: InputMaybe<EntityFieldsCreateNestedManyWithoutLocationsInput>;
  fields?: InputMaybe<LocationFieldsCreateNestedManyWithoutLocationInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductFieldsCreateNestedManyWithoutLocationsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  statuses?: InputMaybe<StatusFieldsCreateNestedManyWithoutLocationsInput>;
  subActivities?: InputMaybe<SubActivityFieldsCreateNestedManyWithoutLocationsInput>;
  subProducts?: InputMaybe<SubProductFieldsCreateNestedManyWithoutLocationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationCreateWithoutBusinessUnitsInput = {
  activities?: InputMaybe<ActivityFieldsCreateNestedManyWithoutLocationsInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsCreateNestedManyWithoutLocationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileCreateNestedManyWithoutLocationInput>;
  definition?: InputMaybe<DefinitionFieldsCreateNestedManyWithoutLocationInput>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutLocationInput>;
  entities?: InputMaybe<EntityFieldsCreateNestedManyWithoutLocationsInput>;
  fields?: InputMaybe<LocationFieldsCreateNestedManyWithoutLocationInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductFieldsCreateNestedManyWithoutLocationsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  statuses?: InputMaybe<StatusFieldsCreateNestedManyWithoutLocationsInput>;
  subActivities?: InputMaybe<SubActivityFieldsCreateNestedManyWithoutLocationsInput>;
  subProducts?: InputMaybe<SubProductFieldsCreateNestedManyWithoutLocationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationCreateWithoutClientTypesInput = {
  activities?: InputMaybe<ActivityFieldsCreateNestedManyWithoutLocationsInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsCreateNestedManyWithoutLocationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileCreateNestedManyWithoutLocationInput>;
  definition?: InputMaybe<DefinitionFieldsCreateNestedManyWithoutLocationInput>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutLocationInput>;
  entities?: InputMaybe<EntityFieldsCreateNestedManyWithoutLocationsInput>;
  fields?: InputMaybe<LocationFieldsCreateNestedManyWithoutLocationInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductFieldsCreateNestedManyWithoutLocationsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  statuses?: InputMaybe<StatusFieldsCreateNestedManyWithoutLocationsInput>;
  subActivities?: InputMaybe<SubActivityFieldsCreateNestedManyWithoutLocationsInput>;
  subProducts?: InputMaybe<SubProductFieldsCreateNestedManyWithoutLocationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationCreateWithoutDataImportFilesInput = {
  activities?: InputMaybe<ActivityFieldsCreateNestedManyWithoutLocationsInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsCreateNestedManyWithoutLocationsInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsCreateNestedManyWithoutLocationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  definition?: InputMaybe<DefinitionFieldsCreateNestedManyWithoutLocationInput>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutLocationInput>;
  entities?: InputMaybe<EntityFieldsCreateNestedManyWithoutLocationsInput>;
  fields?: InputMaybe<LocationFieldsCreateNestedManyWithoutLocationInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductFieldsCreateNestedManyWithoutLocationsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  statuses?: InputMaybe<StatusFieldsCreateNestedManyWithoutLocationsInput>;
  subActivities?: InputMaybe<SubActivityFieldsCreateNestedManyWithoutLocationsInput>;
  subProducts?: InputMaybe<SubProductFieldsCreateNestedManyWithoutLocationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationCreateWithoutDefinitionInput = {
  activities?: InputMaybe<ActivityFieldsCreateNestedManyWithoutLocationsInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsCreateNestedManyWithoutLocationsInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsCreateNestedManyWithoutLocationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileCreateNestedManyWithoutLocationInput>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutLocationInput>;
  entities?: InputMaybe<EntityFieldsCreateNestedManyWithoutLocationsInput>;
  fields?: InputMaybe<LocationFieldsCreateNestedManyWithoutLocationInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductFieldsCreateNestedManyWithoutLocationsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  statuses?: InputMaybe<StatusFieldsCreateNestedManyWithoutLocationsInput>;
  subActivities?: InputMaybe<SubActivityFieldsCreateNestedManyWithoutLocationsInput>;
  subProducts?: InputMaybe<SubProductFieldsCreateNestedManyWithoutLocationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationCreateWithoutDocumentsInput = {
  activities?: InputMaybe<ActivityFieldsCreateNestedManyWithoutLocationsInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsCreateNestedManyWithoutLocationsInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsCreateNestedManyWithoutLocationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileCreateNestedManyWithoutLocationInput>;
  definition?: InputMaybe<DefinitionFieldsCreateNestedManyWithoutLocationInput>;
  entities?: InputMaybe<EntityFieldsCreateNestedManyWithoutLocationsInput>;
  fields?: InputMaybe<LocationFieldsCreateNestedManyWithoutLocationInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductFieldsCreateNestedManyWithoutLocationsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  statuses?: InputMaybe<StatusFieldsCreateNestedManyWithoutLocationsInput>;
  subActivities?: InputMaybe<SubActivityFieldsCreateNestedManyWithoutLocationsInput>;
  subProducts?: InputMaybe<SubProductFieldsCreateNestedManyWithoutLocationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationCreateWithoutEntitiesInput = {
  activities?: InputMaybe<ActivityFieldsCreateNestedManyWithoutLocationsInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsCreateNestedManyWithoutLocationsInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsCreateNestedManyWithoutLocationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileCreateNestedManyWithoutLocationInput>;
  definition?: InputMaybe<DefinitionFieldsCreateNestedManyWithoutLocationInput>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutLocationInput>;
  fields?: InputMaybe<LocationFieldsCreateNestedManyWithoutLocationInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductFieldsCreateNestedManyWithoutLocationsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  statuses?: InputMaybe<StatusFieldsCreateNestedManyWithoutLocationsInput>;
  subActivities?: InputMaybe<SubActivityFieldsCreateNestedManyWithoutLocationsInput>;
  subProducts?: InputMaybe<SubProductFieldsCreateNestedManyWithoutLocationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationCreateWithoutFieldsInput = {
  activities?: InputMaybe<ActivityFieldsCreateNestedManyWithoutLocationsInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsCreateNestedManyWithoutLocationsInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsCreateNestedManyWithoutLocationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileCreateNestedManyWithoutLocationInput>;
  definition?: InputMaybe<DefinitionFieldsCreateNestedManyWithoutLocationInput>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutLocationInput>;
  entities?: InputMaybe<EntityFieldsCreateNestedManyWithoutLocationsInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductFieldsCreateNestedManyWithoutLocationsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  statuses?: InputMaybe<StatusFieldsCreateNestedManyWithoutLocationsInput>;
  subActivities?: InputMaybe<SubActivityFieldsCreateNestedManyWithoutLocationsInput>;
  subProducts?: InputMaybe<SubProductFieldsCreateNestedManyWithoutLocationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationCreateWithoutProductsInput = {
  activities?: InputMaybe<ActivityFieldsCreateNestedManyWithoutLocationsInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsCreateNestedManyWithoutLocationsInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsCreateNestedManyWithoutLocationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileCreateNestedManyWithoutLocationInput>;
  definition?: InputMaybe<DefinitionFieldsCreateNestedManyWithoutLocationInput>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutLocationInput>;
  entities?: InputMaybe<EntityFieldsCreateNestedManyWithoutLocationsInput>;
  fields?: InputMaybe<LocationFieldsCreateNestedManyWithoutLocationInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  statuses?: InputMaybe<StatusFieldsCreateNestedManyWithoutLocationsInput>;
  subActivities?: InputMaybe<SubActivityFieldsCreateNestedManyWithoutLocationsInput>;
  subProducts?: InputMaybe<SubProductFieldsCreateNestedManyWithoutLocationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationCreateWithoutStatusesInput = {
  activities?: InputMaybe<ActivityFieldsCreateNestedManyWithoutLocationsInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsCreateNestedManyWithoutLocationsInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsCreateNestedManyWithoutLocationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileCreateNestedManyWithoutLocationInput>;
  definition?: InputMaybe<DefinitionFieldsCreateNestedManyWithoutLocationInput>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutLocationInput>;
  entities?: InputMaybe<EntityFieldsCreateNestedManyWithoutLocationsInput>;
  fields?: InputMaybe<LocationFieldsCreateNestedManyWithoutLocationInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductFieldsCreateNestedManyWithoutLocationsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  subActivities?: InputMaybe<SubActivityFieldsCreateNestedManyWithoutLocationsInput>;
  subProducts?: InputMaybe<SubProductFieldsCreateNestedManyWithoutLocationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationCreateWithoutSubActivitiesInput = {
  activities?: InputMaybe<ActivityFieldsCreateNestedManyWithoutLocationsInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsCreateNestedManyWithoutLocationsInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsCreateNestedManyWithoutLocationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileCreateNestedManyWithoutLocationInput>;
  definition?: InputMaybe<DefinitionFieldsCreateNestedManyWithoutLocationInput>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutLocationInput>;
  entities?: InputMaybe<EntityFieldsCreateNestedManyWithoutLocationsInput>;
  fields?: InputMaybe<LocationFieldsCreateNestedManyWithoutLocationInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductFieldsCreateNestedManyWithoutLocationsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  statuses?: InputMaybe<StatusFieldsCreateNestedManyWithoutLocationsInput>;
  subProducts?: InputMaybe<SubProductFieldsCreateNestedManyWithoutLocationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationCreateWithoutSubProductsInput = {
  activities?: InputMaybe<ActivityFieldsCreateNestedManyWithoutLocationsInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsCreateNestedManyWithoutLocationsInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsCreateNestedManyWithoutLocationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileCreateNestedManyWithoutLocationInput>;
  definition?: InputMaybe<DefinitionFieldsCreateNestedManyWithoutLocationInput>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutLocationInput>;
  entities?: InputMaybe<EntityFieldsCreateNestedManyWithoutLocationsInput>;
  fields?: InputMaybe<LocationFieldsCreateNestedManyWithoutLocationInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductFieldsCreateNestedManyWithoutLocationsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  statuses?: InputMaybe<StatusFieldsCreateNestedManyWithoutLocationsInput>;
  subActivities?: InputMaybe<SubActivityFieldsCreateNestedManyWithoutLocationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationEdge = {
  __typename?: 'LocationEdge';
  cursor: Scalars['String'];
  node: LocationFields;
};

export type LocationFields = {
  __typename?: 'LocationFields';
  _count: LocationFieldsCountOutputType;
  cmsId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isEEA?: Maybe<Scalars['Boolean']>;
  isoCountryCode?: Maybe<Scalars['String']>;
  latestDocumentCycleName?: Maybe<Scalars['String']>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']>;
  locationType: Scalars['String'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  permissions: Array<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  publishedDate?: Maybe<Scalars['DateTime']>;
  stack: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type LocationFieldsPermissionsArgs = {
  cursor?: InputMaybe<LocationFields_PermissionsWhereUniqueInput>;
  distinct?: InputMaybe<LocationFields_PermissionsScalarFieldEnum>;
  orderBy?: InputMaybe<LocationFields_PermissionsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationFields_PermissionsWhereInput>;
};

export type LocationFieldsAvgAggregateOutputType = {
  __typename?: 'LocationFieldsAvgAggregateOutputType';
  order?: Maybe<Scalars['Float']>;
};

export type LocationFieldsAvgOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type LocationFieldsConnection = {
  __typename?: 'LocationFieldsConnection';
  aggregate: AggregateLocationFields;
  edges: Array<Maybe<LocationFieldsEdge>>;
  pageInfo: PageInfo;
};

export type LocationFieldsCountAggregateOutputType = {
  __typename?: 'LocationFieldsCountAggregateOutputType';
  _all: Scalars['Int'];
  cmsId: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  isEEA: Scalars['Int'];
  isoCountryCode: Scalars['Int'];
  latestDocumentCycleName: Scalars['Int'];
  locationId: Scalars['Int'];
  locationType: Scalars['Int'];
  name: Scalars['Int'];
  order: Scalars['Int'];
  pending: Scalars['Int'];
  published: Scalars['Int'];
  publishedDate: Scalars['Int'];
  stack: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type LocationFieldsCountOrderByAggregateInput = {
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isEEA?: InputMaybe<SortOrder>;
  isoCountryCode?: InputMaybe<SortOrder>;
  latestDocumentCycleName?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  locationType?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  publishedDate?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type LocationFieldsCountOutputType = {
  __typename?: 'LocationFieldsCountOutputType';
  permissions: Scalars['Int'];
};

export type LocationFieldsCreateInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isEEA?: InputMaybe<Scalars['Boolean']>;
  isoCountryCode?: InputMaybe<Scalars['String']>;
  latestDocumentCycleName?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationCreateNestedOneWithoutFieldsInput>;
  locationType: Scalars['String'];
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  permissions?: InputMaybe<LocationFields_PermissionsCreateNestedManyWithoutLocationfieldsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedDate?: InputMaybe<Scalars['DateTime']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationFieldsCreateManyInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isEEA?: InputMaybe<Scalars['Boolean']>;
  isoCountryCode?: InputMaybe<Scalars['String']>;
  latestDocumentCycleName?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  locationType: Scalars['String'];
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedDate?: InputMaybe<Scalars['DateTime']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationFieldsCreateManyLocationInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isEEA?: InputMaybe<Scalars['Boolean']>;
  isoCountryCode?: InputMaybe<Scalars['String']>;
  latestDocumentCycleName?: InputMaybe<Scalars['String']>;
  locationType: Scalars['String'];
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedDate?: InputMaybe<Scalars['DateTime']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationFieldsCreateManyLocationInputEnvelope = {
  data: Array<LocationFieldsCreateManyLocationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type LocationFieldsCreateNestedManyWithoutLocationInput = {
  connect?: InputMaybe<Array<LocationFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationFieldsCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<LocationFieldsCreateWithoutLocationInput>>;
  createMany?: InputMaybe<LocationFieldsCreateManyLocationInputEnvelope>;
};

export type LocationFieldsCreateNestedOneWithoutPermissionsInput = {
  connect?: InputMaybe<LocationFieldsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationFieldsCreateOrConnectWithoutPermissionsInput>;
  create?: InputMaybe<LocationFieldsUncheckedCreateWithoutPermissionsInput>;
};

export type LocationFieldsCreateOrConnectWithoutLocationInput = {
  create: LocationFieldsUncheckedCreateWithoutLocationInput;
  where: LocationFieldsWhereUniqueInput;
};

export type LocationFieldsCreateOrConnectWithoutPermissionsInput = {
  create: LocationFieldsUncheckedCreateWithoutPermissionsInput;
  where: LocationFieldsWhereUniqueInput;
};

export type LocationFieldsCreateWithoutLocationInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isEEA?: InputMaybe<Scalars['Boolean']>;
  isoCountryCode?: InputMaybe<Scalars['String']>;
  latestDocumentCycleName?: InputMaybe<Scalars['String']>;
  locationType: Scalars['String'];
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  permissions?: InputMaybe<LocationFields_PermissionsCreateNestedManyWithoutLocationfieldsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedDate?: InputMaybe<Scalars['DateTime']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationFieldsCreateWithoutPermissionsInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isEEA?: InputMaybe<Scalars['Boolean']>;
  isoCountryCode?: InputMaybe<Scalars['String']>;
  latestDocumentCycleName?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationCreateNestedOneWithoutFieldsInput>;
  locationType: Scalars['String'];
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedDate?: InputMaybe<Scalars['DateTime']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationFieldsEdge = {
  __typename?: 'LocationFieldsEdge';
  cursor: Scalars['String'];
  node: LocationFields;
};

export type LocationFieldsListRelationFilter = {
  every?: InputMaybe<LocationFieldsWhereInput>;
  none?: InputMaybe<LocationFieldsWhereInput>;
  some?: InputMaybe<LocationFieldsWhereInput>;
};

export type LocationFieldsMaxAggregateOutputType = {
  __typename?: 'LocationFieldsMaxAggregateOutputType';
  cmsId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isEEA?: Maybe<Scalars['Boolean']>;
  isoCountryCode?: Maybe<Scalars['String']>;
  latestDocumentCycleName?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  locationType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  publishedDate?: Maybe<Scalars['DateTime']>;
  stack?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LocationFieldsMaxOrderByAggregateInput = {
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isEEA?: InputMaybe<SortOrder>;
  isoCountryCode?: InputMaybe<SortOrder>;
  latestDocumentCycleName?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  locationType?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  publishedDate?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type LocationFieldsMinAggregateOutputType = {
  __typename?: 'LocationFieldsMinAggregateOutputType';
  cmsId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isEEA?: Maybe<Scalars['Boolean']>;
  isoCountryCode?: Maybe<Scalars['String']>;
  latestDocumentCycleName?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  locationType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  publishedDate?: Maybe<Scalars['DateTime']>;
  stack?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LocationFieldsMinOrderByAggregateInput = {
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isEEA?: InputMaybe<SortOrder>;
  isoCountryCode?: InputMaybe<SortOrder>;
  latestDocumentCycleName?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  locationType?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  publishedDate?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type LocationFieldsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type LocationFieldsOrderByWithAggregationInput = {
  _avg?: InputMaybe<LocationFieldsAvgOrderByAggregateInput>;
  _count?: InputMaybe<LocationFieldsCountOrderByAggregateInput>;
  _max?: InputMaybe<LocationFieldsMaxOrderByAggregateInput>;
  _min?: InputMaybe<LocationFieldsMinOrderByAggregateInput>;
  _sum?: InputMaybe<LocationFieldsSumOrderByAggregateInput>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isEEA?: InputMaybe<SortOrderInput>;
  isoCountryCode?: InputMaybe<SortOrderInput>;
  latestDocumentCycleName?: InputMaybe<SortOrderInput>;
  locationId?: InputMaybe<SortOrderInput>;
  locationType?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrderInput>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  publishedDate?: InputMaybe<SortOrderInput>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type LocationFieldsOrderByWithRelationInput = {
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isEEA?: InputMaybe<SortOrderInput>;
  isoCountryCode?: InputMaybe<SortOrderInput>;
  latestDocumentCycleName?: InputMaybe<SortOrderInput>;
  location?: InputMaybe<LocationOrderByWithRelationInput>;
  locationId?: InputMaybe<SortOrderInput>;
  locationType?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrderInput>;
  pending?: InputMaybe<SortOrderInput>;
  permissions?: InputMaybe<LocationFields_PermissionsOrderByRelationAggregateInput>;
  published?: InputMaybe<SortOrderInput>;
  publishedDate?: InputMaybe<SortOrderInput>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type LocationFieldsRelationFilter = {
  is?: InputMaybe<LocationFieldsWhereInput>;
  isNot?: InputMaybe<LocationFieldsWhereInput>;
};

export enum LocationFieldsScalarFieldEnum {
  CmsId = 'cmsId',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  IsEea = 'isEEA',
  IsoCountryCode = 'isoCountryCode',
  LatestDocumentCycleName = 'latestDocumentCycleName',
  LocationId = 'locationId',
  LocationType = 'locationType',
  Name = 'name',
  Order = 'order',
  Pending = 'pending',
  Published = 'published',
  PublishedDate = 'publishedDate',
  Stack = 'stack',
  UpdatedAt = 'updatedAt'
}

export type LocationFieldsScalarWhereInput = {
  AND?: InputMaybe<Array<LocationFieldsScalarWhereInput>>;
  NOT?: InputMaybe<Array<LocationFieldsScalarWhereInput>>;
  OR?: InputMaybe<Array<LocationFieldsScalarWhereInput>>;
  cmsId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isEEA?: InputMaybe<BoolNullableFilter>;
  isoCountryCode?: InputMaybe<StringNullableFilter>;
  latestDocumentCycleName?: InputMaybe<StringNullableFilter>;
  locationId?: InputMaybe<StringNullableFilter>;
  locationType?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  publishedDate?: InputMaybe<DateTimeNullableFilter>;
  stack?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type LocationFieldsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<LocationFieldsScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<LocationFieldsScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<LocationFieldsScalarWhereWithAggregatesInput>>;
  cmsId?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isEEA?: InputMaybe<BoolNullableWithAggregatesFilter>;
  isoCountryCode?: InputMaybe<StringNullableWithAggregatesFilter>;
  latestDocumentCycleName?: InputMaybe<StringNullableWithAggregatesFilter>;
  locationId?: InputMaybe<StringNullableWithAggregatesFilter>;
  locationType?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  order?: InputMaybe<IntNullableWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  publishedDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  stack?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type LocationFieldsSumAggregateOutputType = {
  __typename?: 'LocationFieldsSumAggregateOutputType';
  order?: Maybe<Scalars['Int']>;
};

export type LocationFieldsSumOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type LocationFieldsUncheckedCreateInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isEEA?: InputMaybe<Scalars['Boolean']>;
  isoCountryCode?: InputMaybe<Scalars['String']>;
  latestDocumentCycleName?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  locationType: Scalars['String'];
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  permissions?: InputMaybe<LocationFields_PermissionsUncheckedCreateNestedManyWithoutLocationfieldsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedDate?: InputMaybe<Scalars['DateTime']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationFieldsUncheckedCreateNestedManyWithoutLocationInput = {
  connect?: InputMaybe<Array<LocationFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationFieldsCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<LocationFieldsCreateWithoutLocationInput>>;
  createMany?: InputMaybe<LocationFieldsCreateManyLocationInputEnvelope>;
};

export type LocationFieldsUncheckedCreateWithoutLocationInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isEEA?: InputMaybe<Scalars['Boolean']>;
  isoCountryCode?: InputMaybe<Scalars['String']>;
  latestDocumentCycleName?: InputMaybe<Scalars['String']>;
  locationType: Scalars['String'];
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  permissions?: InputMaybe<LocationFields_PermissionsUncheckedCreateNestedManyWithoutLocationfieldsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedDate?: InputMaybe<Scalars['DateTime']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationFieldsUncheckedCreateWithoutPermissionsInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isEEA?: InputMaybe<Scalars['Boolean']>;
  isoCountryCode?: InputMaybe<Scalars['String']>;
  latestDocumentCycleName?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  locationType: Scalars['String'];
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedDate?: InputMaybe<Scalars['DateTime']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationFieldsUncheckedUpdateInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEEA?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isoCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  latestDocumentCycleName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationType?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  permissions?: InputMaybe<LocationFields_PermissionsUncheckedUpdateManyWithoutLocationfieldsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationFieldsUncheckedUpdateManyInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEEA?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isoCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  latestDocumentCycleName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationType?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationFieldsUncheckedUpdateManyWithoutFieldsInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEEA?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isoCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  latestDocumentCycleName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationType?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationFieldsUncheckedUpdateManyWithoutLocationNestedInput = {
  connect?: InputMaybe<Array<LocationFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationFieldsCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<LocationFieldsCreateWithoutLocationInput>>;
  createMany?: InputMaybe<LocationFieldsCreateManyLocationInputEnvelope>;
  delete?: InputMaybe<Array<LocationFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationFieldsUpdateWithWhereUniqueWithoutLocationInput>>;
  updateMany?: InputMaybe<Array<LocationFieldsUpdateManyWithWhereWithoutLocationInput>>;
  upsert?: InputMaybe<Array<LocationFieldsUpsertWithWhereUniqueWithoutLocationInput>>;
};

export type LocationFieldsUncheckedUpdateWithoutLocationInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEEA?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isoCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  latestDocumentCycleName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationType?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  permissions?: InputMaybe<LocationFields_PermissionsUncheckedUpdateManyWithoutLocationfieldsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationFieldsUncheckedUpdateWithoutPermissionsInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEEA?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isoCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  latestDocumentCycleName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationType?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationFieldsUpdateInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEEA?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isoCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  latestDocumentCycleName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneWithoutFieldsNestedInput>;
  locationType?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  permissions?: InputMaybe<LocationFields_PermissionsUpdateManyWithoutLocationfieldsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationFieldsUpdateManyMutationInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEEA?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isoCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  latestDocumentCycleName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationType?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationFieldsUpdateManyWithWhereWithoutLocationInput = {
  data: LocationFieldsUncheckedUpdateManyWithoutFieldsInput;
  where: LocationFieldsScalarWhereInput;
};

export type LocationFieldsUpdateManyWithoutLocationNestedInput = {
  connect?: InputMaybe<Array<LocationFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationFieldsCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<LocationFieldsCreateWithoutLocationInput>>;
  createMany?: InputMaybe<LocationFieldsCreateManyLocationInputEnvelope>;
  delete?: InputMaybe<Array<LocationFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationFieldsUpdateWithWhereUniqueWithoutLocationInput>>;
  updateMany?: InputMaybe<Array<LocationFieldsUpdateManyWithWhereWithoutLocationInput>>;
  upsert?: InputMaybe<Array<LocationFieldsUpsertWithWhereUniqueWithoutLocationInput>>;
};

export type LocationFieldsUpdateOneRequiredWithoutPermissionsNestedInput = {
  connect?: InputMaybe<LocationFieldsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationFieldsCreateOrConnectWithoutPermissionsInput>;
  create?: InputMaybe<LocationFieldsUncheckedCreateWithoutPermissionsInput>;
  update?: InputMaybe<LocationFieldsUncheckedUpdateWithoutPermissionsInput>;
  upsert?: InputMaybe<LocationFieldsUpsertWithoutPermissionsInput>;
};

export type LocationFieldsUpdateWithWhereUniqueWithoutLocationInput = {
  data: LocationFieldsUncheckedUpdateWithoutLocationInput;
  where: LocationFieldsWhereUniqueInput;
};

export type LocationFieldsUpdateWithoutLocationInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEEA?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isoCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  latestDocumentCycleName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationType?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  permissions?: InputMaybe<LocationFields_PermissionsUpdateManyWithoutLocationfieldsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationFieldsUpdateWithoutPermissionsInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEEA?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isoCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  latestDocumentCycleName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneWithoutFieldsNestedInput>;
  locationType?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationFieldsUpsertWithWhereUniqueWithoutLocationInput = {
  create: LocationFieldsUncheckedCreateWithoutLocationInput;
  update: LocationFieldsUncheckedUpdateWithoutLocationInput;
  where: LocationFieldsWhereUniqueInput;
};

export type LocationFieldsUpsertWithoutPermissionsInput = {
  create: LocationFieldsUncheckedCreateWithoutPermissionsInput;
  update: LocationFieldsUncheckedUpdateWithoutPermissionsInput;
};

export type LocationFieldsWhereInput = {
  AND?: InputMaybe<Array<LocationFieldsWhereInput>>;
  NOT?: InputMaybe<Array<LocationFieldsWhereInput>>;
  OR?: InputMaybe<Array<LocationFieldsWhereInput>>;
  cmsId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isEEA?: InputMaybe<BoolNullableFilter>;
  isoCountryCode?: InputMaybe<StringNullableFilter>;
  latestDocumentCycleName?: InputMaybe<StringNullableFilter>;
  location?: InputMaybe<LocationWhereInput>;
  locationId?: InputMaybe<StringNullableFilter>;
  locationType?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  permissions?: InputMaybe<LocationFields_PermissionsListRelationFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  publishedDate?: InputMaybe<DateTimeNullableFilter>;
  stack?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type LocationFieldsWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type LocationFields_Permissions = {
  __typename?: 'LocationFields_permissions';
  locationfields: LocationFields;
  nodeId: Scalars['String'];
  position: Scalars['Int'];
  value: Scalars['String'];
};

export type LocationFields_PermissionsAvgAggregateOutputType = {
  __typename?: 'LocationFields_permissionsAvgAggregateOutputType';
  position?: Maybe<Scalars['Float']>;
};

export type LocationFields_PermissionsAvgOrderByAggregateInput = {
  position?: InputMaybe<SortOrder>;
};

export type LocationFields_PermissionsCountAggregateOutputType = {
  __typename?: 'LocationFields_permissionsCountAggregateOutputType';
  _all: Scalars['Int'];
  nodeId: Scalars['Int'];
  position: Scalars['Int'];
  value: Scalars['Int'];
};

export type LocationFields_PermissionsCountOrderByAggregateInput = {
  nodeId?: InputMaybe<SortOrder>;
  position?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type LocationFields_PermissionsCreateInput = {
  locationfields: LocationFieldsCreateNestedOneWithoutPermissionsInput;
  position: Scalars['Int'];
  value: Scalars['String'];
};

export type LocationFields_PermissionsCreateManyInput = {
  nodeId: Scalars['String'];
  position: Scalars['Int'];
  value: Scalars['String'];
};

export type LocationFields_PermissionsCreateManyLocationfieldsInput = {
  position: Scalars['Int'];
  value: Scalars['String'];
};

export type LocationFields_PermissionsCreateManyLocationfieldsInputEnvelope = {
  data: Array<LocationFields_PermissionsCreateManyLocationfieldsInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type LocationFields_PermissionsCreateNestedManyWithoutLocationfieldsInput = {
  connect?: InputMaybe<Array<LocationFields_PermissionsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationFields_PermissionsCreateOrConnectWithoutLocationfieldsInput>>;
  create?: InputMaybe<Array<LocationFields_PermissionsCreateWithoutLocationfieldsInput>>;
  createMany?: InputMaybe<LocationFields_PermissionsCreateManyLocationfieldsInputEnvelope>;
};

export type LocationFields_PermissionsCreateOrConnectWithoutLocationfieldsInput = {
  create: LocationFields_PermissionsUncheckedCreateWithoutLocationfieldsInput;
  where: LocationFields_PermissionsWhereUniqueInput;
};

export type LocationFields_PermissionsCreateWithoutLocationfieldsInput = {
  position: Scalars['Int'];
  value: Scalars['String'];
};

export type LocationFields_PermissionsListRelationFilter = {
  every?: InputMaybe<LocationFields_PermissionsWhereInput>;
  none?: InputMaybe<LocationFields_PermissionsWhereInput>;
  some?: InputMaybe<LocationFields_PermissionsWhereInput>;
};

export type LocationFields_PermissionsMaxAggregateOutputType = {
  __typename?: 'LocationFields_permissionsMaxAggregateOutputType';
  nodeId?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type LocationFields_PermissionsMaxOrderByAggregateInput = {
  nodeId?: InputMaybe<SortOrder>;
  position?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type LocationFields_PermissionsMinAggregateOutputType = {
  __typename?: 'LocationFields_permissionsMinAggregateOutputType';
  nodeId?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type LocationFields_PermissionsMinOrderByAggregateInput = {
  nodeId?: InputMaybe<SortOrder>;
  position?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type LocationFields_PermissionsNodeIdPositionCompoundUniqueInput = {
  nodeId: Scalars['String'];
  position: Scalars['Int'];
};

export type LocationFields_PermissionsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type LocationFields_PermissionsOrderByWithAggregationInput = {
  _avg?: InputMaybe<LocationFields_PermissionsAvgOrderByAggregateInput>;
  _count?: InputMaybe<LocationFields_PermissionsCountOrderByAggregateInput>;
  _max?: InputMaybe<LocationFields_PermissionsMaxOrderByAggregateInput>;
  _min?: InputMaybe<LocationFields_PermissionsMinOrderByAggregateInput>;
  _sum?: InputMaybe<LocationFields_PermissionsSumOrderByAggregateInput>;
  nodeId?: InputMaybe<SortOrder>;
  position?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type LocationFields_PermissionsOrderByWithRelationInput = {
  locationfields?: InputMaybe<LocationFieldsOrderByWithRelationInput>;
  nodeId?: InputMaybe<SortOrder>;
  position?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export enum LocationFields_PermissionsScalarFieldEnum {
  NodeId = 'nodeId',
  Position = 'position',
  Value = 'value'
}

export type LocationFields_PermissionsScalarWhereInput = {
  AND?: InputMaybe<Array<LocationFields_PermissionsScalarWhereInput>>;
  NOT?: InputMaybe<Array<LocationFields_PermissionsScalarWhereInput>>;
  OR?: InputMaybe<Array<LocationFields_PermissionsScalarWhereInput>>;
  nodeId?: InputMaybe<StringFilter>;
  position?: InputMaybe<IntFilter>;
  value?: InputMaybe<StringFilter>;
};

export type LocationFields_PermissionsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<LocationFields_PermissionsScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<LocationFields_PermissionsScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<LocationFields_PermissionsScalarWhereWithAggregatesInput>>;
  nodeId?: InputMaybe<StringWithAggregatesFilter>;
  position?: InputMaybe<IntWithAggregatesFilter>;
  value?: InputMaybe<StringWithAggregatesFilter>;
};

export type LocationFields_PermissionsSumAggregateOutputType = {
  __typename?: 'LocationFields_permissionsSumAggregateOutputType';
  position?: Maybe<Scalars['Int']>;
};

export type LocationFields_PermissionsSumOrderByAggregateInput = {
  position?: InputMaybe<SortOrder>;
};

export type LocationFields_PermissionsUncheckedCreateInput = {
  nodeId: Scalars['String'];
  position: Scalars['Int'];
  value: Scalars['String'];
};

export type LocationFields_PermissionsUncheckedCreateNestedManyWithoutLocationfieldsInput = {
  connect?: InputMaybe<Array<LocationFields_PermissionsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationFields_PermissionsCreateOrConnectWithoutLocationfieldsInput>>;
  create?: InputMaybe<Array<LocationFields_PermissionsCreateWithoutLocationfieldsInput>>;
  createMany?: InputMaybe<LocationFields_PermissionsCreateManyLocationfieldsInputEnvelope>;
};

export type LocationFields_PermissionsUncheckedCreateWithoutLocationfieldsInput = {
  position: Scalars['Int'];
  value: Scalars['String'];
};

export type LocationFields_PermissionsUncheckedUpdateInput = {
  nodeId?: InputMaybe<StringFieldUpdateOperationsInput>;
  position?: InputMaybe<IntFieldUpdateOperationsInput>;
  value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LocationFields_PermissionsUncheckedUpdateManyInput = {
  nodeId?: InputMaybe<StringFieldUpdateOperationsInput>;
  position?: InputMaybe<IntFieldUpdateOperationsInput>;
  value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LocationFields_PermissionsUncheckedUpdateManyWithoutLocationfieldsNestedInput = {
  connect?: InputMaybe<Array<LocationFields_PermissionsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationFields_PermissionsCreateOrConnectWithoutLocationfieldsInput>>;
  create?: InputMaybe<Array<LocationFields_PermissionsCreateWithoutLocationfieldsInput>>;
  createMany?: InputMaybe<LocationFields_PermissionsCreateManyLocationfieldsInputEnvelope>;
  delete?: InputMaybe<Array<LocationFields_PermissionsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationFields_PermissionsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationFields_PermissionsWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationFields_PermissionsWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationFields_PermissionsUpdateWithWhereUniqueWithoutLocationfieldsInput>>;
  updateMany?: InputMaybe<Array<LocationFields_PermissionsUpdateManyWithWhereWithoutLocationfieldsInput>>;
  upsert?: InputMaybe<Array<LocationFields_PermissionsUpsertWithWhereUniqueWithoutLocationfieldsInput>>;
};

export type LocationFields_PermissionsUncheckedUpdateManyWithoutPermissionsInput = {
  position?: InputMaybe<IntFieldUpdateOperationsInput>;
  value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LocationFields_PermissionsUncheckedUpdateWithoutLocationfieldsInput = {
  position?: InputMaybe<IntFieldUpdateOperationsInput>;
  value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LocationFields_PermissionsUpdateInput = {
  locationfields?: InputMaybe<LocationFieldsUpdateOneRequiredWithoutPermissionsNestedInput>;
  position?: InputMaybe<IntFieldUpdateOperationsInput>;
  value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LocationFields_PermissionsUpdateManyMutationInput = {
  position?: InputMaybe<IntFieldUpdateOperationsInput>;
  value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LocationFields_PermissionsUpdateManyWithWhereWithoutLocationfieldsInput = {
  data: LocationFields_PermissionsUncheckedUpdateManyWithoutPermissionsInput;
  where: LocationFields_PermissionsScalarWhereInput;
};

export type LocationFields_PermissionsUpdateManyWithoutLocationfieldsNestedInput = {
  connect?: InputMaybe<Array<LocationFields_PermissionsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationFields_PermissionsCreateOrConnectWithoutLocationfieldsInput>>;
  create?: InputMaybe<Array<LocationFields_PermissionsCreateWithoutLocationfieldsInput>>;
  createMany?: InputMaybe<LocationFields_PermissionsCreateManyLocationfieldsInputEnvelope>;
  delete?: InputMaybe<Array<LocationFields_PermissionsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationFields_PermissionsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationFields_PermissionsWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationFields_PermissionsWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationFields_PermissionsUpdateWithWhereUniqueWithoutLocationfieldsInput>>;
  updateMany?: InputMaybe<Array<LocationFields_PermissionsUpdateManyWithWhereWithoutLocationfieldsInput>>;
  upsert?: InputMaybe<Array<LocationFields_PermissionsUpsertWithWhereUniqueWithoutLocationfieldsInput>>;
};

export type LocationFields_PermissionsUpdateWithWhereUniqueWithoutLocationfieldsInput = {
  data: LocationFields_PermissionsUncheckedUpdateWithoutLocationfieldsInput;
  where: LocationFields_PermissionsWhereUniqueInput;
};

export type LocationFields_PermissionsUpdateWithoutLocationfieldsInput = {
  position?: InputMaybe<IntFieldUpdateOperationsInput>;
  value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LocationFields_PermissionsUpsertWithWhereUniqueWithoutLocationfieldsInput = {
  create: LocationFields_PermissionsUncheckedCreateWithoutLocationfieldsInput;
  update: LocationFields_PermissionsUncheckedUpdateWithoutLocationfieldsInput;
  where: LocationFields_PermissionsWhereUniqueInput;
};

export type LocationFields_PermissionsWhereInput = {
  AND?: InputMaybe<Array<LocationFields_PermissionsWhereInput>>;
  NOT?: InputMaybe<Array<LocationFields_PermissionsWhereInput>>;
  OR?: InputMaybe<Array<LocationFields_PermissionsWhereInput>>;
  locationfields?: InputMaybe<LocationFieldsWhereInput>;
  nodeId?: InputMaybe<StringFilter>;
  position?: InputMaybe<IntFilter>;
  value?: InputMaybe<StringFilter>;
};

export type LocationFields_PermissionsWhereUniqueInput = {
  nodeId_position?: InputMaybe<LocationFields_PermissionsNodeIdPositionCompoundUniqueInput>;
};

export type LocationListRelationFilter = {
  every?: InputMaybe<LocationWhereInput>;
  none?: InputMaybe<LocationWhereInput>;
  some?: InputMaybe<LocationWhereInput>;
};

export type LocationMaxAggregateOutputType = {
  __typename?: 'LocationMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LocationMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type LocationMinAggregateOutputType = {
  __typename?: 'LocationMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LocationMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type LocationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type LocationOrderByWithAggregationInput = {
  _count?: InputMaybe<LocationCountOrderByAggregateInput>;
  _max?: InputMaybe<LocationMaxOrderByAggregateInput>;
  _min?: InputMaybe<LocationMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type LocationOrderByWithRelationInput = {
  activities?: InputMaybe<ActivityFieldsOrderByRelationAggregateInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsOrderByRelationAggregateInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  dataImportFiles?: InputMaybe<DataImportFileOrderByRelationAggregateInput>;
  definition?: InputMaybe<DefinitionFieldsOrderByRelationAggregateInput>;
  documents?: InputMaybe<DocumentOrderByRelationAggregateInput>;
  entities?: InputMaybe<EntityFieldsOrderByRelationAggregateInput>;
  fields?: InputMaybe<LocationFieldsOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  products?: InputMaybe<ProductFieldsOrderByRelationAggregateInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrder>;
  statuses?: InputMaybe<StatusFieldsOrderByRelationAggregateInput>;
  subActivities?: InputMaybe<SubActivityFieldsOrderByRelationAggregateInput>;
  subProducts?: InputMaybe<SubProductFieldsOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type LocationRelationFilter = {
  is?: InputMaybe<LocationWhereInput>;
  isNot?: InputMaybe<LocationWhereInput>;
};

export enum LocationScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Pending = 'pending',
  Published = 'published',
  Reference = 'reference',
  UpdatedAt = 'updatedAt'
}

export type LocationScalarWhereInput = {
  AND?: InputMaybe<Array<LocationScalarWhereInput>>;
  NOT?: InputMaybe<Array<LocationScalarWhereInput>>;
  OR?: InputMaybe<Array<LocationScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  reference?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type LocationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<LocationScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<LocationScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<LocationScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  reference?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type LocationUncheckedCreateInput = {
  activities?: InputMaybe<ActivityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedCreateNestedManyWithoutLocationInput>;
  definition?: InputMaybe<DefinitionFieldsUncheckedCreateNestedManyWithoutLocationInput>;
  documents?: InputMaybe<DocumentUncheckedCreateNestedManyWithoutLocationInput>;
  entities?: InputMaybe<EntityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  fields?: InputMaybe<LocationFieldsUncheckedCreateNestedManyWithoutLocationInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  statuses?: InputMaybe<StatusFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  subActivities?: InputMaybe<SubActivityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  subProducts?: InputMaybe<SubProductFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationUncheckedCreateNestedManyWithoutActivitiesInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutActivitiesInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutActivitiesInput>>;
};

export type LocationUncheckedCreateNestedManyWithoutBusinessUnitsInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutBusinessUnitsInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutBusinessUnitsInput>>;
};

export type LocationUncheckedCreateNestedManyWithoutClientTypesInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutClientTypesInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutClientTypesInput>>;
};

export type LocationUncheckedCreateNestedManyWithoutDefinitionInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutDefinitionInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutDefinitionInput>>;
};

export type LocationUncheckedCreateNestedManyWithoutEntitiesInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutEntitiesInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutEntitiesInput>>;
};

export type LocationUncheckedCreateNestedManyWithoutProductsInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutProductsInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutProductsInput>>;
};

export type LocationUncheckedCreateNestedManyWithoutStatusesInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutStatusesInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutStatusesInput>>;
};

export type LocationUncheckedCreateNestedManyWithoutSubActivitiesInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutSubActivitiesInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutSubActivitiesInput>>;
};

export type LocationUncheckedCreateNestedManyWithoutSubProductsInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutSubProductsInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutSubProductsInput>>;
};

export type LocationUncheckedCreateWithoutActivitiesInput = {
  businessUnits?: InputMaybe<BusinessUnitFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedCreateNestedManyWithoutLocationInput>;
  definition?: InputMaybe<DefinitionFieldsUncheckedCreateNestedManyWithoutLocationInput>;
  documents?: InputMaybe<DocumentUncheckedCreateNestedManyWithoutLocationInput>;
  entities?: InputMaybe<EntityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  fields?: InputMaybe<LocationFieldsUncheckedCreateNestedManyWithoutLocationInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  statuses?: InputMaybe<StatusFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  subActivities?: InputMaybe<SubActivityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  subProducts?: InputMaybe<SubProductFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationUncheckedCreateWithoutBusinessUnitsInput = {
  activities?: InputMaybe<ActivityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedCreateNestedManyWithoutLocationInput>;
  definition?: InputMaybe<DefinitionFieldsUncheckedCreateNestedManyWithoutLocationInput>;
  documents?: InputMaybe<DocumentUncheckedCreateNestedManyWithoutLocationInput>;
  entities?: InputMaybe<EntityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  fields?: InputMaybe<LocationFieldsUncheckedCreateNestedManyWithoutLocationInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  statuses?: InputMaybe<StatusFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  subActivities?: InputMaybe<SubActivityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  subProducts?: InputMaybe<SubProductFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationUncheckedCreateWithoutClientTypesInput = {
  activities?: InputMaybe<ActivityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedCreateNestedManyWithoutLocationInput>;
  definition?: InputMaybe<DefinitionFieldsUncheckedCreateNestedManyWithoutLocationInput>;
  documents?: InputMaybe<DocumentUncheckedCreateNestedManyWithoutLocationInput>;
  entities?: InputMaybe<EntityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  fields?: InputMaybe<LocationFieldsUncheckedCreateNestedManyWithoutLocationInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  statuses?: InputMaybe<StatusFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  subActivities?: InputMaybe<SubActivityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  subProducts?: InputMaybe<SubProductFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationUncheckedCreateWithoutDataImportFilesInput = {
  activities?: InputMaybe<ActivityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  definition?: InputMaybe<DefinitionFieldsUncheckedCreateNestedManyWithoutLocationInput>;
  documents?: InputMaybe<DocumentUncheckedCreateNestedManyWithoutLocationInput>;
  entities?: InputMaybe<EntityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  fields?: InputMaybe<LocationFieldsUncheckedCreateNestedManyWithoutLocationInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  statuses?: InputMaybe<StatusFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  subActivities?: InputMaybe<SubActivityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  subProducts?: InputMaybe<SubProductFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationUncheckedCreateWithoutDefinitionInput = {
  activities?: InputMaybe<ActivityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedCreateNestedManyWithoutLocationInput>;
  documents?: InputMaybe<DocumentUncheckedCreateNestedManyWithoutLocationInput>;
  entities?: InputMaybe<EntityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  fields?: InputMaybe<LocationFieldsUncheckedCreateNestedManyWithoutLocationInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  statuses?: InputMaybe<StatusFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  subActivities?: InputMaybe<SubActivityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  subProducts?: InputMaybe<SubProductFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationUncheckedCreateWithoutDocumentsInput = {
  activities?: InputMaybe<ActivityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedCreateNestedManyWithoutLocationInput>;
  definition?: InputMaybe<DefinitionFieldsUncheckedCreateNestedManyWithoutLocationInput>;
  entities?: InputMaybe<EntityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  fields?: InputMaybe<LocationFieldsUncheckedCreateNestedManyWithoutLocationInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  statuses?: InputMaybe<StatusFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  subActivities?: InputMaybe<SubActivityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  subProducts?: InputMaybe<SubProductFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationUncheckedCreateWithoutEntitiesInput = {
  activities?: InputMaybe<ActivityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedCreateNestedManyWithoutLocationInput>;
  definition?: InputMaybe<DefinitionFieldsUncheckedCreateNestedManyWithoutLocationInput>;
  documents?: InputMaybe<DocumentUncheckedCreateNestedManyWithoutLocationInput>;
  fields?: InputMaybe<LocationFieldsUncheckedCreateNestedManyWithoutLocationInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  statuses?: InputMaybe<StatusFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  subActivities?: InputMaybe<SubActivityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  subProducts?: InputMaybe<SubProductFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationUncheckedCreateWithoutFieldsInput = {
  activities?: InputMaybe<ActivityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedCreateNestedManyWithoutLocationInput>;
  definition?: InputMaybe<DefinitionFieldsUncheckedCreateNestedManyWithoutLocationInput>;
  documents?: InputMaybe<DocumentUncheckedCreateNestedManyWithoutLocationInput>;
  entities?: InputMaybe<EntityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  statuses?: InputMaybe<StatusFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  subActivities?: InputMaybe<SubActivityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  subProducts?: InputMaybe<SubProductFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationUncheckedCreateWithoutProductsInput = {
  activities?: InputMaybe<ActivityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedCreateNestedManyWithoutLocationInput>;
  definition?: InputMaybe<DefinitionFieldsUncheckedCreateNestedManyWithoutLocationInput>;
  documents?: InputMaybe<DocumentUncheckedCreateNestedManyWithoutLocationInput>;
  entities?: InputMaybe<EntityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  fields?: InputMaybe<LocationFieldsUncheckedCreateNestedManyWithoutLocationInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  statuses?: InputMaybe<StatusFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  subActivities?: InputMaybe<SubActivityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  subProducts?: InputMaybe<SubProductFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationUncheckedCreateWithoutStatusesInput = {
  activities?: InputMaybe<ActivityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedCreateNestedManyWithoutLocationInput>;
  definition?: InputMaybe<DefinitionFieldsUncheckedCreateNestedManyWithoutLocationInput>;
  documents?: InputMaybe<DocumentUncheckedCreateNestedManyWithoutLocationInput>;
  entities?: InputMaybe<EntityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  fields?: InputMaybe<LocationFieldsUncheckedCreateNestedManyWithoutLocationInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  subActivities?: InputMaybe<SubActivityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  subProducts?: InputMaybe<SubProductFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationUncheckedCreateWithoutSubActivitiesInput = {
  activities?: InputMaybe<ActivityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedCreateNestedManyWithoutLocationInput>;
  definition?: InputMaybe<DefinitionFieldsUncheckedCreateNestedManyWithoutLocationInput>;
  documents?: InputMaybe<DocumentUncheckedCreateNestedManyWithoutLocationInput>;
  entities?: InputMaybe<EntityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  fields?: InputMaybe<LocationFieldsUncheckedCreateNestedManyWithoutLocationInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  statuses?: InputMaybe<StatusFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  subProducts?: InputMaybe<SubProductFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationUncheckedCreateWithoutSubProductsInput = {
  activities?: InputMaybe<ActivityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedCreateNestedManyWithoutLocationInput>;
  definition?: InputMaybe<DefinitionFieldsUncheckedCreateNestedManyWithoutLocationInput>;
  documents?: InputMaybe<DocumentUncheckedCreateNestedManyWithoutLocationInput>;
  entities?: InputMaybe<EntityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  fields?: InputMaybe<LocationFieldsUncheckedCreateNestedManyWithoutLocationInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  statuses?: InputMaybe<StatusFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  subActivities?: InputMaybe<SubActivityFieldsUncheckedCreateNestedManyWithoutLocationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationUncheckedUpdateInput = {
  activities?: InputMaybe<ActivityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedUpdateManyWithoutLocationNestedInput>;
  definition?: InputMaybe<DefinitionFieldsUncheckedUpdateManyWithoutLocationNestedInput>;
  documents?: InputMaybe<DocumentUncheckedUpdateManyWithoutLocationNestedInput>;
  entities?: InputMaybe<EntityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  fields?: InputMaybe<LocationFieldsUncheckedUpdateManyWithoutLocationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  statuses?: InputMaybe<StatusFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  subActivities?: InputMaybe<SubActivityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  subProducts?: InputMaybe<SubProductFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUncheckedUpdateManyWithoutActivitiesNestedInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutActivitiesInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutActivitiesInput>>;
  delete?: InputMaybe<Array<LocationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationUpdateWithWhereUniqueWithoutActivitiesInput>>;
  updateMany?: InputMaybe<Array<LocationUpdateManyWithWhereWithoutActivitiesInput>>;
  upsert?: InputMaybe<Array<LocationUpsertWithWhereUniqueWithoutActivitiesInput>>;
};

export type LocationUncheckedUpdateManyWithoutBusinessUnitsNestedInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutBusinessUnitsInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutBusinessUnitsInput>>;
  delete?: InputMaybe<Array<LocationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationUpdateWithWhereUniqueWithoutBusinessUnitsInput>>;
  updateMany?: InputMaybe<Array<LocationUpdateManyWithWhereWithoutBusinessUnitsInput>>;
  upsert?: InputMaybe<Array<LocationUpsertWithWhereUniqueWithoutBusinessUnitsInput>>;
};

export type LocationUncheckedUpdateManyWithoutClientTypesNestedInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutClientTypesInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutClientTypesInput>>;
  delete?: InputMaybe<Array<LocationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationUpdateWithWhereUniqueWithoutClientTypesInput>>;
  updateMany?: InputMaybe<Array<LocationUpdateManyWithWhereWithoutClientTypesInput>>;
  upsert?: InputMaybe<Array<LocationUpsertWithWhereUniqueWithoutClientTypesInput>>;
};

export type LocationUncheckedUpdateManyWithoutDefinitionNestedInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutDefinitionInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutDefinitionInput>>;
  delete?: InputMaybe<Array<LocationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationUpdateWithWhereUniqueWithoutDefinitionInput>>;
  updateMany?: InputMaybe<Array<LocationUpdateManyWithWhereWithoutDefinitionInput>>;
  upsert?: InputMaybe<Array<LocationUpsertWithWhereUniqueWithoutDefinitionInput>>;
};

export type LocationUncheckedUpdateManyWithoutEntitiesNestedInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutEntitiesInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutEntitiesInput>>;
  delete?: InputMaybe<Array<LocationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationUpdateWithWhereUniqueWithoutEntitiesInput>>;
  updateMany?: InputMaybe<Array<LocationUpdateManyWithWhereWithoutEntitiesInput>>;
  upsert?: InputMaybe<Array<LocationUpsertWithWhereUniqueWithoutEntitiesInput>>;
};

export type LocationUncheckedUpdateManyWithoutLocationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUncheckedUpdateManyWithoutLocationsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUncheckedUpdateManyWithoutProductsNestedInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutProductsInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutProductsInput>>;
  delete?: InputMaybe<Array<LocationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationUpdateWithWhereUniqueWithoutProductsInput>>;
  updateMany?: InputMaybe<Array<LocationUpdateManyWithWhereWithoutProductsInput>>;
  upsert?: InputMaybe<Array<LocationUpsertWithWhereUniqueWithoutProductsInput>>;
};

export type LocationUncheckedUpdateManyWithoutStatusesNestedInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutStatusesInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutStatusesInput>>;
  delete?: InputMaybe<Array<LocationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationUpdateWithWhereUniqueWithoutStatusesInput>>;
  updateMany?: InputMaybe<Array<LocationUpdateManyWithWhereWithoutStatusesInput>>;
  upsert?: InputMaybe<Array<LocationUpsertWithWhereUniqueWithoutStatusesInput>>;
};

export type LocationUncheckedUpdateManyWithoutSubActivitiesNestedInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutSubActivitiesInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutSubActivitiesInput>>;
  delete?: InputMaybe<Array<LocationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationUpdateWithWhereUniqueWithoutSubActivitiesInput>>;
  updateMany?: InputMaybe<Array<LocationUpdateManyWithWhereWithoutSubActivitiesInput>>;
  upsert?: InputMaybe<Array<LocationUpsertWithWhereUniqueWithoutSubActivitiesInput>>;
};

export type LocationUncheckedUpdateManyWithoutSubProductsNestedInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutSubProductsInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutSubProductsInput>>;
  delete?: InputMaybe<Array<LocationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationUpdateWithWhereUniqueWithoutSubProductsInput>>;
  updateMany?: InputMaybe<Array<LocationUpdateManyWithWhereWithoutSubProductsInput>>;
  upsert?: InputMaybe<Array<LocationUpsertWithWhereUniqueWithoutSubProductsInput>>;
};

export type LocationUncheckedUpdateWithoutActivitiesInput = {
  businessUnits?: InputMaybe<BusinessUnitFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedUpdateManyWithoutLocationNestedInput>;
  definition?: InputMaybe<DefinitionFieldsUncheckedUpdateManyWithoutLocationNestedInput>;
  documents?: InputMaybe<DocumentUncheckedUpdateManyWithoutLocationNestedInput>;
  entities?: InputMaybe<EntityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  fields?: InputMaybe<LocationFieldsUncheckedUpdateManyWithoutLocationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  statuses?: InputMaybe<StatusFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  subActivities?: InputMaybe<SubActivityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  subProducts?: InputMaybe<SubProductFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUncheckedUpdateWithoutBusinessUnitsInput = {
  activities?: InputMaybe<ActivityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedUpdateManyWithoutLocationNestedInput>;
  definition?: InputMaybe<DefinitionFieldsUncheckedUpdateManyWithoutLocationNestedInput>;
  documents?: InputMaybe<DocumentUncheckedUpdateManyWithoutLocationNestedInput>;
  entities?: InputMaybe<EntityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  fields?: InputMaybe<LocationFieldsUncheckedUpdateManyWithoutLocationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  statuses?: InputMaybe<StatusFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  subActivities?: InputMaybe<SubActivityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  subProducts?: InputMaybe<SubProductFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUncheckedUpdateWithoutClientTypesInput = {
  activities?: InputMaybe<ActivityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedUpdateManyWithoutLocationNestedInput>;
  definition?: InputMaybe<DefinitionFieldsUncheckedUpdateManyWithoutLocationNestedInput>;
  documents?: InputMaybe<DocumentUncheckedUpdateManyWithoutLocationNestedInput>;
  entities?: InputMaybe<EntityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  fields?: InputMaybe<LocationFieldsUncheckedUpdateManyWithoutLocationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  statuses?: InputMaybe<StatusFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  subActivities?: InputMaybe<SubActivityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  subProducts?: InputMaybe<SubProductFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUncheckedUpdateWithoutDataImportFilesInput = {
  activities?: InputMaybe<ActivityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  definition?: InputMaybe<DefinitionFieldsUncheckedUpdateManyWithoutLocationNestedInput>;
  documents?: InputMaybe<DocumentUncheckedUpdateManyWithoutLocationNestedInput>;
  entities?: InputMaybe<EntityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  fields?: InputMaybe<LocationFieldsUncheckedUpdateManyWithoutLocationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  statuses?: InputMaybe<StatusFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  subActivities?: InputMaybe<SubActivityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  subProducts?: InputMaybe<SubProductFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUncheckedUpdateWithoutDefinitionInput = {
  activities?: InputMaybe<ActivityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedUpdateManyWithoutLocationNestedInput>;
  documents?: InputMaybe<DocumentUncheckedUpdateManyWithoutLocationNestedInput>;
  entities?: InputMaybe<EntityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  fields?: InputMaybe<LocationFieldsUncheckedUpdateManyWithoutLocationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  statuses?: InputMaybe<StatusFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  subActivities?: InputMaybe<SubActivityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  subProducts?: InputMaybe<SubProductFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUncheckedUpdateWithoutDocumentsInput = {
  activities?: InputMaybe<ActivityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedUpdateManyWithoutLocationNestedInput>;
  definition?: InputMaybe<DefinitionFieldsUncheckedUpdateManyWithoutLocationNestedInput>;
  entities?: InputMaybe<EntityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  fields?: InputMaybe<LocationFieldsUncheckedUpdateManyWithoutLocationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  statuses?: InputMaybe<StatusFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  subActivities?: InputMaybe<SubActivityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  subProducts?: InputMaybe<SubProductFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUncheckedUpdateWithoutEntitiesInput = {
  activities?: InputMaybe<ActivityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedUpdateManyWithoutLocationNestedInput>;
  definition?: InputMaybe<DefinitionFieldsUncheckedUpdateManyWithoutLocationNestedInput>;
  documents?: InputMaybe<DocumentUncheckedUpdateManyWithoutLocationNestedInput>;
  fields?: InputMaybe<LocationFieldsUncheckedUpdateManyWithoutLocationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  statuses?: InputMaybe<StatusFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  subActivities?: InputMaybe<SubActivityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  subProducts?: InputMaybe<SubProductFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUncheckedUpdateWithoutFieldsInput = {
  activities?: InputMaybe<ActivityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedUpdateManyWithoutLocationNestedInput>;
  definition?: InputMaybe<DefinitionFieldsUncheckedUpdateManyWithoutLocationNestedInput>;
  documents?: InputMaybe<DocumentUncheckedUpdateManyWithoutLocationNestedInput>;
  entities?: InputMaybe<EntityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  statuses?: InputMaybe<StatusFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  subActivities?: InputMaybe<SubActivityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  subProducts?: InputMaybe<SubProductFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUncheckedUpdateWithoutProductsInput = {
  activities?: InputMaybe<ActivityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedUpdateManyWithoutLocationNestedInput>;
  definition?: InputMaybe<DefinitionFieldsUncheckedUpdateManyWithoutLocationNestedInput>;
  documents?: InputMaybe<DocumentUncheckedUpdateManyWithoutLocationNestedInput>;
  entities?: InputMaybe<EntityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  fields?: InputMaybe<LocationFieldsUncheckedUpdateManyWithoutLocationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  statuses?: InputMaybe<StatusFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  subActivities?: InputMaybe<SubActivityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  subProducts?: InputMaybe<SubProductFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUncheckedUpdateWithoutStatusesInput = {
  activities?: InputMaybe<ActivityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedUpdateManyWithoutLocationNestedInput>;
  definition?: InputMaybe<DefinitionFieldsUncheckedUpdateManyWithoutLocationNestedInput>;
  documents?: InputMaybe<DocumentUncheckedUpdateManyWithoutLocationNestedInput>;
  entities?: InputMaybe<EntityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  fields?: InputMaybe<LocationFieldsUncheckedUpdateManyWithoutLocationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  subActivities?: InputMaybe<SubActivityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  subProducts?: InputMaybe<SubProductFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUncheckedUpdateWithoutSubActivitiesInput = {
  activities?: InputMaybe<ActivityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedUpdateManyWithoutLocationNestedInput>;
  definition?: InputMaybe<DefinitionFieldsUncheckedUpdateManyWithoutLocationNestedInput>;
  documents?: InputMaybe<DocumentUncheckedUpdateManyWithoutLocationNestedInput>;
  entities?: InputMaybe<EntityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  fields?: InputMaybe<LocationFieldsUncheckedUpdateManyWithoutLocationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  statuses?: InputMaybe<StatusFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  subProducts?: InputMaybe<SubProductFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUncheckedUpdateWithoutSubProductsInput = {
  activities?: InputMaybe<ActivityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUncheckedUpdateManyWithoutLocationNestedInput>;
  definition?: InputMaybe<DefinitionFieldsUncheckedUpdateManyWithoutLocationNestedInput>;
  documents?: InputMaybe<DocumentUncheckedUpdateManyWithoutLocationNestedInput>;
  entities?: InputMaybe<EntityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  fields?: InputMaybe<LocationFieldsUncheckedUpdateManyWithoutLocationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  statuses?: InputMaybe<StatusFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  subActivities?: InputMaybe<SubActivityFieldsUncheckedUpdateManyWithoutLocationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUpdateInput = {
  activities?: InputMaybe<ActivityFieldsUpdateManyWithoutLocationsNestedInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUpdateManyWithoutLocationsNestedInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUpdateManyWithoutLocationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUpdateManyWithoutLocationNestedInput>;
  definition?: InputMaybe<DefinitionFieldsUpdateManyWithoutLocationNestedInput>;
  documents?: InputMaybe<DocumentUpdateManyWithoutLocationNestedInput>;
  entities?: InputMaybe<EntityFieldsUpdateManyWithoutLocationsNestedInput>;
  fields?: InputMaybe<LocationFieldsUpdateManyWithoutLocationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductFieldsUpdateManyWithoutLocationsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  statuses?: InputMaybe<StatusFieldsUpdateManyWithoutLocationsNestedInput>;
  subActivities?: InputMaybe<SubActivityFieldsUpdateManyWithoutLocationsNestedInput>;
  subProducts?: InputMaybe<SubProductFieldsUpdateManyWithoutLocationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUpdateManyWithWhereWithoutActivitiesInput = {
  data: LocationUncheckedUpdateManyWithoutLocationsInput;
  where: LocationScalarWhereInput;
};

export type LocationUpdateManyWithWhereWithoutBusinessUnitsInput = {
  data: LocationUncheckedUpdateManyWithoutLocationsInput;
  where: LocationScalarWhereInput;
};

export type LocationUpdateManyWithWhereWithoutClientTypesInput = {
  data: LocationUncheckedUpdateManyWithoutLocationsInput;
  where: LocationScalarWhereInput;
};

export type LocationUpdateManyWithWhereWithoutDefinitionInput = {
  data: LocationUncheckedUpdateManyWithoutLocationInput;
  where: LocationScalarWhereInput;
};

export type LocationUpdateManyWithWhereWithoutEntitiesInput = {
  data: LocationUncheckedUpdateManyWithoutLocationsInput;
  where: LocationScalarWhereInput;
};

export type LocationUpdateManyWithWhereWithoutProductsInput = {
  data: LocationUncheckedUpdateManyWithoutLocationsInput;
  where: LocationScalarWhereInput;
};

export type LocationUpdateManyWithWhereWithoutStatusesInput = {
  data: LocationUncheckedUpdateManyWithoutLocationsInput;
  where: LocationScalarWhereInput;
};

export type LocationUpdateManyWithWhereWithoutSubActivitiesInput = {
  data: LocationUncheckedUpdateManyWithoutLocationsInput;
  where: LocationScalarWhereInput;
};

export type LocationUpdateManyWithWhereWithoutSubProductsInput = {
  data: LocationUncheckedUpdateManyWithoutLocationsInput;
  where: LocationScalarWhereInput;
};

export type LocationUpdateManyWithoutActivitiesNestedInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutActivitiesInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutActivitiesInput>>;
  delete?: InputMaybe<Array<LocationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationUpdateWithWhereUniqueWithoutActivitiesInput>>;
  updateMany?: InputMaybe<Array<LocationUpdateManyWithWhereWithoutActivitiesInput>>;
  upsert?: InputMaybe<Array<LocationUpsertWithWhereUniqueWithoutActivitiesInput>>;
};

export type LocationUpdateManyWithoutBusinessUnitsNestedInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutBusinessUnitsInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutBusinessUnitsInput>>;
  delete?: InputMaybe<Array<LocationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationUpdateWithWhereUniqueWithoutBusinessUnitsInput>>;
  updateMany?: InputMaybe<Array<LocationUpdateManyWithWhereWithoutBusinessUnitsInput>>;
  upsert?: InputMaybe<Array<LocationUpsertWithWhereUniqueWithoutBusinessUnitsInput>>;
};

export type LocationUpdateManyWithoutClientTypesNestedInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutClientTypesInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutClientTypesInput>>;
  delete?: InputMaybe<Array<LocationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationUpdateWithWhereUniqueWithoutClientTypesInput>>;
  updateMany?: InputMaybe<Array<LocationUpdateManyWithWhereWithoutClientTypesInput>>;
  upsert?: InputMaybe<Array<LocationUpsertWithWhereUniqueWithoutClientTypesInput>>;
};

export type LocationUpdateManyWithoutDefinitionNestedInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutDefinitionInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutDefinitionInput>>;
  delete?: InputMaybe<Array<LocationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationUpdateWithWhereUniqueWithoutDefinitionInput>>;
  updateMany?: InputMaybe<Array<LocationUpdateManyWithWhereWithoutDefinitionInput>>;
  upsert?: InputMaybe<Array<LocationUpsertWithWhereUniqueWithoutDefinitionInput>>;
};

export type LocationUpdateManyWithoutEntitiesNestedInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutEntitiesInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutEntitiesInput>>;
  delete?: InputMaybe<Array<LocationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationUpdateWithWhereUniqueWithoutEntitiesInput>>;
  updateMany?: InputMaybe<Array<LocationUpdateManyWithWhereWithoutEntitiesInput>>;
  upsert?: InputMaybe<Array<LocationUpsertWithWhereUniqueWithoutEntitiesInput>>;
};

export type LocationUpdateManyWithoutProductsNestedInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutProductsInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutProductsInput>>;
  delete?: InputMaybe<Array<LocationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationUpdateWithWhereUniqueWithoutProductsInput>>;
  updateMany?: InputMaybe<Array<LocationUpdateManyWithWhereWithoutProductsInput>>;
  upsert?: InputMaybe<Array<LocationUpsertWithWhereUniqueWithoutProductsInput>>;
};

export type LocationUpdateManyWithoutStatusesNestedInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutStatusesInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutStatusesInput>>;
  delete?: InputMaybe<Array<LocationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationUpdateWithWhereUniqueWithoutStatusesInput>>;
  updateMany?: InputMaybe<Array<LocationUpdateManyWithWhereWithoutStatusesInput>>;
  upsert?: InputMaybe<Array<LocationUpsertWithWhereUniqueWithoutStatusesInput>>;
};

export type LocationUpdateManyWithoutSubActivitiesNestedInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutSubActivitiesInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutSubActivitiesInput>>;
  delete?: InputMaybe<Array<LocationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationUpdateWithWhereUniqueWithoutSubActivitiesInput>>;
  updateMany?: InputMaybe<Array<LocationUpdateManyWithWhereWithoutSubActivitiesInput>>;
  upsert?: InputMaybe<Array<LocationUpsertWithWhereUniqueWithoutSubActivitiesInput>>;
};

export type LocationUpdateManyWithoutSubProductsNestedInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutSubProductsInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutSubProductsInput>>;
  delete?: InputMaybe<Array<LocationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationUpdateWithWhereUniqueWithoutSubProductsInput>>;
  updateMany?: InputMaybe<Array<LocationUpdateManyWithWhereWithoutSubProductsInput>>;
  upsert?: InputMaybe<Array<LocationUpsertWithWhereUniqueWithoutSubProductsInput>>;
};

export type LocationUpdateOneWithoutDataImportFilesNestedInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutDataImportFilesInput>;
  create?: InputMaybe<LocationUncheckedCreateWithoutDataImportFilesInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<LocationUncheckedUpdateWithoutDataImportFilesInput>;
  upsert?: InputMaybe<LocationUpsertWithoutDataImportFilesInput>;
};

export type LocationUpdateOneWithoutDocumentsNestedInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutDocumentsInput>;
  create?: InputMaybe<LocationUncheckedCreateWithoutDocumentsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<LocationUncheckedUpdateWithoutDocumentsInput>;
  upsert?: InputMaybe<LocationUpsertWithoutDocumentsInput>;
};

export type LocationUpdateOneWithoutFieldsNestedInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<LocationUncheckedCreateWithoutFieldsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<LocationUncheckedUpdateWithoutFieldsInput>;
  upsert?: InputMaybe<LocationUpsertWithoutFieldsInput>;
};

export type LocationUpdateWithWhereUniqueWithoutActivitiesInput = {
  data: LocationUncheckedUpdateWithoutActivitiesInput;
  where: LocationWhereUniqueInput;
};

export type LocationUpdateWithWhereUniqueWithoutBusinessUnitsInput = {
  data: LocationUncheckedUpdateWithoutBusinessUnitsInput;
  where: LocationWhereUniqueInput;
};

export type LocationUpdateWithWhereUniqueWithoutClientTypesInput = {
  data: LocationUncheckedUpdateWithoutClientTypesInput;
  where: LocationWhereUniqueInput;
};

export type LocationUpdateWithWhereUniqueWithoutDefinitionInput = {
  data: LocationUncheckedUpdateWithoutDefinitionInput;
  where: LocationWhereUniqueInput;
};

export type LocationUpdateWithWhereUniqueWithoutEntitiesInput = {
  data: LocationUncheckedUpdateWithoutEntitiesInput;
  where: LocationWhereUniqueInput;
};

export type LocationUpdateWithWhereUniqueWithoutProductsInput = {
  data: LocationUncheckedUpdateWithoutProductsInput;
  where: LocationWhereUniqueInput;
};

export type LocationUpdateWithWhereUniqueWithoutStatusesInput = {
  data: LocationUncheckedUpdateWithoutStatusesInput;
  where: LocationWhereUniqueInput;
};

export type LocationUpdateWithWhereUniqueWithoutSubActivitiesInput = {
  data: LocationUncheckedUpdateWithoutSubActivitiesInput;
  where: LocationWhereUniqueInput;
};

export type LocationUpdateWithWhereUniqueWithoutSubProductsInput = {
  data: LocationUncheckedUpdateWithoutSubProductsInput;
  where: LocationWhereUniqueInput;
};

export type LocationUpdateWithoutActivitiesInput = {
  businessUnits?: InputMaybe<BusinessUnitFieldsUpdateManyWithoutLocationsNestedInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUpdateManyWithoutLocationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUpdateManyWithoutLocationNestedInput>;
  definition?: InputMaybe<DefinitionFieldsUpdateManyWithoutLocationNestedInput>;
  documents?: InputMaybe<DocumentUpdateManyWithoutLocationNestedInput>;
  entities?: InputMaybe<EntityFieldsUpdateManyWithoutLocationsNestedInput>;
  fields?: InputMaybe<LocationFieldsUpdateManyWithoutLocationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductFieldsUpdateManyWithoutLocationsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  statuses?: InputMaybe<StatusFieldsUpdateManyWithoutLocationsNestedInput>;
  subActivities?: InputMaybe<SubActivityFieldsUpdateManyWithoutLocationsNestedInput>;
  subProducts?: InputMaybe<SubProductFieldsUpdateManyWithoutLocationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUpdateWithoutBusinessUnitsInput = {
  activities?: InputMaybe<ActivityFieldsUpdateManyWithoutLocationsNestedInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUpdateManyWithoutLocationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUpdateManyWithoutLocationNestedInput>;
  definition?: InputMaybe<DefinitionFieldsUpdateManyWithoutLocationNestedInput>;
  documents?: InputMaybe<DocumentUpdateManyWithoutLocationNestedInput>;
  entities?: InputMaybe<EntityFieldsUpdateManyWithoutLocationsNestedInput>;
  fields?: InputMaybe<LocationFieldsUpdateManyWithoutLocationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductFieldsUpdateManyWithoutLocationsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  statuses?: InputMaybe<StatusFieldsUpdateManyWithoutLocationsNestedInput>;
  subActivities?: InputMaybe<SubActivityFieldsUpdateManyWithoutLocationsNestedInput>;
  subProducts?: InputMaybe<SubProductFieldsUpdateManyWithoutLocationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUpdateWithoutClientTypesInput = {
  activities?: InputMaybe<ActivityFieldsUpdateManyWithoutLocationsNestedInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUpdateManyWithoutLocationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUpdateManyWithoutLocationNestedInput>;
  definition?: InputMaybe<DefinitionFieldsUpdateManyWithoutLocationNestedInput>;
  documents?: InputMaybe<DocumentUpdateManyWithoutLocationNestedInput>;
  entities?: InputMaybe<EntityFieldsUpdateManyWithoutLocationsNestedInput>;
  fields?: InputMaybe<LocationFieldsUpdateManyWithoutLocationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductFieldsUpdateManyWithoutLocationsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  statuses?: InputMaybe<StatusFieldsUpdateManyWithoutLocationsNestedInput>;
  subActivities?: InputMaybe<SubActivityFieldsUpdateManyWithoutLocationsNestedInput>;
  subProducts?: InputMaybe<SubProductFieldsUpdateManyWithoutLocationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUpdateWithoutDataImportFilesInput = {
  activities?: InputMaybe<ActivityFieldsUpdateManyWithoutLocationsNestedInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUpdateManyWithoutLocationsNestedInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUpdateManyWithoutLocationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  definition?: InputMaybe<DefinitionFieldsUpdateManyWithoutLocationNestedInput>;
  documents?: InputMaybe<DocumentUpdateManyWithoutLocationNestedInput>;
  entities?: InputMaybe<EntityFieldsUpdateManyWithoutLocationsNestedInput>;
  fields?: InputMaybe<LocationFieldsUpdateManyWithoutLocationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductFieldsUpdateManyWithoutLocationsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  statuses?: InputMaybe<StatusFieldsUpdateManyWithoutLocationsNestedInput>;
  subActivities?: InputMaybe<SubActivityFieldsUpdateManyWithoutLocationsNestedInput>;
  subProducts?: InputMaybe<SubProductFieldsUpdateManyWithoutLocationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUpdateWithoutDefinitionInput = {
  activities?: InputMaybe<ActivityFieldsUpdateManyWithoutLocationsNestedInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUpdateManyWithoutLocationsNestedInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUpdateManyWithoutLocationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUpdateManyWithoutLocationNestedInput>;
  documents?: InputMaybe<DocumentUpdateManyWithoutLocationNestedInput>;
  entities?: InputMaybe<EntityFieldsUpdateManyWithoutLocationsNestedInput>;
  fields?: InputMaybe<LocationFieldsUpdateManyWithoutLocationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductFieldsUpdateManyWithoutLocationsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  statuses?: InputMaybe<StatusFieldsUpdateManyWithoutLocationsNestedInput>;
  subActivities?: InputMaybe<SubActivityFieldsUpdateManyWithoutLocationsNestedInput>;
  subProducts?: InputMaybe<SubProductFieldsUpdateManyWithoutLocationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUpdateWithoutDocumentsInput = {
  activities?: InputMaybe<ActivityFieldsUpdateManyWithoutLocationsNestedInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUpdateManyWithoutLocationsNestedInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUpdateManyWithoutLocationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUpdateManyWithoutLocationNestedInput>;
  definition?: InputMaybe<DefinitionFieldsUpdateManyWithoutLocationNestedInput>;
  entities?: InputMaybe<EntityFieldsUpdateManyWithoutLocationsNestedInput>;
  fields?: InputMaybe<LocationFieldsUpdateManyWithoutLocationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductFieldsUpdateManyWithoutLocationsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  statuses?: InputMaybe<StatusFieldsUpdateManyWithoutLocationsNestedInput>;
  subActivities?: InputMaybe<SubActivityFieldsUpdateManyWithoutLocationsNestedInput>;
  subProducts?: InputMaybe<SubProductFieldsUpdateManyWithoutLocationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUpdateWithoutEntitiesInput = {
  activities?: InputMaybe<ActivityFieldsUpdateManyWithoutLocationsNestedInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUpdateManyWithoutLocationsNestedInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUpdateManyWithoutLocationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUpdateManyWithoutLocationNestedInput>;
  definition?: InputMaybe<DefinitionFieldsUpdateManyWithoutLocationNestedInput>;
  documents?: InputMaybe<DocumentUpdateManyWithoutLocationNestedInput>;
  fields?: InputMaybe<LocationFieldsUpdateManyWithoutLocationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductFieldsUpdateManyWithoutLocationsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  statuses?: InputMaybe<StatusFieldsUpdateManyWithoutLocationsNestedInput>;
  subActivities?: InputMaybe<SubActivityFieldsUpdateManyWithoutLocationsNestedInput>;
  subProducts?: InputMaybe<SubProductFieldsUpdateManyWithoutLocationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUpdateWithoutFieldsInput = {
  activities?: InputMaybe<ActivityFieldsUpdateManyWithoutLocationsNestedInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUpdateManyWithoutLocationsNestedInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUpdateManyWithoutLocationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUpdateManyWithoutLocationNestedInput>;
  definition?: InputMaybe<DefinitionFieldsUpdateManyWithoutLocationNestedInput>;
  documents?: InputMaybe<DocumentUpdateManyWithoutLocationNestedInput>;
  entities?: InputMaybe<EntityFieldsUpdateManyWithoutLocationsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductFieldsUpdateManyWithoutLocationsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  statuses?: InputMaybe<StatusFieldsUpdateManyWithoutLocationsNestedInput>;
  subActivities?: InputMaybe<SubActivityFieldsUpdateManyWithoutLocationsNestedInput>;
  subProducts?: InputMaybe<SubProductFieldsUpdateManyWithoutLocationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUpdateWithoutProductsInput = {
  activities?: InputMaybe<ActivityFieldsUpdateManyWithoutLocationsNestedInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUpdateManyWithoutLocationsNestedInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUpdateManyWithoutLocationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUpdateManyWithoutLocationNestedInput>;
  definition?: InputMaybe<DefinitionFieldsUpdateManyWithoutLocationNestedInput>;
  documents?: InputMaybe<DocumentUpdateManyWithoutLocationNestedInput>;
  entities?: InputMaybe<EntityFieldsUpdateManyWithoutLocationsNestedInput>;
  fields?: InputMaybe<LocationFieldsUpdateManyWithoutLocationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  statuses?: InputMaybe<StatusFieldsUpdateManyWithoutLocationsNestedInput>;
  subActivities?: InputMaybe<SubActivityFieldsUpdateManyWithoutLocationsNestedInput>;
  subProducts?: InputMaybe<SubProductFieldsUpdateManyWithoutLocationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUpdateWithoutStatusesInput = {
  activities?: InputMaybe<ActivityFieldsUpdateManyWithoutLocationsNestedInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUpdateManyWithoutLocationsNestedInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUpdateManyWithoutLocationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUpdateManyWithoutLocationNestedInput>;
  definition?: InputMaybe<DefinitionFieldsUpdateManyWithoutLocationNestedInput>;
  documents?: InputMaybe<DocumentUpdateManyWithoutLocationNestedInput>;
  entities?: InputMaybe<EntityFieldsUpdateManyWithoutLocationsNestedInput>;
  fields?: InputMaybe<LocationFieldsUpdateManyWithoutLocationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductFieldsUpdateManyWithoutLocationsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  subActivities?: InputMaybe<SubActivityFieldsUpdateManyWithoutLocationsNestedInput>;
  subProducts?: InputMaybe<SubProductFieldsUpdateManyWithoutLocationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUpdateWithoutSubActivitiesInput = {
  activities?: InputMaybe<ActivityFieldsUpdateManyWithoutLocationsNestedInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUpdateManyWithoutLocationsNestedInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUpdateManyWithoutLocationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUpdateManyWithoutLocationNestedInput>;
  definition?: InputMaybe<DefinitionFieldsUpdateManyWithoutLocationNestedInput>;
  documents?: InputMaybe<DocumentUpdateManyWithoutLocationNestedInput>;
  entities?: InputMaybe<EntityFieldsUpdateManyWithoutLocationsNestedInput>;
  fields?: InputMaybe<LocationFieldsUpdateManyWithoutLocationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductFieldsUpdateManyWithoutLocationsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  statuses?: InputMaybe<StatusFieldsUpdateManyWithoutLocationsNestedInput>;
  subProducts?: InputMaybe<SubProductFieldsUpdateManyWithoutLocationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUpdateWithoutSubProductsInput = {
  activities?: InputMaybe<ActivityFieldsUpdateManyWithoutLocationsNestedInput>;
  businessUnits?: InputMaybe<BusinessUnitFieldsUpdateManyWithoutLocationsNestedInput>;
  clientTypes?: InputMaybe<ClientTypeFieldsUpdateManyWithoutLocationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataImportFiles?: InputMaybe<DataImportFileUpdateManyWithoutLocationNestedInput>;
  definition?: InputMaybe<DefinitionFieldsUpdateManyWithoutLocationNestedInput>;
  documents?: InputMaybe<DocumentUpdateManyWithoutLocationNestedInput>;
  entities?: InputMaybe<EntityFieldsUpdateManyWithoutLocationsNestedInput>;
  fields?: InputMaybe<LocationFieldsUpdateManyWithoutLocationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductFieldsUpdateManyWithoutLocationsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  statuses?: InputMaybe<StatusFieldsUpdateManyWithoutLocationsNestedInput>;
  subActivities?: InputMaybe<SubActivityFieldsUpdateManyWithoutLocationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUpsertWithWhereUniqueWithoutActivitiesInput = {
  create: LocationUncheckedCreateWithoutActivitiesInput;
  update: LocationUncheckedUpdateWithoutActivitiesInput;
  where: LocationWhereUniqueInput;
};

export type LocationUpsertWithWhereUniqueWithoutBusinessUnitsInput = {
  create: LocationUncheckedCreateWithoutBusinessUnitsInput;
  update: LocationUncheckedUpdateWithoutBusinessUnitsInput;
  where: LocationWhereUniqueInput;
};

export type LocationUpsertWithWhereUniqueWithoutClientTypesInput = {
  create: LocationUncheckedCreateWithoutClientTypesInput;
  update: LocationUncheckedUpdateWithoutClientTypesInput;
  where: LocationWhereUniqueInput;
};

export type LocationUpsertWithWhereUniqueWithoutDefinitionInput = {
  create: LocationUncheckedCreateWithoutDefinitionInput;
  update: LocationUncheckedUpdateWithoutDefinitionInput;
  where: LocationWhereUniqueInput;
};

export type LocationUpsertWithWhereUniqueWithoutEntitiesInput = {
  create: LocationUncheckedCreateWithoutEntitiesInput;
  update: LocationUncheckedUpdateWithoutEntitiesInput;
  where: LocationWhereUniqueInput;
};

export type LocationUpsertWithWhereUniqueWithoutProductsInput = {
  create: LocationUncheckedCreateWithoutProductsInput;
  update: LocationUncheckedUpdateWithoutProductsInput;
  where: LocationWhereUniqueInput;
};

export type LocationUpsertWithWhereUniqueWithoutStatusesInput = {
  create: LocationUncheckedCreateWithoutStatusesInput;
  update: LocationUncheckedUpdateWithoutStatusesInput;
  where: LocationWhereUniqueInput;
};

export type LocationUpsertWithWhereUniqueWithoutSubActivitiesInput = {
  create: LocationUncheckedCreateWithoutSubActivitiesInput;
  update: LocationUncheckedUpdateWithoutSubActivitiesInput;
  where: LocationWhereUniqueInput;
};

export type LocationUpsertWithWhereUniqueWithoutSubProductsInput = {
  create: LocationUncheckedCreateWithoutSubProductsInput;
  update: LocationUncheckedUpdateWithoutSubProductsInput;
  where: LocationWhereUniqueInput;
};

export type LocationUpsertWithoutDataImportFilesInput = {
  create: LocationUncheckedCreateWithoutDataImportFilesInput;
  update: LocationUncheckedUpdateWithoutDataImportFilesInput;
};

export type LocationUpsertWithoutDocumentsInput = {
  create: LocationUncheckedCreateWithoutDocumentsInput;
  update: LocationUncheckedUpdateWithoutDocumentsInput;
};

export type LocationUpsertWithoutFieldsInput = {
  create: LocationUncheckedCreateWithoutFieldsInput;
  update: LocationUncheckedUpdateWithoutFieldsInput;
};

export type LocationWhereInput = {
  AND?: InputMaybe<Array<LocationWhereInput>>;
  NOT?: InputMaybe<Array<LocationWhereInput>>;
  OR?: InputMaybe<Array<LocationWhereInput>>;
  activities?: InputMaybe<ActivityFieldsListRelationFilter>;
  businessUnits?: InputMaybe<BusinessUnitFieldsListRelationFilter>;
  clientTypes?: InputMaybe<ClientTypeFieldsListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dataImportFiles?: InputMaybe<DataImportFileListRelationFilter>;
  definition?: InputMaybe<DefinitionFieldsListRelationFilter>;
  documents?: InputMaybe<DocumentListRelationFilter>;
  entities?: InputMaybe<EntityFieldsListRelationFilter>;
  fields?: InputMaybe<LocationFieldsListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  products?: InputMaybe<ProductFieldsListRelationFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  reference?: InputMaybe<StringFilter>;
  statuses?: InputMaybe<StatusFieldsListRelationFilter>;
  subActivities?: InputMaybe<SubActivityFieldsListRelationFilter>;
  subProducts?: InputMaybe<SubProductFieldsListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type LocationWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type MethodForActivity = {
  __typename?: 'MethodForActivity';
  _count: MethodForActivityCountOutputType;
  createdAt: Scalars['DateTime'];
  fields: Array<Maybe<MethodForActivityFields>>;
  id: Scalars['String'];
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type MethodForActivityFieldsArgs = {
  cursor?: InputMaybe<MethodForActivityFieldsWhereUniqueInput>;
  distinct?: InputMaybe<MethodForActivityFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<MethodForActivityFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MethodForActivityFieldsWhereInput>;
};

export type MethodForActivityCountAggregateOutputType = {
  __typename?: 'MethodForActivityCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  pending: Scalars['Int'];
  published: Scalars['Int'];
  reference: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MethodForActivityCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type MethodForActivityCountOutputType = {
  __typename?: 'MethodForActivityCountOutputType';
  fields: Scalars['Int'];
};

export type MethodForActivityCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<MethodForActivityFieldsCreateNestedManyWithoutMethodForActivityInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MethodForActivityCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MethodForActivityCreateNestedOneWithoutFieldsInput = {
  connect?: InputMaybe<MethodForActivityWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MethodForActivityCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<MethodForActivityUncheckedCreateWithoutFieldsInput>;
};

export type MethodForActivityCreateOrConnectWithoutFieldsInput = {
  create: MethodForActivityUncheckedCreateWithoutFieldsInput;
  where: MethodForActivityWhereUniqueInput;
};

export type MethodForActivityCreateWithoutFieldsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MethodForActivityFields = {
  __typename?: 'MethodForActivityFields';
  cmsId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  methodForActivity?: Maybe<MethodForActivity>;
  methodForActivityId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type MethodForActivityFieldsAvgAggregateOutputType = {
  __typename?: 'MethodForActivityFieldsAvgAggregateOutputType';
  order?: Maybe<Scalars['Float']>;
};

export type MethodForActivityFieldsAvgOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type MethodForActivityFieldsCountAggregateOutputType = {
  __typename?: 'MethodForActivityFieldsCountAggregateOutputType';
  _all: Scalars['Int'];
  cmsId: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  methodForActivityId: Scalars['Int'];
  name: Scalars['Int'];
  order: Scalars['Int'];
  pending: Scalars['Int'];
  published: Scalars['Int'];
  stack: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MethodForActivityFieldsCountOrderByAggregateInput = {
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  methodForActivityId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type MethodForActivityFieldsCreateInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  methodForActivity?: InputMaybe<MethodForActivityCreateNestedOneWithoutFieldsInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MethodForActivityFieldsCreateManyInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  methodForActivityId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MethodForActivityFieldsCreateManyMethodForActivityInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MethodForActivityFieldsCreateManyMethodForActivityInputEnvelope = {
  data: Array<MethodForActivityFieldsCreateManyMethodForActivityInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MethodForActivityFieldsCreateNestedManyWithoutMethodForActivityInput = {
  connect?: InputMaybe<Array<MethodForActivityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MethodForActivityFieldsCreateOrConnectWithoutMethodForActivityInput>>;
  create?: InputMaybe<Array<MethodForActivityFieldsCreateWithoutMethodForActivityInput>>;
  createMany?: InputMaybe<MethodForActivityFieldsCreateManyMethodForActivityInputEnvelope>;
};

export type MethodForActivityFieldsCreateOrConnectWithoutMethodForActivityInput = {
  create: MethodForActivityFieldsUncheckedCreateWithoutMethodForActivityInput;
  where: MethodForActivityFieldsWhereUniqueInput;
};

export type MethodForActivityFieldsCreateWithoutMethodForActivityInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MethodForActivityFieldsListRelationFilter = {
  every?: InputMaybe<MethodForActivityFieldsWhereInput>;
  none?: InputMaybe<MethodForActivityFieldsWhereInput>;
  some?: InputMaybe<MethodForActivityFieldsWhereInput>;
};

export type MethodForActivityFieldsMaxAggregateOutputType = {
  __typename?: 'MethodForActivityFieldsMaxAggregateOutputType';
  cmsId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  methodForActivityId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  stack?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MethodForActivityFieldsMaxOrderByAggregateInput = {
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  methodForActivityId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type MethodForActivityFieldsMinAggregateOutputType = {
  __typename?: 'MethodForActivityFieldsMinAggregateOutputType';
  cmsId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  methodForActivityId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  stack?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MethodForActivityFieldsMinOrderByAggregateInput = {
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  methodForActivityId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type MethodForActivityFieldsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MethodForActivityFieldsOrderByWithAggregationInput = {
  _avg?: InputMaybe<MethodForActivityFieldsAvgOrderByAggregateInput>;
  _count?: InputMaybe<MethodForActivityFieldsCountOrderByAggregateInput>;
  _max?: InputMaybe<MethodForActivityFieldsMaxOrderByAggregateInput>;
  _min?: InputMaybe<MethodForActivityFieldsMinOrderByAggregateInput>;
  _sum?: InputMaybe<MethodForActivityFieldsSumOrderByAggregateInput>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  methodForActivityId?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrderInput>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type MethodForActivityFieldsOrderByWithRelationInput = {
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  methodForActivity?: InputMaybe<MethodForActivityOrderByWithRelationInput>;
  methodForActivityId?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrderInput>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum MethodForActivityFieldsScalarFieldEnum {
  CmsId = 'cmsId',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  MethodForActivityId = 'methodForActivityId',
  Name = 'name',
  Order = 'order',
  Pending = 'pending',
  Published = 'published',
  Stack = 'stack',
  UpdatedAt = 'updatedAt'
}

export type MethodForActivityFieldsScalarWhereInput = {
  AND?: InputMaybe<Array<MethodForActivityFieldsScalarWhereInput>>;
  NOT?: InputMaybe<Array<MethodForActivityFieldsScalarWhereInput>>;
  OR?: InputMaybe<Array<MethodForActivityFieldsScalarWhereInput>>;
  cmsId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  methodForActivityId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  stack?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MethodForActivityFieldsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<MethodForActivityFieldsScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<MethodForActivityFieldsScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<MethodForActivityFieldsScalarWhereWithAggregatesInput>>;
  cmsId?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  methodForActivityId?: InputMaybe<StringNullableWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  order?: InputMaybe<IntNullableWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  stack?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type MethodForActivityFieldsSumAggregateOutputType = {
  __typename?: 'MethodForActivityFieldsSumAggregateOutputType';
  order?: Maybe<Scalars['Int']>;
};

export type MethodForActivityFieldsSumOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type MethodForActivityFieldsUncheckedCreateInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  methodForActivityId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MethodForActivityFieldsUncheckedCreateNestedManyWithoutMethodForActivityInput = {
  connect?: InputMaybe<Array<MethodForActivityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MethodForActivityFieldsCreateOrConnectWithoutMethodForActivityInput>>;
  create?: InputMaybe<Array<MethodForActivityFieldsCreateWithoutMethodForActivityInput>>;
  createMany?: InputMaybe<MethodForActivityFieldsCreateManyMethodForActivityInputEnvelope>;
};

export type MethodForActivityFieldsUncheckedCreateWithoutMethodForActivityInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MethodForActivityFieldsUncheckedUpdateInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  methodForActivityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MethodForActivityFieldsUncheckedUpdateManyInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  methodForActivityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MethodForActivityFieldsUncheckedUpdateManyWithoutFieldsInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MethodForActivityFieldsUncheckedUpdateManyWithoutMethodForActivityNestedInput = {
  connect?: InputMaybe<Array<MethodForActivityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MethodForActivityFieldsCreateOrConnectWithoutMethodForActivityInput>>;
  create?: InputMaybe<Array<MethodForActivityFieldsCreateWithoutMethodForActivityInput>>;
  createMany?: InputMaybe<MethodForActivityFieldsCreateManyMethodForActivityInputEnvelope>;
  delete?: InputMaybe<Array<MethodForActivityFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MethodForActivityFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MethodForActivityFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<MethodForActivityFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<MethodForActivityFieldsUpdateWithWhereUniqueWithoutMethodForActivityInput>>;
  updateMany?: InputMaybe<Array<MethodForActivityFieldsUpdateManyWithWhereWithoutMethodForActivityInput>>;
  upsert?: InputMaybe<Array<MethodForActivityFieldsUpsertWithWhereUniqueWithoutMethodForActivityInput>>;
};

export type MethodForActivityFieldsUncheckedUpdateWithoutMethodForActivityInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MethodForActivityFieldsUpdateInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  methodForActivity?: InputMaybe<MethodForActivityUpdateOneWithoutFieldsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MethodForActivityFieldsUpdateManyMutationInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MethodForActivityFieldsUpdateManyWithWhereWithoutMethodForActivityInput = {
  data: MethodForActivityFieldsUncheckedUpdateManyWithoutFieldsInput;
  where: MethodForActivityFieldsScalarWhereInput;
};

export type MethodForActivityFieldsUpdateManyWithoutMethodForActivityNestedInput = {
  connect?: InputMaybe<Array<MethodForActivityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MethodForActivityFieldsCreateOrConnectWithoutMethodForActivityInput>>;
  create?: InputMaybe<Array<MethodForActivityFieldsCreateWithoutMethodForActivityInput>>;
  createMany?: InputMaybe<MethodForActivityFieldsCreateManyMethodForActivityInputEnvelope>;
  delete?: InputMaybe<Array<MethodForActivityFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MethodForActivityFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MethodForActivityFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<MethodForActivityFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<MethodForActivityFieldsUpdateWithWhereUniqueWithoutMethodForActivityInput>>;
  updateMany?: InputMaybe<Array<MethodForActivityFieldsUpdateManyWithWhereWithoutMethodForActivityInput>>;
  upsert?: InputMaybe<Array<MethodForActivityFieldsUpsertWithWhereUniqueWithoutMethodForActivityInput>>;
};

export type MethodForActivityFieldsUpdateWithWhereUniqueWithoutMethodForActivityInput = {
  data: MethodForActivityFieldsUncheckedUpdateWithoutMethodForActivityInput;
  where: MethodForActivityFieldsWhereUniqueInput;
};

export type MethodForActivityFieldsUpdateWithoutMethodForActivityInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MethodForActivityFieldsUpsertWithWhereUniqueWithoutMethodForActivityInput = {
  create: MethodForActivityFieldsUncheckedCreateWithoutMethodForActivityInput;
  update: MethodForActivityFieldsUncheckedUpdateWithoutMethodForActivityInput;
  where: MethodForActivityFieldsWhereUniqueInput;
};

export type MethodForActivityFieldsWhereInput = {
  AND?: InputMaybe<Array<MethodForActivityFieldsWhereInput>>;
  NOT?: InputMaybe<Array<MethodForActivityFieldsWhereInput>>;
  OR?: InputMaybe<Array<MethodForActivityFieldsWhereInput>>;
  cmsId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  methodForActivity?: InputMaybe<MethodForActivityWhereInput>;
  methodForActivityId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  stack?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MethodForActivityFieldsWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type MethodForActivityMaxAggregateOutputType = {
  __typename?: 'MethodForActivityMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MethodForActivityMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type MethodForActivityMinAggregateOutputType = {
  __typename?: 'MethodForActivityMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MethodForActivityMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type MethodForActivityOrderByWithAggregationInput = {
  _count?: InputMaybe<MethodForActivityCountOrderByAggregateInput>;
  _max?: InputMaybe<MethodForActivityMaxOrderByAggregateInput>;
  _min?: InputMaybe<MethodForActivityMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type MethodForActivityOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  fields?: InputMaybe<MethodForActivityFieldsOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type MethodForActivityRelationFilter = {
  is?: InputMaybe<MethodForActivityWhereInput>;
  isNot?: InputMaybe<MethodForActivityWhereInput>;
};

export enum MethodForActivityScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Pending = 'pending',
  Published = 'published',
  Reference = 'reference',
  UpdatedAt = 'updatedAt'
}

export type MethodForActivityScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<MethodForActivityScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<MethodForActivityScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<MethodForActivityScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  reference?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type MethodForActivityUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<MethodForActivityFieldsUncheckedCreateNestedManyWithoutMethodForActivityInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MethodForActivityUncheckedCreateWithoutFieldsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MethodForActivityUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<MethodForActivityFieldsUncheckedUpdateManyWithoutMethodForActivityNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MethodForActivityUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MethodForActivityUncheckedUpdateWithoutFieldsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MethodForActivityUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<MethodForActivityFieldsUpdateManyWithoutMethodForActivityNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MethodForActivityUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MethodForActivityUpdateOneWithoutFieldsNestedInput = {
  connect?: InputMaybe<MethodForActivityWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MethodForActivityCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<MethodForActivityUncheckedCreateWithoutFieldsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<MethodForActivityUncheckedUpdateWithoutFieldsInput>;
  upsert?: InputMaybe<MethodForActivityUpsertWithoutFieldsInput>;
};

export type MethodForActivityUpdateWithoutFieldsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MethodForActivityUpsertWithoutFieldsInput = {
  create: MethodForActivityUncheckedCreateWithoutFieldsInput;
  update: MethodForActivityUncheckedUpdateWithoutFieldsInput;
};

export type MethodForActivityWhereInput = {
  AND?: InputMaybe<Array<MethodForActivityWhereInput>>;
  NOT?: InputMaybe<Array<MethodForActivityWhereInput>>;
  OR?: InputMaybe<Array<MethodForActivityWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fields?: InputMaybe<MethodForActivityFieldsListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  reference?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MethodForActivityWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptAllSuggestions?: Maybe<AcceptAllSuggestions>;
  archiveAudits: BatchPayload;
  createActivity: Activity;
  createActivityFields: ActivityFields;
  createAudit: Audit;
  createBusinessUnit: BusinessUnit;
  createBusinessUnitFields: BusinessUnitFields;
  createCategory: Category;
  createCategoryFields: CategoryFields;
  createClientType: ClientType;
  createClientTypeFields: ClientTypeFields;
  createCycle: Cycle;
  createCycleAndDocuments: Cycle;
  createDataImport: DataImport;
  createDataImportFile: DataImportFile;
  createDataImportProgressSummary: DataImportProgressSummary;
  createDataImportValidation: DataImportValidation;
  createDataImportValidationAudit: DataImportValidationAudit;
  createDefinition: Definition;
  createDefinitionFields: DefinitionFields;
  createDocument: Document;
  createDocumentCycle: DocumentCycle;
  createEntity: Entity;
  createEntityFields: EntityFields;
  createLocation: Location;
  createLocationFields: LocationFields;
  createMethodForActivity: MethodForActivity;
  createMethodForActivityFields: MethodForActivityFields;
  createPredefinedResponse: PredefinedResponse;
  createPredefinedResponseFields: PredefinedResponseFields;
  createProduct: Product;
  createProductFields: ProductFields;
  createReverseEnquiry: ReverseEnquiry;
  createReverseEnquiryFields: ReverseEnquiryFields;
  createReviewGuidance: ReviewGuidance;
  createReviewGuidanceFields: ReviewGuidanceFields;
  createStatus: Status;
  createStatusFields: StatusFields;
  createSubActivity: SubActivity;
  createSubActivityFields: SubActivityFields;
  createSubProduct: SubProduct;
  createSubProductFields: SubProductFields;
  createVersion: Version;
  dearchiveAudits: BatchPayload;
  deleteActivity?: Maybe<Activity>;
  deleteActivityFields?: Maybe<ActivityFields>;
  deleteAudit?: Maybe<Audit>;
  deleteBusinessUnit?: Maybe<BusinessUnit>;
  deleteBusinessUnitFields?: Maybe<BusinessUnitFields>;
  deleteCategory?: Maybe<Category>;
  deleteCategoryFields?: Maybe<CategoryFields>;
  deleteClientType?: Maybe<ClientType>;
  deleteClientTypeFields?: Maybe<ClientTypeFields>;
  deleteCycle?: Maybe<Cycle>;
  deleteDataImport?: Maybe<DataImport>;
  deleteDataImportFile?: Maybe<DataImportFile>;
  deleteDataImportProgressSummary?: Maybe<DataImportProgressSummary>;
  deleteDataImportValidation?: Maybe<DataImportValidation>;
  deleteDataImportValidationAudit?: Maybe<DataImportValidationAudit>;
  deleteDefinition?: Maybe<Definition>;
  deleteDefinitionFields?: Maybe<DefinitionFields>;
  deleteDocument?: Maybe<Document>;
  deleteDocumentCycle?: Maybe<DocumentCycle>;
  deleteEntity?: Maybe<Entity>;
  deleteEntityFields?: Maybe<EntityFields>;
  deleteLocation?: Maybe<Location>;
  deleteLocationFields?: Maybe<LocationFields>;
  deleteManyAudits?: Maybe<BatchPayload>;
  deleteManyPredefinedResponseFieldses?: Maybe<BatchPayload>;
  deleteManyPredefinedResponses?: Maybe<BatchPayload>;
  deleteMethodForActivity?: Maybe<MethodForActivity>;
  deleteMethodForActivityFields?: Maybe<MethodForActivityFields>;
  deletePredefinedResponse?: Maybe<PredefinedResponse>;
  deletePredefinedResponseFields?: Maybe<PredefinedResponseFields>;
  deleteProduct?: Maybe<Product>;
  deleteProductFields?: Maybe<ProductFields>;
  deleteReverseEnquiry?: Maybe<ReverseEnquiry>;
  deleteReverseEnquiryFields?: Maybe<ReverseEnquiryFields>;
  deleteReviewGuidance?: Maybe<ReviewGuidance>;
  deleteReviewGuidanceFields?: Maybe<ReviewGuidanceFields>;
  deleteStatus?: Maybe<Status>;
  deleteStatusFields?: Maybe<StatusFields>;
  deleteSubActivity?: Maybe<SubActivity>;
  deleteSubActivityFields?: Maybe<SubActivityFields>;
  deleteSubProduct?: Maybe<SubProduct>;
  deleteSubProductFields?: Maybe<SubProductFields>;
  deleteVersion?: Maybe<Version>;
  updateActivity: Activity;
  updateActivityFields: ActivityFields;
  updateAudit: Audit;
  updateBusinessUnit: BusinessUnit;
  updateBusinessUnitFields: BusinessUnitFields;
  updateCategory: Category;
  updateCategoryFields: CategoryFields;
  updateClientType: ClientType;
  updateClientTypeFields: ClientTypeFields;
  updateCycle: Cycle;
  updateDataImport: DataImport;
  updateDataImportFile: DataImportFile;
  updateDataImportProgressSummary: DataImportProgressSummary;
  updateDataImportValidation: DataImportValidation;
  updateDataImportValidationAudit: DataImportValidationAudit;
  updateDefinition: Definition;
  updateDefinitionFields: DefinitionFields;
  updateDocument: Document;
  updateDocumentCycle: DocumentCycle;
  updateEntity: Entity;
  updateEntityFields: EntityFields;
  updateLocation: Location;
  updateLocationFields: LocationFields;
  updateManyAudits?: Maybe<BatchPayload>;
  updateManyDataImports?: Maybe<BatchPayload>;
  updateManyDefinitionFieldses?: Maybe<BatchPayload>;
  updateManyDocumentCycles?: Maybe<BatchPayload>;
  updateManyPredefinedResponseFieldses?: Maybe<BatchPayload>;
  updateManyPredefinedResponses?: Maybe<BatchPayload>;
  updateManyStatusFieldses?: Maybe<BatchPayload>;
  updateMethodForActivity: MethodForActivity;
  updateMethodForActivityFields: MethodForActivityFields;
  updatePredefinedResponse: PredefinedResponse;
  updatePredefinedResponseFields: PredefinedResponseFields;
  updateProduct: Product;
  updateProductFields: ProductFields;
  updateReverseEnquiry: ReverseEnquiry;
  updateReverseEnquiryFields: ReverseEnquiryFields;
  updateReviewGuidance: ReviewGuidance;
  updateReviewGuidanceFields: ReviewGuidanceFields;
  updateStatus: Status;
  updateStatusFields: StatusFields;
  updateSubActivity: SubActivity;
  updateSubActivityFields: SubActivityFields;
  updateSubProduct: SubProduct;
  updateSubProductFields: SubProductFields;
  updateVersion: Version;
};


export type MutationAcceptAllSuggestionsArgs = {
  where: DocumentCycleWhereUniqueInput;
};


export type MutationArchiveAuditsArgs = {
  where?: InputMaybe<AuditWhereInput>;
};


export type MutationCreateActivityArgs = {
  data: ActivityCreateInput;
};


export type MutationCreateActivityFieldsArgs = {
  data: ActivityFieldsCreateInput;
};


export type MutationCreateAuditArgs = {
  data: AuditCreateInput;
};


export type MutationCreateBusinessUnitArgs = {
  data: BusinessUnitCreateInput;
};


export type MutationCreateBusinessUnitFieldsArgs = {
  data: BusinessUnitFieldsCreateInput;
};


export type MutationCreateCategoryArgs = {
  data: CategoryCreateInput;
};


export type MutationCreateCategoryFieldsArgs = {
  data: CategoryFieldsCreateInput;
};


export type MutationCreateClientTypeArgs = {
  data: ClientTypeCreateInput;
};


export type MutationCreateClientTypeFieldsArgs = {
  data: ClientTypeFieldsCreateInput;
};


export type MutationCreateCycleArgs = {
  data: CycleCreateInput;
};


export type MutationCreateCycleAndDocumentsArgs = {
  data: CycleAndDocumentsCreateInput;
};


export type MutationCreateDataImportArgs = {
  data: DataImportCreateInput;
};


export type MutationCreateDataImportFileArgs = {
  data: DataImportFileCreateInput;
};


export type MutationCreateDataImportProgressSummaryArgs = {
  data: DataImportProgressSummaryCreateInput;
};


export type MutationCreateDataImportValidationArgs = {
  data: DataImportValidationCreateInput;
};


export type MutationCreateDataImportValidationAuditArgs = {
  data: DataImportValidationAuditCreateInput;
};


export type MutationCreateDefinitionArgs = {
  data: DefinitionCreateInput;
};


export type MutationCreateDefinitionFieldsArgs = {
  data: DefinitionFieldsCreateInput;
};


export type MutationCreateDocumentArgs = {
  data: DocumentCreateInput;
};


export type MutationCreateDocumentCycleArgs = {
  data: DocumentCycleCreateInput;
};


export type MutationCreateEntityArgs = {
  data: EntityCreateInput;
};


export type MutationCreateEntityFieldsArgs = {
  data: EntityFieldsCreateInput;
};


export type MutationCreateLocationArgs = {
  data: LocationCreateInput;
};


export type MutationCreateLocationFieldsArgs = {
  data: LocationFieldsCreateInput;
};


export type MutationCreateMethodForActivityArgs = {
  data: MethodForActivityCreateInput;
};


export type MutationCreateMethodForActivityFieldsArgs = {
  data: MethodForActivityFieldsCreateInput;
};


export type MutationCreatePredefinedResponseArgs = {
  data: PredefinedResponseCreateInput;
};


export type MutationCreatePredefinedResponseFieldsArgs = {
  data: PredefinedResponseFieldsCreateInput;
};


export type MutationCreateProductArgs = {
  data: ProductCreateInput;
};


export type MutationCreateProductFieldsArgs = {
  data: ProductFieldsCreateInput;
};


export type MutationCreateReverseEnquiryArgs = {
  data: ReverseEnquiryCreateInput;
};


export type MutationCreateReverseEnquiryFieldsArgs = {
  data: ReverseEnquiryFieldsCreateInput;
};


export type MutationCreateReviewGuidanceArgs = {
  data: ReviewGuidanceCreateInput;
};


export type MutationCreateReviewGuidanceFieldsArgs = {
  data: ReviewGuidanceFieldsCreateInput;
};


export type MutationCreateStatusArgs = {
  data: StatusCreateInput;
};


export type MutationCreateStatusFieldsArgs = {
  data: StatusFieldsCreateInput;
};


export type MutationCreateSubActivityArgs = {
  data: SubActivityCreateInput;
};


export type MutationCreateSubActivityFieldsArgs = {
  data: SubActivityFieldsCreateInput;
};


export type MutationCreateSubProductArgs = {
  data: SubProductCreateInput;
};


export type MutationCreateSubProductFieldsArgs = {
  data: SubProductFieldsCreateInput;
};


export type MutationCreateVersionArgs = {
  data: VersionCreateInput;
};


export type MutationDearchiveAuditsArgs = {
  where?: InputMaybe<AuditWhereInput>;
};


export type MutationDeleteActivityArgs = {
  where: ActivityWhereUniqueInput;
};


export type MutationDeleteActivityFieldsArgs = {
  where: ActivityFieldsWhereUniqueInput;
};


export type MutationDeleteAuditArgs = {
  where: AuditWhereUniqueInput;
};


export type MutationDeleteBusinessUnitArgs = {
  where: BusinessUnitWhereUniqueInput;
};


export type MutationDeleteBusinessUnitFieldsArgs = {
  where: BusinessUnitFieldsWhereUniqueInput;
};


export type MutationDeleteCategoryArgs = {
  where: CategoryWhereUniqueInput;
};


export type MutationDeleteCategoryFieldsArgs = {
  where: CategoryFieldsWhereUniqueInput;
};


export type MutationDeleteClientTypeArgs = {
  where: ClientTypeWhereUniqueInput;
};


export type MutationDeleteClientTypeFieldsArgs = {
  where: ClientTypeFieldsWhereUniqueInput;
};


export type MutationDeleteCycleArgs = {
  where: CycleWhereUniqueInput;
};


export type MutationDeleteDataImportArgs = {
  where: DataImportWhereUniqueInput;
};


export type MutationDeleteDataImportFileArgs = {
  where: DataImportFileWhereUniqueInput;
};


export type MutationDeleteDataImportProgressSummaryArgs = {
  where: DataImportProgressSummaryWhereUniqueInput;
};


export type MutationDeleteDataImportValidationArgs = {
  where: DataImportValidationWhereUniqueInput;
};


export type MutationDeleteDataImportValidationAuditArgs = {
  where: DataImportValidationAuditWhereUniqueInput;
};


export type MutationDeleteDefinitionArgs = {
  where: DefinitionWhereUniqueInput;
};


export type MutationDeleteDefinitionFieldsArgs = {
  where: DefinitionFieldsWhereUniqueInput;
};


export type MutationDeleteDocumentArgs = {
  where: DocumentWhereUniqueInput;
};


export type MutationDeleteDocumentCycleArgs = {
  where: DocumentCycleWhereUniqueInput;
};


export type MutationDeleteEntityArgs = {
  where: EntityWhereUniqueInput;
};


export type MutationDeleteEntityFieldsArgs = {
  where: EntityFieldsWhereUniqueInput;
};


export type MutationDeleteLocationArgs = {
  where: LocationWhereUniqueInput;
};


export type MutationDeleteLocationFieldsArgs = {
  where: LocationFieldsWhereUniqueInput;
};


export type MutationDeleteManyAuditsArgs = {
  where?: InputMaybe<AuditWhereInput>;
};


export type MutationDeleteManyPredefinedResponseFieldsesArgs = {
  where?: InputMaybe<PredefinedResponseFieldsWhereInput>;
};


export type MutationDeleteManyPredefinedResponsesArgs = {
  where?: InputMaybe<PredefinedResponseWhereInput>;
};


export type MutationDeleteMethodForActivityArgs = {
  where: MethodForActivityWhereUniqueInput;
};


export type MutationDeleteMethodForActivityFieldsArgs = {
  where: MethodForActivityFieldsWhereUniqueInput;
};


export type MutationDeletePredefinedResponseArgs = {
  where: PredefinedResponseWhereUniqueInput;
};


export type MutationDeletePredefinedResponseFieldsArgs = {
  where: PredefinedResponseFieldsWhereUniqueInput;
};


export type MutationDeleteProductArgs = {
  where: ProductWhereUniqueInput;
};


export type MutationDeleteProductFieldsArgs = {
  where: ProductFieldsWhereUniqueInput;
};


export type MutationDeleteReverseEnquiryArgs = {
  where: ReverseEnquiryWhereUniqueInput;
};


export type MutationDeleteReverseEnquiryFieldsArgs = {
  where: ReverseEnquiryFieldsWhereUniqueInput;
};


export type MutationDeleteReviewGuidanceArgs = {
  where: ReviewGuidanceWhereUniqueInput;
};


export type MutationDeleteReviewGuidanceFieldsArgs = {
  where: ReviewGuidanceFieldsWhereUniqueInput;
};


export type MutationDeleteStatusArgs = {
  where: StatusWhereUniqueInput;
};


export type MutationDeleteStatusFieldsArgs = {
  where: StatusFieldsWhereUniqueInput;
};


export type MutationDeleteSubActivityArgs = {
  where: SubActivityWhereUniqueInput;
};


export type MutationDeleteSubActivityFieldsArgs = {
  where: SubActivityFieldsWhereUniqueInput;
};


export type MutationDeleteSubProductArgs = {
  where: SubProductWhereUniqueInput;
};


export type MutationDeleteSubProductFieldsArgs = {
  where: SubProductFieldsWhereUniqueInput;
};


export type MutationDeleteVersionArgs = {
  where: VersionWhereUniqueInput;
};


export type MutationUpdateActivityArgs = {
  data: ActivityUpdateInput;
  where: ActivityWhereUniqueInput;
};


export type MutationUpdateActivityFieldsArgs = {
  data: ActivityFieldsUpdateInput;
  where: ActivityFieldsWhereUniqueInput;
};


export type MutationUpdateAuditArgs = {
  data: AuditUpdateInput;
  where: AuditWhereUniqueInput;
};


export type MutationUpdateBusinessUnitArgs = {
  data: BusinessUnitUpdateInput;
  where: BusinessUnitWhereUniqueInput;
};


export type MutationUpdateBusinessUnitFieldsArgs = {
  data: BusinessUnitFieldsUpdateInput;
  where: BusinessUnitFieldsWhereUniqueInput;
};


export type MutationUpdateCategoryArgs = {
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};


export type MutationUpdateCategoryFieldsArgs = {
  data: CategoryFieldsUpdateInput;
  where: CategoryFieldsWhereUniqueInput;
};


export type MutationUpdateClientTypeArgs = {
  data: ClientTypeUpdateInput;
  where: ClientTypeWhereUniqueInput;
};


export type MutationUpdateClientTypeFieldsArgs = {
  data: ClientTypeFieldsUpdateInput;
  where: ClientTypeFieldsWhereUniqueInput;
};


export type MutationUpdateCycleArgs = {
  data: CycleUpdateInput;
  where: CycleWhereUniqueInput;
};


export type MutationUpdateDataImportArgs = {
  data: DataImportUpdateInput;
  where: DataImportWhereUniqueInput;
};


export type MutationUpdateDataImportFileArgs = {
  data: DataImportFileUpdateInput;
  where: DataImportFileWhereUniqueInput;
};


export type MutationUpdateDataImportProgressSummaryArgs = {
  data: DataImportProgressSummaryUpdateInput;
  where: DataImportProgressSummaryWhereUniqueInput;
};


export type MutationUpdateDataImportValidationArgs = {
  data: DataImportValidationUpdateInput;
  where: DataImportValidationWhereUniqueInput;
};


export type MutationUpdateDataImportValidationAuditArgs = {
  data: DataImportValidationAuditUpdateInput;
  where: DataImportValidationAuditWhereUniqueInput;
};


export type MutationUpdateDefinitionArgs = {
  data: DefinitionUpdateInput;
  where: DefinitionWhereUniqueInput;
};


export type MutationUpdateDefinitionFieldsArgs = {
  data: DefinitionFieldsUpdateInput;
  where: DefinitionFieldsWhereUniqueInput;
};


export type MutationUpdateDocumentArgs = {
  data: DocumentUpdateInput;
  where: DocumentWhereUniqueInput;
};


export type MutationUpdateDocumentCycleArgs = {
  data: DocumentCycleUpdateInput;
  where: DocumentCycleWhereUniqueInput;
};


export type MutationUpdateEntityArgs = {
  data: EntityUpdateInput;
  where: EntityWhereUniqueInput;
};


export type MutationUpdateEntityFieldsArgs = {
  data: EntityFieldsUpdateInput;
  where: EntityFieldsWhereUniqueInput;
};


export type MutationUpdateLocationArgs = {
  data: LocationUpdateInput;
  where: LocationWhereUniqueInput;
};


export type MutationUpdateLocationFieldsArgs = {
  data: LocationFieldsUpdateInput;
  where: LocationFieldsWhereUniqueInput;
};


export type MutationUpdateManyAuditsArgs = {
  data: AuditUpdateManyMutationInput;
  where?: InputMaybe<AuditWhereInput>;
};


export type MutationUpdateManyDataImportsArgs = {
  data: DataImportUpdateManyMutationInput;
  where?: InputMaybe<DataImportWhereInput>;
};


export type MutationUpdateManyDefinitionFieldsesArgs = {
  data: DefinitionFieldsUpdateManyMutationInput;
  where?: InputMaybe<DefinitionFieldsWhereInput>;
};


export type MutationUpdateManyDocumentCyclesArgs = {
  data: DocumentCycleUpdateManyMutationInput;
  where?: InputMaybe<DocumentCycleWhereInput>;
};


export type MutationUpdateManyPredefinedResponseFieldsesArgs = {
  data: PredefinedResponseFieldsUpdateManyMutationInput;
  where?: InputMaybe<PredefinedResponseFieldsWhereInput>;
};


export type MutationUpdateManyPredefinedResponsesArgs = {
  data: PredefinedResponseUpdateManyMutationInput;
  where?: InputMaybe<PredefinedResponseWhereInput>;
};


export type MutationUpdateManyStatusFieldsesArgs = {
  data: StatusFieldsUpdateManyMutationInput;
  where?: InputMaybe<StatusFieldsWhereInput>;
};


export type MutationUpdateMethodForActivityArgs = {
  data: MethodForActivityUpdateInput;
  where: MethodForActivityWhereUniqueInput;
};


export type MutationUpdateMethodForActivityFieldsArgs = {
  data: MethodForActivityFieldsUpdateInput;
  where: MethodForActivityFieldsWhereUniqueInput;
};


export type MutationUpdatePredefinedResponseArgs = {
  data: PredefinedResponseUpdateInput;
  where: PredefinedResponseWhereUniqueInput;
};


export type MutationUpdatePredefinedResponseFieldsArgs = {
  data: PredefinedResponseFieldsUpdateInput;
  where: PredefinedResponseFieldsWhereUniqueInput;
};


export type MutationUpdateProductArgs = {
  data: ProductUpdateInput;
  where: ProductWhereUniqueInput;
};


export type MutationUpdateProductFieldsArgs = {
  data: ProductFieldsUpdateInput;
  where: ProductFieldsWhereUniqueInput;
};


export type MutationUpdateReverseEnquiryArgs = {
  data: ReverseEnquiryUpdateInput;
  where: ReverseEnquiryWhereUniqueInput;
};


export type MutationUpdateReverseEnquiryFieldsArgs = {
  data: ReverseEnquiryFieldsUpdateInput;
  where: ReverseEnquiryFieldsWhereUniqueInput;
};


export type MutationUpdateReviewGuidanceArgs = {
  data: ReviewGuidanceUpdateInput;
  where: ReviewGuidanceWhereUniqueInput;
};


export type MutationUpdateReviewGuidanceFieldsArgs = {
  data: ReviewGuidanceFieldsUpdateInput;
  where: ReviewGuidanceFieldsWhereUniqueInput;
};


export type MutationUpdateStatusArgs = {
  data: StatusUpdateInput;
  where: StatusWhereUniqueInput;
};


export type MutationUpdateStatusFieldsArgs = {
  data: StatusFieldsUpdateInput;
  where: StatusFieldsWhereUniqueInput;
};


export type MutationUpdateSubActivityArgs = {
  data: SubActivityUpdateInput;
  where: SubActivityWhereUniqueInput;
};


export type MutationUpdateSubActivityFieldsArgs = {
  data: SubActivityFieldsUpdateInput;
  where: SubActivityFieldsWhereUniqueInput;
};


export type MutationUpdateSubProductArgs = {
  data: SubProductUpdateInput;
  where: SubProductWhereUniqueInput;
};


export type MutationUpdateSubProductFieldsArgs = {
  data: SubProductFieldsUpdateInput;
  where: SubProductFieldsWhereUniqueInput;
};


export type MutationUpdateVersionArgs = {
  data: VersionUpdateInput;
  where: VersionWhereUniqueInput;
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type NestedBoolNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedBoolNullableFilter>;
  _min?: InputMaybe<NestedBoolNullableFilter>;
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolNullableWithAggregatesFilter>;
};

export type NestedBoolWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedBoolFilter>;
  _min?: InputMaybe<NestedBoolFilter>;
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolWithAggregatesFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedDateTimeNullableFilter>;
  _min?: InputMaybe<NestedDateTimeNullableFilter>;
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedEnumAuditActionFilter = {
  equals?: InputMaybe<AuditAction>;
  in?: InputMaybe<Array<AuditAction>>;
  not?: InputMaybe<NestedEnumAuditActionFilter>;
  notIn?: InputMaybe<Array<AuditAction>>;
};

export type NestedEnumAuditActionWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumAuditActionFilter>;
  _min?: InputMaybe<NestedEnumAuditActionFilter>;
  equals?: InputMaybe<AuditAction>;
  in?: InputMaybe<Array<AuditAction>>;
  not?: InputMaybe<NestedEnumAuditActionWithAggregatesFilter>;
  notIn?: InputMaybe<Array<AuditAction>>;
};

export type NestedEnumAuditTypeFilter = {
  equals?: InputMaybe<AuditType>;
  in?: InputMaybe<Array<AuditType>>;
  not?: InputMaybe<NestedEnumAuditTypeFilter>;
  notIn?: InputMaybe<Array<AuditType>>;
};

export type NestedEnumAuditTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumAuditTypeFilter>;
  _min?: InputMaybe<NestedEnumAuditTypeFilter>;
  equals?: InputMaybe<AuditType>;
  in?: InputMaybe<Array<AuditType>>;
  not?: InputMaybe<NestedEnumAuditTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<AuditType>>;
};

export type NestedEnumDataImportEnvironmentFilter = {
  equals?: InputMaybe<DataImportEnvironment>;
  in?: InputMaybe<Array<DataImportEnvironment>>;
  not?: InputMaybe<NestedEnumDataImportEnvironmentFilter>;
  notIn?: InputMaybe<Array<DataImportEnvironment>>;
};

export type NestedEnumDataImportEnvironmentWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDataImportEnvironmentFilter>;
  _min?: InputMaybe<NestedEnumDataImportEnvironmentFilter>;
  equals?: InputMaybe<DataImportEnvironment>;
  in?: InputMaybe<Array<DataImportEnvironment>>;
  not?: InputMaybe<NestedEnumDataImportEnvironmentWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DataImportEnvironment>>;
};

export type NestedEnumDataImportFileTypeFilter = {
  equals?: InputMaybe<DataImportFileType>;
  in?: InputMaybe<Array<DataImportFileType>>;
  not?: InputMaybe<NestedEnumDataImportFileTypeFilter>;
  notIn?: InputMaybe<Array<DataImportFileType>>;
};

export type NestedEnumDataImportFileTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDataImportFileTypeFilter>;
  _min?: InputMaybe<NestedEnumDataImportFileTypeFilter>;
  equals?: InputMaybe<DataImportFileType>;
  in?: InputMaybe<Array<DataImportFileType>>;
  not?: InputMaybe<NestedEnumDataImportFileTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DataImportFileType>>;
};

export type NestedEnumDataImportProgressStatusNullableFilter = {
  equals?: InputMaybe<DataImportProgressStatus>;
  in?: InputMaybe<Array<DataImportProgressStatus>>;
  not?: InputMaybe<NestedEnumDataImportProgressStatusNullableFilter>;
  notIn?: InputMaybe<Array<DataImportProgressStatus>>;
};

export type NestedEnumDataImportProgressStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDataImportProgressStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumDataImportProgressStatusNullableFilter>;
  equals?: InputMaybe<DataImportProgressStatus>;
  in?: InputMaybe<Array<DataImportProgressStatus>>;
  not?: InputMaybe<NestedEnumDataImportProgressStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DataImportProgressStatus>>;
};

export type NestedEnumDataImportPublishStatusNullableFilter = {
  equals?: InputMaybe<DataImportPublishStatus>;
  in?: InputMaybe<Array<DataImportPublishStatus>>;
  not?: InputMaybe<NestedEnumDataImportPublishStatusNullableFilter>;
  notIn?: InputMaybe<Array<DataImportPublishStatus>>;
};

export type NestedEnumDataImportPublishStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDataImportPublishStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumDataImportPublishStatusNullableFilter>;
  equals?: InputMaybe<DataImportPublishStatus>;
  in?: InputMaybe<Array<DataImportPublishStatus>>;
  not?: InputMaybe<NestedEnumDataImportPublishStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DataImportPublishStatus>>;
};

export type NestedEnumDataImportValidationAuditTypeFilter = {
  equals?: InputMaybe<DataImportValidationAuditType>;
  in?: InputMaybe<Array<DataImportValidationAuditType>>;
  not?: InputMaybe<NestedEnumDataImportValidationAuditTypeFilter>;
  notIn?: InputMaybe<Array<DataImportValidationAuditType>>;
};

export type NestedEnumDataImportValidationAuditTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDataImportValidationAuditTypeFilter>;
  _min?: InputMaybe<NestedEnumDataImportValidationAuditTypeFilter>;
  equals?: InputMaybe<DataImportValidationAuditType>;
  in?: InputMaybe<Array<DataImportValidationAuditType>>;
  not?: InputMaybe<NestedEnumDataImportValidationAuditTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DataImportValidationAuditType>>;
};

export type NestedEnumDataImportValidationStatusNullableFilter = {
  equals?: InputMaybe<DataImportValidationStatus>;
  in?: InputMaybe<Array<DataImportValidationStatus>>;
  not?: InputMaybe<NestedEnumDataImportValidationStatusNullableFilter>;
  notIn?: InputMaybe<Array<DataImportValidationStatus>>;
};

export type NestedEnumDataImportValidationStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDataImportValidationStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumDataImportValidationStatusNullableFilter>;
  equals?: InputMaybe<DataImportValidationStatus>;
  in?: InputMaybe<Array<DataImportValidationStatus>>;
  not?: InputMaybe<NestedEnumDataImportValidationStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DataImportValidationStatus>>;
};

export type NestedEnumProgressStatusNullableFilter = {
  equals?: InputMaybe<ProgressStatus>;
  in?: InputMaybe<Array<ProgressStatus>>;
  not?: InputMaybe<NestedEnumProgressStatusNullableFilter>;
  notIn?: InputMaybe<Array<ProgressStatus>>;
};

export type NestedEnumProgressStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumProgressStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumProgressStatusNullableFilter>;
  equals?: InputMaybe<ProgressStatus>;
  in?: InputMaybe<Array<ProgressStatus>>;
  not?: InputMaybe<NestedEnumProgressStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ProgressStatus>>;
};

export type NestedEnumPublishStatusNullableFilter = {
  equals?: InputMaybe<PublishStatus>;
  in?: InputMaybe<Array<PublishStatus>>;
  not?: InputMaybe<NestedEnumPublishStatusNullableFilter>;
  notIn?: InputMaybe<Array<PublishStatus>>;
};

export type NestedEnumPublishStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumPublishStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumPublishStatusNullableFilter>;
  equals?: InputMaybe<PublishStatus>;
  in?: InputMaybe<Array<PublishStatus>>;
  not?: InputMaybe<NestedEnumPublishStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PublishStatus>>;
};

export type NestedFloatFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type NestedFloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedIntNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedIntNullableFilter>;
  _min?: InputMaybe<NestedIntNullableFilter>;
  _sum?: InputMaybe<NestedIntNullableFilter>;
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedIntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedIntFilter>;
  _min?: InputMaybe<NestedIntFilter>;
  _sum?: InputMaybe<NestedIntFilter>;
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedJsonNullableFilter = {
  array_contains?: InputMaybe<Scalars['Json']>;
  array_ends_with?: InputMaybe<Scalars['Json']>;
  array_starts_with?: InputMaybe<Scalars['Json']>;
  equals?: InputMaybe<Scalars['Json']>;
  gt?: InputMaybe<Scalars['Json']>;
  gte?: InputMaybe<Scalars['Json']>;
  lt?: InputMaybe<Scalars['Json']>;
  lte?: InputMaybe<Scalars['Json']>;
  not?: InputMaybe<Scalars['Json']>;
  path?: InputMaybe<Scalars['String']>;
  string_contains?: InputMaybe<Scalars['String']>;
  string_ends_with?: InputMaybe<Scalars['String']>;
  string_starts_with?: InputMaybe<Scalars['String']>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NullableBoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']>;
};

export type NullableEnumDataImportProgressStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<DataImportProgressStatus>;
};

export type NullableEnumDataImportPublishStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<DataImportPublishStatus>;
};

export type NullableEnumDataImportValidationStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<DataImportValidationStatus>;
};

export type NullableEnumProgressStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<ProgressStatus>;
};

export type NullableEnumPublishStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<PublishStatus>;
};

export type NullableIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']>;
  divide?: InputMaybe<Scalars['Int']>;
  increment?: InputMaybe<Scalars['Int']>;
  multiply?: InputMaybe<Scalars['Int']>;
  set?: InputMaybe<Scalars['Int']>;
};

export enum NullableJsonNullValueInput {
  DbNull = 'DbNull',
  JsonNull = 'JsonNull'
}

export type NullableStringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']>;
};

export enum NullsOrder {
  First = 'first',
  Last = 'last'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type PermissionListRelationFilter = {
  every?: InputMaybe<PermissionWhereInput>;
  none?: InputMaybe<PermissionWhereInput>;
  some?: InputMaybe<PermissionWhereInput>;
};

export type PermissionWhereInput = {
  AND?: InputMaybe<Array<PermissionWhereInput>>;
  NOT?: InputMaybe<Array<PermissionWhereInput>>;
  OR?: InputMaybe<Array<PermissionWhereInput>>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  reference?: InputMaybe<StringFilter>;
};

export type PredefinedResponse = {
  __typename?: 'PredefinedResponse';
  _count: PredefinedResponseCountOutputType;
  createdAt: Scalars['DateTime'];
  fields: Array<Maybe<PredefinedResponseFields>>;
  id: Scalars['String'];
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type PredefinedResponseFieldsArgs = {
  cursor?: InputMaybe<PredefinedResponseFieldsWhereUniqueInput>;
  distinct?: InputMaybe<PredefinedResponseFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<PredefinedResponseFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PredefinedResponseFieldsWhereInput>;
};

export type PredefinedResponseCountAggregateOutputType = {
  __typename?: 'PredefinedResponseCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  pending: Scalars['Int'];
  published: Scalars['Int'];
  reference: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type PredefinedResponseCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PredefinedResponseCountOutputType = {
  __typename?: 'PredefinedResponseCountOutputType';
  fields: Scalars['Int'];
};

export type PredefinedResponseCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<PredefinedResponseFieldsCreateNestedManyWithoutPredefinedResponseInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PredefinedResponseCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PredefinedResponseCreateNestedOneWithoutFieldsInput = {
  connect?: InputMaybe<PredefinedResponseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PredefinedResponseCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<PredefinedResponseUncheckedCreateWithoutFieldsInput>;
};

export type PredefinedResponseCreateOrConnectWithoutFieldsInput = {
  create: PredefinedResponseUncheckedCreateWithoutFieldsInput;
  where: PredefinedResponseWhereUniqueInput;
};

export type PredefinedResponseCreateWithoutFieldsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PredefinedResponseFields = {
  __typename?: 'PredefinedResponseFields';
  cmsId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  pending?: Maybe<Scalars['Boolean']>;
  predefinedResponse?: Maybe<PredefinedResponse>;
  predefinedResponseId?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  responseText: Scalars['String'];
  stack?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type PredefinedResponseFieldsCountAggregateOutputType = {
  __typename?: 'PredefinedResponseFieldsCountAggregateOutputType';
  _all: Scalars['Int'];
  cmsId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  pending: Scalars['Int'];
  predefinedResponseId: Scalars['Int'];
  published: Scalars['Int'];
  responseText: Scalars['Int'];
  stack: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type PredefinedResponseFieldsCountOrderByAggregateInput = {
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  predefinedResponseId?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  responseText?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PredefinedResponseFieldsCreateInput = {
  cmsId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  predefinedResponse?: InputMaybe<PredefinedResponseCreateNestedOneWithoutFieldsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  responseText: Scalars['String'];
  stack?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PredefinedResponseFieldsCreateManyInput = {
  cmsId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  predefinedResponseId?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  responseText: Scalars['String'];
  stack?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PredefinedResponseFieldsCreateManyPredefinedResponseInput = {
  cmsId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  responseText: Scalars['String'];
  stack?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PredefinedResponseFieldsCreateManyPredefinedResponseInputEnvelope = {
  data: Array<PredefinedResponseFieldsCreateManyPredefinedResponseInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type PredefinedResponseFieldsCreateNestedManyWithoutPredefinedResponseInput = {
  connect?: InputMaybe<Array<PredefinedResponseFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PredefinedResponseFieldsCreateOrConnectWithoutPredefinedResponseInput>>;
  create?: InputMaybe<Array<PredefinedResponseFieldsCreateWithoutPredefinedResponseInput>>;
  createMany?: InputMaybe<PredefinedResponseFieldsCreateManyPredefinedResponseInputEnvelope>;
};

export type PredefinedResponseFieldsCreateOrConnectWithoutPredefinedResponseInput = {
  create: PredefinedResponseFieldsUncheckedCreateWithoutPredefinedResponseInput;
  where: PredefinedResponseFieldsWhereUniqueInput;
};

export type PredefinedResponseFieldsCreateWithoutPredefinedResponseInput = {
  cmsId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  responseText: Scalars['String'];
  stack?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PredefinedResponseFieldsListRelationFilter = {
  every?: InputMaybe<PredefinedResponseFieldsWhereInput>;
  none?: InputMaybe<PredefinedResponseFieldsWhereInput>;
  some?: InputMaybe<PredefinedResponseFieldsWhereInput>;
};

export type PredefinedResponseFieldsMaxAggregateOutputType = {
  __typename?: 'PredefinedResponseFieldsMaxAggregateOutputType';
  cmsId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  predefinedResponseId?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  responseText?: Maybe<Scalars['String']>;
  stack?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PredefinedResponseFieldsMaxOrderByAggregateInput = {
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  predefinedResponseId?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  responseText?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PredefinedResponseFieldsMinAggregateOutputType = {
  __typename?: 'PredefinedResponseFieldsMinAggregateOutputType';
  cmsId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  predefinedResponseId?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  responseText?: Maybe<Scalars['String']>;
  stack?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PredefinedResponseFieldsMinOrderByAggregateInput = {
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  predefinedResponseId?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  responseText?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PredefinedResponseFieldsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PredefinedResponseFieldsOrderByWithAggregationInput = {
  _count?: InputMaybe<PredefinedResponseFieldsCountOrderByAggregateInput>;
  _max?: InputMaybe<PredefinedResponseFieldsMaxOrderByAggregateInput>;
  _min?: InputMaybe<PredefinedResponseFieldsMinOrderByAggregateInput>;
  cmsId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  predefinedResponseId?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  responseText?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PredefinedResponseFieldsOrderByWithRelationInput = {
  cmsId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  predefinedResponse?: InputMaybe<PredefinedResponseOrderByWithRelationInput>;
  predefinedResponseId?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  responseText?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum PredefinedResponseFieldsScalarFieldEnum {
  CmsId = 'cmsId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Pending = 'pending',
  PredefinedResponseId = 'predefinedResponseId',
  Published = 'published',
  ResponseText = 'responseText',
  Stack = 'stack',
  UpdatedAt = 'updatedAt'
}

export type PredefinedResponseFieldsScalarWhereInput = {
  AND?: InputMaybe<Array<PredefinedResponseFieldsScalarWhereInput>>;
  NOT?: InputMaybe<Array<PredefinedResponseFieldsScalarWhereInput>>;
  OR?: InputMaybe<Array<PredefinedResponseFieldsScalarWhereInput>>;
  cmsId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  predefinedResponseId?: InputMaybe<StringNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  responseText?: InputMaybe<StringFilter>;
  stack?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PredefinedResponseFieldsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<PredefinedResponseFieldsScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<PredefinedResponseFieldsScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<PredefinedResponseFieldsScalarWhereWithAggregatesInput>>;
  cmsId?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  predefinedResponseId?: InputMaybe<StringNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  responseText?: InputMaybe<StringWithAggregatesFilter>;
  stack?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type PredefinedResponseFieldsUncheckedCreateInput = {
  cmsId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  predefinedResponseId?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  responseText: Scalars['String'];
  stack?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PredefinedResponseFieldsUncheckedCreateNestedManyWithoutPredefinedResponseInput = {
  connect?: InputMaybe<Array<PredefinedResponseFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PredefinedResponseFieldsCreateOrConnectWithoutPredefinedResponseInput>>;
  create?: InputMaybe<Array<PredefinedResponseFieldsCreateWithoutPredefinedResponseInput>>;
  createMany?: InputMaybe<PredefinedResponseFieldsCreateManyPredefinedResponseInputEnvelope>;
};

export type PredefinedResponseFieldsUncheckedCreateWithoutPredefinedResponseInput = {
  cmsId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  responseText: Scalars['String'];
  stack?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PredefinedResponseFieldsUncheckedUpdateInput = {
  cmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  predefinedResponseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  responseText?: InputMaybe<StringFieldUpdateOperationsInput>;
  stack?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PredefinedResponseFieldsUncheckedUpdateManyInput = {
  cmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  predefinedResponseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  responseText?: InputMaybe<StringFieldUpdateOperationsInput>;
  stack?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PredefinedResponseFieldsUncheckedUpdateManyWithoutFieldsInput = {
  cmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  responseText?: InputMaybe<StringFieldUpdateOperationsInput>;
  stack?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PredefinedResponseFieldsUncheckedUpdateManyWithoutPredefinedResponseNestedInput = {
  connect?: InputMaybe<Array<PredefinedResponseFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PredefinedResponseFieldsCreateOrConnectWithoutPredefinedResponseInput>>;
  create?: InputMaybe<Array<PredefinedResponseFieldsCreateWithoutPredefinedResponseInput>>;
  createMany?: InputMaybe<PredefinedResponseFieldsCreateManyPredefinedResponseInputEnvelope>;
  delete?: InputMaybe<Array<PredefinedResponseFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PredefinedResponseFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PredefinedResponseFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<PredefinedResponseFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<PredefinedResponseFieldsUpdateWithWhereUniqueWithoutPredefinedResponseInput>>;
  updateMany?: InputMaybe<Array<PredefinedResponseFieldsUpdateManyWithWhereWithoutPredefinedResponseInput>>;
  upsert?: InputMaybe<Array<PredefinedResponseFieldsUpsertWithWhereUniqueWithoutPredefinedResponseInput>>;
};

export type PredefinedResponseFieldsUncheckedUpdateWithoutPredefinedResponseInput = {
  cmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  responseText?: InputMaybe<StringFieldUpdateOperationsInput>;
  stack?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PredefinedResponseFieldsUpdateInput = {
  cmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  predefinedResponse?: InputMaybe<PredefinedResponseUpdateOneWithoutFieldsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  responseText?: InputMaybe<StringFieldUpdateOperationsInput>;
  stack?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PredefinedResponseFieldsUpdateManyMutationInput = {
  cmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  responseText?: InputMaybe<StringFieldUpdateOperationsInput>;
  stack?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PredefinedResponseFieldsUpdateManyWithWhereWithoutPredefinedResponseInput = {
  data: PredefinedResponseFieldsUncheckedUpdateManyWithoutFieldsInput;
  where: PredefinedResponseFieldsScalarWhereInput;
};

export type PredefinedResponseFieldsUpdateManyWithoutPredefinedResponseNestedInput = {
  connect?: InputMaybe<Array<PredefinedResponseFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PredefinedResponseFieldsCreateOrConnectWithoutPredefinedResponseInput>>;
  create?: InputMaybe<Array<PredefinedResponseFieldsCreateWithoutPredefinedResponseInput>>;
  createMany?: InputMaybe<PredefinedResponseFieldsCreateManyPredefinedResponseInputEnvelope>;
  delete?: InputMaybe<Array<PredefinedResponseFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PredefinedResponseFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PredefinedResponseFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<PredefinedResponseFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<PredefinedResponseFieldsUpdateWithWhereUniqueWithoutPredefinedResponseInput>>;
  updateMany?: InputMaybe<Array<PredefinedResponseFieldsUpdateManyWithWhereWithoutPredefinedResponseInput>>;
  upsert?: InputMaybe<Array<PredefinedResponseFieldsUpsertWithWhereUniqueWithoutPredefinedResponseInput>>;
};

export type PredefinedResponseFieldsUpdateWithWhereUniqueWithoutPredefinedResponseInput = {
  data: PredefinedResponseFieldsUncheckedUpdateWithoutPredefinedResponseInput;
  where: PredefinedResponseFieldsWhereUniqueInput;
};

export type PredefinedResponseFieldsUpdateWithoutPredefinedResponseInput = {
  cmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  responseText?: InputMaybe<StringFieldUpdateOperationsInput>;
  stack?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PredefinedResponseFieldsUpsertWithWhereUniqueWithoutPredefinedResponseInput = {
  create: PredefinedResponseFieldsUncheckedCreateWithoutPredefinedResponseInput;
  update: PredefinedResponseFieldsUncheckedUpdateWithoutPredefinedResponseInput;
  where: PredefinedResponseFieldsWhereUniqueInput;
};

export type PredefinedResponseFieldsWhereInput = {
  AND?: InputMaybe<Array<PredefinedResponseFieldsWhereInput>>;
  NOT?: InputMaybe<Array<PredefinedResponseFieldsWhereInput>>;
  OR?: InputMaybe<Array<PredefinedResponseFieldsWhereInput>>;
  cmsId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  predefinedResponse?: InputMaybe<PredefinedResponseWhereInput>;
  predefinedResponseId?: InputMaybe<StringNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  responseText?: InputMaybe<StringFilter>;
  stack?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PredefinedResponseFieldsWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type PredefinedResponseMaxAggregateOutputType = {
  __typename?: 'PredefinedResponseMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PredefinedResponseMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PredefinedResponseMinAggregateOutputType = {
  __typename?: 'PredefinedResponseMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PredefinedResponseMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PredefinedResponseOrderByWithAggregationInput = {
  _count?: InputMaybe<PredefinedResponseCountOrderByAggregateInput>;
  _max?: InputMaybe<PredefinedResponseMaxOrderByAggregateInput>;
  _min?: InputMaybe<PredefinedResponseMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PredefinedResponseOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  fields?: InputMaybe<PredefinedResponseFieldsOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PredefinedResponseRelationFilter = {
  is?: InputMaybe<PredefinedResponseWhereInput>;
  isNot?: InputMaybe<PredefinedResponseWhereInput>;
};

export enum PredefinedResponseScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Pending = 'pending',
  Published = 'published',
  Reference = 'reference',
  UpdatedAt = 'updatedAt'
}

export type PredefinedResponseScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<PredefinedResponseScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<PredefinedResponseScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<PredefinedResponseScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  reference?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type PredefinedResponseUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<PredefinedResponseFieldsUncheckedCreateNestedManyWithoutPredefinedResponseInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PredefinedResponseUncheckedCreateWithoutFieldsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PredefinedResponseUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<PredefinedResponseFieldsUncheckedUpdateManyWithoutPredefinedResponseNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PredefinedResponseUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PredefinedResponseUncheckedUpdateWithoutFieldsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PredefinedResponseUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<PredefinedResponseFieldsUpdateManyWithoutPredefinedResponseNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PredefinedResponseUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PredefinedResponseUpdateOneWithoutFieldsNestedInput = {
  connect?: InputMaybe<PredefinedResponseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PredefinedResponseCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<PredefinedResponseUncheckedCreateWithoutFieldsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<PredefinedResponseUncheckedUpdateWithoutFieldsInput>;
  upsert?: InputMaybe<PredefinedResponseUpsertWithoutFieldsInput>;
};

export type PredefinedResponseUpdateWithoutFieldsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PredefinedResponseUpsertWithoutFieldsInput = {
  create: PredefinedResponseUncheckedCreateWithoutFieldsInput;
  update: PredefinedResponseUncheckedUpdateWithoutFieldsInput;
};

export type PredefinedResponseWhereInput = {
  AND?: InputMaybe<Array<PredefinedResponseWhereInput>>;
  NOT?: InputMaybe<Array<PredefinedResponseWhereInput>>;
  OR?: InputMaybe<Array<PredefinedResponseWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fields?: InputMaybe<PredefinedResponseFieldsListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  reference?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PredefinedResponseWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type Product = {
  __typename?: 'Product';
  _count: ProductCountOutputType;
  createdAt: Scalars['DateTime'];
  fields: Array<Maybe<ProductFields>>;
  id: Scalars['String'];
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  subProducts: Array<Maybe<SubProductFields>>;
  updatedAt: Scalars['DateTime'];
};


export type ProductFieldsArgs = {
  cursor?: InputMaybe<ProductFieldsWhereUniqueInput>;
  distinct?: InputMaybe<ProductFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<ProductFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductFieldsWhereInput>;
};


export type ProductSubProductsArgs = {
  cursor?: InputMaybe<SubProductFieldsWhereUniqueInput>;
  distinct?: InputMaybe<SubProductFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<SubProductFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SubProductFieldsWhereInput>;
};

export type ProductCountAggregateOutputType = {
  __typename?: 'ProductCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  pending: Scalars['Int'];
  published: Scalars['Int'];
  reference: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ProductCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProductCountOutputType = {
  __typename?: 'ProductCountOutputType';
  fields: Scalars['Int'];
  subProducts: Scalars['Int'];
};

export type ProductCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<ProductFieldsCreateNestedManyWithoutProductInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  subProducts?: InputMaybe<SubProductFieldsCreateNestedManyWithoutProductsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ProductCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ProductCreateNestedManyWithoutSubProductsInput = {
  connect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductCreateOrConnectWithoutSubProductsInput>>;
  create?: InputMaybe<Array<ProductCreateWithoutSubProductsInput>>;
};

export type ProductCreateNestedOneWithoutFieldsInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<ProductUncheckedCreateWithoutFieldsInput>;
};

export type ProductCreateOrConnectWithoutFieldsInput = {
  create: ProductUncheckedCreateWithoutFieldsInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutSubProductsInput = {
  create: ProductUncheckedCreateWithoutSubProductsInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateWithoutFieldsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  subProducts?: InputMaybe<SubProductFieldsCreateNestedManyWithoutProductsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ProductCreateWithoutSubProductsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<ProductFieldsCreateNestedManyWithoutProductInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ProductFields = {
  __typename?: 'ProductFields';
  _count: ProductFieldsCountOutputType;
  businessUnits: Array<Maybe<BusinessUnit>>;
  cmsId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  locations: Array<Maybe<Location>>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type ProductFieldsBusinessUnitsArgs = {
  cursor?: InputMaybe<BusinessUnitWhereUniqueInput>;
  distinct?: InputMaybe<BusinessUnitScalarFieldEnum>;
  orderBy?: InputMaybe<BusinessUnitOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BusinessUnitWhereInput>;
};


export type ProductFieldsLocationsArgs = {
  cursor?: InputMaybe<LocationWhereUniqueInput>;
  distinct?: InputMaybe<LocationScalarFieldEnum>;
  orderBy?: InputMaybe<LocationOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationWhereInput>;
};

export type ProductFieldsAvgAggregateOutputType = {
  __typename?: 'ProductFieldsAvgAggregateOutputType';
  order?: Maybe<Scalars['Float']>;
};

export type ProductFieldsAvgOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type ProductFieldsCountAggregateOutputType = {
  __typename?: 'ProductFieldsCountAggregateOutputType';
  _all: Scalars['Int'];
  cmsId: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  order: Scalars['Int'];
  pending: Scalars['Int'];
  productId: Scalars['Int'];
  published: Scalars['Int'];
  stack: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ProductFieldsCountOrderByAggregateInput = {
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProductFieldsCountOutputType = {
  __typename?: 'ProductFieldsCountOutputType';
  businessUnits: Scalars['Int'];
  locations: Scalars['Int'];
};

export type ProductFieldsCreateInput = {
  businessUnits?: InputMaybe<BusinessUnitCreateNestedManyWithoutProductsInput>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutProductsInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  product?: InputMaybe<ProductCreateNestedOneWithoutFieldsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ProductFieldsCreateManyInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  productId?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ProductFieldsCreateManyProductInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ProductFieldsCreateManyProductInputEnvelope = {
  data: Array<ProductFieldsCreateManyProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ProductFieldsCreateNestedManyWithoutBusinessUnitsInput = {
  connect?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductFieldsCreateOrConnectWithoutBusinessUnitsInput>>;
  create?: InputMaybe<Array<ProductFieldsCreateWithoutBusinessUnitsInput>>;
};

export type ProductFieldsCreateNestedManyWithoutLocationsInput = {
  connect?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<ProductFieldsCreateWithoutLocationsInput>>;
};

export type ProductFieldsCreateNestedManyWithoutProductInput = {
  connect?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductFieldsCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<ProductFieldsCreateWithoutProductInput>>;
  createMany?: InputMaybe<ProductFieldsCreateManyProductInputEnvelope>;
};

export type ProductFieldsCreateOrConnectWithoutBusinessUnitsInput = {
  create: ProductFieldsUncheckedCreateWithoutBusinessUnitsInput;
  where: ProductFieldsWhereUniqueInput;
};

export type ProductFieldsCreateOrConnectWithoutLocationsInput = {
  create: ProductFieldsUncheckedCreateWithoutLocationsInput;
  where: ProductFieldsWhereUniqueInput;
};

export type ProductFieldsCreateOrConnectWithoutProductInput = {
  create: ProductFieldsUncheckedCreateWithoutProductInput;
  where: ProductFieldsWhereUniqueInput;
};

export type ProductFieldsCreateWithoutBusinessUnitsInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutProductsInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  product?: InputMaybe<ProductCreateNestedOneWithoutFieldsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ProductFieldsCreateWithoutLocationsInput = {
  businessUnits?: InputMaybe<BusinessUnitCreateNestedManyWithoutProductsInput>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  product?: InputMaybe<ProductCreateNestedOneWithoutFieldsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ProductFieldsCreateWithoutProductInput = {
  businessUnits?: InputMaybe<BusinessUnitCreateNestedManyWithoutProductsInput>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutProductsInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ProductFieldsListRelationFilter = {
  every?: InputMaybe<ProductFieldsWhereInput>;
  none?: InputMaybe<ProductFieldsWhereInput>;
  some?: InputMaybe<ProductFieldsWhereInput>;
};

export type ProductFieldsMaxAggregateOutputType = {
  __typename?: 'ProductFieldsMaxAggregateOutputType';
  cmsId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  productId?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  stack?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductFieldsMaxOrderByAggregateInput = {
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProductFieldsMinAggregateOutputType = {
  __typename?: 'ProductFieldsMinAggregateOutputType';
  cmsId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  productId?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  stack?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductFieldsMinOrderByAggregateInput = {
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProductFieldsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductFieldsOrderByWithAggregationInput = {
  _avg?: InputMaybe<ProductFieldsAvgOrderByAggregateInput>;
  _count?: InputMaybe<ProductFieldsCountOrderByAggregateInput>;
  _max?: InputMaybe<ProductFieldsMaxOrderByAggregateInput>;
  _min?: InputMaybe<ProductFieldsMinOrderByAggregateInput>;
  _sum?: InputMaybe<ProductFieldsSumOrderByAggregateInput>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrderInput>;
  pending?: InputMaybe<SortOrderInput>;
  productId?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProductFieldsOrderByWithRelationInput = {
  businessUnits?: InputMaybe<BusinessUnitOrderByRelationAggregateInput>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  locations?: InputMaybe<LocationOrderByRelationAggregateInput>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrderInput>;
  pending?: InputMaybe<SortOrderInput>;
  product?: InputMaybe<ProductOrderByWithRelationInput>;
  productId?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ProductFieldsScalarFieldEnum {
  CmsId = 'cmsId',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Name = 'name',
  Order = 'order',
  Pending = 'pending',
  ProductId = 'productId',
  Published = 'published',
  Stack = 'stack',
  UpdatedAt = 'updatedAt'
}

export type ProductFieldsScalarWhereInput = {
  AND?: InputMaybe<Array<ProductFieldsScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProductFieldsScalarWhereInput>>;
  OR?: InputMaybe<Array<ProductFieldsScalarWhereInput>>;
  cmsId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  productId?: InputMaybe<StringNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  stack?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProductFieldsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ProductFieldsScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ProductFieldsScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ProductFieldsScalarWhereWithAggregatesInput>>;
  cmsId?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  order?: InputMaybe<IntNullableWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  productId?: InputMaybe<StringNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  stack?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ProductFieldsSumAggregateOutputType = {
  __typename?: 'ProductFieldsSumAggregateOutputType';
  order?: Maybe<Scalars['Int']>;
};

export type ProductFieldsSumOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type ProductFieldsUncheckedCreateInput = {
  businessUnits?: InputMaybe<BusinessUnitUncheckedCreateNestedManyWithoutProductsInput>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationUncheckedCreateNestedManyWithoutProductsInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  productId?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ProductFieldsUncheckedCreateNestedManyWithoutBusinessUnitsInput = {
  connect?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductFieldsCreateOrConnectWithoutBusinessUnitsInput>>;
  create?: InputMaybe<Array<ProductFieldsCreateWithoutBusinessUnitsInput>>;
};

export type ProductFieldsUncheckedCreateNestedManyWithoutLocationsInput = {
  connect?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<ProductFieldsCreateWithoutLocationsInput>>;
};

export type ProductFieldsUncheckedCreateNestedManyWithoutProductInput = {
  connect?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductFieldsCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<ProductFieldsCreateWithoutProductInput>>;
  createMany?: InputMaybe<ProductFieldsCreateManyProductInputEnvelope>;
};

export type ProductFieldsUncheckedCreateWithoutBusinessUnitsInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationUncheckedCreateNestedManyWithoutProductsInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  productId?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ProductFieldsUncheckedCreateWithoutLocationsInput = {
  businessUnits?: InputMaybe<BusinessUnitUncheckedCreateNestedManyWithoutProductsInput>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  productId?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ProductFieldsUncheckedCreateWithoutProductInput = {
  businessUnits?: InputMaybe<BusinessUnitUncheckedCreateNestedManyWithoutProductsInput>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationUncheckedCreateNestedManyWithoutProductsInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ProductFieldsUncheckedUpdateInput = {
  businessUnits?: InputMaybe<BusinessUnitUncheckedUpdateManyWithoutProductsNestedInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUncheckedUpdateManyWithoutProductsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  productId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductFieldsUncheckedUpdateManyInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  productId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductFieldsUncheckedUpdateManyWithoutBusinessUnitsNestedInput = {
  connect?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductFieldsCreateOrConnectWithoutBusinessUnitsInput>>;
  create?: InputMaybe<Array<ProductFieldsCreateWithoutBusinessUnitsInput>>;
  delete?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductFieldsUpdateWithWhereUniqueWithoutBusinessUnitsInput>>;
  updateMany?: InputMaybe<Array<ProductFieldsUpdateManyWithWhereWithoutBusinessUnitsInput>>;
  upsert?: InputMaybe<Array<ProductFieldsUpsertWithWhereUniqueWithoutBusinessUnitsInput>>;
};

export type ProductFieldsUncheckedUpdateManyWithoutFieldsInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductFieldsUncheckedUpdateManyWithoutLocationsNestedInput = {
  connect?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<ProductFieldsCreateWithoutLocationsInput>>;
  delete?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductFieldsUpdateWithWhereUniqueWithoutLocationsInput>>;
  updateMany?: InputMaybe<Array<ProductFieldsUpdateManyWithWhereWithoutLocationsInput>>;
  upsert?: InputMaybe<Array<ProductFieldsUpsertWithWhereUniqueWithoutLocationsInput>>;
};

export type ProductFieldsUncheckedUpdateManyWithoutProductNestedInput = {
  connect?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductFieldsCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<ProductFieldsCreateWithoutProductInput>>;
  createMany?: InputMaybe<ProductFieldsCreateManyProductInputEnvelope>;
  delete?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductFieldsUpdateWithWhereUniqueWithoutProductInput>>;
  updateMany?: InputMaybe<Array<ProductFieldsUpdateManyWithWhereWithoutProductInput>>;
  upsert?: InputMaybe<Array<ProductFieldsUpsertWithWhereUniqueWithoutProductInput>>;
};

export type ProductFieldsUncheckedUpdateManyWithoutProductsInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  productId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductFieldsUncheckedUpdateWithoutBusinessUnitsInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUncheckedUpdateManyWithoutProductsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  productId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductFieldsUncheckedUpdateWithoutLocationsInput = {
  businessUnits?: InputMaybe<BusinessUnitUncheckedUpdateManyWithoutProductsNestedInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  productId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductFieldsUncheckedUpdateWithoutProductInput = {
  businessUnits?: InputMaybe<BusinessUnitUncheckedUpdateManyWithoutProductsNestedInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUncheckedUpdateManyWithoutProductsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductFieldsUpdateInput = {
  businessUnits?: InputMaybe<BusinessUnitUpdateManyWithoutProductsNestedInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutProductsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneWithoutFieldsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductFieldsUpdateManyMutationInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductFieldsUpdateManyWithWhereWithoutBusinessUnitsInput = {
  data: ProductFieldsUncheckedUpdateManyWithoutProductsInput;
  where: ProductFieldsScalarWhereInput;
};

export type ProductFieldsUpdateManyWithWhereWithoutLocationsInput = {
  data: ProductFieldsUncheckedUpdateManyWithoutProductsInput;
  where: ProductFieldsScalarWhereInput;
};

export type ProductFieldsUpdateManyWithWhereWithoutProductInput = {
  data: ProductFieldsUncheckedUpdateManyWithoutFieldsInput;
  where: ProductFieldsScalarWhereInput;
};

export type ProductFieldsUpdateManyWithoutBusinessUnitsNestedInput = {
  connect?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductFieldsCreateOrConnectWithoutBusinessUnitsInput>>;
  create?: InputMaybe<Array<ProductFieldsCreateWithoutBusinessUnitsInput>>;
  delete?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductFieldsUpdateWithWhereUniqueWithoutBusinessUnitsInput>>;
  updateMany?: InputMaybe<Array<ProductFieldsUpdateManyWithWhereWithoutBusinessUnitsInput>>;
  upsert?: InputMaybe<Array<ProductFieldsUpsertWithWhereUniqueWithoutBusinessUnitsInput>>;
};

export type ProductFieldsUpdateManyWithoutLocationsNestedInput = {
  connect?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<ProductFieldsCreateWithoutLocationsInput>>;
  delete?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductFieldsUpdateWithWhereUniqueWithoutLocationsInput>>;
  updateMany?: InputMaybe<Array<ProductFieldsUpdateManyWithWhereWithoutLocationsInput>>;
  upsert?: InputMaybe<Array<ProductFieldsUpsertWithWhereUniqueWithoutLocationsInput>>;
};

export type ProductFieldsUpdateManyWithoutProductNestedInput = {
  connect?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductFieldsCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<ProductFieldsCreateWithoutProductInput>>;
  createMany?: InputMaybe<ProductFieldsCreateManyProductInputEnvelope>;
  delete?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductFieldsUpdateWithWhereUniqueWithoutProductInput>>;
  updateMany?: InputMaybe<Array<ProductFieldsUpdateManyWithWhereWithoutProductInput>>;
  upsert?: InputMaybe<Array<ProductFieldsUpsertWithWhereUniqueWithoutProductInput>>;
};

export type ProductFieldsUpdateWithWhereUniqueWithoutBusinessUnitsInput = {
  data: ProductFieldsUncheckedUpdateWithoutBusinessUnitsInput;
  where: ProductFieldsWhereUniqueInput;
};

export type ProductFieldsUpdateWithWhereUniqueWithoutLocationsInput = {
  data: ProductFieldsUncheckedUpdateWithoutLocationsInput;
  where: ProductFieldsWhereUniqueInput;
};

export type ProductFieldsUpdateWithWhereUniqueWithoutProductInput = {
  data: ProductFieldsUncheckedUpdateWithoutProductInput;
  where: ProductFieldsWhereUniqueInput;
};

export type ProductFieldsUpdateWithoutBusinessUnitsInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutProductsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneWithoutFieldsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductFieldsUpdateWithoutLocationsInput = {
  businessUnits?: InputMaybe<BusinessUnitUpdateManyWithoutProductsNestedInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneWithoutFieldsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductFieldsUpdateWithoutProductInput = {
  businessUnits?: InputMaybe<BusinessUnitUpdateManyWithoutProductsNestedInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutProductsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductFieldsUpsertWithWhereUniqueWithoutBusinessUnitsInput = {
  create: ProductFieldsUncheckedCreateWithoutBusinessUnitsInput;
  update: ProductFieldsUncheckedUpdateWithoutBusinessUnitsInput;
  where: ProductFieldsWhereUniqueInput;
};

export type ProductFieldsUpsertWithWhereUniqueWithoutLocationsInput = {
  create: ProductFieldsUncheckedCreateWithoutLocationsInput;
  update: ProductFieldsUncheckedUpdateWithoutLocationsInput;
  where: ProductFieldsWhereUniqueInput;
};

export type ProductFieldsUpsertWithWhereUniqueWithoutProductInput = {
  create: ProductFieldsUncheckedCreateWithoutProductInput;
  update: ProductFieldsUncheckedUpdateWithoutProductInput;
  where: ProductFieldsWhereUniqueInput;
};

export type ProductFieldsWhereInput = {
  AND?: InputMaybe<Array<ProductFieldsWhereInput>>;
  NOT?: InputMaybe<Array<ProductFieldsWhereInput>>;
  OR?: InputMaybe<Array<ProductFieldsWhereInput>>;
  businessUnits?: InputMaybe<BusinessUnitListRelationFilter>;
  cmsId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  locations?: InputMaybe<LocationListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  product?: InputMaybe<ProductWhereInput>;
  productId?: InputMaybe<StringNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  stack?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProductFieldsWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ProductListRelationFilter = {
  every?: InputMaybe<ProductWhereInput>;
  none?: InputMaybe<ProductWhereInput>;
  some?: InputMaybe<ProductWhereInput>;
};

export type ProductMaxAggregateOutputType = {
  __typename?: 'ProductMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProductMinAggregateOutputType = {
  __typename?: 'ProductMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProductOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductOrderByWithAggregationInput = {
  _count?: InputMaybe<ProductCountOrderByAggregateInput>;
  _max?: InputMaybe<ProductMaxOrderByAggregateInput>;
  _min?: InputMaybe<ProductMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProductOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  fields?: InputMaybe<ProductFieldsOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrder>;
  subProducts?: InputMaybe<SubProductFieldsOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProductRelationFilter = {
  is?: InputMaybe<ProductWhereInput>;
  isNot?: InputMaybe<ProductWhereInput>;
};

export enum ProductScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Pending = 'pending',
  Published = 'published',
  Reference = 'reference',
  UpdatedAt = 'updatedAt'
}

export type ProductScalarWhereInput = {
  AND?: InputMaybe<Array<ProductScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProductScalarWhereInput>>;
  OR?: InputMaybe<Array<ProductScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  reference?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProductScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ProductScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ProductScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ProductScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  reference?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ProductUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<ProductFieldsUncheckedCreateNestedManyWithoutProductInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  subProducts?: InputMaybe<SubProductFieldsUncheckedCreateNestedManyWithoutProductsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ProductUncheckedCreateNestedManyWithoutSubProductsInput = {
  connect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductCreateOrConnectWithoutSubProductsInput>>;
  create?: InputMaybe<Array<ProductCreateWithoutSubProductsInput>>;
};

export type ProductUncheckedCreateWithoutFieldsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  subProducts?: InputMaybe<SubProductFieldsUncheckedCreateNestedManyWithoutProductsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ProductUncheckedCreateWithoutSubProductsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<ProductFieldsUncheckedCreateNestedManyWithoutProductInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ProductUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<ProductFieldsUncheckedUpdateManyWithoutProductNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  subProducts?: InputMaybe<SubProductFieldsUncheckedUpdateManyWithoutProductsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductUncheckedUpdateManyWithoutProductsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductUncheckedUpdateManyWithoutSubProductsNestedInput = {
  connect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductCreateOrConnectWithoutSubProductsInput>>;
  create?: InputMaybe<Array<ProductCreateWithoutSubProductsInput>>;
  delete?: InputMaybe<Array<ProductWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductUpdateWithWhereUniqueWithoutSubProductsInput>>;
  updateMany?: InputMaybe<Array<ProductUpdateManyWithWhereWithoutSubProductsInput>>;
  upsert?: InputMaybe<Array<ProductUpsertWithWhereUniqueWithoutSubProductsInput>>;
};

export type ProductUncheckedUpdateWithoutFieldsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  subProducts?: InputMaybe<SubProductFieldsUncheckedUpdateManyWithoutProductsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductUncheckedUpdateWithoutSubProductsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<ProductFieldsUncheckedUpdateManyWithoutProductNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<ProductFieldsUpdateManyWithoutProductNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  subProducts?: InputMaybe<SubProductFieldsUpdateManyWithoutProductsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductUpdateManyWithWhereWithoutSubProductsInput = {
  data: ProductUncheckedUpdateManyWithoutProductsInput;
  where: ProductScalarWhereInput;
};

export type ProductUpdateManyWithoutSubProductsNestedInput = {
  connect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductCreateOrConnectWithoutSubProductsInput>>;
  create?: InputMaybe<Array<ProductCreateWithoutSubProductsInput>>;
  delete?: InputMaybe<Array<ProductWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductUpdateWithWhereUniqueWithoutSubProductsInput>>;
  updateMany?: InputMaybe<Array<ProductUpdateManyWithWhereWithoutSubProductsInput>>;
  upsert?: InputMaybe<Array<ProductUpsertWithWhereUniqueWithoutSubProductsInput>>;
};

export type ProductUpdateOneWithoutFieldsNestedInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<ProductUncheckedCreateWithoutFieldsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ProductUncheckedUpdateWithoutFieldsInput>;
  upsert?: InputMaybe<ProductUpsertWithoutFieldsInput>;
};

export type ProductUpdateWithWhereUniqueWithoutSubProductsInput = {
  data: ProductUncheckedUpdateWithoutSubProductsInput;
  where: ProductWhereUniqueInput;
};

export type ProductUpdateWithoutFieldsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  subProducts?: InputMaybe<SubProductFieldsUpdateManyWithoutProductsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductUpdateWithoutSubProductsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<ProductFieldsUpdateManyWithoutProductNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductUpsertWithWhereUniqueWithoutSubProductsInput = {
  create: ProductUncheckedCreateWithoutSubProductsInput;
  update: ProductUncheckedUpdateWithoutSubProductsInput;
  where: ProductWhereUniqueInput;
};

export type ProductUpsertWithoutFieldsInput = {
  create: ProductUncheckedCreateWithoutFieldsInput;
  update: ProductUncheckedUpdateWithoutFieldsInput;
};

export type ProductWhereInput = {
  AND?: InputMaybe<Array<ProductWhereInput>>;
  NOT?: InputMaybe<Array<ProductWhereInput>>;
  OR?: InputMaybe<Array<ProductWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fields?: InputMaybe<ProductFieldsListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  reference?: InputMaybe<StringFilter>;
  subProducts?: InputMaybe<SubProductFieldsListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProductWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export enum ProgressStatus {
  Abandoned = 'ABANDONED',
  ActiveCounsel = 'ACTIVE_COUNSEL',
  ActiveSimmons = 'ACTIVE_SIMMONS',
  Approved = 'APPROVED',
  Prep = 'PREP',
  Published = 'PUBLISHED'
}

export enum PublishStatus {
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Published = 'PUBLISHED',
  Scheduled = 'SCHEDULED',
  Unpublished = 'UNPUBLISHED'
}

export type Query = {
  __typename?: 'Query';
  activities?: Maybe<Array<Maybe<Activity>>>;
  activityFieldses?: Maybe<Array<Maybe<ActivityFields>>>;
  audits?: Maybe<Array<Maybe<Audit>>>;
  auditsConnection: AuditConnection;
  auditsFilteredByContent: Array<Maybe<Audit>>;
  auditsWithUser: Array<Maybe<AuditUser>>;
  auditsWithUserConnection: AuditUserConnection;
  businessUnitFieldses?: Maybe<Array<Maybe<BusinessUnitFields>>>;
  businessUnits?: Maybe<Array<Maybe<BusinessUnit>>>;
  categories?: Maybe<Array<Maybe<Category>>>;
  categoryFieldses?: Maybe<Array<Maybe<CategoryFields>>>;
  clearCache: Scalars['Boolean'];
  clearOwnersCache: Scalars['Boolean'];
  clearUsersCache: Scalars['Boolean'];
  clientTypeFieldses?: Maybe<Array<Maybe<ClientTypeFields>>>;
  clientTypes?: Maybe<Array<Maybe<ClientType>>>;
  cycles?: Maybe<Array<Maybe<Cycle>>>;
  cyclesConnection: CycleConnection;
  dataImportFiles?: Maybe<Array<Maybe<DataImportFile>>>;
  dataImportFilesConnection: DataImportFileConnection;
  dataImportMasterFileLocations: Array<Maybe<DataImportMasterFileLocation>>;
  dataImportMasterFileLocationsConnection: DataImportMasterFileLocationConnection;
  dataImportProgressSummaries?: Maybe<Array<Maybe<DataImportProgressSummary>>>;
  dataImportValidationAudits?: Maybe<Array<Maybe<DataImportValidationAudit>>>;
  dataImportValidations?: Maybe<Array<Maybe<DataImportValidation>>>;
  dataImports?: Maybe<Array<Maybe<DataImport>>>;
  dataImportsConnection: DataImportConnection;
  dataImportsWithOwner: Array<Maybe<DataImportOwner>>;
  dataImportsWithOwnerConnection: DataImportOwnerConnection;
  definitionFieldses?: Maybe<Array<Maybe<DefinitionFields>>>;
  definitionFieldsesConnection: DefinitionFieldsConnection;
  definitions?: Maybe<Array<Maybe<Definition>>>;
  documentCycles?: Maybe<Array<Maybe<DocumentCycle>>>;
  documentCyclesConnection: DocumentCycleConnection;
  documentCyclesWithOwner: Array<Maybe<DocumentCycleOwner>>;
  documentCyclesWithOwnerConnection: DocumentCycleOwnerConnection;
  documents?: Maybe<Array<Maybe<Document>>>;
  documentsConnection: DocumentConnection;
  documentsWithOwner: Array<Maybe<DocumentOwner>>;
  documentsWithOwnerConnection: DocumentOwnerConnection;
  eeaDefinitionFieldsesConnection: DefinitionFieldsConnection;
  entities?: Maybe<Array<Maybe<Entity>>>;
  entityFieldses?: Maybe<Array<Maybe<EntityFields>>>;
  globalDefinitionFieldsesConnection: DefinitionFieldsConnection;
  health: HealthCheck;
  localDefinitionFieldsesConnection: DefinitionFieldsConnection;
  locationFieldses?: Maybe<Array<Maybe<LocationFields>>>;
  locationFieldsesConnection: LocationFieldsConnection;
  locations?: Maybe<Array<Maybe<Location>>>;
  locationsConnection: LocationConnection;
  methodForActivities?: Maybe<Array<Maybe<MethodForActivity>>>;
  methodForActivityFieldses?: Maybe<Array<Maybe<MethodForActivityFields>>>;
  notificationsEnabled: Scalars['Boolean'];
  owners: Array<Maybe<User>>;
  predefinedResponseFieldses?: Maybe<Array<Maybe<PredefinedResponseFields>>>;
  predefinedResponses?: Maybe<Array<Maybe<PredefinedResponse>>>;
  productFieldses?: Maybe<Array<Maybe<ProductFields>>>;
  products?: Maybe<Array<Maybe<Product>>>;
  reverseEnquiries?: Maybe<Array<Maybe<ReverseEnquiry>>>;
  reverseEnquiryFieldses?: Maybe<Array<Maybe<ReverseEnquiryFields>>>;
  reviewGuidanceFieldses?: Maybe<Array<Maybe<ReviewGuidanceFields>>>;
  reviewGuidances?: Maybe<Array<Maybe<ReviewGuidance>>>;
  statusFieldses?: Maybe<Array<Maybe<StatusFields>>>;
  statusFieldsesConnection: StatusFieldsConnection;
  statuses?: Maybe<Array<Maybe<Status>>>;
  subActivities?: Maybe<Array<Maybe<SubActivity>>>;
  subActivityFieldses?: Maybe<Array<Maybe<SubActivityFields>>>;
  subProductFieldses?: Maybe<Array<Maybe<SubProductFields>>>;
  subProducts?: Maybe<Array<Maybe<SubProduct>>>;
  users: Array<Maybe<User>>;
  versions?: Maybe<Array<Maybe<Version>>>;
  versionsConnection: VersionConnection;
};


export type QueryActivitiesArgs = {
  cursor?: InputMaybe<ActivityWhereUniqueInput>;
  distinct?: InputMaybe<ActivityScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<ActivityOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ActivityWhereInput>;
};


export type QueryActivityFieldsesArgs = {
  cursor?: InputMaybe<ActivityFieldsWhereUniqueInput>;
  distinct?: InputMaybe<ActivityFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<ActivityFieldsOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ActivityFieldsWhereInput>;
};


export type QueryAuditsArgs = {
  cursor?: InputMaybe<AuditWhereUniqueInput>;
  distinct?: InputMaybe<AuditScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<AuditOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AuditWhereInput>;
};


export type QueryAuditsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AuditOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AuditWhereInput>;
};


export type QueryAuditsFilteredByContentArgs = {
  contentWhere?: InputMaybe<AuditFilteredByContentWhere>;
  where?: InputMaybe<AuditWhereInput>;
};


export type QueryAuditsWithUserArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AuditUserOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AuditUserWhereInput>;
};


export type QueryAuditsWithUserConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AuditUserOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AuditUserWhereInput>;
};


export type QueryBusinessUnitFieldsesArgs = {
  cursor?: InputMaybe<BusinessUnitFieldsWhereUniqueInput>;
  distinct?: InputMaybe<BusinessUnitFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<BusinessUnitFieldsOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BusinessUnitFieldsWhereInput>;
};


export type QueryBusinessUnitsArgs = {
  cursor?: InputMaybe<BusinessUnitWhereUniqueInput>;
  distinct?: InputMaybe<BusinessUnitScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<BusinessUnitOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BusinessUnitWhereInput>;
};


export type QueryCategoriesArgs = {
  cursor?: InputMaybe<CategoryWhereUniqueInput>;
  distinct?: InputMaybe<CategoryScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<CategoryOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CategoryWhereInput>;
};


export type QueryCategoryFieldsesArgs = {
  cursor?: InputMaybe<CategoryFieldsWhereUniqueInput>;
  distinct?: InputMaybe<CategoryFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<CategoryFieldsOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CategoryFieldsWhereInput>;
};


export type QueryClientTypeFieldsesArgs = {
  cursor?: InputMaybe<ClientTypeFieldsWhereUniqueInput>;
  distinct?: InputMaybe<ClientTypeFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<ClientTypeFieldsOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ClientTypeFieldsWhereInput>;
};


export type QueryClientTypesArgs = {
  cursor?: InputMaybe<ClientTypeWhereUniqueInput>;
  distinct?: InputMaybe<ClientTypeScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<ClientTypeOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ClientTypeWhereInput>;
};


export type QueryCyclesArgs = {
  cursor?: InputMaybe<CycleWhereUniqueInput>;
  distinct?: InputMaybe<CycleScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<CycleOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CycleWhereInput>;
};


export type QueryCyclesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<CycleOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CycleWhereInput>;
};


export type QueryDataImportFilesArgs = {
  cursor?: InputMaybe<DataImportFileWhereUniqueInput>;
  distinct?: InputMaybe<DataImportFileScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<DataImportFileOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DataImportFileWhereInput>;
};


export type QueryDataImportFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DataImportFileOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DataImportFileWhereInput>;
};


export type QueryDataImportMasterFileLocationsArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DataImportMasterFileLocationOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DataImportMasterFileLocationWhereInput>;
};


export type QueryDataImportMasterFileLocationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DataImportMasterFileLocationOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DataImportMasterFileLocationWhereInput>;
};


export type QueryDataImportProgressSummariesArgs = {
  cursor?: InputMaybe<DataImportProgressSummaryWhereUniqueInput>;
  distinct?: InputMaybe<DataImportProgressSummaryScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<DataImportProgressSummaryOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DataImportProgressSummaryWhereInput>;
};


export type QueryDataImportValidationAuditsArgs = {
  cursor?: InputMaybe<DataImportValidationAuditWhereUniqueInput>;
  distinct?: InputMaybe<DataImportValidationAuditScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<DataImportValidationAuditOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DataImportValidationAuditWhereInput>;
};


export type QueryDataImportValidationsArgs = {
  cursor?: InputMaybe<DataImportValidationWhereUniqueInput>;
  distinct?: InputMaybe<DataImportValidationScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<DataImportValidationOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DataImportValidationWhereInput>;
};


export type QueryDataImportsArgs = {
  cursor?: InputMaybe<DataImportWhereUniqueInput>;
  distinct?: InputMaybe<DataImportScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<DataImportOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DataImportWhereInput>;
};


export type QueryDataImportsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DataImportOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DataImportWhereInput>;
};


export type QueryDataImportsWithOwnerArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DataImportOwnerOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DataImportOwnerWhereInput>;
};


export type QueryDataImportsWithOwnerConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DataImportOwnerOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DataImportOwnerWhereInput>;
};


export type QueryDefinitionFieldsesArgs = {
  cursor?: InputMaybe<DefinitionFieldsWhereUniqueInput>;
  distinct?: InputMaybe<DefinitionFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<DefinitionFieldsOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DefinitionFieldsWhereInput>;
};


export type QueryDefinitionFieldsesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DefinitionFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DefinitionFieldsWhereInput>;
};


export type QueryDefinitionsArgs = {
  cursor?: InputMaybe<DefinitionWhereUniqueInput>;
  distinct?: InputMaybe<DefinitionScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<DefinitionOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DefinitionWhereInput>;
};


export type QueryDocumentCyclesArgs = {
  cursor?: InputMaybe<DocumentCycleWhereUniqueInput>;
  distinct?: InputMaybe<DocumentCycleScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<DocumentCycleOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DocumentCycleWhereInput>;
};


export type QueryDocumentCyclesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DocumentCycleOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DocumentCycleWhereInput>;
};


export type QueryDocumentCyclesWithOwnerArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DocumentCycleOwnerOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DocumentCycleOwnerWhereInput>;
};


export type QueryDocumentCyclesWithOwnerConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DocumentCycleOwnerOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DocumentCycleOwnerWhereInput>;
};


export type QueryDocumentsArgs = {
  cursor?: InputMaybe<DocumentWhereUniqueInput>;
  distinct?: InputMaybe<DocumentScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<DocumentOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DocumentWhereInput>;
};


export type QueryDocumentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DocumentOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DocumentWhereInput>;
};


export type QueryDocumentsWithOwnerArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DocumentOwnerOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DocumentOwnerWhereInput>;
};


export type QueryDocumentsWithOwnerConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DocumentOwnerOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DocumentOwnerWhereInput>;
};


export type QueryEeaDefinitionFieldsesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DefinitionFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DefinitionFieldsWhereInput>;
};


export type QueryEntitiesArgs = {
  cursor?: InputMaybe<EntityWhereUniqueInput>;
  distinct?: InputMaybe<EntityScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<EntityOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EntityWhereInput>;
};


export type QueryEntityFieldsesArgs = {
  cursor?: InputMaybe<EntityFieldsWhereUniqueInput>;
  distinct?: InputMaybe<EntityFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<EntityFieldsOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EntityFieldsWhereInput>;
};


export type QueryGlobalDefinitionFieldsesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DefinitionFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DefinitionFieldsWhereInput>;
};


export type QueryLocalDefinitionFieldsesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DefinitionFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DefinitionFieldsWhereInput>;
};


export type QueryLocationFieldsesArgs = {
  cursor?: InputMaybe<LocationFieldsWhereUniqueInput>;
  distinct?: InputMaybe<LocationFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<LocationFieldsOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationFieldsWhereInput>;
};


export type QueryLocationFieldsesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<LocationFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationFieldsWhereInput>;
};


export type QueryLocationsArgs = {
  cursor?: InputMaybe<LocationWhereUniqueInput>;
  distinct?: InputMaybe<LocationScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<LocationOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationWhereInput>;
};


export type QueryLocationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<LocationOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationWhereInput>;
};


export type QueryMethodForActivitiesArgs = {
  cursor?: InputMaybe<MethodForActivityWhereUniqueInput>;
  distinct?: InputMaybe<MethodForActivityScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<MethodForActivityOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MethodForActivityWhereInput>;
};


export type QueryMethodForActivityFieldsesArgs = {
  cursor?: InputMaybe<MethodForActivityFieldsWhereUniqueInput>;
  distinct?: InputMaybe<MethodForActivityFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<MethodForActivityFieldsOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MethodForActivityFieldsWhereInput>;
};


export type QueryOwnersArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<UserOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryPredefinedResponseFieldsesArgs = {
  cursor?: InputMaybe<PredefinedResponseFieldsWhereUniqueInput>;
  distinct?: InputMaybe<PredefinedResponseFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<PredefinedResponseFieldsOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PredefinedResponseFieldsWhereInput>;
};


export type QueryPredefinedResponsesArgs = {
  cursor?: InputMaybe<PredefinedResponseWhereUniqueInput>;
  distinct?: InputMaybe<PredefinedResponseScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<PredefinedResponseOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PredefinedResponseWhereInput>;
};


export type QueryProductFieldsesArgs = {
  cursor?: InputMaybe<ProductFieldsWhereUniqueInput>;
  distinct?: InputMaybe<ProductFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<ProductFieldsOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductFieldsWhereInput>;
};


export type QueryProductsArgs = {
  cursor?: InputMaybe<ProductWhereUniqueInput>;
  distinct?: InputMaybe<ProductScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<ProductOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductWhereInput>;
};


export type QueryReverseEnquiriesArgs = {
  cursor?: InputMaybe<ReverseEnquiryWhereUniqueInput>;
  distinct?: InputMaybe<ReverseEnquiryScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<ReverseEnquiryOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ReverseEnquiryWhereInput>;
};


export type QueryReverseEnquiryFieldsesArgs = {
  cursor?: InputMaybe<ReverseEnquiryFieldsWhereUniqueInput>;
  distinct?: InputMaybe<ReverseEnquiryFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<ReverseEnquiryFieldsOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ReverseEnquiryFieldsWhereInput>;
};


export type QueryReviewGuidanceFieldsesArgs = {
  cursor?: InputMaybe<ReviewGuidanceFieldsWhereUniqueInput>;
  distinct?: InputMaybe<ReviewGuidanceFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<ReviewGuidanceFieldsOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ReviewGuidanceFieldsWhereInput>;
};


export type QueryReviewGuidancesArgs = {
  cursor?: InputMaybe<ReviewGuidanceWhereUniqueInput>;
  distinct?: InputMaybe<ReviewGuidanceScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<ReviewGuidanceOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ReviewGuidanceWhereInput>;
};


export type QueryStatusFieldsesArgs = {
  cursor?: InputMaybe<StatusFieldsWhereUniqueInput>;
  distinct?: InputMaybe<StatusFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<StatusFieldsOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StatusFieldsWhereInput>;
};


export type QueryStatusFieldsesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<StatusFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StatusFieldsWhereInput>;
};


export type QueryStatusesArgs = {
  cursor?: InputMaybe<StatusWhereUniqueInput>;
  distinct?: InputMaybe<StatusScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<StatusOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StatusWhereInput>;
};


export type QuerySubActivitiesArgs = {
  cursor?: InputMaybe<SubActivityWhereUniqueInput>;
  distinct?: InputMaybe<SubActivityScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<SubActivityOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SubActivityWhereInput>;
};


export type QuerySubActivityFieldsesArgs = {
  cursor?: InputMaybe<SubActivityFieldsWhereUniqueInput>;
  distinct?: InputMaybe<SubActivityFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<SubActivityFieldsOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SubActivityFieldsWhereInput>;
};


export type QuerySubProductFieldsesArgs = {
  cursor?: InputMaybe<SubProductFieldsWhereUniqueInput>;
  distinct?: InputMaybe<SubProductFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<SubProductFieldsOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SubProductFieldsWhereInput>;
};


export type QuerySubProductsArgs = {
  cursor?: InputMaybe<SubProductWhereUniqueInput>;
  distinct?: InputMaybe<SubProductScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<SubProductOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SubProductWhereInput>;
};


export type QueryUsersArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<UserOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryVersionsArgs = {
  cursor?: InputMaybe<VersionWhereUniqueInput>;
  distinct?: InputMaybe<VersionScalarFieldEnum>;
  orderBy?: InputMaybe<Array<InputMaybe<VersionOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VersionWhereInput>;
};


export type QueryVersionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<VersionOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VersionWhereInput>;
};

export type ReverseEnquiry = {
  __typename?: 'ReverseEnquiry';
  _count: ReverseEnquiryCountOutputType;
  createdAt: Scalars['DateTime'];
  fields: Array<Maybe<ReverseEnquiryFields>>;
  id: Scalars['String'];
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type ReverseEnquiryFieldsArgs = {
  cursor?: InputMaybe<ReverseEnquiryFieldsWhereUniqueInput>;
  distinct?: InputMaybe<ReverseEnquiryFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<ReverseEnquiryFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ReverseEnquiryFieldsWhereInput>;
};

export type ReverseEnquiryCountAggregateOutputType = {
  __typename?: 'ReverseEnquiryCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  pending: Scalars['Int'];
  published: Scalars['Int'];
  reference: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ReverseEnquiryCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ReverseEnquiryCountOutputType = {
  __typename?: 'ReverseEnquiryCountOutputType';
  fields: Scalars['Int'];
};

export type ReverseEnquiryCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<ReverseEnquiryFieldsCreateNestedManyWithoutReverseEnquiryInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReverseEnquiryCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReverseEnquiryCreateNestedOneWithoutFieldsInput = {
  connect?: InputMaybe<ReverseEnquiryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ReverseEnquiryCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<ReverseEnquiryUncheckedCreateWithoutFieldsInput>;
};

export type ReverseEnquiryCreateOrConnectWithoutFieldsInput = {
  create: ReverseEnquiryUncheckedCreateWithoutFieldsInput;
  where: ReverseEnquiryWhereUniqueInput;
};

export type ReverseEnquiryCreateWithoutFieldsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReverseEnquiryFields = {
  __typename?: 'ReverseEnquiryFields';
  cmsId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reverseEnquiry?: Maybe<ReverseEnquiry>;
  reverseEnquiryId?: Maybe<Scalars['String']>;
  stack: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ReverseEnquiryFieldsAvgAggregateOutputType = {
  __typename?: 'ReverseEnquiryFieldsAvgAggregateOutputType';
  order?: Maybe<Scalars['Float']>;
};

export type ReverseEnquiryFieldsAvgOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type ReverseEnquiryFieldsCountAggregateOutputType = {
  __typename?: 'ReverseEnquiryFieldsCountAggregateOutputType';
  _all: Scalars['Int'];
  cmsId: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  order: Scalars['Int'];
  pending: Scalars['Int'];
  published: Scalars['Int'];
  reverseEnquiryId: Scalars['Int'];
  stack: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ReverseEnquiryFieldsCountOrderByAggregateInput = {
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reverseEnquiryId?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ReverseEnquiryFieldsCreateInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reverseEnquiry?: InputMaybe<ReverseEnquiryCreateNestedOneWithoutFieldsInput>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReverseEnquiryFieldsCreateManyInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reverseEnquiryId?: InputMaybe<Scalars['String']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReverseEnquiryFieldsCreateManyReverseEnquiryInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReverseEnquiryFieldsCreateManyReverseEnquiryInputEnvelope = {
  data: Array<ReverseEnquiryFieldsCreateManyReverseEnquiryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ReverseEnquiryFieldsCreateNestedManyWithoutReverseEnquiryInput = {
  connect?: InputMaybe<Array<ReverseEnquiryFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReverseEnquiryFieldsCreateOrConnectWithoutReverseEnquiryInput>>;
  create?: InputMaybe<Array<ReverseEnquiryFieldsCreateWithoutReverseEnquiryInput>>;
  createMany?: InputMaybe<ReverseEnquiryFieldsCreateManyReverseEnquiryInputEnvelope>;
};

export type ReverseEnquiryFieldsCreateOrConnectWithoutReverseEnquiryInput = {
  create: ReverseEnquiryFieldsUncheckedCreateWithoutReverseEnquiryInput;
  where: ReverseEnquiryFieldsWhereUniqueInput;
};

export type ReverseEnquiryFieldsCreateWithoutReverseEnquiryInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReverseEnquiryFieldsListRelationFilter = {
  every?: InputMaybe<ReverseEnquiryFieldsWhereInput>;
  none?: InputMaybe<ReverseEnquiryFieldsWhereInput>;
  some?: InputMaybe<ReverseEnquiryFieldsWhereInput>;
};

export type ReverseEnquiryFieldsMaxAggregateOutputType = {
  __typename?: 'ReverseEnquiryFieldsMaxAggregateOutputType';
  cmsId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reverseEnquiryId?: Maybe<Scalars['String']>;
  stack?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReverseEnquiryFieldsMaxOrderByAggregateInput = {
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reverseEnquiryId?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ReverseEnquiryFieldsMinAggregateOutputType = {
  __typename?: 'ReverseEnquiryFieldsMinAggregateOutputType';
  cmsId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reverseEnquiryId?: Maybe<Scalars['String']>;
  stack?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReverseEnquiryFieldsMinOrderByAggregateInput = {
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reverseEnquiryId?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ReverseEnquiryFieldsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ReverseEnquiryFieldsOrderByWithAggregationInput = {
  _avg?: InputMaybe<ReverseEnquiryFieldsAvgOrderByAggregateInput>;
  _count?: InputMaybe<ReverseEnquiryFieldsCountOrderByAggregateInput>;
  _max?: InputMaybe<ReverseEnquiryFieldsMaxOrderByAggregateInput>;
  _min?: InputMaybe<ReverseEnquiryFieldsMinOrderByAggregateInput>;
  _sum?: InputMaybe<ReverseEnquiryFieldsSumOrderByAggregateInput>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrderInput>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reverseEnquiryId?: InputMaybe<SortOrderInput>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ReverseEnquiryFieldsOrderByWithRelationInput = {
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrderInput>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reverseEnquiry?: InputMaybe<ReverseEnquiryOrderByWithRelationInput>;
  reverseEnquiryId?: InputMaybe<SortOrderInput>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ReverseEnquiryFieldsScalarFieldEnum {
  CmsId = 'cmsId',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Name = 'name',
  Order = 'order',
  Pending = 'pending',
  Published = 'published',
  ReverseEnquiryId = 'reverseEnquiryId',
  Stack = 'stack',
  UpdatedAt = 'updatedAt'
}

export type ReverseEnquiryFieldsScalarWhereInput = {
  AND?: InputMaybe<Array<ReverseEnquiryFieldsScalarWhereInput>>;
  NOT?: InputMaybe<Array<ReverseEnquiryFieldsScalarWhereInput>>;
  OR?: InputMaybe<Array<ReverseEnquiryFieldsScalarWhereInput>>;
  cmsId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  reverseEnquiryId?: InputMaybe<StringNullableFilter>;
  stack?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ReverseEnquiryFieldsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ReverseEnquiryFieldsScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ReverseEnquiryFieldsScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ReverseEnquiryFieldsScalarWhereWithAggregatesInput>>;
  cmsId?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  order?: InputMaybe<IntNullableWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  reverseEnquiryId?: InputMaybe<StringNullableWithAggregatesFilter>;
  stack?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ReverseEnquiryFieldsSumAggregateOutputType = {
  __typename?: 'ReverseEnquiryFieldsSumAggregateOutputType';
  order?: Maybe<Scalars['Int']>;
};

export type ReverseEnquiryFieldsSumOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type ReverseEnquiryFieldsUncheckedCreateInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reverseEnquiryId?: InputMaybe<Scalars['String']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReverseEnquiryFieldsUncheckedCreateNestedManyWithoutReverseEnquiryInput = {
  connect?: InputMaybe<Array<ReverseEnquiryFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReverseEnquiryFieldsCreateOrConnectWithoutReverseEnquiryInput>>;
  create?: InputMaybe<Array<ReverseEnquiryFieldsCreateWithoutReverseEnquiryInput>>;
  createMany?: InputMaybe<ReverseEnquiryFieldsCreateManyReverseEnquiryInputEnvelope>;
};

export type ReverseEnquiryFieldsUncheckedCreateWithoutReverseEnquiryInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReverseEnquiryFieldsUncheckedUpdateInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reverseEnquiryId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReverseEnquiryFieldsUncheckedUpdateManyInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reverseEnquiryId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReverseEnquiryFieldsUncheckedUpdateManyWithoutFieldsInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReverseEnquiryFieldsUncheckedUpdateManyWithoutReverseEnquiryNestedInput = {
  connect?: InputMaybe<Array<ReverseEnquiryFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReverseEnquiryFieldsCreateOrConnectWithoutReverseEnquiryInput>>;
  create?: InputMaybe<Array<ReverseEnquiryFieldsCreateWithoutReverseEnquiryInput>>;
  createMany?: InputMaybe<ReverseEnquiryFieldsCreateManyReverseEnquiryInputEnvelope>;
  delete?: InputMaybe<Array<ReverseEnquiryFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ReverseEnquiryFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ReverseEnquiryFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<ReverseEnquiryFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<ReverseEnquiryFieldsUpdateWithWhereUniqueWithoutReverseEnquiryInput>>;
  updateMany?: InputMaybe<Array<ReverseEnquiryFieldsUpdateManyWithWhereWithoutReverseEnquiryInput>>;
  upsert?: InputMaybe<Array<ReverseEnquiryFieldsUpsertWithWhereUniqueWithoutReverseEnquiryInput>>;
};

export type ReverseEnquiryFieldsUncheckedUpdateWithoutReverseEnquiryInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReverseEnquiryFieldsUpdateInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reverseEnquiry?: InputMaybe<ReverseEnquiryUpdateOneWithoutFieldsNestedInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReverseEnquiryFieldsUpdateManyMutationInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReverseEnquiryFieldsUpdateManyWithWhereWithoutReverseEnquiryInput = {
  data: ReverseEnquiryFieldsUncheckedUpdateManyWithoutFieldsInput;
  where: ReverseEnquiryFieldsScalarWhereInput;
};

export type ReverseEnquiryFieldsUpdateManyWithoutReverseEnquiryNestedInput = {
  connect?: InputMaybe<Array<ReverseEnquiryFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReverseEnquiryFieldsCreateOrConnectWithoutReverseEnquiryInput>>;
  create?: InputMaybe<Array<ReverseEnquiryFieldsCreateWithoutReverseEnquiryInput>>;
  createMany?: InputMaybe<ReverseEnquiryFieldsCreateManyReverseEnquiryInputEnvelope>;
  delete?: InputMaybe<Array<ReverseEnquiryFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ReverseEnquiryFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ReverseEnquiryFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<ReverseEnquiryFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<ReverseEnquiryFieldsUpdateWithWhereUniqueWithoutReverseEnquiryInput>>;
  updateMany?: InputMaybe<Array<ReverseEnquiryFieldsUpdateManyWithWhereWithoutReverseEnquiryInput>>;
  upsert?: InputMaybe<Array<ReverseEnquiryFieldsUpsertWithWhereUniqueWithoutReverseEnquiryInput>>;
};

export type ReverseEnquiryFieldsUpdateWithWhereUniqueWithoutReverseEnquiryInput = {
  data: ReverseEnquiryFieldsUncheckedUpdateWithoutReverseEnquiryInput;
  where: ReverseEnquiryFieldsWhereUniqueInput;
};

export type ReverseEnquiryFieldsUpdateWithoutReverseEnquiryInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReverseEnquiryFieldsUpsertWithWhereUniqueWithoutReverseEnquiryInput = {
  create: ReverseEnquiryFieldsUncheckedCreateWithoutReverseEnquiryInput;
  update: ReverseEnquiryFieldsUncheckedUpdateWithoutReverseEnquiryInput;
  where: ReverseEnquiryFieldsWhereUniqueInput;
};

export type ReverseEnquiryFieldsWhereInput = {
  AND?: InputMaybe<Array<ReverseEnquiryFieldsWhereInput>>;
  NOT?: InputMaybe<Array<ReverseEnquiryFieldsWhereInput>>;
  OR?: InputMaybe<Array<ReverseEnquiryFieldsWhereInput>>;
  cmsId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  reverseEnquiry?: InputMaybe<ReverseEnquiryWhereInput>;
  reverseEnquiryId?: InputMaybe<StringNullableFilter>;
  stack?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ReverseEnquiryFieldsWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ReverseEnquiryMaxAggregateOutputType = {
  __typename?: 'ReverseEnquiryMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReverseEnquiryMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ReverseEnquiryMinAggregateOutputType = {
  __typename?: 'ReverseEnquiryMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReverseEnquiryMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ReverseEnquiryOrderByWithAggregationInput = {
  _count?: InputMaybe<ReverseEnquiryCountOrderByAggregateInput>;
  _max?: InputMaybe<ReverseEnquiryMaxOrderByAggregateInput>;
  _min?: InputMaybe<ReverseEnquiryMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ReverseEnquiryOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  fields?: InputMaybe<ReverseEnquiryFieldsOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ReverseEnquiryRelationFilter = {
  is?: InputMaybe<ReverseEnquiryWhereInput>;
  isNot?: InputMaybe<ReverseEnquiryWhereInput>;
};

export enum ReverseEnquiryScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Pending = 'pending',
  Published = 'published',
  Reference = 'reference',
  UpdatedAt = 'updatedAt'
}

export type ReverseEnquiryScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ReverseEnquiryScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ReverseEnquiryScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ReverseEnquiryScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  reference?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ReverseEnquiryUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<ReverseEnquiryFieldsUncheckedCreateNestedManyWithoutReverseEnquiryInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReverseEnquiryUncheckedCreateWithoutFieldsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReverseEnquiryUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<ReverseEnquiryFieldsUncheckedUpdateManyWithoutReverseEnquiryNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReverseEnquiryUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReverseEnquiryUncheckedUpdateWithoutFieldsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReverseEnquiryUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<ReverseEnquiryFieldsUpdateManyWithoutReverseEnquiryNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReverseEnquiryUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReverseEnquiryUpdateOneWithoutFieldsNestedInput = {
  connect?: InputMaybe<ReverseEnquiryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ReverseEnquiryCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<ReverseEnquiryUncheckedCreateWithoutFieldsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ReverseEnquiryUncheckedUpdateWithoutFieldsInput>;
  upsert?: InputMaybe<ReverseEnquiryUpsertWithoutFieldsInput>;
};

export type ReverseEnquiryUpdateWithoutFieldsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReverseEnquiryUpsertWithoutFieldsInput = {
  create: ReverseEnquiryUncheckedCreateWithoutFieldsInput;
  update: ReverseEnquiryUncheckedUpdateWithoutFieldsInput;
};

export type ReverseEnquiryWhereInput = {
  AND?: InputMaybe<Array<ReverseEnquiryWhereInput>>;
  NOT?: InputMaybe<Array<ReverseEnquiryWhereInput>>;
  OR?: InputMaybe<Array<ReverseEnquiryWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fields?: InputMaybe<ReverseEnquiryFieldsListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  reference?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ReverseEnquiryWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ReviewGuidance = {
  __typename?: 'ReviewGuidance';
  _count: ReviewGuidanceCountOutputType;
  createdAt: Scalars['DateTime'];
  fields: Array<Maybe<ReviewGuidanceFields>>;
  id: Scalars['String'];
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type ReviewGuidanceFieldsArgs = {
  cursor?: InputMaybe<ReviewGuidanceFieldsWhereUniqueInput>;
  distinct?: InputMaybe<ReviewGuidanceFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<ReviewGuidanceFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ReviewGuidanceFieldsWhereInput>;
};

export type ReviewGuidanceCountAggregateOutputType = {
  __typename?: 'ReviewGuidanceCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  pending: Scalars['Int'];
  published: Scalars['Int'];
  reference: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ReviewGuidanceCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ReviewGuidanceCountOutputType = {
  __typename?: 'ReviewGuidanceCountOutputType';
  fields: Scalars['Int'];
};

export type ReviewGuidanceCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<ReviewGuidanceFieldsCreateNestedManyWithoutReviewGuidanceInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReviewGuidanceCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReviewGuidanceCreateNestedOneWithoutFieldsInput = {
  connect?: InputMaybe<ReviewGuidanceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ReviewGuidanceCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<ReviewGuidanceUncheckedCreateWithoutFieldsInput>;
};

export type ReviewGuidanceCreateOrConnectWithoutFieldsInput = {
  create: ReviewGuidanceUncheckedCreateWithoutFieldsInput;
  where: ReviewGuidanceWhereUniqueInput;
};

export type ReviewGuidanceCreateWithoutFieldsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReviewGuidanceFields = {
  __typename?: 'ReviewGuidanceFields';
  cmsId?: Maybe<Scalars['String']>;
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  name: Scalars['String'];
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reviewGuidance?: Maybe<ReviewGuidance>;
  reviewGuidanceId?: Maybe<Scalars['String']>;
  stack?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type ReviewGuidanceFieldsCountAggregateOutputType = {
  __typename?: 'ReviewGuidanceFieldsCountAggregateOutputType';
  _all: Scalars['Int'];
  cmsId: Scalars['Int'];
  content: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  pending: Scalars['Int'];
  published: Scalars['Int'];
  reviewGuidanceId: Scalars['Int'];
  stack: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ReviewGuidanceFieldsCountOrderByAggregateInput = {
  cmsId?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reviewGuidanceId?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ReviewGuidanceFieldsCreateInput = {
  cmsId?: InputMaybe<Scalars['String']>;
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reviewGuidance?: InputMaybe<ReviewGuidanceCreateNestedOneWithoutFieldsInput>;
  stack?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReviewGuidanceFieldsCreateManyInput = {
  cmsId?: InputMaybe<Scalars['String']>;
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reviewGuidanceId?: InputMaybe<Scalars['String']>;
  stack?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReviewGuidanceFieldsCreateManyReviewGuidanceInput = {
  cmsId?: InputMaybe<Scalars['String']>;
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReviewGuidanceFieldsCreateManyReviewGuidanceInputEnvelope = {
  data: Array<ReviewGuidanceFieldsCreateManyReviewGuidanceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ReviewGuidanceFieldsCreateNestedManyWithoutReviewGuidanceInput = {
  connect?: InputMaybe<Array<ReviewGuidanceFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReviewGuidanceFieldsCreateOrConnectWithoutReviewGuidanceInput>>;
  create?: InputMaybe<Array<ReviewGuidanceFieldsCreateWithoutReviewGuidanceInput>>;
  createMany?: InputMaybe<ReviewGuidanceFieldsCreateManyReviewGuidanceInputEnvelope>;
};

export type ReviewGuidanceFieldsCreateOrConnectWithoutReviewGuidanceInput = {
  create: ReviewGuidanceFieldsUncheckedCreateWithoutReviewGuidanceInput;
  where: ReviewGuidanceFieldsWhereUniqueInput;
};

export type ReviewGuidanceFieldsCreateWithoutReviewGuidanceInput = {
  cmsId?: InputMaybe<Scalars['String']>;
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReviewGuidanceFieldsListRelationFilter = {
  every?: InputMaybe<ReviewGuidanceFieldsWhereInput>;
  none?: InputMaybe<ReviewGuidanceFieldsWhereInput>;
  some?: InputMaybe<ReviewGuidanceFieldsWhereInput>;
};

export type ReviewGuidanceFieldsMaxAggregateOutputType = {
  __typename?: 'ReviewGuidanceFieldsMaxAggregateOutputType';
  cmsId?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reviewGuidanceId?: Maybe<Scalars['String']>;
  stack?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewGuidanceFieldsMaxOrderByAggregateInput = {
  cmsId?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reviewGuidanceId?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ReviewGuidanceFieldsMinAggregateOutputType = {
  __typename?: 'ReviewGuidanceFieldsMinAggregateOutputType';
  cmsId?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reviewGuidanceId?: Maybe<Scalars['String']>;
  stack?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewGuidanceFieldsMinOrderByAggregateInput = {
  cmsId?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reviewGuidanceId?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ReviewGuidanceFieldsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ReviewGuidanceFieldsOrderByWithAggregationInput = {
  _count?: InputMaybe<ReviewGuidanceFieldsCountOrderByAggregateInput>;
  _max?: InputMaybe<ReviewGuidanceFieldsMaxOrderByAggregateInput>;
  _min?: InputMaybe<ReviewGuidanceFieldsMinOrderByAggregateInput>;
  cmsId?: InputMaybe<SortOrderInput>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reviewGuidanceId?: InputMaybe<SortOrderInput>;
  stack?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ReviewGuidanceFieldsOrderByWithRelationInput = {
  cmsId?: InputMaybe<SortOrderInput>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reviewGuidance?: InputMaybe<ReviewGuidanceOrderByWithRelationInput>;
  reviewGuidanceId?: InputMaybe<SortOrderInput>;
  stack?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ReviewGuidanceFieldsScalarFieldEnum {
  CmsId = 'cmsId',
  Content = 'content',
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  Pending = 'pending',
  Published = 'published',
  ReviewGuidanceId = 'reviewGuidanceId',
  Stack = 'stack',
  UpdatedAt = 'updatedAt'
}

export type ReviewGuidanceFieldsScalarWhereInput = {
  AND?: InputMaybe<Array<ReviewGuidanceFieldsScalarWhereInput>>;
  NOT?: InputMaybe<Array<ReviewGuidanceFieldsScalarWhereInput>>;
  OR?: InputMaybe<Array<ReviewGuidanceFieldsScalarWhereInput>>;
  cmsId?: InputMaybe<StringNullableFilter>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  reviewGuidanceId?: InputMaybe<StringNullableFilter>;
  stack?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ReviewGuidanceFieldsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ReviewGuidanceFieldsScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ReviewGuidanceFieldsScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ReviewGuidanceFieldsScalarWhereWithAggregatesInput>>;
  cmsId?: InputMaybe<StringNullableWithAggregatesFilter>;
  content?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  reviewGuidanceId?: InputMaybe<StringNullableWithAggregatesFilter>;
  stack?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ReviewGuidanceFieldsUncheckedCreateInput = {
  cmsId?: InputMaybe<Scalars['String']>;
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reviewGuidanceId?: InputMaybe<Scalars['String']>;
  stack?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReviewGuidanceFieldsUncheckedCreateNestedManyWithoutReviewGuidanceInput = {
  connect?: InputMaybe<Array<ReviewGuidanceFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReviewGuidanceFieldsCreateOrConnectWithoutReviewGuidanceInput>>;
  create?: InputMaybe<Array<ReviewGuidanceFieldsCreateWithoutReviewGuidanceInput>>;
  createMany?: InputMaybe<ReviewGuidanceFieldsCreateManyReviewGuidanceInputEnvelope>;
};

export type ReviewGuidanceFieldsUncheckedCreateWithoutReviewGuidanceInput = {
  cmsId?: InputMaybe<Scalars['String']>;
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReviewGuidanceFieldsUncheckedUpdateInput = {
  cmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reviewGuidanceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stack?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReviewGuidanceFieldsUncheckedUpdateManyInput = {
  cmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reviewGuidanceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stack?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReviewGuidanceFieldsUncheckedUpdateManyWithoutFieldsInput = {
  cmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReviewGuidanceFieldsUncheckedUpdateManyWithoutReviewGuidanceNestedInput = {
  connect?: InputMaybe<Array<ReviewGuidanceFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReviewGuidanceFieldsCreateOrConnectWithoutReviewGuidanceInput>>;
  create?: InputMaybe<Array<ReviewGuidanceFieldsCreateWithoutReviewGuidanceInput>>;
  createMany?: InputMaybe<ReviewGuidanceFieldsCreateManyReviewGuidanceInputEnvelope>;
  delete?: InputMaybe<Array<ReviewGuidanceFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ReviewGuidanceFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ReviewGuidanceFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<ReviewGuidanceFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<ReviewGuidanceFieldsUpdateWithWhereUniqueWithoutReviewGuidanceInput>>;
  updateMany?: InputMaybe<Array<ReviewGuidanceFieldsUpdateManyWithWhereWithoutReviewGuidanceInput>>;
  upsert?: InputMaybe<Array<ReviewGuidanceFieldsUpsertWithWhereUniqueWithoutReviewGuidanceInput>>;
};

export type ReviewGuidanceFieldsUncheckedUpdateWithoutReviewGuidanceInput = {
  cmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReviewGuidanceFieldsUpdateInput = {
  cmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reviewGuidance?: InputMaybe<ReviewGuidanceUpdateOneWithoutFieldsNestedInput>;
  stack?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReviewGuidanceFieldsUpdateManyMutationInput = {
  cmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReviewGuidanceFieldsUpdateManyWithWhereWithoutReviewGuidanceInput = {
  data: ReviewGuidanceFieldsUncheckedUpdateManyWithoutFieldsInput;
  where: ReviewGuidanceFieldsScalarWhereInput;
};

export type ReviewGuidanceFieldsUpdateManyWithoutReviewGuidanceNestedInput = {
  connect?: InputMaybe<Array<ReviewGuidanceFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReviewGuidanceFieldsCreateOrConnectWithoutReviewGuidanceInput>>;
  create?: InputMaybe<Array<ReviewGuidanceFieldsCreateWithoutReviewGuidanceInput>>;
  createMany?: InputMaybe<ReviewGuidanceFieldsCreateManyReviewGuidanceInputEnvelope>;
  delete?: InputMaybe<Array<ReviewGuidanceFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ReviewGuidanceFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ReviewGuidanceFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<ReviewGuidanceFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<ReviewGuidanceFieldsUpdateWithWhereUniqueWithoutReviewGuidanceInput>>;
  updateMany?: InputMaybe<Array<ReviewGuidanceFieldsUpdateManyWithWhereWithoutReviewGuidanceInput>>;
  upsert?: InputMaybe<Array<ReviewGuidanceFieldsUpsertWithWhereUniqueWithoutReviewGuidanceInput>>;
};

export type ReviewGuidanceFieldsUpdateWithWhereUniqueWithoutReviewGuidanceInput = {
  data: ReviewGuidanceFieldsUncheckedUpdateWithoutReviewGuidanceInput;
  where: ReviewGuidanceFieldsWhereUniqueInput;
};

export type ReviewGuidanceFieldsUpdateWithoutReviewGuidanceInput = {
  cmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReviewGuidanceFieldsUpsertWithWhereUniqueWithoutReviewGuidanceInput = {
  create: ReviewGuidanceFieldsUncheckedCreateWithoutReviewGuidanceInput;
  update: ReviewGuidanceFieldsUncheckedUpdateWithoutReviewGuidanceInput;
  where: ReviewGuidanceFieldsWhereUniqueInput;
};

export type ReviewGuidanceFieldsWhereInput = {
  AND?: InputMaybe<Array<ReviewGuidanceFieldsWhereInput>>;
  NOT?: InputMaybe<Array<ReviewGuidanceFieldsWhereInput>>;
  OR?: InputMaybe<Array<ReviewGuidanceFieldsWhereInput>>;
  cmsId?: InputMaybe<StringNullableFilter>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  reviewGuidance?: InputMaybe<ReviewGuidanceWhereInput>;
  reviewGuidanceId?: InputMaybe<StringNullableFilter>;
  stack?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ReviewGuidanceFieldsWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ReviewGuidanceMaxAggregateOutputType = {
  __typename?: 'ReviewGuidanceMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewGuidanceMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ReviewGuidanceMinAggregateOutputType = {
  __typename?: 'ReviewGuidanceMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewGuidanceMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ReviewGuidanceOrderByWithAggregationInput = {
  _count?: InputMaybe<ReviewGuidanceCountOrderByAggregateInput>;
  _max?: InputMaybe<ReviewGuidanceMaxOrderByAggregateInput>;
  _min?: InputMaybe<ReviewGuidanceMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ReviewGuidanceOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  fields?: InputMaybe<ReviewGuidanceFieldsOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ReviewGuidanceRelationFilter = {
  is?: InputMaybe<ReviewGuidanceWhereInput>;
  isNot?: InputMaybe<ReviewGuidanceWhereInput>;
};

export enum ReviewGuidanceScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Pending = 'pending',
  Published = 'published',
  Reference = 'reference',
  UpdatedAt = 'updatedAt'
}

export type ReviewGuidanceScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ReviewGuidanceScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ReviewGuidanceScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ReviewGuidanceScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  reference?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ReviewGuidanceUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<ReviewGuidanceFieldsUncheckedCreateNestedManyWithoutReviewGuidanceInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReviewGuidanceUncheckedCreateWithoutFieldsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReviewGuidanceUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<ReviewGuidanceFieldsUncheckedUpdateManyWithoutReviewGuidanceNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReviewGuidanceUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReviewGuidanceUncheckedUpdateWithoutFieldsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReviewGuidanceUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<ReviewGuidanceFieldsUpdateManyWithoutReviewGuidanceNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReviewGuidanceUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReviewGuidanceUpdateOneWithoutFieldsNestedInput = {
  connect?: InputMaybe<ReviewGuidanceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ReviewGuidanceCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<ReviewGuidanceUncheckedCreateWithoutFieldsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ReviewGuidanceUncheckedUpdateWithoutFieldsInput>;
  upsert?: InputMaybe<ReviewGuidanceUpsertWithoutFieldsInput>;
};

export type ReviewGuidanceUpdateWithoutFieldsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReviewGuidanceUpsertWithoutFieldsInput = {
  create: ReviewGuidanceUncheckedCreateWithoutFieldsInput;
  update: ReviewGuidanceUncheckedUpdateWithoutFieldsInput;
};

export type ReviewGuidanceWhereInput = {
  AND?: InputMaybe<Array<ReviewGuidanceWhereInput>>;
  NOT?: InputMaybe<Array<ReviewGuidanceWhereInput>>;
  OR?: InputMaybe<Array<ReviewGuidanceWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fields?: InputMaybe<ReviewGuidanceFieldsListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  reference?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ReviewGuidanceWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortOrderInput = {
  nulls?: InputMaybe<NullsOrder>;
  sort: SortOrder;
};

export type Status = {
  __typename?: 'Status';
  _count: StatusCountOutputType;
  createdAt: Scalars['DateTime'];
  fields: Array<Maybe<StatusFields>>;
  id: Scalars['String'];
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type StatusFieldsArgs = {
  cursor?: InputMaybe<StatusFieldsWhereUniqueInput>;
  distinct?: InputMaybe<StatusFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<StatusFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StatusFieldsWhereInput>;
};

export type StatusCountAggregateOutputType = {
  __typename?: 'StatusCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  pending: Scalars['Int'];
  published: Scalars['Int'];
  reference: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type StatusCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type StatusCountOutputType = {
  __typename?: 'StatusCountOutputType';
  fields: Scalars['Int'];
};

export type StatusCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<StatusFieldsCreateNestedManyWithoutStatusInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type StatusCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type StatusCreateNestedOneWithoutFieldsInput = {
  connect?: InputMaybe<StatusWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StatusCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<StatusUncheckedCreateWithoutFieldsInput>;
};

export type StatusCreateOrConnectWithoutFieldsInput = {
  create: StatusUncheckedCreateWithoutFieldsInput;
  where: StatusWhereUniqueInput;
};

export type StatusCreateWithoutFieldsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type StatusFields = {
  __typename?: 'StatusFields';
  _count: StatusFieldsCountOutputType;
  adHoc?: Maybe<Scalars['Boolean']>;
  changes?: Maybe<Scalars['String']>;
  cmsId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  date?: Maybe<Scalars['DateTime']>;
  forthcomingChanges?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  locations: Array<Maybe<Location>>;
  name: Scalars['String'];
  pending?: Maybe<Scalars['Boolean']>;
  publishDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  status?: Maybe<Status>;
  statusId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type StatusFieldsLocationsArgs = {
  cursor?: InputMaybe<LocationWhereUniqueInput>;
  distinct?: InputMaybe<LocationScalarFieldEnum>;
  orderBy?: InputMaybe<LocationOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationWhereInput>;
};

export type StatusFieldsConnection = {
  __typename?: 'StatusFieldsConnection';
  aggregate: AggregateStatusFields;
  edges: Array<Maybe<StatusFieldsEdge>>;
  pageInfo: PageInfo;
};

export type StatusFieldsCountAggregateOutputType = {
  __typename?: 'StatusFieldsCountAggregateOutputType';
  _all: Scalars['Int'];
  adHoc: Scalars['Int'];
  changes: Scalars['Int'];
  cmsId: Scalars['Int'];
  createdAt: Scalars['Int'];
  date: Scalars['Int'];
  forthcomingChanges: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  pending: Scalars['Int'];
  publishDate: Scalars['Int'];
  published: Scalars['Int'];
  stack: Scalars['Int'];
  statusId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type StatusFieldsCountOrderByAggregateInput = {
  adHoc?: InputMaybe<SortOrder>;
  changes?: InputMaybe<SortOrder>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  forthcomingChanges?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  publishDate?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  statusId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type StatusFieldsCountOutputType = {
  __typename?: 'StatusFieldsCountOutputType';
  locations: Scalars['Int'];
};

export type StatusFieldsCreateInput = {
  adHoc?: InputMaybe<Scalars['Boolean']>;
  changes?: InputMaybe<Scalars['String']>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  forthcomingChanges?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutStatusesInput>;
  name: Scalars['String'];
  pending?: InputMaybe<Scalars['Boolean']>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  status?: InputMaybe<StatusCreateNestedOneWithoutFieldsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type StatusFieldsCreateManyInput = {
  adHoc?: InputMaybe<Scalars['Boolean']>;
  changes?: InputMaybe<Scalars['String']>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  forthcomingChanges?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pending?: InputMaybe<Scalars['Boolean']>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  statusId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type StatusFieldsCreateManyStatusInput = {
  adHoc?: InputMaybe<Scalars['Boolean']>;
  changes?: InputMaybe<Scalars['String']>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  forthcomingChanges?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pending?: InputMaybe<Scalars['Boolean']>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type StatusFieldsCreateManyStatusInputEnvelope = {
  data: Array<StatusFieldsCreateManyStatusInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type StatusFieldsCreateNestedManyWithoutLocationsInput = {
  connect?: InputMaybe<Array<StatusFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StatusFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<StatusFieldsCreateWithoutLocationsInput>>;
};

export type StatusFieldsCreateNestedManyWithoutStatusInput = {
  connect?: InputMaybe<Array<StatusFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StatusFieldsCreateOrConnectWithoutStatusInput>>;
  create?: InputMaybe<Array<StatusFieldsCreateWithoutStatusInput>>;
  createMany?: InputMaybe<StatusFieldsCreateManyStatusInputEnvelope>;
};

export type StatusFieldsCreateOrConnectWithoutLocationsInput = {
  create: StatusFieldsUncheckedCreateWithoutLocationsInput;
  where: StatusFieldsWhereUniqueInput;
};

export type StatusFieldsCreateOrConnectWithoutStatusInput = {
  create: StatusFieldsUncheckedCreateWithoutStatusInput;
  where: StatusFieldsWhereUniqueInput;
};

export type StatusFieldsCreateWithoutLocationsInput = {
  adHoc?: InputMaybe<Scalars['Boolean']>;
  changes?: InputMaybe<Scalars['String']>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  forthcomingChanges?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pending?: InputMaybe<Scalars['Boolean']>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  status?: InputMaybe<StatusCreateNestedOneWithoutFieldsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type StatusFieldsCreateWithoutStatusInput = {
  adHoc?: InputMaybe<Scalars['Boolean']>;
  changes?: InputMaybe<Scalars['String']>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  forthcomingChanges?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutStatusesInput>;
  name: Scalars['String'];
  pending?: InputMaybe<Scalars['Boolean']>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type StatusFieldsEdge = {
  __typename?: 'StatusFieldsEdge';
  cursor: Scalars['String'];
  node: StatusFields;
};

export type StatusFieldsListRelationFilter = {
  every?: InputMaybe<StatusFieldsWhereInput>;
  none?: InputMaybe<StatusFieldsWhereInput>;
  some?: InputMaybe<StatusFieldsWhereInput>;
};

export type StatusFieldsMaxAggregateOutputType = {
  __typename?: 'StatusFieldsMaxAggregateOutputType';
  adHoc?: Maybe<Scalars['Boolean']>;
  changes?: Maybe<Scalars['String']>;
  cmsId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  forthcomingChanges?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  publishDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  stack?: Maybe<Scalars['String']>;
  statusId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StatusFieldsMaxOrderByAggregateInput = {
  adHoc?: InputMaybe<SortOrder>;
  changes?: InputMaybe<SortOrder>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  forthcomingChanges?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  publishDate?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  statusId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type StatusFieldsMinAggregateOutputType = {
  __typename?: 'StatusFieldsMinAggregateOutputType';
  adHoc?: Maybe<Scalars['Boolean']>;
  changes?: Maybe<Scalars['String']>;
  cmsId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  forthcomingChanges?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  publishDate?: Maybe<Scalars['DateTime']>;
  published?: Maybe<Scalars['Boolean']>;
  stack?: Maybe<Scalars['String']>;
  statusId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StatusFieldsMinOrderByAggregateInput = {
  adHoc?: InputMaybe<SortOrder>;
  changes?: InputMaybe<SortOrder>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  forthcomingChanges?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  publishDate?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  statusId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type StatusFieldsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type StatusFieldsOrderByWithAggregationInput = {
  _count?: InputMaybe<StatusFieldsCountOrderByAggregateInput>;
  _max?: InputMaybe<StatusFieldsMaxOrderByAggregateInput>;
  _min?: InputMaybe<StatusFieldsMinOrderByAggregateInput>;
  adHoc?: InputMaybe<SortOrderInput>;
  changes?: InputMaybe<SortOrderInput>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrderInput>;
  forthcomingChanges?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  publishDate?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  stack?: InputMaybe<SortOrder>;
  statusId?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type StatusFieldsOrderByWithRelationInput = {
  adHoc?: InputMaybe<SortOrderInput>;
  changes?: InputMaybe<SortOrderInput>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrderInput>;
  forthcomingChanges?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  locations?: InputMaybe<LocationOrderByRelationAggregateInput>;
  name?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  publishDate?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  stack?: InputMaybe<SortOrder>;
  status?: InputMaybe<StatusOrderByWithRelationInput>;
  statusId?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum StatusFieldsScalarFieldEnum {
  AdHoc = 'adHoc',
  Changes = 'changes',
  CmsId = 'cmsId',
  CreatedAt = 'createdAt',
  Date = 'date',
  ForthcomingChanges = 'forthcomingChanges',
  Id = 'id',
  Name = 'name',
  Pending = 'pending',
  PublishDate = 'publishDate',
  Published = 'published',
  Stack = 'stack',
  StatusId = 'statusId',
  UpdatedAt = 'updatedAt'
}

export type StatusFieldsScalarWhereInput = {
  AND?: InputMaybe<Array<StatusFieldsScalarWhereInput>>;
  NOT?: InputMaybe<Array<StatusFieldsScalarWhereInput>>;
  OR?: InputMaybe<Array<StatusFieldsScalarWhereInput>>;
  adHoc?: InputMaybe<BoolNullableFilter>;
  changes?: InputMaybe<StringNullableFilter>;
  cmsId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  date?: InputMaybe<DateTimeNullableFilter>;
  forthcomingChanges?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  publishDate?: InputMaybe<DateTimeNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  stack?: InputMaybe<StringFilter>;
  statusId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type StatusFieldsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<StatusFieldsScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<StatusFieldsScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<StatusFieldsScalarWhereWithAggregatesInput>>;
  adHoc?: InputMaybe<BoolNullableWithAggregatesFilter>;
  changes?: InputMaybe<StringNullableWithAggregatesFilter>;
  cmsId?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  date?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  forthcomingChanges?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  publishDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  stack?: InputMaybe<StringWithAggregatesFilter>;
  statusId?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type StatusFieldsUncheckedCreateInput = {
  adHoc?: InputMaybe<Scalars['Boolean']>;
  changes?: InputMaybe<Scalars['String']>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  forthcomingChanges?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationUncheckedCreateNestedManyWithoutStatusesInput>;
  name: Scalars['String'];
  pending?: InputMaybe<Scalars['Boolean']>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  statusId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type StatusFieldsUncheckedCreateNestedManyWithoutLocationsInput = {
  connect?: InputMaybe<Array<StatusFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StatusFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<StatusFieldsCreateWithoutLocationsInput>>;
};

export type StatusFieldsUncheckedCreateNestedManyWithoutStatusInput = {
  connect?: InputMaybe<Array<StatusFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StatusFieldsCreateOrConnectWithoutStatusInput>>;
  create?: InputMaybe<Array<StatusFieldsCreateWithoutStatusInput>>;
  createMany?: InputMaybe<StatusFieldsCreateManyStatusInputEnvelope>;
};

export type StatusFieldsUncheckedCreateWithoutLocationsInput = {
  adHoc?: InputMaybe<Scalars['Boolean']>;
  changes?: InputMaybe<Scalars['String']>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  forthcomingChanges?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pending?: InputMaybe<Scalars['Boolean']>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  statusId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type StatusFieldsUncheckedCreateWithoutStatusInput = {
  adHoc?: InputMaybe<Scalars['Boolean']>;
  changes?: InputMaybe<Scalars['String']>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  forthcomingChanges?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationUncheckedCreateNestedManyWithoutStatusesInput>;
  name: Scalars['String'];
  pending?: InputMaybe<Scalars['Boolean']>;
  publishDate?: InputMaybe<Scalars['DateTime']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type StatusFieldsUncheckedUpdateInput = {
  adHoc?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  changes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  forthcomingChanges?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUncheckedUpdateManyWithoutStatusesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  statusId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StatusFieldsUncheckedUpdateManyInput = {
  adHoc?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  changes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  forthcomingChanges?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  statusId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StatusFieldsUncheckedUpdateManyWithoutFieldsInput = {
  adHoc?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  changes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  forthcomingChanges?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StatusFieldsUncheckedUpdateManyWithoutLocationsNestedInput = {
  connect?: InputMaybe<Array<StatusFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StatusFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<StatusFieldsCreateWithoutLocationsInput>>;
  delete?: InputMaybe<Array<StatusFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StatusFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StatusFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<StatusFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<StatusFieldsUpdateWithWhereUniqueWithoutLocationsInput>>;
  updateMany?: InputMaybe<Array<StatusFieldsUpdateManyWithWhereWithoutLocationsInput>>;
  upsert?: InputMaybe<Array<StatusFieldsUpsertWithWhereUniqueWithoutLocationsInput>>;
};

export type StatusFieldsUncheckedUpdateManyWithoutStatusNestedInput = {
  connect?: InputMaybe<Array<StatusFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StatusFieldsCreateOrConnectWithoutStatusInput>>;
  create?: InputMaybe<Array<StatusFieldsCreateWithoutStatusInput>>;
  createMany?: InputMaybe<StatusFieldsCreateManyStatusInputEnvelope>;
  delete?: InputMaybe<Array<StatusFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StatusFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StatusFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<StatusFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<StatusFieldsUpdateWithWhereUniqueWithoutStatusInput>>;
  updateMany?: InputMaybe<Array<StatusFieldsUpdateManyWithWhereWithoutStatusInput>>;
  upsert?: InputMaybe<Array<StatusFieldsUpsertWithWhereUniqueWithoutStatusInput>>;
};

export type StatusFieldsUncheckedUpdateManyWithoutStatusesInput = {
  adHoc?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  changes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  forthcomingChanges?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  statusId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StatusFieldsUncheckedUpdateWithoutLocationsInput = {
  adHoc?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  changes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  forthcomingChanges?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  statusId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StatusFieldsUncheckedUpdateWithoutStatusInput = {
  adHoc?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  changes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  forthcomingChanges?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUncheckedUpdateManyWithoutStatusesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StatusFieldsUpdateInput = {
  adHoc?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  changes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  forthcomingChanges?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutStatusesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<StatusUpdateOneWithoutFieldsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StatusFieldsUpdateManyMutationInput = {
  adHoc?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  changes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  forthcomingChanges?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StatusFieldsUpdateManyWithWhereWithoutLocationsInput = {
  data: StatusFieldsUncheckedUpdateManyWithoutStatusesInput;
  where: StatusFieldsScalarWhereInput;
};

export type StatusFieldsUpdateManyWithWhereWithoutStatusInput = {
  data: StatusFieldsUncheckedUpdateManyWithoutFieldsInput;
  where: StatusFieldsScalarWhereInput;
};

export type StatusFieldsUpdateManyWithoutLocationsNestedInput = {
  connect?: InputMaybe<Array<StatusFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StatusFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<StatusFieldsCreateWithoutLocationsInput>>;
  delete?: InputMaybe<Array<StatusFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StatusFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StatusFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<StatusFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<StatusFieldsUpdateWithWhereUniqueWithoutLocationsInput>>;
  updateMany?: InputMaybe<Array<StatusFieldsUpdateManyWithWhereWithoutLocationsInput>>;
  upsert?: InputMaybe<Array<StatusFieldsUpsertWithWhereUniqueWithoutLocationsInput>>;
};

export type StatusFieldsUpdateManyWithoutStatusNestedInput = {
  connect?: InputMaybe<Array<StatusFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StatusFieldsCreateOrConnectWithoutStatusInput>>;
  create?: InputMaybe<Array<StatusFieldsCreateWithoutStatusInput>>;
  createMany?: InputMaybe<StatusFieldsCreateManyStatusInputEnvelope>;
  delete?: InputMaybe<Array<StatusFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StatusFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StatusFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<StatusFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<StatusFieldsUpdateWithWhereUniqueWithoutStatusInput>>;
  updateMany?: InputMaybe<Array<StatusFieldsUpdateManyWithWhereWithoutStatusInput>>;
  upsert?: InputMaybe<Array<StatusFieldsUpsertWithWhereUniqueWithoutStatusInput>>;
};

export type StatusFieldsUpdateWithWhereUniqueWithoutLocationsInput = {
  data: StatusFieldsUncheckedUpdateWithoutLocationsInput;
  where: StatusFieldsWhereUniqueInput;
};

export type StatusFieldsUpdateWithWhereUniqueWithoutStatusInput = {
  data: StatusFieldsUncheckedUpdateWithoutStatusInput;
  where: StatusFieldsWhereUniqueInput;
};

export type StatusFieldsUpdateWithoutLocationsInput = {
  adHoc?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  changes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  forthcomingChanges?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<StatusUpdateOneWithoutFieldsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StatusFieldsUpdateWithoutStatusInput = {
  adHoc?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  changes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  forthcomingChanges?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutStatusesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StatusFieldsUpsertWithWhereUniqueWithoutLocationsInput = {
  create: StatusFieldsUncheckedCreateWithoutLocationsInput;
  update: StatusFieldsUncheckedUpdateWithoutLocationsInput;
  where: StatusFieldsWhereUniqueInput;
};

export type StatusFieldsUpsertWithWhereUniqueWithoutStatusInput = {
  create: StatusFieldsUncheckedCreateWithoutStatusInput;
  update: StatusFieldsUncheckedUpdateWithoutStatusInput;
  where: StatusFieldsWhereUniqueInput;
};

export type StatusFieldsWhereInput = {
  AND?: InputMaybe<Array<StatusFieldsWhereInput>>;
  NOT?: InputMaybe<Array<StatusFieldsWhereInput>>;
  OR?: InputMaybe<Array<StatusFieldsWhereInput>>;
  adHoc?: InputMaybe<BoolNullableFilter>;
  changes?: InputMaybe<StringNullableFilter>;
  cmsId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  date?: InputMaybe<DateTimeNullableFilter>;
  forthcomingChanges?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  locations?: InputMaybe<LocationListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  publishDate?: InputMaybe<DateTimeNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  stack?: InputMaybe<StringFilter>;
  status?: InputMaybe<StatusWhereInput>;
  statusId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type StatusFieldsWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type StatusMaxAggregateOutputType = {
  __typename?: 'StatusMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StatusMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type StatusMinAggregateOutputType = {
  __typename?: 'StatusMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StatusMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type StatusOrderByWithAggregationInput = {
  _count?: InputMaybe<StatusCountOrderByAggregateInput>;
  _max?: InputMaybe<StatusMaxOrderByAggregateInput>;
  _min?: InputMaybe<StatusMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type StatusOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  fields?: InputMaybe<StatusFieldsOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type StatusRelationFilter = {
  is?: InputMaybe<StatusWhereInput>;
  isNot?: InputMaybe<StatusWhereInput>;
};

export enum StatusScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Pending = 'pending',
  Published = 'published',
  Reference = 'reference',
  UpdatedAt = 'updatedAt'
}

export type StatusScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<StatusScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<StatusScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<StatusScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  reference?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type StatusUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<StatusFieldsUncheckedCreateNestedManyWithoutStatusInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type StatusUncheckedCreateWithoutFieldsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type StatusUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<StatusFieldsUncheckedUpdateManyWithoutStatusNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StatusUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StatusUncheckedUpdateWithoutFieldsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StatusUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<StatusFieldsUpdateManyWithoutStatusNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StatusUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StatusUpdateOneWithoutFieldsNestedInput = {
  connect?: InputMaybe<StatusWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StatusCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<StatusUncheckedCreateWithoutFieldsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<StatusUncheckedUpdateWithoutFieldsInput>;
  upsert?: InputMaybe<StatusUpsertWithoutFieldsInput>;
};

export type StatusUpdateWithoutFieldsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StatusUpsertWithoutFieldsInput = {
  create: StatusUncheckedCreateWithoutFieldsInput;
  update: StatusUncheckedUpdateWithoutFieldsInput;
};

export type StatusWhereInput = {
  AND?: InputMaybe<Array<StatusWhereInput>>;
  NOT?: InputMaybe<Array<StatusWhereInput>>;
  OR?: InputMaybe<Array<StatusWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fields?: InputMaybe<StatusFieldsListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  reference?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type StatusWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type SubActivity = {
  __typename?: 'SubActivity';
  _count: SubActivityCountOutputType;
  createdAt: Scalars['DateTime'];
  fields: Array<Maybe<SubActivityFields>>;
  id: Scalars['String'];
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type SubActivityFieldsArgs = {
  cursor?: InputMaybe<SubActivityFieldsWhereUniqueInput>;
  distinct?: InputMaybe<SubActivityFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<SubActivityFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SubActivityFieldsWhereInput>;
};

export type SubActivityCountAggregateOutputType = {
  __typename?: 'SubActivityCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  pending: Scalars['Int'];
  published: Scalars['Int'];
  reference: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type SubActivityCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SubActivityCountOutputType = {
  __typename?: 'SubActivityCountOutputType';
  fields: Scalars['Int'];
};

export type SubActivityCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<SubActivityFieldsCreateNestedManyWithoutSubActivityInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubActivityCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubActivityCreateNestedOneWithoutFieldsInput = {
  connect?: InputMaybe<SubActivityWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SubActivityCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<SubActivityUncheckedCreateWithoutFieldsInput>;
};

export type SubActivityCreateOrConnectWithoutFieldsInput = {
  create: SubActivityUncheckedCreateWithoutFieldsInput;
  where: SubActivityWhereUniqueInput;
};

export type SubActivityCreateWithoutFieldsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubActivityFields = {
  __typename?: 'SubActivityFields';
  _count: SubActivityFieldsCountOutputType;
  activities: Array<Maybe<Activity>>;
  cmsId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  locations: Array<Maybe<Location>>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  subActivity?: Maybe<SubActivity>;
  subActivityId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type SubActivityFieldsActivitiesArgs = {
  cursor?: InputMaybe<ActivityWhereUniqueInput>;
  distinct?: InputMaybe<ActivityScalarFieldEnum>;
  orderBy?: InputMaybe<ActivityOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ActivityWhereInput>;
};


export type SubActivityFieldsLocationsArgs = {
  cursor?: InputMaybe<LocationWhereUniqueInput>;
  distinct?: InputMaybe<LocationScalarFieldEnum>;
  orderBy?: InputMaybe<LocationOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationWhereInput>;
};

export type SubActivityFieldsAvgAggregateOutputType = {
  __typename?: 'SubActivityFieldsAvgAggregateOutputType';
  order?: Maybe<Scalars['Float']>;
};

export type SubActivityFieldsAvgOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type SubActivityFieldsCountAggregateOutputType = {
  __typename?: 'SubActivityFieldsCountAggregateOutputType';
  _all: Scalars['Int'];
  cmsId: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  order: Scalars['Int'];
  pending: Scalars['Int'];
  published: Scalars['Int'];
  stack: Scalars['Int'];
  subActivityId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type SubActivityFieldsCountOrderByAggregateInput = {
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  subActivityId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SubActivityFieldsCountOutputType = {
  __typename?: 'SubActivityFieldsCountOutputType';
  activities: Scalars['Int'];
  locations: Scalars['Int'];
};

export type SubActivityFieldsCreateInput = {
  activities?: InputMaybe<ActivityCreateNestedManyWithoutSubActivitiesInput>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutSubActivitiesInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  subActivity?: InputMaybe<SubActivityCreateNestedOneWithoutFieldsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubActivityFieldsCreateManyInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  subActivityId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubActivityFieldsCreateManySubActivityInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubActivityFieldsCreateManySubActivityInputEnvelope = {
  data: Array<SubActivityFieldsCreateManySubActivityInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type SubActivityFieldsCreateNestedManyWithoutActivitiesInput = {
  connect?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubActivityFieldsCreateOrConnectWithoutActivitiesInput>>;
  create?: InputMaybe<Array<SubActivityFieldsCreateWithoutActivitiesInput>>;
};

export type SubActivityFieldsCreateNestedManyWithoutLocationsInput = {
  connect?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubActivityFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<SubActivityFieldsCreateWithoutLocationsInput>>;
};

export type SubActivityFieldsCreateNestedManyWithoutSubActivityInput = {
  connect?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubActivityFieldsCreateOrConnectWithoutSubActivityInput>>;
  create?: InputMaybe<Array<SubActivityFieldsCreateWithoutSubActivityInput>>;
  createMany?: InputMaybe<SubActivityFieldsCreateManySubActivityInputEnvelope>;
};

export type SubActivityFieldsCreateOrConnectWithoutActivitiesInput = {
  create: SubActivityFieldsUncheckedCreateWithoutActivitiesInput;
  where: SubActivityFieldsWhereUniqueInput;
};

export type SubActivityFieldsCreateOrConnectWithoutLocationsInput = {
  create: SubActivityFieldsUncheckedCreateWithoutLocationsInput;
  where: SubActivityFieldsWhereUniqueInput;
};

export type SubActivityFieldsCreateOrConnectWithoutSubActivityInput = {
  create: SubActivityFieldsUncheckedCreateWithoutSubActivityInput;
  where: SubActivityFieldsWhereUniqueInput;
};

export type SubActivityFieldsCreateWithoutActivitiesInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutSubActivitiesInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  subActivity?: InputMaybe<SubActivityCreateNestedOneWithoutFieldsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubActivityFieldsCreateWithoutLocationsInput = {
  activities?: InputMaybe<ActivityCreateNestedManyWithoutSubActivitiesInput>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  subActivity?: InputMaybe<SubActivityCreateNestedOneWithoutFieldsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubActivityFieldsCreateWithoutSubActivityInput = {
  activities?: InputMaybe<ActivityCreateNestedManyWithoutSubActivitiesInput>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutSubActivitiesInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubActivityFieldsListRelationFilter = {
  every?: InputMaybe<SubActivityFieldsWhereInput>;
  none?: InputMaybe<SubActivityFieldsWhereInput>;
  some?: InputMaybe<SubActivityFieldsWhereInput>;
};

export type SubActivityFieldsMaxAggregateOutputType = {
  __typename?: 'SubActivityFieldsMaxAggregateOutputType';
  cmsId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  stack?: Maybe<Scalars['String']>;
  subActivityId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SubActivityFieldsMaxOrderByAggregateInput = {
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  subActivityId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SubActivityFieldsMinAggregateOutputType = {
  __typename?: 'SubActivityFieldsMinAggregateOutputType';
  cmsId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  stack?: Maybe<Scalars['String']>;
  subActivityId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SubActivityFieldsMinOrderByAggregateInput = {
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  subActivityId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SubActivityFieldsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type SubActivityFieldsOrderByWithAggregationInput = {
  _avg?: InputMaybe<SubActivityFieldsAvgOrderByAggregateInput>;
  _count?: InputMaybe<SubActivityFieldsCountOrderByAggregateInput>;
  _max?: InputMaybe<SubActivityFieldsMaxOrderByAggregateInput>;
  _min?: InputMaybe<SubActivityFieldsMinOrderByAggregateInput>;
  _sum?: InputMaybe<SubActivityFieldsSumOrderByAggregateInput>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrderInput>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  stack?: InputMaybe<SortOrder>;
  subActivityId?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SubActivityFieldsOrderByWithRelationInput = {
  activities?: InputMaybe<ActivityOrderByRelationAggregateInput>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  locations?: InputMaybe<LocationOrderByRelationAggregateInput>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrderInput>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  stack?: InputMaybe<SortOrder>;
  subActivity?: InputMaybe<SubActivityOrderByWithRelationInput>;
  subActivityId?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum SubActivityFieldsScalarFieldEnum {
  CmsId = 'cmsId',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Name = 'name',
  Order = 'order',
  Pending = 'pending',
  Published = 'published',
  Stack = 'stack',
  SubActivityId = 'subActivityId',
  UpdatedAt = 'updatedAt'
}

export type SubActivityFieldsScalarWhereInput = {
  AND?: InputMaybe<Array<SubActivityFieldsScalarWhereInput>>;
  NOT?: InputMaybe<Array<SubActivityFieldsScalarWhereInput>>;
  OR?: InputMaybe<Array<SubActivityFieldsScalarWhereInput>>;
  cmsId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  stack?: InputMaybe<StringFilter>;
  subActivityId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SubActivityFieldsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<SubActivityFieldsScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<SubActivityFieldsScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<SubActivityFieldsScalarWhereWithAggregatesInput>>;
  cmsId?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  order?: InputMaybe<IntNullableWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  stack?: InputMaybe<StringWithAggregatesFilter>;
  subActivityId?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type SubActivityFieldsSumAggregateOutputType = {
  __typename?: 'SubActivityFieldsSumAggregateOutputType';
  order?: Maybe<Scalars['Int']>;
};

export type SubActivityFieldsSumOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type SubActivityFieldsUncheckedCreateInput = {
  activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutSubActivitiesInput>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationUncheckedCreateNestedManyWithoutSubActivitiesInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  subActivityId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubActivityFieldsUncheckedCreateNestedManyWithoutActivitiesInput = {
  connect?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubActivityFieldsCreateOrConnectWithoutActivitiesInput>>;
  create?: InputMaybe<Array<SubActivityFieldsCreateWithoutActivitiesInput>>;
};

export type SubActivityFieldsUncheckedCreateNestedManyWithoutLocationsInput = {
  connect?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubActivityFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<SubActivityFieldsCreateWithoutLocationsInput>>;
};

export type SubActivityFieldsUncheckedCreateNestedManyWithoutSubActivityInput = {
  connect?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubActivityFieldsCreateOrConnectWithoutSubActivityInput>>;
  create?: InputMaybe<Array<SubActivityFieldsCreateWithoutSubActivityInput>>;
  createMany?: InputMaybe<SubActivityFieldsCreateManySubActivityInputEnvelope>;
};

export type SubActivityFieldsUncheckedCreateWithoutActivitiesInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationUncheckedCreateNestedManyWithoutSubActivitiesInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  subActivityId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubActivityFieldsUncheckedCreateWithoutLocationsInput = {
  activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutSubActivitiesInput>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  subActivityId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubActivityFieldsUncheckedCreateWithoutSubActivityInput = {
  activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutSubActivitiesInput>;
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationUncheckedCreateNestedManyWithoutSubActivitiesInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubActivityFieldsUncheckedUpdateInput = {
  activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutSubActivitiesNestedInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUncheckedUpdateManyWithoutSubActivitiesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  subActivityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubActivityFieldsUncheckedUpdateManyInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  subActivityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubActivityFieldsUncheckedUpdateManyWithoutActivitiesNestedInput = {
  connect?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubActivityFieldsCreateOrConnectWithoutActivitiesInput>>;
  create?: InputMaybe<Array<SubActivityFieldsCreateWithoutActivitiesInput>>;
  delete?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SubActivityFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<SubActivityFieldsUpdateWithWhereUniqueWithoutActivitiesInput>>;
  updateMany?: InputMaybe<Array<SubActivityFieldsUpdateManyWithWhereWithoutActivitiesInput>>;
  upsert?: InputMaybe<Array<SubActivityFieldsUpsertWithWhereUniqueWithoutActivitiesInput>>;
};

export type SubActivityFieldsUncheckedUpdateManyWithoutFieldsInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubActivityFieldsUncheckedUpdateManyWithoutLocationsNestedInput = {
  connect?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubActivityFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<SubActivityFieldsCreateWithoutLocationsInput>>;
  delete?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SubActivityFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<SubActivityFieldsUpdateWithWhereUniqueWithoutLocationsInput>>;
  updateMany?: InputMaybe<Array<SubActivityFieldsUpdateManyWithWhereWithoutLocationsInput>>;
  upsert?: InputMaybe<Array<SubActivityFieldsUpsertWithWhereUniqueWithoutLocationsInput>>;
};

export type SubActivityFieldsUncheckedUpdateManyWithoutSubActivitiesInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  subActivityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubActivityFieldsUncheckedUpdateManyWithoutSubActivityNestedInput = {
  connect?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubActivityFieldsCreateOrConnectWithoutSubActivityInput>>;
  create?: InputMaybe<Array<SubActivityFieldsCreateWithoutSubActivityInput>>;
  createMany?: InputMaybe<SubActivityFieldsCreateManySubActivityInputEnvelope>;
  delete?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SubActivityFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<SubActivityFieldsUpdateWithWhereUniqueWithoutSubActivityInput>>;
  updateMany?: InputMaybe<Array<SubActivityFieldsUpdateManyWithWhereWithoutSubActivityInput>>;
  upsert?: InputMaybe<Array<SubActivityFieldsUpsertWithWhereUniqueWithoutSubActivityInput>>;
};

export type SubActivityFieldsUncheckedUpdateWithoutActivitiesInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUncheckedUpdateManyWithoutSubActivitiesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  subActivityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubActivityFieldsUncheckedUpdateWithoutLocationsInput = {
  activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutSubActivitiesNestedInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  subActivityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubActivityFieldsUncheckedUpdateWithoutSubActivityInput = {
  activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutSubActivitiesNestedInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUncheckedUpdateManyWithoutSubActivitiesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubActivityFieldsUpdateInput = {
  activities?: InputMaybe<ActivityUpdateManyWithoutSubActivitiesNestedInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutSubActivitiesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  subActivity?: InputMaybe<SubActivityUpdateOneWithoutFieldsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubActivityFieldsUpdateManyMutationInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubActivityFieldsUpdateManyWithWhereWithoutActivitiesInput = {
  data: SubActivityFieldsUncheckedUpdateManyWithoutSubActivitiesInput;
  where: SubActivityFieldsScalarWhereInput;
};

export type SubActivityFieldsUpdateManyWithWhereWithoutLocationsInput = {
  data: SubActivityFieldsUncheckedUpdateManyWithoutSubActivitiesInput;
  where: SubActivityFieldsScalarWhereInput;
};

export type SubActivityFieldsUpdateManyWithWhereWithoutSubActivityInput = {
  data: SubActivityFieldsUncheckedUpdateManyWithoutFieldsInput;
  where: SubActivityFieldsScalarWhereInput;
};

export type SubActivityFieldsUpdateManyWithoutActivitiesNestedInput = {
  connect?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubActivityFieldsCreateOrConnectWithoutActivitiesInput>>;
  create?: InputMaybe<Array<SubActivityFieldsCreateWithoutActivitiesInput>>;
  delete?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SubActivityFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<SubActivityFieldsUpdateWithWhereUniqueWithoutActivitiesInput>>;
  updateMany?: InputMaybe<Array<SubActivityFieldsUpdateManyWithWhereWithoutActivitiesInput>>;
  upsert?: InputMaybe<Array<SubActivityFieldsUpsertWithWhereUniqueWithoutActivitiesInput>>;
};

export type SubActivityFieldsUpdateManyWithoutLocationsNestedInput = {
  connect?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubActivityFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<SubActivityFieldsCreateWithoutLocationsInput>>;
  delete?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SubActivityFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<SubActivityFieldsUpdateWithWhereUniqueWithoutLocationsInput>>;
  updateMany?: InputMaybe<Array<SubActivityFieldsUpdateManyWithWhereWithoutLocationsInput>>;
  upsert?: InputMaybe<Array<SubActivityFieldsUpsertWithWhereUniqueWithoutLocationsInput>>;
};

export type SubActivityFieldsUpdateManyWithoutSubActivityNestedInput = {
  connect?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubActivityFieldsCreateOrConnectWithoutSubActivityInput>>;
  create?: InputMaybe<Array<SubActivityFieldsCreateWithoutSubActivityInput>>;
  createMany?: InputMaybe<SubActivityFieldsCreateManySubActivityInputEnvelope>;
  delete?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SubActivityFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<SubActivityFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<SubActivityFieldsUpdateWithWhereUniqueWithoutSubActivityInput>>;
  updateMany?: InputMaybe<Array<SubActivityFieldsUpdateManyWithWhereWithoutSubActivityInput>>;
  upsert?: InputMaybe<Array<SubActivityFieldsUpsertWithWhereUniqueWithoutSubActivityInput>>;
};

export type SubActivityFieldsUpdateWithWhereUniqueWithoutActivitiesInput = {
  data: SubActivityFieldsUncheckedUpdateWithoutActivitiesInput;
  where: SubActivityFieldsWhereUniqueInput;
};

export type SubActivityFieldsUpdateWithWhereUniqueWithoutLocationsInput = {
  data: SubActivityFieldsUncheckedUpdateWithoutLocationsInput;
  where: SubActivityFieldsWhereUniqueInput;
};

export type SubActivityFieldsUpdateWithWhereUniqueWithoutSubActivityInput = {
  data: SubActivityFieldsUncheckedUpdateWithoutSubActivityInput;
  where: SubActivityFieldsWhereUniqueInput;
};

export type SubActivityFieldsUpdateWithoutActivitiesInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutSubActivitiesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  subActivity?: InputMaybe<SubActivityUpdateOneWithoutFieldsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubActivityFieldsUpdateWithoutLocationsInput = {
  activities?: InputMaybe<ActivityUpdateManyWithoutSubActivitiesNestedInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  subActivity?: InputMaybe<SubActivityUpdateOneWithoutFieldsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubActivityFieldsUpdateWithoutSubActivityInput = {
  activities?: InputMaybe<ActivityUpdateManyWithoutSubActivitiesNestedInput>;
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutSubActivitiesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubActivityFieldsUpsertWithWhereUniqueWithoutActivitiesInput = {
  create: SubActivityFieldsUncheckedCreateWithoutActivitiesInput;
  update: SubActivityFieldsUncheckedUpdateWithoutActivitiesInput;
  where: SubActivityFieldsWhereUniqueInput;
};

export type SubActivityFieldsUpsertWithWhereUniqueWithoutLocationsInput = {
  create: SubActivityFieldsUncheckedCreateWithoutLocationsInput;
  update: SubActivityFieldsUncheckedUpdateWithoutLocationsInput;
  where: SubActivityFieldsWhereUniqueInput;
};

export type SubActivityFieldsUpsertWithWhereUniqueWithoutSubActivityInput = {
  create: SubActivityFieldsUncheckedCreateWithoutSubActivityInput;
  update: SubActivityFieldsUncheckedUpdateWithoutSubActivityInput;
  where: SubActivityFieldsWhereUniqueInput;
};

export type SubActivityFieldsWhereInput = {
  AND?: InputMaybe<Array<SubActivityFieldsWhereInput>>;
  NOT?: InputMaybe<Array<SubActivityFieldsWhereInput>>;
  OR?: InputMaybe<Array<SubActivityFieldsWhereInput>>;
  activities?: InputMaybe<ActivityListRelationFilter>;
  cmsId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  locations?: InputMaybe<LocationListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  stack?: InputMaybe<StringFilter>;
  subActivity?: InputMaybe<SubActivityWhereInput>;
  subActivityId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SubActivityFieldsWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type SubActivityMaxAggregateOutputType = {
  __typename?: 'SubActivityMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SubActivityMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SubActivityMinAggregateOutputType = {
  __typename?: 'SubActivityMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SubActivityMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SubActivityOrderByWithAggregationInput = {
  _count?: InputMaybe<SubActivityCountOrderByAggregateInput>;
  _max?: InputMaybe<SubActivityMaxOrderByAggregateInput>;
  _min?: InputMaybe<SubActivityMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SubActivityOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  fields?: InputMaybe<SubActivityFieldsOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SubActivityRelationFilter = {
  is?: InputMaybe<SubActivityWhereInput>;
  isNot?: InputMaybe<SubActivityWhereInput>;
};

export enum SubActivityScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Pending = 'pending',
  Published = 'published',
  Reference = 'reference',
  UpdatedAt = 'updatedAt'
}

export type SubActivityScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<SubActivityScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<SubActivityScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<SubActivityScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  reference?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type SubActivityUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<SubActivityFieldsUncheckedCreateNestedManyWithoutSubActivityInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubActivityUncheckedCreateWithoutFieldsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubActivityUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<SubActivityFieldsUncheckedUpdateManyWithoutSubActivityNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubActivityUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubActivityUncheckedUpdateWithoutFieldsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubActivityUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<SubActivityFieldsUpdateManyWithoutSubActivityNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubActivityUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubActivityUpdateOneWithoutFieldsNestedInput = {
  connect?: InputMaybe<SubActivityWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SubActivityCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<SubActivityUncheckedCreateWithoutFieldsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<SubActivityUncheckedUpdateWithoutFieldsInput>;
  upsert?: InputMaybe<SubActivityUpsertWithoutFieldsInput>;
};

export type SubActivityUpdateWithoutFieldsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubActivityUpsertWithoutFieldsInput = {
  create: SubActivityUncheckedCreateWithoutFieldsInput;
  update: SubActivityUncheckedUpdateWithoutFieldsInput;
};

export type SubActivityWhereInput = {
  AND?: InputMaybe<Array<SubActivityWhereInput>>;
  NOT?: InputMaybe<Array<SubActivityWhereInput>>;
  OR?: InputMaybe<Array<SubActivityWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fields?: InputMaybe<SubActivityFieldsListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  reference?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SubActivityWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type SubProduct = {
  __typename?: 'SubProduct';
  _count: SubProductCountOutputType;
  activities: Array<Maybe<ActivityFields>>;
  createdAt: Scalars['DateTime'];
  fields: Array<Maybe<SubProductFields>>;
  id: Scalars['String'];
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type SubProductActivitiesArgs = {
  cursor?: InputMaybe<ActivityFieldsWhereUniqueInput>;
  distinct?: InputMaybe<ActivityFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<ActivityFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ActivityFieldsWhereInput>;
};


export type SubProductFieldsArgs = {
  cursor?: InputMaybe<SubProductFieldsWhereUniqueInput>;
  distinct?: InputMaybe<SubProductFieldsScalarFieldEnum>;
  orderBy?: InputMaybe<SubProductFieldsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SubProductFieldsWhereInput>;
};

export type SubProductCountAggregateOutputType = {
  __typename?: 'SubProductCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  pending: Scalars['Int'];
  published: Scalars['Int'];
  reference: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type SubProductCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SubProductCountOutputType = {
  __typename?: 'SubProductCountOutputType';
  activities: Scalars['Int'];
  fields: Scalars['Int'];
};

export type SubProductCreateInput = {
  activities?: InputMaybe<ActivityFieldsCreateNestedManyWithoutSubProductsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<SubProductFieldsCreateNestedManyWithoutSubProductInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubProductCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubProductCreateNestedManyWithoutActivitiesInput = {
  connect?: InputMaybe<Array<SubProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubProductCreateOrConnectWithoutActivitiesInput>>;
  create?: InputMaybe<Array<SubProductCreateWithoutActivitiesInput>>;
};

export type SubProductCreateNestedOneWithoutFieldsInput = {
  connect?: InputMaybe<SubProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SubProductCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<SubProductUncheckedCreateWithoutFieldsInput>;
};

export type SubProductCreateOrConnectWithoutActivitiesInput = {
  create: SubProductUncheckedCreateWithoutActivitiesInput;
  where: SubProductWhereUniqueInput;
};

export type SubProductCreateOrConnectWithoutFieldsInput = {
  create: SubProductUncheckedCreateWithoutFieldsInput;
  where: SubProductWhereUniqueInput;
};

export type SubProductCreateWithoutActivitiesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<SubProductFieldsCreateNestedManyWithoutSubProductInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubProductCreateWithoutFieldsInput = {
  activities?: InputMaybe<ActivityFieldsCreateNestedManyWithoutSubProductsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubProductFields = {
  __typename?: 'SubProductFields';
  _count: SubProductFieldsCountOutputType;
  cmsId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  locations: Array<Maybe<Location>>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  products: Array<Maybe<Product>>;
  published?: Maybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  subProduct?: Maybe<SubProduct>;
  subProductId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type SubProductFieldsLocationsArgs = {
  cursor?: InputMaybe<LocationWhereUniqueInput>;
  distinct?: InputMaybe<LocationScalarFieldEnum>;
  orderBy?: InputMaybe<LocationOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationWhereInput>;
};


export type SubProductFieldsProductsArgs = {
  cursor?: InputMaybe<ProductWhereUniqueInput>;
  distinct?: InputMaybe<ProductScalarFieldEnum>;
  orderBy?: InputMaybe<ProductOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductWhereInput>;
};

export type SubProductFieldsAvgAggregateOutputType = {
  __typename?: 'SubProductFieldsAvgAggregateOutputType';
  order?: Maybe<Scalars['Float']>;
};

export type SubProductFieldsAvgOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type SubProductFieldsCountAggregateOutputType = {
  __typename?: 'SubProductFieldsCountAggregateOutputType';
  _all: Scalars['Int'];
  cmsId: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  order: Scalars['Int'];
  pending: Scalars['Int'];
  published: Scalars['Int'];
  stack: Scalars['Int'];
  subProductId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type SubProductFieldsCountOrderByAggregateInput = {
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  subProductId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SubProductFieldsCountOutputType = {
  __typename?: 'SubProductFieldsCountOutputType';
  locations: Scalars['Int'];
  products: Scalars['Int'];
};

export type SubProductFieldsCreateInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutSubProductsInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductCreateNestedManyWithoutSubProductsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  subProduct?: InputMaybe<SubProductCreateNestedOneWithoutFieldsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubProductFieldsCreateManyInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  subProductId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubProductFieldsCreateManySubProductInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubProductFieldsCreateManySubProductInputEnvelope = {
  data: Array<SubProductFieldsCreateManySubProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type SubProductFieldsCreateNestedManyWithoutLocationsInput = {
  connect?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubProductFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<SubProductFieldsCreateWithoutLocationsInput>>;
};

export type SubProductFieldsCreateNestedManyWithoutProductsInput = {
  connect?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubProductFieldsCreateOrConnectWithoutProductsInput>>;
  create?: InputMaybe<Array<SubProductFieldsCreateWithoutProductsInput>>;
};

export type SubProductFieldsCreateNestedManyWithoutSubProductInput = {
  connect?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubProductFieldsCreateOrConnectWithoutSubProductInput>>;
  create?: InputMaybe<Array<SubProductFieldsCreateWithoutSubProductInput>>;
  createMany?: InputMaybe<SubProductFieldsCreateManySubProductInputEnvelope>;
};

export type SubProductFieldsCreateOrConnectWithoutLocationsInput = {
  create: SubProductFieldsUncheckedCreateWithoutLocationsInput;
  where: SubProductFieldsWhereUniqueInput;
};

export type SubProductFieldsCreateOrConnectWithoutProductsInput = {
  create: SubProductFieldsUncheckedCreateWithoutProductsInput;
  where: SubProductFieldsWhereUniqueInput;
};

export type SubProductFieldsCreateOrConnectWithoutSubProductInput = {
  create: SubProductFieldsUncheckedCreateWithoutSubProductInput;
  where: SubProductFieldsWhereUniqueInput;
};

export type SubProductFieldsCreateWithoutLocationsInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductCreateNestedManyWithoutSubProductsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  subProduct?: InputMaybe<SubProductCreateNestedOneWithoutFieldsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubProductFieldsCreateWithoutProductsInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutSubProductsInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  subProduct?: InputMaybe<SubProductCreateNestedOneWithoutFieldsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubProductFieldsCreateWithoutSubProductInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutSubProductsInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductCreateNestedManyWithoutSubProductsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubProductFieldsListRelationFilter = {
  every?: InputMaybe<SubProductFieldsWhereInput>;
  none?: InputMaybe<SubProductFieldsWhereInput>;
  some?: InputMaybe<SubProductFieldsWhereInput>;
};

export type SubProductFieldsMaxAggregateOutputType = {
  __typename?: 'SubProductFieldsMaxAggregateOutputType';
  cmsId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  stack?: Maybe<Scalars['String']>;
  subProductId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SubProductFieldsMaxOrderByAggregateInput = {
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  subProductId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SubProductFieldsMinAggregateOutputType = {
  __typename?: 'SubProductFieldsMinAggregateOutputType';
  cmsId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  stack?: Maybe<Scalars['String']>;
  subProductId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SubProductFieldsMinOrderByAggregateInput = {
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  stack?: InputMaybe<SortOrder>;
  subProductId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SubProductFieldsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type SubProductFieldsOrderByWithAggregationInput = {
  _avg?: InputMaybe<SubProductFieldsAvgOrderByAggregateInput>;
  _count?: InputMaybe<SubProductFieldsCountOrderByAggregateInput>;
  _max?: InputMaybe<SubProductFieldsMaxOrderByAggregateInput>;
  _min?: InputMaybe<SubProductFieldsMinOrderByAggregateInput>;
  _sum?: InputMaybe<SubProductFieldsSumOrderByAggregateInput>;
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrderInput>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  stack?: InputMaybe<SortOrder>;
  subProductId?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SubProductFieldsOrderByWithRelationInput = {
  cmsId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  locations?: InputMaybe<LocationOrderByRelationAggregateInput>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrderInput>;
  pending?: InputMaybe<SortOrderInput>;
  products?: InputMaybe<ProductOrderByRelationAggregateInput>;
  published?: InputMaybe<SortOrderInput>;
  stack?: InputMaybe<SortOrder>;
  subProduct?: InputMaybe<SubProductOrderByWithRelationInput>;
  subProductId?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum SubProductFieldsScalarFieldEnum {
  CmsId = 'cmsId',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Name = 'name',
  Order = 'order',
  Pending = 'pending',
  Published = 'published',
  Stack = 'stack',
  SubProductId = 'subProductId',
  UpdatedAt = 'updatedAt'
}

export type SubProductFieldsScalarWhereInput = {
  AND?: InputMaybe<Array<SubProductFieldsScalarWhereInput>>;
  NOT?: InputMaybe<Array<SubProductFieldsScalarWhereInput>>;
  OR?: InputMaybe<Array<SubProductFieldsScalarWhereInput>>;
  cmsId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  stack?: InputMaybe<StringFilter>;
  subProductId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SubProductFieldsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<SubProductFieldsScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<SubProductFieldsScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<SubProductFieldsScalarWhereWithAggregatesInput>>;
  cmsId?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  order?: InputMaybe<IntNullableWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  stack?: InputMaybe<StringWithAggregatesFilter>;
  subProductId?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type SubProductFieldsSumAggregateOutputType = {
  __typename?: 'SubProductFieldsSumAggregateOutputType';
  order?: Maybe<Scalars['Int']>;
};

export type SubProductFieldsSumOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type SubProductFieldsUncheckedCreateInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationUncheckedCreateNestedManyWithoutSubProductsInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductUncheckedCreateNestedManyWithoutSubProductsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  subProductId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubProductFieldsUncheckedCreateNestedManyWithoutLocationsInput = {
  connect?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubProductFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<SubProductFieldsCreateWithoutLocationsInput>>;
};

export type SubProductFieldsUncheckedCreateNestedManyWithoutProductsInput = {
  connect?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubProductFieldsCreateOrConnectWithoutProductsInput>>;
  create?: InputMaybe<Array<SubProductFieldsCreateWithoutProductsInput>>;
};

export type SubProductFieldsUncheckedCreateNestedManyWithoutSubProductInput = {
  connect?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubProductFieldsCreateOrConnectWithoutSubProductInput>>;
  create?: InputMaybe<Array<SubProductFieldsCreateWithoutSubProductInput>>;
  createMany?: InputMaybe<SubProductFieldsCreateManySubProductInputEnvelope>;
};

export type SubProductFieldsUncheckedCreateWithoutLocationsInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductUncheckedCreateNestedManyWithoutSubProductsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  subProductId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubProductFieldsUncheckedCreateWithoutProductsInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationUncheckedCreateNestedManyWithoutSubProductsInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  subProductId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubProductFieldsUncheckedCreateWithoutSubProductInput = {
  cmsId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationUncheckedCreateNestedManyWithoutSubProductsInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  products?: InputMaybe<ProductUncheckedCreateNestedManyWithoutSubProductsInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  stack: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubProductFieldsUncheckedUpdateInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUncheckedUpdateManyWithoutSubProductsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductUncheckedUpdateManyWithoutSubProductsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  subProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubProductFieldsUncheckedUpdateManyInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  subProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubProductFieldsUncheckedUpdateManyWithoutFieldsInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubProductFieldsUncheckedUpdateManyWithoutLocationsNestedInput = {
  connect?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubProductFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<SubProductFieldsCreateWithoutLocationsInput>>;
  delete?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SubProductFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<SubProductFieldsUpdateWithWhereUniqueWithoutLocationsInput>>;
  updateMany?: InputMaybe<Array<SubProductFieldsUpdateManyWithWhereWithoutLocationsInput>>;
  upsert?: InputMaybe<Array<SubProductFieldsUpsertWithWhereUniqueWithoutLocationsInput>>;
};

export type SubProductFieldsUncheckedUpdateManyWithoutProductsNestedInput = {
  connect?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubProductFieldsCreateOrConnectWithoutProductsInput>>;
  create?: InputMaybe<Array<SubProductFieldsCreateWithoutProductsInput>>;
  delete?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SubProductFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<SubProductFieldsUpdateWithWhereUniqueWithoutProductsInput>>;
  updateMany?: InputMaybe<Array<SubProductFieldsUpdateManyWithWhereWithoutProductsInput>>;
  upsert?: InputMaybe<Array<SubProductFieldsUpsertWithWhereUniqueWithoutProductsInput>>;
};

export type SubProductFieldsUncheckedUpdateManyWithoutSubProductNestedInput = {
  connect?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubProductFieldsCreateOrConnectWithoutSubProductInput>>;
  create?: InputMaybe<Array<SubProductFieldsCreateWithoutSubProductInput>>;
  createMany?: InputMaybe<SubProductFieldsCreateManySubProductInputEnvelope>;
  delete?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SubProductFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<SubProductFieldsUpdateWithWhereUniqueWithoutSubProductInput>>;
  updateMany?: InputMaybe<Array<SubProductFieldsUpdateManyWithWhereWithoutSubProductInput>>;
  upsert?: InputMaybe<Array<SubProductFieldsUpsertWithWhereUniqueWithoutSubProductInput>>;
};

export type SubProductFieldsUncheckedUpdateManyWithoutSubProductsInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  subProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubProductFieldsUncheckedUpdateWithoutLocationsInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductUncheckedUpdateManyWithoutSubProductsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  subProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubProductFieldsUncheckedUpdateWithoutProductsInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUncheckedUpdateManyWithoutSubProductsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  subProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubProductFieldsUncheckedUpdateWithoutSubProductInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUncheckedUpdateManyWithoutSubProductsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductUncheckedUpdateManyWithoutSubProductsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubProductFieldsUpdateInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutSubProductsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductUpdateManyWithoutSubProductsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  subProduct?: InputMaybe<SubProductUpdateOneWithoutFieldsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubProductFieldsUpdateManyMutationInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubProductFieldsUpdateManyWithWhereWithoutLocationsInput = {
  data: SubProductFieldsUncheckedUpdateManyWithoutSubProductsInput;
  where: SubProductFieldsScalarWhereInput;
};

export type SubProductFieldsUpdateManyWithWhereWithoutProductsInput = {
  data: SubProductFieldsUncheckedUpdateManyWithoutSubProductsInput;
  where: SubProductFieldsScalarWhereInput;
};

export type SubProductFieldsUpdateManyWithWhereWithoutSubProductInput = {
  data: SubProductFieldsUncheckedUpdateManyWithoutFieldsInput;
  where: SubProductFieldsScalarWhereInput;
};

export type SubProductFieldsUpdateManyWithoutLocationsNestedInput = {
  connect?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubProductFieldsCreateOrConnectWithoutLocationsInput>>;
  create?: InputMaybe<Array<SubProductFieldsCreateWithoutLocationsInput>>;
  delete?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SubProductFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<SubProductFieldsUpdateWithWhereUniqueWithoutLocationsInput>>;
  updateMany?: InputMaybe<Array<SubProductFieldsUpdateManyWithWhereWithoutLocationsInput>>;
  upsert?: InputMaybe<Array<SubProductFieldsUpsertWithWhereUniqueWithoutLocationsInput>>;
};

export type SubProductFieldsUpdateManyWithoutProductsNestedInput = {
  connect?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubProductFieldsCreateOrConnectWithoutProductsInput>>;
  create?: InputMaybe<Array<SubProductFieldsCreateWithoutProductsInput>>;
  delete?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SubProductFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<SubProductFieldsUpdateWithWhereUniqueWithoutProductsInput>>;
  updateMany?: InputMaybe<Array<SubProductFieldsUpdateManyWithWhereWithoutProductsInput>>;
  upsert?: InputMaybe<Array<SubProductFieldsUpsertWithWhereUniqueWithoutProductsInput>>;
};

export type SubProductFieldsUpdateManyWithoutSubProductNestedInput = {
  connect?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubProductFieldsCreateOrConnectWithoutSubProductInput>>;
  create?: InputMaybe<Array<SubProductFieldsCreateWithoutSubProductInput>>;
  createMany?: InputMaybe<SubProductFieldsCreateManySubProductInputEnvelope>;
  delete?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SubProductFieldsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  set?: InputMaybe<Array<SubProductFieldsWhereUniqueInput>>;
  update?: InputMaybe<Array<SubProductFieldsUpdateWithWhereUniqueWithoutSubProductInput>>;
  updateMany?: InputMaybe<Array<SubProductFieldsUpdateManyWithWhereWithoutSubProductInput>>;
  upsert?: InputMaybe<Array<SubProductFieldsUpsertWithWhereUniqueWithoutSubProductInput>>;
};

export type SubProductFieldsUpdateWithWhereUniqueWithoutLocationsInput = {
  data: SubProductFieldsUncheckedUpdateWithoutLocationsInput;
  where: SubProductFieldsWhereUniqueInput;
};

export type SubProductFieldsUpdateWithWhereUniqueWithoutProductsInput = {
  data: SubProductFieldsUncheckedUpdateWithoutProductsInput;
  where: SubProductFieldsWhereUniqueInput;
};

export type SubProductFieldsUpdateWithWhereUniqueWithoutSubProductInput = {
  data: SubProductFieldsUncheckedUpdateWithoutSubProductInput;
  where: SubProductFieldsWhereUniqueInput;
};

export type SubProductFieldsUpdateWithoutLocationsInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductUpdateManyWithoutSubProductsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  subProduct?: InputMaybe<SubProductUpdateOneWithoutFieldsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubProductFieldsUpdateWithoutProductsInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutSubProductsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  subProduct?: InputMaybe<SubProductUpdateOneWithoutFieldsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubProductFieldsUpdateWithoutSubProductInput = {
  cmsId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutSubProductsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductUpdateManyWithoutSubProductsNestedInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stack?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubProductFieldsUpsertWithWhereUniqueWithoutLocationsInput = {
  create: SubProductFieldsUncheckedCreateWithoutLocationsInput;
  update: SubProductFieldsUncheckedUpdateWithoutLocationsInput;
  where: SubProductFieldsWhereUniqueInput;
};

export type SubProductFieldsUpsertWithWhereUniqueWithoutProductsInput = {
  create: SubProductFieldsUncheckedCreateWithoutProductsInput;
  update: SubProductFieldsUncheckedUpdateWithoutProductsInput;
  where: SubProductFieldsWhereUniqueInput;
};

export type SubProductFieldsUpsertWithWhereUniqueWithoutSubProductInput = {
  create: SubProductFieldsUncheckedCreateWithoutSubProductInput;
  update: SubProductFieldsUncheckedUpdateWithoutSubProductInput;
  where: SubProductFieldsWhereUniqueInput;
};

export type SubProductFieldsWhereInput = {
  AND?: InputMaybe<Array<SubProductFieldsWhereInput>>;
  NOT?: InputMaybe<Array<SubProductFieldsWhereInput>>;
  OR?: InputMaybe<Array<SubProductFieldsWhereInput>>;
  cmsId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  locations?: InputMaybe<LocationListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  products?: InputMaybe<ProductListRelationFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  stack?: InputMaybe<StringFilter>;
  subProduct?: InputMaybe<SubProductWhereInput>;
  subProductId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SubProductFieldsWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type SubProductListRelationFilter = {
  every?: InputMaybe<SubProductWhereInput>;
  none?: InputMaybe<SubProductWhereInput>;
  some?: InputMaybe<SubProductWhereInput>;
};

export type SubProductMaxAggregateOutputType = {
  __typename?: 'SubProductMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SubProductMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SubProductMinAggregateOutputType = {
  __typename?: 'SubProductMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SubProductMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SubProductOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type SubProductOrderByWithAggregationInput = {
  _count?: InputMaybe<SubProductCountOrderByAggregateInput>;
  _max?: InputMaybe<SubProductMaxOrderByAggregateInput>;
  _min?: InputMaybe<SubProductMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SubProductOrderByWithRelationInput = {
  activities?: InputMaybe<ActivityFieldsOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  fields?: InputMaybe<SubProductFieldsOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  pending?: InputMaybe<SortOrderInput>;
  published?: InputMaybe<SortOrderInput>;
  reference?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SubProductRelationFilter = {
  is?: InputMaybe<SubProductWhereInput>;
  isNot?: InputMaybe<SubProductWhereInput>;
};

export enum SubProductScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Pending = 'pending',
  Published = 'published',
  Reference = 'reference',
  UpdatedAt = 'updatedAt'
}

export type SubProductScalarWhereInput = {
  AND?: InputMaybe<Array<SubProductScalarWhereInput>>;
  NOT?: InputMaybe<Array<SubProductScalarWhereInput>>;
  OR?: InputMaybe<Array<SubProductScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  reference?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SubProductScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<SubProductScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<SubProductScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<SubProductScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  pending?: InputMaybe<BoolNullableWithAggregatesFilter>;
  published?: InputMaybe<BoolNullableWithAggregatesFilter>;
  reference?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type SubProductUncheckedCreateInput = {
  activities?: InputMaybe<ActivityFieldsUncheckedCreateNestedManyWithoutSubProductsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<SubProductFieldsUncheckedCreateNestedManyWithoutSubProductInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubProductUncheckedCreateNestedManyWithoutActivitiesInput = {
  connect?: InputMaybe<Array<SubProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubProductCreateOrConnectWithoutActivitiesInput>>;
  create?: InputMaybe<Array<SubProductCreateWithoutActivitiesInput>>;
};

export type SubProductUncheckedCreateWithoutActivitiesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fields?: InputMaybe<SubProductFieldsUncheckedCreateNestedManyWithoutSubProductInput>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubProductUncheckedCreateWithoutFieldsInput = {
  activities?: InputMaybe<ActivityFieldsUncheckedCreateNestedManyWithoutSubProductsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  pending?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubProductUncheckedUpdateInput = {
  activities?: InputMaybe<ActivityFieldsUncheckedUpdateManyWithoutSubProductsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<SubProductFieldsUncheckedUpdateManyWithoutSubProductNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubProductUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubProductUncheckedUpdateManyWithoutActivitiesNestedInput = {
  connect?: InputMaybe<Array<SubProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubProductCreateOrConnectWithoutActivitiesInput>>;
  create?: InputMaybe<Array<SubProductCreateWithoutActivitiesInput>>;
  delete?: InputMaybe<Array<SubProductWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SubProductScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SubProductWhereUniqueInput>>;
  set?: InputMaybe<Array<SubProductWhereUniqueInput>>;
  update?: InputMaybe<Array<SubProductUpdateWithWhereUniqueWithoutActivitiesInput>>;
  updateMany?: InputMaybe<Array<SubProductUpdateManyWithWhereWithoutActivitiesInput>>;
  upsert?: InputMaybe<Array<SubProductUpsertWithWhereUniqueWithoutActivitiesInput>>;
};

export type SubProductUncheckedUpdateManyWithoutSubProductsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubProductUncheckedUpdateWithoutActivitiesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<SubProductFieldsUncheckedUpdateManyWithoutSubProductNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubProductUncheckedUpdateWithoutFieldsInput = {
  activities?: InputMaybe<ActivityFieldsUncheckedUpdateManyWithoutSubProductsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubProductUpdateInput = {
  activities?: InputMaybe<ActivityFieldsUpdateManyWithoutSubProductsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<SubProductFieldsUpdateManyWithoutSubProductNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubProductUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubProductUpdateManyWithWhereWithoutActivitiesInput = {
  data: SubProductUncheckedUpdateManyWithoutSubProductsInput;
  where: SubProductScalarWhereInput;
};

export type SubProductUpdateManyWithoutActivitiesNestedInput = {
  connect?: InputMaybe<Array<SubProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubProductCreateOrConnectWithoutActivitiesInput>>;
  create?: InputMaybe<Array<SubProductCreateWithoutActivitiesInput>>;
  delete?: InputMaybe<Array<SubProductWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SubProductScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SubProductWhereUniqueInput>>;
  set?: InputMaybe<Array<SubProductWhereUniqueInput>>;
  update?: InputMaybe<Array<SubProductUpdateWithWhereUniqueWithoutActivitiesInput>>;
  updateMany?: InputMaybe<Array<SubProductUpdateManyWithWhereWithoutActivitiesInput>>;
  upsert?: InputMaybe<Array<SubProductUpsertWithWhereUniqueWithoutActivitiesInput>>;
};

export type SubProductUpdateOneWithoutFieldsNestedInput = {
  connect?: InputMaybe<SubProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SubProductCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<SubProductUncheckedCreateWithoutFieldsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<SubProductUncheckedUpdateWithoutFieldsInput>;
  upsert?: InputMaybe<SubProductUpsertWithoutFieldsInput>;
};

export type SubProductUpdateWithWhereUniqueWithoutActivitiesInput = {
  data: SubProductUncheckedUpdateWithoutActivitiesInput;
  where: SubProductWhereUniqueInput;
};

export type SubProductUpdateWithoutActivitiesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fields?: InputMaybe<SubProductFieldsUpdateManyWithoutSubProductNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubProductUpdateWithoutFieldsInput = {
  activities?: InputMaybe<ActivityFieldsUpdateManyWithoutSubProductsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pending?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SubProductUpsertWithWhereUniqueWithoutActivitiesInput = {
  create: SubProductUncheckedCreateWithoutActivitiesInput;
  update: SubProductUncheckedUpdateWithoutActivitiesInput;
  where: SubProductWhereUniqueInput;
};

export type SubProductUpsertWithoutFieldsInput = {
  create: SubProductUncheckedCreateWithoutFieldsInput;
  update: SubProductUncheckedUpdateWithoutFieldsInput;
};

export type SubProductWhereInput = {
  AND?: InputMaybe<Array<SubProductWhereInput>>;
  NOT?: InputMaybe<Array<SubProductWhereInput>>;
  OR?: InputMaybe<Array<SubProductWhereInput>>;
  activities?: InputMaybe<ActivityFieldsListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fields?: InputMaybe<SubProductFieldsListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  pending?: InputMaybe<BoolNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  reference?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SubProductWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export enum TransactionIsolationLevel {
  ReadCommitted = 'ReadCommitted',
  ReadUncommitted = 'ReadUncommitted',
  RepeatableRead = 'RepeatableRead',
  Serializable = 'Serializable'
}

export type User = {
  __typename?: 'User';
  activeCollaborationPermissionsCache?: Maybe<Scalars['String']>;
  activeCollaborationPermissionsReferenceCache?: Maybe<Scalars['String']>;
  authId: Scalars['String'];
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type UserOrderByWithRelationInput = {
  authId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type UserWhereInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  activeCollaborationPermissions?: InputMaybe<PermissionListRelationFilter>;
  authId?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
};

export type Version = {
  __typename?: 'Version';
  _count: VersionCountOutputType;
  active: Scalars['Boolean'];
  audits: Array<Maybe<Audit>>;
  changes?: Maybe<Scalars['Boolean']>;
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  documentCycle?: Maybe<DocumentCycle>;
  documentCycleId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  openChanges?: Maybe<Scalars['Boolean']>;
  originalContent?: Maybe<Scalars['String']>;
  previousVersion?: Maybe<Version>;
  previousVersionId?: Maybe<Scalars['String']>;
  processing?: Maybe<Scalars['Boolean']>;
  progressStatus?: Maybe<ProgressStatus>;
  subsequentVersions: Array<Maybe<Version>>;
  updatedAt: Scalars['DateTime'];
};


export type VersionAuditsArgs = {
  cursor?: InputMaybe<AuditWhereUniqueInput>;
  distinct?: InputMaybe<AuditScalarFieldEnum>;
  orderBy?: InputMaybe<AuditOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AuditWhereInput>;
};


export type VersionSubsequentVersionsArgs = {
  cursor?: InputMaybe<VersionWhereUniqueInput>;
  distinct?: InputMaybe<VersionScalarFieldEnum>;
  orderBy?: InputMaybe<VersionOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VersionWhereInput>;
};

export type VersionConnection = {
  __typename?: 'VersionConnection';
  aggregate: AggregateVersion;
  edges: Array<Maybe<VersionEdge>>;
  pageInfo: PageInfo;
};

export type VersionCountAggregateOutputType = {
  __typename?: 'VersionCountAggregateOutputType';
  _all: Scalars['Int'];
  active: Scalars['Int'];
  changes: Scalars['Int'];
  content: Scalars['Int'];
  createdAt: Scalars['Int'];
  documentCycleId: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  notes: Scalars['Int'];
  openChanges: Scalars['Int'];
  originalContent: Scalars['Int'];
  previousVersionId: Scalars['Int'];
  processing: Scalars['Int'];
  progressStatus: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type VersionCountOrderByAggregateInput = {
  active?: InputMaybe<SortOrder>;
  changes?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  documentCycleId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  notes?: InputMaybe<SortOrder>;
  openChanges?: InputMaybe<SortOrder>;
  originalContent?: InputMaybe<SortOrder>;
  previousVersionId?: InputMaybe<SortOrder>;
  processing?: InputMaybe<SortOrder>;
  progressStatus?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type VersionCountOutputType = {
  __typename?: 'VersionCountOutputType';
  audits: Scalars['Int'];
  subsequentVersions: Scalars['Int'];
};

export type VersionCreateInput = {
  active: Scalars['Boolean'];
  audits?: InputMaybe<AuditCreateNestedManyWithoutVersionInput>;
  changes?: InputMaybe<Scalars['Boolean']>;
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  documentCycle?: InputMaybe<DocumentCycleCreateNestedOneWithoutVersionsInput>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  openChanges?: InputMaybe<Scalars['Boolean']>;
  originalContent?: InputMaybe<Scalars['String']>;
  previousVersion?: InputMaybe<VersionCreateNestedOneWithoutSubsequentVersionsInput>;
  processing?: InputMaybe<Scalars['Boolean']>;
  progressStatus?: InputMaybe<ProgressStatus>;
  subsequentVersions?: InputMaybe<VersionCreateNestedManyWithoutPreviousVersionInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type VersionCreateManyDocumentCycleInput = {
  active: Scalars['Boolean'];
  changes?: InputMaybe<Scalars['Boolean']>;
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  openChanges?: InputMaybe<Scalars['Boolean']>;
  originalContent?: InputMaybe<Scalars['String']>;
  previousVersionId?: InputMaybe<Scalars['String']>;
  processing?: InputMaybe<Scalars['Boolean']>;
  progressStatus?: InputMaybe<ProgressStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type VersionCreateManyDocumentCycleInputEnvelope = {
  data: Array<VersionCreateManyDocumentCycleInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type VersionCreateManyInput = {
  active: Scalars['Boolean'];
  changes?: InputMaybe<Scalars['Boolean']>;
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  documentCycleId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  openChanges?: InputMaybe<Scalars['Boolean']>;
  originalContent?: InputMaybe<Scalars['String']>;
  previousVersionId?: InputMaybe<Scalars['String']>;
  processing?: InputMaybe<Scalars['Boolean']>;
  progressStatus?: InputMaybe<ProgressStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type VersionCreateManyPreviousVersionInput = {
  active: Scalars['Boolean'];
  changes?: InputMaybe<Scalars['Boolean']>;
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  documentCycleId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  openChanges?: InputMaybe<Scalars['Boolean']>;
  originalContent?: InputMaybe<Scalars['String']>;
  processing?: InputMaybe<Scalars['Boolean']>;
  progressStatus?: InputMaybe<ProgressStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type VersionCreateManyPreviousVersionInputEnvelope = {
  data: Array<VersionCreateManyPreviousVersionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type VersionCreateNestedManyWithoutDocumentCycleInput = {
  connect?: InputMaybe<Array<VersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<VersionCreateOrConnectWithoutDocumentCycleInput>>;
  create?: InputMaybe<Array<VersionCreateWithoutDocumentCycleInput>>;
  createMany?: InputMaybe<VersionCreateManyDocumentCycleInputEnvelope>;
};

export type VersionCreateNestedManyWithoutPreviousVersionInput = {
  connect?: InputMaybe<Array<VersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<VersionCreateOrConnectWithoutPreviousVersionInput>>;
  create?: InputMaybe<Array<VersionCreateWithoutPreviousVersionInput>>;
  createMany?: InputMaybe<VersionCreateManyPreviousVersionInputEnvelope>;
};

export type VersionCreateNestedOneWithoutAuditsInput = {
  connect?: InputMaybe<VersionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VersionCreateOrConnectWithoutAuditsInput>;
  create?: InputMaybe<VersionUncheckedCreateWithoutAuditsInput>;
};

export type VersionCreateNestedOneWithoutSubsequentVersionsInput = {
  connect?: InputMaybe<VersionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VersionCreateOrConnectWithoutSubsequentVersionsInput>;
  create?: InputMaybe<VersionUncheckedCreateWithoutSubsequentVersionsInput>;
};

export type VersionCreateOrConnectWithoutAuditsInput = {
  create: VersionUncheckedCreateWithoutAuditsInput;
  where: VersionWhereUniqueInput;
};

export type VersionCreateOrConnectWithoutDocumentCycleInput = {
  create: VersionUncheckedCreateWithoutDocumentCycleInput;
  where: VersionWhereUniqueInput;
};

export type VersionCreateOrConnectWithoutPreviousVersionInput = {
  create: VersionUncheckedCreateWithoutPreviousVersionInput;
  where: VersionWhereUniqueInput;
};

export type VersionCreateOrConnectWithoutSubsequentVersionsInput = {
  create: VersionUncheckedCreateWithoutSubsequentVersionsInput;
  where: VersionWhereUniqueInput;
};

export type VersionCreateWithoutAuditsInput = {
  active: Scalars['Boolean'];
  changes?: InputMaybe<Scalars['Boolean']>;
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  documentCycle?: InputMaybe<DocumentCycleCreateNestedOneWithoutVersionsInput>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  openChanges?: InputMaybe<Scalars['Boolean']>;
  originalContent?: InputMaybe<Scalars['String']>;
  previousVersion?: InputMaybe<VersionCreateNestedOneWithoutSubsequentVersionsInput>;
  processing?: InputMaybe<Scalars['Boolean']>;
  progressStatus?: InputMaybe<ProgressStatus>;
  subsequentVersions?: InputMaybe<VersionCreateNestedManyWithoutPreviousVersionInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type VersionCreateWithoutDocumentCycleInput = {
  active: Scalars['Boolean'];
  audits?: InputMaybe<AuditCreateNestedManyWithoutVersionInput>;
  changes?: InputMaybe<Scalars['Boolean']>;
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  openChanges?: InputMaybe<Scalars['Boolean']>;
  originalContent?: InputMaybe<Scalars['String']>;
  previousVersion?: InputMaybe<VersionCreateNestedOneWithoutSubsequentVersionsInput>;
  processing?: InputMaybe<Scalars['Boolean']>;
  progressStatus?: InputMaybe<ProgressStatus>;
  subsequentVersions?: InputMaybe<VersionCreateNestedManyWithoutPreviousVersionInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type VersionCreateWithoutPreviousVersionInput = {
  active: Scalars['Boolean'];
  audits?: InputMaybe<AuditCreateNestedManyWithoutVersionInput>;
  changes?: InputMaybe<Scalars['Boolean']>;
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  documentCycle?: InputMaybe<DocumentCycleCreateNestedOneWithoutVersionsInput>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  openChanges?: InputMaybe<Scalars['Boolean']>;
  originalContent?: InputMaybe<Scalars['String']>;
  processing?: InputMaybe<Scalars['Boolean']>;
  progressStatus?: InputMaybe<ProgressStatus>;
  subsequentVersions?: InputMaybe<VersionCreateNestedManyWithoutPreviousVersionInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type VersionCreateWithoutSubsequentVersionsInput = {
  active: Scalars['Boolean'];
  audits?: InputMaybe<AuditCreateNestedManyWithoutVersionInput>;
  changes?: InputMaybe<Scalars['Boolean']>;
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  documentCycle?: InputMaybe<DocumentCycleCreateNestedOneWithoutVersionsInput>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  openChanges?: InputMaybe<Scalars['Boolean']>;
  originalContent?: InputMaybe<Scalars['String']>;
  previousVersion?: InputMaybe<VersionCreateNestedOneWithoutSubsequentVersionsInput>;
  processing?: InputMaybe<Scalars['Boolean']>;
  progressStatus?: InputMaybe<ProgressStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type VersionEdge = {
  __typename?: 'VersionEdge';
  cursor: Scalars['String'];
  node: Version;
};

export type VersionListRelationFilter = {
  every?: InputMaybe<VersionWhereInput>;
  none?: InputMaybe<VersionWhereInput>;
  some?: InputMaybe<VersionWhereInput>;
};

export type VersionMaxAggregateOutputType = {
  __typename?: 'VersionMaxAggregateOutputType';
  active?: Maybe<Scalars['Boolean']>;
  changes?: Maybe<Scalars['Boolean']>;
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  documentCycleId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  openChanges?: Maybe<Scalars['Boolean']>;
  originalContent?: Maybe<Scalars['String']>;
  previousVersionId?: Maybe<Scalars['String']>;
  processing?: Maybe<Scalars['Boolean']>;
  progressStatus?: Maybe<ProgressStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VersionMaxOrderByAggregateInput = {
  active?: InputMaybe<SortOrder>;
  changes?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  documentCycleId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  notes?: InputMaybe<SortOrder>;
  openChanges?: InputMaybe<SortOrder>;
  originalContent?: InputMaybe<SortOrder>;
  previousVersionId?: InputMaybe<SortOrder>;
  processing?: InputMaybe<SortOrder>;
  progressStatus?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type VersionMinAggregateOutputType = {
  __typename?: 'VersionMinAggregateOutputType';
  active?: Maybe<Scalars['Boolean']>;
  changes?: Maybe<Scalars['Boolean']>;
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  documentCycleId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  openChanges?: Maybe<Scalars['Boolean']>;
  originalContent?: Maybe<Scalars['String']>;
  previousVersionId?: Maybe<Scalars['String']>;
  processing?: Maybe<Scalars['Boolean']>;
  progressStatus?: Maybe<ProgressStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VersionMinOrderByAggregateInput = {
  active?: InputMaybe<SortOrder>;
  changes?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  documentCycleId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  notes?: InputMaybe<SortOrder>;
  openChanges?: InputMaybe<SortOrder>;
  originalContent?: InputMaybe<SortOrder>;
  previousVersionId?: InputMaybe<SortOrder>;
  processing?: InputMaybe<SortOrder>;
  progressStatus?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type VersionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type VersionOrderByWithAggregationInput = {
  _count?: InputMaybe<VersionCountOrderByAggregateInput>;
  _max?: InputMaybe<VersionMaxOrderByAggregateInput>;
  _min?: InputMaybe<VersionMinOrderByAggregateInput>;
  active?: InputMaybe<SortOrder>;
  changes?: InputMaybe<SortOrderInput>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  documentCycleId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  notes?: InputMaybe<SortOrderInput>;
  openChanges?: InputMaybe<SortOrderInput>;
  originalContent?: InputMaybe<SortOrderInput>;
  previousVersionId?: InputMaybe<SortOrderInput>;
  processing?: InputMaybe<SortOrderInput>;
  progressStatus?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type VersionOrderByWithRelationInput = {
  active?: InputMaybe<SortOrder>;
  audits?: InputMaybe<AuditOrderByRelationAggregateInput>;
  changes?: InputMaybe<SortOrderInput>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  documentCycle?: InputMaybe<DocumentCycleOrderByWithRelationInput>;
  documentCycleId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  notes?: InputMaybe<SortOrderInput>;
  openChanges?: InputMaybe<SortOrderInput>;
  originalContent?: InputMaybe<SortOrderInput>;
  previousVersion?: InputMaybe<VersionOrderByWithRelationInput>;
  previousVersionId?: InputMaybe<SortOrderInput>;
  processing?: InputMaybe<SortOrderInput>;
  progressStatus?: InputMaybe<SortOrderInput>;
  subsequentVersions?: InputMaybe<VersionOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type VersionRelationFilter = {
  is?: InputMaybe<VersionWhereInput>;
  isNot?: InputMaybe<VersionWhereInput>;
};

export enum VersionScalarFieldEnum {
  Active = 'active',
  Changes = 'changes',
  Content = 'content',
  CreatedAt = 'createdAt',
  DocumentCycleId = 'documentCycleId',
  Id = 'id',
  Name = 'name',
  Notes = 'notes',
  OpenChanges = 'openChanges',
  OriginalContent = 'originalContent',
  PreviousVersionId = 'previousVersionId',
  Processing = 'processing',
  ProgressStatus = 'progressStatus',
  UpdatedAt = 'updatedAt'
}

export type VersionScalarWhereInput = {
  AND?: InputMaybe<Array<VersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<VersionScalarWhereInput>>;
  OR?: InputMaybe<Array<VersionScalarWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  changes?: InputMaybe<BoolNullableFilter>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentCycleId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  openChanges?: InputMaybe<BoolNullableFilter>;
  originalContent?: InputMaybe<StringNullableFilter>;
  previousVersionId?: InputMaybe<StringNullableFilter>;
  processing?: InputMaybe<BoolNullableFilter>;
  progressStatus?: InputMaybe<EnumProgressStatusNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type VersionScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<VersionScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<VersionScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<VersionScalarWhereWithAggregatesInput>>;
  active?: InputMaybe<BoolWithAggregatesFilter>;
  changes?: InputMaybe<BoolNullableWithAggregatesFilter>;
  content?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  documentCycleId?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  notes?: InputMaybe<StringNullableWithAggregatesFilter>;
  openChanges?: InputMaybe<BoolNullableWithAggregatesFilter>;
  originalContent?: InputMaybe<StringNullableWithAggregatesFilter>;
  previousVersionId?: InputMaybe<StringNullableWithAggregatesFilter>;
  processing?: InputMaybe<BoolNullableWithAggregatesFilter>;
  progressStatus?: InputMaybe<EnumProgressStatusNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type VersionUncheckedCreateInput = {
  active: Scalars['Boolean'];
  audits?: InputMaybe<AuditUncheckedCreateNestedManyWithoutVersionInput>;
  changes?: InputMaybe<Scalars['Boolean']>;
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  documentCycleId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  openChanges?: InputMaybe<Scalars['Boolean']>;
  originalContent?: InputMaybe<Scalars['String']>;
  previousVersionId?: InputMaybe<Scalars['String']>;
  processing?: InputMaybe<Scalars['Boolean']>;
  progressStatus?: InputMaybe<ProgressStatus>;
  subsequentVersions?: InputMaybe<VersionUncheckedCreateNestedManyWithoutPreviousVersionInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type VersionUncheckedCreateNestedManyWithoutDocumentCycleInput = {
  connect?: InputMaybe<Array<VersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<VersionCreateOrConnectWithoutDocumentCycleInput>>;
  create?: InputMaybe<Array<VersionCreateWithoutDocumentCycleInput>>;
  createMany?: InputMaybe<VersionCreateManyDocumentCycleInputEnvelope>;
};

export type VersionUncheckedCreateNestedManyWithoutPreviousVersionInput = {
  connect?: InputMaybe<Array<VersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<VersionCreateOrConnectWithoutPreviousVersionInput>>;
  create?: InputMaybe<Array<VersionCreateWithoutPreviousVersionInput>>;
  createMany?: InputMaybe<VersionCreateManyPreviousVersionInputEnvelope>;
};

export type VersionUncheckedCreateWithoutAuditsInput = {
  active: Scalars['Boolean'];
  changes?: InputMaybe<Scalars['Boolean']>;
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  documentCycleId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  openChanges?: InputMaybe<Scalars['Boolean']>;
  originalContent?: InputMaybe<Scalars['String']>;
  previousVersionId?: InputMaybe<Scalars['String']>;
  processing?: InputMaybe<Scalars['Boolean']>;
  progressStatus?: InputMaybe<ProgressStatus>;
  subsequentVersions?: InputMaybe<VersionUncheckedCreateNestedManyWithoutPreviousVersionInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type VersionUncheckedCreateWithoutDocumentCycleInput = {
  active: Scalars['Boolean'];
  audits?: InputMaybe<AuditUncheckedCreateNestedManyWithoutVersionInput>;
  changes?: InputMaybe<Scalars['Boolean']>;
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  openChanges?: InputMaybe<Scalars['Boolean']>;
  originalContent?: InputMaybe<Scalars['String']>;
  previousVersionId?: InputMaybe<Scalars['String']>;
  processing?: InputMaybe<Scalars['Boolean']>;
  progressStatus?: InputMaybe<ProgressStatus>;
  subsequentVersions?: InputMaybe<VersionUncheckedCreateNestedManyWithoutPreviousVersionInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type VersionUncheckedCreateWithoutPreviousVersionInput = {
  active: Scalars['Boolean'];
  audits?: InputMaybe<AuditUncheckedCreateNestedManyWithoutVersionInput>;
  changes?: InputMaybe<Scalars['Boolean']>;
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  documentCycleId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  openChanges?: InputMaybe<Scalars['Boolean']>;
  originalContent?: InputMaybe<Scalars['String']>;
  processing?: InputMaybe<Scalars['Boolean']>;
  progressStatus?: InputMaybe<ProgressStatus>;
  subsequentVersions?: InputMaybe<VersionUncheckedCreateNestedManyWithoutPreviousVersionInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type VersionUncheckedCreateWithoutSubsequentVersionsInput = {
  active: Scalars['Boolean'];
  audits?: InputMaybe<AuditUncheckedCreateNestedManyWithoutVersionInput>;
  changes?: InputMaybe<Scalars['Boolean']>;
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  documentCycleId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  openChanges?: InputMaybe<Scalars['Boolean']>;
  originalContent?: InputMaybe<Scalars['String']>;
  previousVersionId?: InputMaybe<Scalars['String']>;
  processing?: InputMaybe<Scalars['Boolean']>;
  progressStatus?: InputMaybe<ProgressStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type VersionUncheckedUpdateInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  audits?: InputMaybe<AuditUncheckedUpdateManyWithoutVersionNestedInput>;
  changes?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  documentCycleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openChanges?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  originalContent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  previousVersionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  progressStatus?: InputMaybe<NullableEnumProgressStatusFieldUpdateOperationsInput>;
  subsequentVersions?: InputMaybe<VersionUncheckedUpdateManyWithoutPreviousVersionNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VersionUncheckedUpdateManyInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  changes?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  documentCycleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openChanges?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  originalContent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  previousVersionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  progressStatus?: InputMaybe<NullableEnumProgressStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VersionUncheckedUpdateManyWithoutDocumentCycleNestedInput = {
  connect?: InputMaybe<Array<VersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<VersionCreateOrConnectWithoutDocumentCycleInput>>;
  create?: InputMaybe<Array<VersionCreateWithoutDocumentCycleInput>>;
  createMany?: InputMaybe<VersionCreateManyDocumentCycleInputEnvelope>;
  delete?: InputMaybe<Array<VersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<VersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<VersionWhereUniqueInput>>;
  set?: InputMaybe<Array<VersionWhereUniqueInput>>;
  update?: InputMaybe<Array<VersionUpdateWithWhereUniqueWithoutDocumentCycleInput>>;
  updateMany?: InputMaybe<Array<VersionUpdateManyWithWhereWithoutDocumentCycleInput>>;
  upsert?: InputMaybe<Array<VersionUpsertWithWhereUniqueWithoutDocumentCycleInput>>;
};

export type VersionUncheckedUpdateManyWithoutPreviousVersionNestedInput = {
  connect?: InputMaybe<Array<VersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<VersionCreateOrConnectWithoutPreviousVersionInput>>;
  create?: InputMaybe<Array<VersionCreateWithoutPreviousVersionInput>>;
  createMany?: InputMaybe<VersionCreateManyPreviousVersionInputEnvelope>;
  delete?: InputMaybe<Array<VersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<VersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<VersionWhereUniqueInput>>;
  set?: InputMaybe<Array<VersionWhereUniqueInput>>;
  update?: InputMaybe<Array<VersionUpdateWithWhereUniqueWithoutPreviousVersionInput>>;
  updateMany?: InputMaybe<Array<VersionUpdateManyWithWhereWithoutPreviousVersionInput>>;
  upsert?: InputMaybe<Array<VersionUpsertWithWhereUniqueWithoutPreviousVersionInput>>;
};

export type VersionUncheckedUpdateManyWithoutSubsequentVersionsInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  changes?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  documentCycleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openChanges?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  originalContent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  progressStatus?: InputMaybe<NullableEnumProgressStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VersionUncheckedUpdateManyWithoutVersionsInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  changes?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openChanges?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  originalContent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  previousVersionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  progressStatus?: InputMaybe<NullableEnumProgressStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VersionUncheckedUpdateWithoutAuditsInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  changes?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  documentCycleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openChanges?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  originalContent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  previousVersionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  progressStatus?: InputMaybe<NullableEnumProgressStatusFieldUpdateOperationsInput>;
  subsequentVersions?: InputMaybe<VersionUncheckedUpdateManyWithoutPreviousVersionNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VersionUncheckedUpdateWithoutDocumentCycleInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  audits?: InputMaybe<AuditUncheckedUpdateManyWithoutVersionNestedInput>;
  changes?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openChanges?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  originalContent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  previousVersionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  progressStatus?: InputMaybe<NullableEnumProgressStatusFieldUpdateOperationsInput>;
  subsequentVersions?: InputMaybe<VersionUncheckedUpdateManyWithoutPreviousVersionNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VersionUncheckedUpdateWithoutPreviousVersionInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  audits?: InputMaybe<AuditUncheckedUpdateManyWithoutVersionNestedInput>;
  changes?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  documentCycleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openChanges?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  originalContent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  progressStatus?: InputMaybe<NullableEnumProgressStatusFieldUpdateOperationsInput>;
  subsequentVersions?: InputMaybe<VersionUncheckedUpdateManyWithoutPreviousVersionNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VersionUncheckedUpdateWithoutSubsequentVersionsInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  audits?: InputMaybe<AuditUncheckedUpdateManyWithoutVersionNestedInput>;
  changes?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  documentCycleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openChanges?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  originalContent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  previousVersionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  progressStatus?: InputMaybe<NullableEnumProgressStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VersionUpdateInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutVersionNestedInput>;
  changes?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  documentCycle?: InputMaybe<DocumentCycleUpdateOneWithoutVersionsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openChanges?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  originalContent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  previousVersion?: InputMaybe<VersionUpdateOneWithoutSubsequentVersionsNestedInput>;
  processing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  progressStatus?: InputMaybe<NullableEnumProgressStatusFieldUpdateOperationsInput>;
  subsequentVersions?: InputMaybe<VersionUpdateManyWithoutPreviousVersionNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VersionUpdateManyMutationInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  changes?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openChanges?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  originalContent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  progressStatus?: InputMaybe<NullableEnumProgressStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VersionUpdateManyWithWhereWithoutDocumentCycleInput = {
  data: VersionUncheckedUpdateManyWithoutVersionsInput;
  where: VersionScalarWhereInput;
};

export type VersionUpdateManyWithWhereWithoutPreviousVersionInput = {
  data: VersionUncheckedUpdateManyWithoutSubsequentVersionsInput;
  where: VersionScalarWhereInput;
};

export type VersionUpdateManyWithoutDocumentCycleNestedInput = {
  connect?: InputMaybe<Array<VersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<VersionCreateOrConnectWithoutDocumentCycleInput>>;
  create?: InputMaybe<Array<VersionCreateWithoutDocumentCycleInput>>;
  createMany?: InputMaybe<VersionCreateManyDocumentCycleInputEnvelope>;
  delete?: InputMaybe<Array<VersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<VersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<VersionWhereUniqueInput>>;
  set?: InputMaybe<Array<VersionWhereUniqueInput>>;
  update?: InputMaybe<Array<VersionUpdateWithWhereUniqueWithoutDocumentCycleInput>>;
  updateMany?: InputMaybe<Array<VersionUpdateManyWithWhereWithoutDocumentCycleInput>>;
  upsert?: InputMaybe<Array<VersionUpsertWithWhereUniqueWithoutDocumentCycleInput>>;
};

export type VersionUpdateManyWithoutPreviousVersionNestedInput = {
  connect?: InputMaybe<Array<VersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<VersionCreateOrConnectWithoutPreviousVersionInput>>;
  create?: InputMaybe<Array<VersionCreateWithoutPreviousVersionInput>>;
  createMany?: InputMaybe<VersionCreateManyPreviousVersionInputEnvelope>;
  delete?: InputMaybe<Array<VersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<VersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<VersionWhereUniqueInput>>;
  set?: InputMaybe<Array<VersionWhereUniqueInput>>;
  update?: InputMaybe<Array<VersionUpdateWithWhereUniqueWithoutPreviousVersionInput>>;
  updateMany?: InputMaybe<Array<VersionUpdateManyWithWhereWithoutPreviousVersionInput>>;
  upsert?: InputMaybe<Array<VersionUpsertWithWhereUniqueWithoutPreviousVersionInput>>;
};

export type VersionUpdateOneWithoutAuditsNestedInput = {
  connect?: InputMaybe<VersionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VersionCreateOrConnectWithoutAuditsInput>;
  create?: InputMaybe<VersionUncheckedCreateWithoutAuditsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<VersionUncheckedUpdateWithoutAuditsInput>;
  upsert?: InputMaybe<VersionUpsertWithoutAuditsInput>;
};

export type VersionUpdateOneWithoutSubsequentVersionsNestedInput = {
  connect?: InputMaybe<VersionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VersionCreateOrConnectWithoutSubsequentVersionsInput>;
  create?: InputMaybe<VersionUncheckedCreateWithoutSubsequentVersionsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<VersionUncheckedUpdateWithoutSubsequentVersionsInput>;
  upsert?: InputMaybe<VersionUpsertWithoutSubsequentVersionsInput>;
};

export type VersionUpdateWithWhereUniqueWithoutDocumentCycleInput = {
  data: VersionUncheckedUpdateWithoutDocumentCycleInput;
  where: VersionWhereUniqueInput;
};

export type VersionUpdateWithWhereUniqueWithoutPreviousVersionInput = {
  data: VersionUncheckedUpdateWithoutPreviousVersionInput;
  where: VersionWhereUniqueInput;
};

export type VersionUpdateWithoutAuditsInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  changes?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  documentCycle?: InputMaybe<DocumentCycleUpdateOneWithoutVersionsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openChanges?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  originalContent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  previousVersion?: InputMaybe<VersionUpdateOneWithoutSubsequentVersionsNestedInput>;
  processing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  progressStatus?: InputMaybe<NullableEnumProgressStatusFieldUpdateOperationsInput>;
  subsequentVersions?: InputMaybe<VersionUpdateManyWithoutPreviousVersionNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VersionUpdateWithoutDocumentCycleInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutVersionNestedInput>;
  changes?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openChanges?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  originalContent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  previousVersion?: InputMaybe<VersionUpdateOneWithoutSubsequentVersionsNestedInput>;
  processing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  progressStatus?: InputMaybe<NullableEnumProgressStatusFieldUpdateOperationsInput>;
  subsequentVersions?: InputMaybe<VersionUpdateManyWithoutPreviousVersionNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VersionUpdateWithoutPreviousVersionInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutVersionNestedInput>;
  changes?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  documentCycle?: InputMaybe<DocumentCycleUpdateOneWithoutVersionsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openChanges?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  originalContent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  progressStatus?: InputMaybe<NullableEnumProgressStatusFieldUpdateOperationsInput>;
  subsequentVersions?: InputMaybe<VersionUpdateManyWithoutPreviousVersionNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VersionUpdateWithoutSubsequentVersionsInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  audits?: InputMaybe<AuditUpdateManyWithoutVersionNestedInput>;
  changes?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  documentCycle?: InputMaybe<DocumentCycleUpdateOneWithoutVersionsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openChanges?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  originalContent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  previousVersion?: InputMaybe<VersionUpdateOneWithoutSubsequentVersionsNestedInput>;
  processing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  progressStatus?: InputMaybe<NullableEnumProgressStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VersionUpsertWithWhereUniqueWithoutDocumentCycleInput = {
  create: VersionUncheckedCreateWithoutDocumentCycleInput;
  update: VersionUncheckedUpdateWithoutDocumentCycleInput;
  where: VersionWhereUniqueInput;
};

export type VersionUpsertWithWhereUniqueWithoutPreviousVersionInput = {
  create: VersionUncheckedCreateWithoutPreviousVersionInput;
  update: VersionUncheckedUpdateWithoutPreviousVersionInput;
  where: VersionWhereUniqueInput;
};

export type VersionUpsertWithoutAuditsInput = {
  create: VersionUncheckedCreateWithoutAuditsInput;
  update: VersionUncheckedUpdateWithoutAuditsInput;
};

export type VersionUpsertWithoutSubsequentVersionsInput = {
  create: VersionUncheckedCreateWithoutSubsequentVersionsInput;
  update: VersionUncheckedUpdateWithoutSubsequentVersionsInput;
};

export type VersionWhereInput = {
  AND?: InputMaybe<Array<VersionWhereInput>>;
  NOT?: InputMaybe<Array<VersionWhereInput>>;
  OR?: InputMaybe<Array<VersionWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  audits?: InputMaybe<AuditListRelationFilter>;
  changes?: InputMaybe<BoolNullableFilter>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentCycle?: InputMaybe<DocumentCycleWhereInput>;
  documentCycleId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  openChanges?: InputMaybe<BoolNullableFilter>;
  originalContent?: InputMaybe<StringNullableFilter>;
  previousVersion?: InputMaybe<VersionWhereInput>;
  previousVersionId?: InputMaybe<StringNullableFilter>;
  processing?: InputMaybe<BoolNullableFilter>;
  progressStatus?: InputMaybe<EnumProgressStatusNullableFilter>;
  subsequentVersions?: InputMaybe<VersionListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type VersionWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};


export const CreateDefinitionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDefinition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DefinitionCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDefinition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateDefinitionMutation, CreateDefinitionMutationVariables>;
export const CreateLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}}]}}]}}]} as unknown as DocumentNode<CreateLocationMutation, CreateLocationMutationVariables>;
export const CreateStatusEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateStatusEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StatusCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publishDate"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"changes"}},{"kind":"Field","name":{"kind":"Name","value":"adHoc"}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateStatusEntryMutation, CreateStatusEntryMutationVariables>;
export const UpdateDefinitionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDefinition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DefinitionUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DefinitionWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDefinition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateDefinitionMutation, UpdateDefinitionMutationVariables>;
export const UpdateDefinitionFieldsesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDefinitionFieldses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DefinitionFieldsUpdateManyMutationInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DefinitionFieldsWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateManyDefinitionFieldses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<UpdateDefinitionFieldsesMutation, UpdateDefinitionFieldsesMutationVariables>;
export const UpdateManyStatusFieldsesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateManyStatusFieldses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StatusFieldsUpdateManyMutationInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StatusFieldsWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateManyStatusFieldses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<UpdateManyStatusFieldsesMutation, UpdateManyStatusFieldsesMutationVariables>;
export const UpdateStatusEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateStatusEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StatusUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StatusWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateStatusEntryMutation, UpdateStatusEntryMutationVariables>;
export const AllLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<AllLocationsQuery, AllLocationsQueryVariables>;
export const DataImportFilesJurisdictionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DataImportFilesJurisdictions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<DataImportFilesJurisdictionsQuery, DataImportFilesJurisdictionsQueryVariables>;
export const DocumentJurisdictionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DocumentJurisdictions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<DocumentJurisdictionsQuery, DocumentJurisdictionsQueryVariables>;
export const NotificationsEnabledDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NotificationsEnabled"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationsEnabled"}}]}}]} as unknown as DocumentNode<NotificationsEnabledQuery, NotificationsEnabledQueryVariables>;
export const StatusesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Statuses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StatusFieldsWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StatusFieldsOrderByWithRelationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statusFieldsesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"publishDate"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"pending"}},{"kind":"Field","name":{"kind":"Name","value":"changes"}},{"kind":"Field","name":{"kind":"Name","value":"adHoc"}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<StatusesQuery, StatusesQueryVariables>;
export const StatusesCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StatusesCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StatusFieldsWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statusFieldsesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<StatusesCountQuery, StatusesCountQueryVariables>;
export const AllUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<AllUsersQuery, AllUsersQueryVariables>;
export const AuditHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AuditHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AuditUserOrderByWithRelationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AuditUserWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auditsWithUserConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"version"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"documentCycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"progressStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AuditHistoryQuery, AuditHistoryQueryVariables>;
export const AuditHistoryPageCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AuditHistoryPageCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AuditUserWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auditsWithUserConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<AuditHistoryPageCountQuery, AuditHistoryPageCountQueryVariables>;
export const UpdateDocumentCycleDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDocumentCycleDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentCycleUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentCycleWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDocumentCycle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"progressStatus"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateDocumentCycleDashboardMutation, UpdateDocumentCycleDashboardMutationVariables>;
export const DocumentCyclesWithOwnerConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DocumentCyclesWithOwnerConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentCycleOwnerOrderByWithRelationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentCycleOwnerWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentCyclesWithOwnerConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledDate"}},{"kind":"Field","name":{"kind":"Name","value":"progressStatus"}},{"kind":"Field","name":{"kind":"Name","value":"processing"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"documentCycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"progressStatus"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"previousVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openChanges"}},{"kind":"Field","name":{"kind":"Name","value":"documentCycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"progressStatus"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"authId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DocumentCyclesWithOwnerConnectionQuery, DocumentCyclesWithOwnerConnectionQueryVariables>;
export const DocumentCyclesWithOwnerPageCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DocumentCyclesWithOwnerPageCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentCycleOwnerWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentCyclesWithOwnerConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<DocumentCyclesWithOwnerPageCountQuery, DocumentCyclesWithOwnerPageCountQueryVariables>;
export const DocumentOwnersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DocumentOwners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<DocumentOwnersQuery, DocumentOwnersQueryVariables>;
export const JurisdictionDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JurisdictionData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DataImportMasterFileLocationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DataImportMasterFileLocationOrderByWithRelationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataImportMasterFileLocationsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"masterFiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<JurisdictionDataQuery, JurisdictionDataQueryVariables>;
export const JurisdictionsPageCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JurisdictionsPageCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DataImportMasterFileLocationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataImportMasterFileLocationsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<JurisdictionsPageCountQuery, JurisdictionsPageCountQueryVariables>;
export const CreateDataImportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDataImport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DataImportCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDataImport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateDataImportMutation, CreateDataImportMutationVariables>;
export const AllDataImportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllDataImports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DataImportOwnerWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DataImportOwnerOrderByWithRelationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataImportsWithOwnerConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"authId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"dataImportId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publishDate"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"validationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"authoringPublishStatus"}},{"kind":"Field","name":{"kind":"Name","value":"publishStatus"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AllDataImportsQuery, AllDataImportsQueryVariables>;
export const AllDataImportsPageCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllDataImportsPageCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DataImportOwnerWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataImportsWithOwnerConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<AllDataImportsPageCountQuery, AllDataImportsPageCountQueryVariables>;
export const AllOwnersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllOwners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"owners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<AllOwnersQuery, AllOwnersQueryVariables>;
export const DataImportValidationAuditCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DataImportValidationAuditCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DataImportValidationAuditWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataImportValidationAudits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<DataImportValidationAuditCountQuery, DataImportValidationAuditCountQueryVariables>;
export const DataImportFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DataImportFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DataImportFileOrderByWithRelationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DataImportFileWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataImportFilesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dataImportValidationAudits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"create"}},{"kind":"Field","name":{"kind":"Name","value":"update"}},{"kind":"Field","name":{"kind":"Name","value":"environment"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishDate"}},{"kind":"Field","name":{"kind":"Name","value":"publishStatus"}},{"kind":"Field","name":{"kind":"Name","value":"authoringPublishStatus"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"validationStatus"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DataImportFilesQuery, DataImportFilesQueryVariables>;
export const DataImportFilesCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DataImportFilesCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DataImportFileWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataImportFilesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<DataImportFilesCountQuery, DataImportFilesCountQueryVariables>;
export const DataImportValidationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DataImportValidations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DataImportValidationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataImportValidations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"}},{"kind":"Field","name":{"kind":"Name","value":"dataImportFiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dataImport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DataImportValidationsQuery, DataImportValidationsQueryVariables>;
export const DataImportValidationAuditsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DataImportValidationAudits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DataImportValidationAuditWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataImportValidationAudits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createRecords"}},{"kind":"Field","name":{"kind":"Name","value":"create"}},{"kind":"Field","name":{"kind":"Name","value":"delete"}},{"kind":"Field","name":{"kind":"Name","value":"deleteRecords"}},{"kind":"Field","name":{"kind":"Name","value":"update"}},{"kind":"Field","name":{"kind":"Name","value":"updateRecords"}},{"kind":"Field","name":{"kind":"Name","value":"dataImportValidation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataImportFiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dataImport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DataImportValidationAuditsQuery, DataImportValidationAuditsQueryVariables>;
export const AcceptAllSuggestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AcceptAllSuggestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentCycleWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptAllSuggestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"suggestions"}}]}}]}}]} as unknown as DocumentNode<AcceptAllSuggestionsMutation, AcceptAllSuggestionsMutationVariables>;
export const UpdateDocumentCycleDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDocumentCycleDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentCycleUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentCycleWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDocumentCycle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"progressStatus"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateDocumentCycleDocumentMutation, UpdateDocumentCycleDocumentMutationVariables>;
export const DocumentCyclesWithVersionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DocumentCyclesWithVersions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"activeVersions"},"name":{"kind":"Name","value":"versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"documentCycle"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"progressStatus"}},{"kind":"Field","name":{"kind":"Name","value":"documentCycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"progressStatus"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentCycles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"progressStatus"}},{"kind":"Field","name":{"kind":"Name","value":"publishStatus"}},{"kind":"Field","name":{"kind":"Name","value":"processing"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"progressStatus"}},{"kind":"Field","name":{"kind":"Name","value":"documentCycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"progressStatus"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DocumentCyclesWithVersionsQuery, DocumentCyclesWithVersionsQueryVariables>;
export const PredefinedResponsesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PredefinedResponses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PredefinedResponseFieldsWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PredefinedResponseFieldsOrderByWithRelationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"predefinedResponseFieldses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"responseText"}}]}}]}}]} as unknown as DocumentNode<PredefinedResponsesQuery, PredefinedResponsesQueryVariables>;
export const ProductUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"product"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"activeCollaborationPermissions"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"AND"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"reference"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startsWith"},"value":{"kind":"Variable","name":{"kind":"Name","value":"product"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"reference"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"endsWith"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location"}}}]}}]}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<ProductUsersQuery, ProductUsersQueryVariables>;
export const ValidateDocumentAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ValidateDocumentAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentCycles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"progressStatus"}},{"kind":"Field","name":{"kind":"Name","value":"processing"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"documentCycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"progressStatus"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"processing"}}]}}]}}]}}]} as unknown as DocumentNode<ValidateDocumentAccessQuery, ValidateDocumentAccessQueryVariables>;
export const VersionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Versions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"documentCycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"progressStatus"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}}]}}]} as unknown as DocumentNode<VersionsQuery, VersionsQueryVariables>;
export const EeaDefinitionsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EEADefinitionsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DefinitionFieldsWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eeaDefinitionFieldsesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<EeaDefinitionsCountQuery, EeaDefinitionsCountQueryVariables>;
export const EeaDefinitionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EEADefinitions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DefinitionFieldsOrderByWithRelationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DefinitionFieldsWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eeaDefinitionFieldsesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"term"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"pending"}},{"kind":"Field","name":{"kind":"Name","value":"publishDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EeaDefinitionsQuery, EeaDefinitionsQueryVariables>;
export const EeaDefinitionsIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EEADefinitionsIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DefinitionFieldsOrderByWithRelationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DefinitionFieldsWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eeaDefinitionFieldsesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publishDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EeaDefinitionsIdsQuery, EeaDefinitionsIdsQueryVariables>;
export const GlobalDefinitionsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GlobalDefinitionsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DefinitionFieldsWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"globalDefinitionFieldsesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GlobalDefinitionsCountQuery, GlobalDefinitionsCountQueryVariables>;
export const GlobalDefinitionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GlobalDefinitions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DefinitionFieldsOrderByWithRelationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DefinitionFieldsWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"globalDefinitionFieldsesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"term"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"pending"}},{"kind":"Field","name":{"kind":"Name","value":"publishDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GlobalDefinitionsQuery, GlobalDefinitionsQueryVariables>;
export const GlobalDefinitionsIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GlobalDefinitionsIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DefinitionFieldsOrderByWithRelationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DefinitionFieldsWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"globalDefinitionFieldsesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publishDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GlobalDefinitionsIdsQuery, GlobalDefinitionsIdsQueryVariables>;
export const UpdateJurisdictionOwnerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateJurisdictionOwner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateJurisdictionOwnerMutation, UpdateJurisdictionOwnerMutationVariables>;
export const UpdateLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateLocationMutation, UpdateLocationMutationVariables>;
export const JurisdictionManagementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JurisdictionManagement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentOwnerOrderByWithRelationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentOwnerWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentsWithOwnerConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"publishedDate"}},{"kind":"Field","name":{"kind":"Name","value":"latestDocumentCycleName"}},{"kind":"Field","name":{"kind":"Name","value":"isEEA"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<JurisdictionManagementQuery, JurisdictionManagementQueryVariables>;
export const JurisdictionManagementPageCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JurisdictionManagementPageCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentOwnerWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentsWithOwnerConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<JurisdictionManagementPageCountQuery, JurisdictionManagementPageCountQueryVariables>;
export const JurisdictionOwnersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JurisdictionOwners"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"owners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<JurisdictionOwnersQuery, JurisdictionOwnersQueryVariables>;
export const JurisdictionsConnectionByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JurisdictionsConnectionByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fields"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"every"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<JurisdictionsConnectionByNameQuery, JurisdictionsConnectionByNameQueryVariables>;
export const LocalDefinitionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LocalDefinitions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DefinitionFieldsOrderByWithRelationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DefinitionFieldsWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"localDefinitionFieldsesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"term"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LocalDefinitionsQuery, LocalDefinitionsQueryVariables>;
export const LocalDefinitionsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LocalDefinitionsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DefinitionFieldsWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"localDefinitionFieldsesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<LocalDefinitionsCountQuery, LocalDefinitionsCountQueryVariables>;
export const CreateCycleAndDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCycleAndDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CycleAndDocumentsCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCycleAndDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateCycleAndDocumentsMutation, CreateCycleAndDocumentsMutationVariables>;
export const UpdateCycleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCycle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CycleUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CycleWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCycle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"progressStatus"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCycleMutation, UpdateCycleMutationVariables>;
export const UpdateDocumentCycleMucDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDocumentCycleMUC"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentCycleUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentCycleWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDocumentCycle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"progressStatus"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledDate"}},{"kind":"Field","name":{"kind":"Name","value":"publishStatus"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateDocumentCycleMucMutation, UpdateDocumentCycleMucMutationVariables>;
export const UpdateManyDocumentCyclesMucDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateManyDocumentCyclesMUC"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentCycleUpdateManyMutationInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentCycleWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateManyDocumentCycles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<UpdateManyDocumentCyclesMucMutation, UpdateManyDocumentCyclesMucMutationVariables>;
export const AllCyclesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllCycles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CycleWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CycleOrderByWithRelationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cyclesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"progressStatus"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AllCyclesQuery, AllCyclesQueryVariables>;
export const AllCyclesPageCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllCyclesPageCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CycleWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cyclesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<AllCyclesPageCountQuery, AllCyclesPageCountQueryVariables>;
export const CyclePublishedDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CyclePublishedDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentCycleOwnerWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentCyclesWithOwnerConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"progressStatus"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CyclePublishedDocumentsQuery, CyclePublishedDocumentsQueryVariables>;
export const CycleDocumentLastPublishedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CycleDocumentLastPublished"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentCycleIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentCycles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"document"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"documentCycles"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentCycleIds"}}}]}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"publishStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"PUBLISHED"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"progressStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"PUBLISHED"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"progressStatus"}},{"kind":"Field","name":{"kind":"Name","value":"publishStatus"}}]}}]}}]} as unknown as DocumentNode<CycleDocumentLastPublishedQuery, CycleDocumentLastPublishedQueryVariables>;
export const CycleDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CycleDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentCycleOwnerOrderByWithRelationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentCycleOwnerWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentCyclesWithOwnerConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"progressStatus"}},{"kind":"Field","name":{"kind":"Name","value":"publishStatus"}},{"kind":"Field","name":{"kind":"Name","value":"processing"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledDate"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CycleDocumentsQuery, CycleDocumentsQueryVariables>;
export const CycleDocumentsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CycleDocumentsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentCycleOwnerWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentCyclesWithOwnerConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<CycleDocumentsCountQuery, CycleDocumentsCountQueryVariables>;
export const CycleDocumentsProcessingOrFailedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CycleDocumentsProcessingOrFailed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastPublished"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentCycles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"AND"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastPublished"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"publishStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"PROCESSING"},{"kind":"EnumValue","value":"FAILED"}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"documentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"progressStatus"}},{"kind":"Field","name":{"kind":"Name","value":"publishStatus"}}]}}]}}]} as unknown as DocumentNode<CycleDocumentsProcessingOrFailedQuery, CycleDocumentsProcessingOrFailedQueryVariables>;
export const CycleNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CycleName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cycles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CycleNameQuery, CycleNameQueryVariables>;
export const CycleWhereDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CycleWhere"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CycleWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cycles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"progressStatus"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reference"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CycleWhereQuery, CycleWhereQueryVariables>;
export const CyclesByOwnerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CyclesByOwner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CycleWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cyclesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"progressStatus"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CyclesByOwnerQuery, CyclesByOwnerQueryVariables>;
export const CyclesConnectionByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CyclesConnectionByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cyclesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<CyclesConnectionByNameQuery, CyclesConnectionByNameQueryVariables>;
export const DocumentsLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DocumentsLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}}]}}]}}]}}]} as unknown as DocumentNode<DocumentsLocationQuery, DocumentsLocationQueryVariables>;
export type CreateDefinitionMutationVariables = Exact<{
  data: DefinitionCreateInput;
}>;


export type CreateDefinitionMutation = { __typename?: 'Mutation', createDefinition: { __typename?: 'Definition', id: string } };

export type CreateLocationMutationVariables = Exact<{
  data: LocationCreateInput;
}>;


export type CreateLocationMutation = { __typename?: 'Mutation', createLocation: { __typename?: 'Location', id: string, reference: string } };

export type CreateStatusEntryMutationVariables = Exact<{
  data: StatusCreateInput;
}>;


export type CreateStatusEntryMutation = { __typename?: 'Mutation', createStatus: { __typename?: 'Status', id: string, fields: Array<{ __typename?: 'StatusFields', id: string, publishDate?: any | null, date?: any | null, published?: boolean | null, changes?: string | null, adHoc?: boolean | null, locations: Array<{ __typename?: 'Location', id: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null> } | null> } };

export type UpdateDefinitionMutationVariables = Exact<{
  data: DefinitionUpdateInput;
  where: DefinitionWhereUniqueInput;
}>;


export type UpdateDefinitionMutation = { __typename?: 'Mutation', updateDefinition: { __typename?: 'Definition', id: string } };

export type UpdateDefinitionFieldsesMutationVariables = Exact<{
  data: DefinitionFieldsUpdateManyMutationInput;
  where?: InputMaybe<DefinitionFieldsWhereInput>;
}>;


export type UpdateDefinitionFieldsesMutation = { __typename?: 'Mutation', updateManyDefinitionFieldses?: { __typename?: 'BatchPayload', count: number } | null };

export type UpdateManyStatusFieldsesMutationVariables = Exact<{
  data: StatusFieldsUpdateManyMutationInput;
  where: StatusFieldsWhereInput;
}>;


export type UpdateManyStatusFieldsesMutation = { __typename?: 'Mutation', updateManyStatusFieldses?: { __typename?: 'BatchPayload', count: number } | null };

export type UpdateStatusEntryMutationVariables = Exact<{
  data: StatusUpdateInput;
  where: StatusWhereUniqueInput;
}>;


export type UpdateStatusEntryMutation = { __typename?: 'Mutation', updateStatus: { __typename?: 'Status', id: string } };

export type AllLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllLocationsQuery = { __typename?: 'Query', locations?: Array<{ __typename?: 'Location', id: string, reference: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null> | null };

export type DataImportFilesJurisdictionsQueryVariables = Exact<{ [key: string]: never; }>;


export type DataImportFilesJurisdictionsQuery = { __typename?: 'Query', locations?: Array<{ __typename?: 'Location', id: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null> | null };

export type DocumentJurisdictionsQueryVariables = Exact<{ [key: string]: never; }>;


export type DocumentJurisdictionsQuery = { __typename?: 'Query', locations?: Array<{ __typename?: 'Location', id: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null> | null };

export type NotificationsEnabledQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsEnabledQuery = { __typename?: 'Query', notificationsEnabled: boolean };

export type StatusesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StatusFieldsWhereInput>;
  orderBy?: InputMaybe<StatusFieldsOrderByWithRelationInput>;
}>;


export type StatusesQuery = { __typename?: 'Query', statusFieldsesConnection: { __typename?: 'StatusFieldsConnection', edges: Array<{ __typename?: 'StatusFieldsEdge', node: { __typename?: 'StatusFields', id: string, date?: any | null, publishDate?: any | null, published?: boolean | null, pending?: boolean | null, changes?: string | null, adHoc?: boolean | null, updatedAt: any, locations: Array<{ __typename?: 'Location', id: string, reference: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null> } } | null> } };

export type StatusesCountQueryVariables = Exact<{
  where?: InputMaybe<StatusFieldsWhereInput>;
}>;


export type StatusesCountQuery = { __typename?: 'Query', statusFieldsesConnection: { __typename?: 'StatusFieldsConnection', aggregate: { __typename?: 'AggregateStatusFields', count: number } } };

export type AllUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type AllUsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', authId: string, firstName?: string | null, lastName?: string | null } | null> };

export type AuditHistoryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AuditUserOrderByWithRelationInput>;
  where?: InputMaybe<AuditUserWhereInput>;
}>;


export type AuditHistoryQuery = { __typename?: 'Query', auditsWithUserConnection: { __typename?: 'AuditUserConnection', edges: Array<{ __typename?: 'AuditUserEdge', node: { __typename?: 'AuditUser', id: string, type: AuditType, action: AuditAction, createdAt: any, content?: any | null, createdBy?: { __typename?: 'User', authId: string, firstName?: string | null, lastName?: string | null } | null, version?: { __typename?: 'Version', id: string, name: string, documentCycle?: { __typename?: 'DocumentCycle', id: string, progressStatus?: ProgressStatus | null, cycle?: { __typename?: 'Cycle', id: string, name: string } | null, document?: { __typename?: 'Document', id: string, location?: { __typename?: 'Location', id: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null } | null } | null } | null } } | null> } };

export type AuditHistoryPageCountQueryVariables = Exact<{
  where?: InputMaybe<AuditUserWhereInput>;
}>;


export type AuditHistoryPageCountQuery = { __typename?: 'Query', auditsWithUserConnection: { __typename?: 'AuditUserConnection', aggregate: { __typename?: 'AggregateAuditUser', count: number } } };

export type UpdateDocumentCycleDashboardMutationVariables = Exact<{
  data: DocumentCycleUpdateInput;
  where: DocumentCycleWhereUniqueInput;
}>;


export type UpdateDocumentCycleDashboardMutation = { __typename?: 'Mutation', updateDocumentCycle: { __typename?: 'DocumentCycle', id: string, progressStatus?: ProgressStatus | null, document?: { __typename?: 'Document', id: string, location?: { __typename?: 'Location', id: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null } | null } };

export type DocumentCyclesWithOwnerConnectionQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DocumentCycleOwnerOrderByWithRelationInput>;
  where?: InputMaybe<DocumentCycleOwnerWhereInput>;
}>;


export type DocumentCyclesWithOwnerConnectionQuery = { __typename?: 'Query', documentCyclesWithOwnerConnection: { __typename?: 'DocumentCycleOwnerConnection', edges: Array<{ __typename?: 'DocumentCycleOwnerEdge', node: { __typename?: 'DocumentCycleOwner', id: string, updatedAt: any, dueDate: any, scheduledDate?: any | null, progressStatus?: ProgressStatus | null, processing?: boolean | null, versions?: Array<{ __typename?: 'Version', id: string, active: boolean, documentCycle?: { __typename?: 'DocumentCycle', id: string, progressStatus?: ProgressStatus | null, document?: { __typename?: 'Document', id: string, location?: { __typename?: 'Location', id: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null } | null } | null, previousVersion?: { __typename?: 'Version', id: string, openChanges?: boolean | null, documentCycle?: { __typename?: 'DocumentCycle', id: string, progressStatus?: ProgressStatus | null, document?: { __typename?: 'Document', id: string, location?: { __typename?: 'Location', id: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null } | null } | null } | null } | null> | null, owner?: { __typename?: 'User', firstName?: string | null, lastName?: string | null, authId: string } | null, document: { __typename?: 'Document', id: string, location?: { __typename?: 'Location', id: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null }, cycle: { __typename?: 'Cycle', id: string, name: string, updatedAt: any } } } | null> } };

export type DocumentCyclesWithOwnerPageCountQueryVariables = Exact<{
  where?: InputMaybe<DocumentCycleOwnerWhereInput>;
}>;


export type DocumentCyclesWithOwnerPageCountQuery = { __typename?: 'Query', documentCyclesWithOwnerConnection: { __typename?: 'DocumentCycleOwnerConnection', aggregate: { __typename?: 'AggregateDocumentCycleOwner', count: number } } };

export type DocumentOwnersQueryVariables = Exact<{ [key: string]: never; }>;


export type DocumentOwnersQuery = { __typename?: 'Query', owners: Array<{ __typename?: 'User', authId: string, firstName?: string | null, lastName?: string | null } | null> };

export type JurisdictionDataQueryVariables = Exact<{
  where?: InputMaybe<DataImportMasterFileLocationWhereInput>;
  orderBy?: InputMaybe<DataImportMasterFileLocationOrderByWithRelationInput>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type JurisdictionDataQuery = { __typename?: 'Query', dataImportMasterFileLocationsConnection: { __typename?: 'DataImportMasterFileLocationConnection', edges: Array<{ __typename?: 'DataImportMasterFileLocationEdge', node: { __typename?: 'DataImportMasterFileLocation', name: string, masterFiles?: Array<{ __typename?: 'DataImportMasterFile', metadata?: any | null, type: DataImportMasterFileType, url: string }> | null } } | null> } };

export type JurisdictionsPageCountQueryVariables = Exact<{
  where?: InputMaybe<DataImportMasterFileLocationWhereInput>;
}>;


export type JurisdictionsPageCountQuery = { __typename?: 'Query', dataImportMasterFileLocationsConnection: { __typename?: 'DataImportMasterFileLocationConnection', aggregate: { __typename?: 'AggregateDataImportMasterFileLocation', count: number } } };

export type CreateDataImportMutationVariables = Exact<{
  data: DataImportCreateInput;
}>;


export type CreateDataImportMutation = { __typename?: 'Mutation', createDataImport: { __typename?: 'DataImport', id: string } };

export type AllDataImportsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DataImportOwnerWhereInput>;
  orderBy?: InputMaybe<DataImportOwnerOrderByWithRelationInput>;
}>;


export type AllDataImportsQuery = { __typename?: 'Query', dataImportsWithOwnerConnection: { __typename?: 'DataImportOwnerConnection', edges: Array<{ __typename?: 'DataImportOwnerEdge', node: { __typename?: 'DataImportOwner', createdAt: any, id: string, reference: string, updatedAt: any, createdBy?: { __typename?: 'User', firstName?: string | null, lastName?: string | null, email: string, authId: string } | null, files?: Array<{ __typename?: 'DataImportFile', createdAt: any, fileType: DataImportFileType, fileName: string, dataImportId?: string | null, id: string, publishDate?: any | null, locationId?: string | null, validationStatus?: DataImportValidationStatus | null, authoringPublishStatus?: DataImportPublishStatus | null, publishStatus?: DataImportPublishStatus | null, updatedAt: any } | null> | null } } | null> } };

export type AllDataImportsPageCountQueryVariables = Exact<{
  where?: InputMaybe<DataImportOwnerWhereInput>;
}>;


export type AllDataImportsPageCountQuery = { __typename?: 'Query', dataImportsWithOwnerConnection: { __typename?: 'DataImportOwnerConnection', aggregate: { __typename?: 'AggregateDataImportOwner', count: number } } };

export type AllOwnersQueryVariables = Exact<{ [key: string]: never; }>;


export type AllOwnersQuery = { __typename?: 'Query', owners: Array<{ __typename?: 'User', authId: string, firstName?: string | null, lastName?: string | null } | null> };

export type DataImportValidationAuditCountQueryVariables = Exact<{
  where?: InputMaybe<DataImportValidationAuditWhereInput>;
}>;


export type DataImportValidationAuditCountQuery = { __typename?: 'Query', dataImportValidationAudits?: Array<{ __typename?: 'DataImportValidationAudit', total?: number | null } | null> | null };

export type DataImportFilesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DataImportFileOrderByWithRelationInput>;
  where?: InputMaybe<DataImportFileWhereInput>;
}>;


export type DataImportFilesQuery = { __typename?: 'Query', dataImportFilesConnection: { __typename?: 'DataImportFileConnection', edges: Array<{ __typename?: 'DataImportFileEdge', node: { __typename?: 'DataImportFile', fileName: string, fileType: DataImportFileType, createdAt: any, publishDate?: any | null, publishStatus?: DataImportPublishStatus | null, authoringPublishStatus?: DataImportPublishStatus | null, id: string, validationStatus?: DataImportValidationStatus | null, validation?: { __typename?: 'DataImportValidation', id: string, dataImportValidationAudits: Array<{ __typename?: 'DataImportValidationAudit', delete?: number | null, total?: number | null, create?: number | null, update?: number | null, environment: DataImportEnvironment, type: DataImportValidationAuditType } | null> } | null, location?: { __typename?: 'Location', fields: Array<{ __typename?: 'LocationFields', name: string, id: string } | null> } | null } } | null> } };

export type DataImportFilesCountQueryVariables = Exact<{
  where?: InputMaybe<DataImportFileWhereInput>;
}>;


export type DataImportFilesCountQuery = { __typename?: 'Query', dataImportFilesConnection: { __typename?: 'DataImportFileConnection', aggregate: { __typename?: 'AggregateDataImportFile', count: number } } };

export type DataImportValidationsQueryVariables = Exact<{
  where?: InputMaybe<DataImportValidationWhereInput>;
}>;


export type DataImportValidationsQuery = { __typename?: 'Query', dataImportValidations?: Array<{ __typename?: 'DataImportValidation', report?: any | null, dataImportFiles: Array<{ __typename?: 'DataImportFile', fileType: DataImportFileType, location?: { __typename?: 'Location', id: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null, dataImport?: { __typename?: 'DataImport', reference: string } | null } | null> } | null> | null };

export type DataImportValidationAuditsQueryVariables = Exact<{
  where?: InputMaybe<DataImportValidationAuditWhereInput>;
}>;


export type DataImportValidationAuditsQuery = { __typename?: 'Query', dataImportValidationAudits?: Array<{ __typename?: 'DataImportValidationAudit', id: string, createdAt: any, total?: number | null, updatedAt: any, createRecords?: any | null, create?: number | null, delete?: number | null, deleteRecords?: any | null, update?: number | null, updateRecords?: any | null, dataImportValidation?: { __typename?: 'DataImportValidation', dataImportFiles: Array<{ __typename?: 'DataImportFile', fileType: DataImportFileType, location?: { __typename?: 'Location', id: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null, dataImport?: { __typename?: 'DataImport', reference: string } | null } | null> } | null } | null> | null };

export type AcceptAllSuggestionsMutationVariables = Exact<{
  where: DocumentCycleWhereUniqueInput;
}>;


export type AcceptAllSuggestionsMutation = { __typename?: 'Mutation', acceptAllSuggestions?: { __typename?: 'AcceptAllSuggestions', message?: string | null, suggestions?: Array<string | null> | null } | null };

export type UpdateDocumentCycleDocumentMutationVariables = Exact<{
  data: DocumentCycleUpdateInput;
  where: DocumentCycleWhereUniqueInput;
}>;


export type UpdateDocumentCycleDocumentMutation = { __typename?: 'Mutation', updateDocumentCycle: { __typename?: 'DocumentCycle', id: string, dueDate: any, progressStatus?: ProgressStatus | null, document?: { __typename?: 'Document', id: string, location?: { __typename?: 'Location', id: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null } | null } };

export type DocumentCyclesWithVersionsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type DocumentCyclesWithVersionsQuery = { __typename?: 'Query', activeVersions?: Array<{ __typename?: 'Version', id: string, content: string, name: string, notes?: string | null, progressStatus?: ProgressStatus | null, documentCycle?: { __typename?: 'DocumentCycle', id: string, progressStatus?: ProgressStatus | null, document?: { __typename?: 'Document', id: string, location?: { __typename?: 'Location', id: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null } | null } | null } | null> | null, documentCycles?: Array<{ __typename?: 'DocumentCycle', id: string, progressStatus?: ProgressStatus | null, publishStatus?: PublishStatus | null, processing?: boolean | null, cycle?: { __typename?: 'Cycle', id: string, name: string } | null, document?: { __typename?: 'Document', id: string, location?: { __typename?: 'Location', id: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null } | null, versions: Array<{ __typename?: 'Version', id: string, name: string, active: boolean, progressStatus?: ProgressStatus | null, documentCycle?: { __typename?: 'DocumentCycle', id: string, progressStatus?: ProgressStatus | null, document?: { __typename?: 'Document', id: string, location?: { __typename?: 'Location', id: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null } | null } | null } | null> } | null> | null };

export type PredefinedResponsesQueryVariables = Exact<{
  where?: InputMaybe<PredefinedResponseFieldsWhereInput>;
  orderBy?: InputMaybe<Array<InputMaybe<PredefinedResponseFieldsOrderByWithRelationInput>> | InputMaybe<PredefinedResponseFieldsOrderByWithRelationInput>>;
}>;


export type PredefinedResponsesQuery = { __typename?: 'Query', predefinedResponseFieldses?: Array<{ __typename?: 'PredefinedResponseFields', id: string, responseText: string } | null> | null };

export type ProductUsersQueryVariables = Exact<{
  product?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
}>;


export type ProductUsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', authId: string, firstName?: string | null, lastName?: string | null, email: string } | null> };

export type ValidateDocumentAccessQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ValidateDocumentAccessQuery = { __typename?: 'Query', documentCycles?: Array<{ __typename?: 'DocumentCycle', id: string, progressStatus?: ProgressStatus | null, processing?: boolean | null, cycle?: { __typename?: 'Cycle', id: string, name: string } | null, document?: { __typename?: 'Document', id: string, location?: { __typename?: 'Location', id: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null } | null, versions: Array<{ __typename?: 'Version', id: string, name: string, processing?: boolean | null, documentCycle?: { __typename?: 'DocumentCycle', id: string, progressStatus?: ProgressStatus | null, document?: { __typename?: 'Document', id: string, location?: { __typename?: 'Location', id: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null } | null } | null } | null> } | null> | null };

export type VersionsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type VersionsQuery = { __typename?: 'Query', versions?: Array<{ __typename?: 'Version', id: string, name: string, content: string, notes?: string | null, documentCycle?: { __typename?: 'DocumentCycle', id: string, progressStatus?: ProgressStatus | null, document?: { __typename?: 'Document', id: string, location?: { __typename?: 'Location', id: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null } | null } | null } | null> | null };

export type EeaDefinitionsCountQueryVariables = Exact<{
  where?: InputMaybe<DefinitionFieldsWhereInput>;
}>;


export type EeaDefinitionsCountQuery = { __typename?: 'Query', eeaDefinitionFieldsesConnection: { __typename?: 'DefinitionFieldsConnection', aggregate: { __typename?: 'AggregateDefinitionFields', count: number } } };

export type EeaDefinitionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DefinitionFieldsOrderByWithRelationInput>;
  where?: InputMaybe<DefinitionFieldsWhereInput>;
}>;


export type EeaDefinitionsQuery = { __typename?: 'Query', eeaDefinitionFieldsesConnection: { __typename?: 'DefinitionFieldsConnection', edges: Array<{ __typename?: 'DefinitionFieldsEdge', node: { __typename?: 'DefinitionFields', id: string, term: string, description?: string | null, published?: boolean | null, pending?: boolean | null, publishDate?: any | null, updatedAt: any } } | null> } };

export type EeaDefinitionsIdsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DefinitionFieldsOrderByWithRelationInput>;
  where?: InputMaybe<DefinitionFieldsWhereInput>;
}>;


export type EeaDefinitionsIdsQuery = { __typename?: 'Query', eeaDefinitionFieldsesConnection: { __typename?: 'DefinitionFieldsConnection', edges: Array<{ __typename?: 'DefinitionFieldsEdge', node: { __typename?: 'DefinitionFields', id: string, publishDate?: any | null, updatedAt: any } } | null> } };

export type GlobalDefinitionsCountQueryVariables = Exact<{
  where?: InputMaybe<DefinitionFieldsWhereInput>;
}>;


export type GlobalDefinitionsCountQuery = { __typename?: 'Query', globalDefinitionFieldsesConnection: { __typename?: 'DefinitionFieldsConnection', aggregate: { __typename?: 'AggregateDefinitionFields', count: number } } };

export type GlobalDefinitionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DefinitionFieldsOrderByWithRelationInput>;
  where?: InputMaybe<DefinitionFieldsWhereInput>;
}>;


export type GlobalDefinitionsQuery = { __typename?: 'Query', globalDefinitionFieldsesConnection: { __typename?: 'DefinitionFieldsConnection', edges: Array<{ __typename?: 'DefinitionFieldsEdge', node: { __typename?: 'DefinitionFields', id: string, term: string, description?: string | null, published?: boolean | null, pending?: boolean | null, publishDate?: any | null, updatedAt: any } } | null> } };

export type GlobalDefinitionsIdsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DefinitionFieldsOrderByWithRelationInput>;
  where?: InputMaybe<DefinitionFieldsWhereInput>;
}>;


export type GlobalDefinitionsIdsQuery = { __typename?: 'Query', globalDefinitionFieldsesConnection: { __typename?: 'DefinitionFieldsConnection', edges: Array<{ __typename?: 'DefinitionFieldsEdge', node: { __typename?: 'DefinitionFields', id: string, publishDate?: any | null, updatedAt: any } } | null> } };

export type UpdateJurisdictionOwnerMutationVariables = Exact<{
  data: DocumentUpdateInput;
  where: DocumentWhereUniqueInput;
}>;


export type UpdateJurisdictionOwnerMutation = { __typename?: 'Mutation', updateDocument: { __typename?: 'Document', id: string, name: string, owner?: string | null, location?: { __typename?: 'Location', id: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null } };

export type UpdateLocationMutationVariables = Exact<{
  data: LocationUpdateInput;
  where: LocationWhereUniqueInput;
}>;


export type UpdateLocationMutation = { __typename?: 'Mutation', updateLocation: { __typename?: 'Location', id: string } };

export type JurisdictionManagementQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DocumentOwnerOrderByWithRelationInput>;
  where?: InputMaybe<DocumentOwnerWhereInput>;
}>;


export type JurisdictionManagementQuery = { __typename?: 'Query', documentsWithOwnerConnection: { __typename?: 'DocumentOwnerConnection', edges: Array<{ __typename?: 'DocumentOwnerEdge', node: { __typename?: 'DocumentOwner', id: string, name: string, owner?: { __typename?: 'User', authId: string, firstName?: string | null, lastName?: string | null } | null, location: { __typename?: 'Location', id: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string, publishedDate?: any | null, latestDocumentCycleName?: string | null, isEEA?: boolean | null, updatedAt: any } | null> } } } | null> } };

export type JurisdictionManagementPageCountQueryVariables = Exact<{
  where?: InputMaybe<DocumentOwnerWhereInput>;
}>;


export type JurisdictionManagementPageCountQuery = { __typename?: 'Query', documentsWithOwnerConnection: { __typename?: 'DocumentOwnerConnection', aggregate: { __typename?: 'AggregateDocumentOwner', count: number } } };

export type JurisdictionOwnersQueryVariables = Exact<{
  where?: InputMaybe<UserWhereInput>;
}>;


export type JurisdictionOwnersQuery = { __typename?: 'Query', owners: Array<{ __typename?: 'User', authId: string, firstName?: string | null, lastName?: string | null } | null> };

export type JurisdictionsConnectionByNameQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type JurisdictionsConnectionByNameQuery = { __typename?: 'Query', locationsConnection: { __typename?: 'LocationConnection', aggregate: { __typename?: 'AggregateLocation', count: number } } };

export type LocalDefinitionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DefinitionFieldsOrderByWithRelationInput>;
  where?: InputMaybe<DefinitionFieldsWhereInput>;
}>;


export type LocalDefinitionsQuery = { __typename?: 'Query', localDefinitionFieldsesConnection: { __typename?: 'DefinitionFieldsConnection', edges: Array<{ __typename?: 'DefinitionFieldsEdge', node: { __typename?: 'DefinitionFields', id: string, term: string, active?: boolean | null, updatedAt: any, location: Array<{ __typename?: 'Location', id: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null> } } | null> } };

export type LocalDefinitionsCountQueryVariables = Exact<{
  where?: InputMaybe<DefinitionFieldsWhereInput>;
}>;


export type LocalDefinitionsCountQuery = { __typename?: 'Query', localDefinitionFieldsesConnection: { __typename?: 'DefinitionFieldsConnection', aggregate: { __typename?: 'AggregateDefinitionFields', count: number } } };

export type CreateCycleAndDocumentsMutationVariables = Exact<{
  data: CycleAndDocumentsCreateInput;
}>;


export type CreateCycleAndDocumentsMutation = { __typename?: 'Mutation', createCycleAndDocuments: { __typename?: 'Cycle', id: string } };

export type UpdateCycleMutationVariables = Exact<{
  data: CycleUpdateInput;
  where: CycleWhereUniqueInput;
}>;


export type UpdateCycleMutation = { __typename?: 'Mutation', updateCycle: { __typename?: 'Cycle', id: string, name: string, startDate: any, documents: Array<{ __typename?: 'DocumentCycle', id: string, dueDate: any, progressStatus?: ProgressStatus | null, document?: { __typename?: 'Document', id: string, location?: { __typename?: 'Location', id: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null } | null } | null> } };

export type UpdateDocumentCycleMucMutationVariables = Exact<{
  data: DocumentCycleUpdateInput;
  where: DocumentCycleWhereUniqueInput;
}>;


export type UpdateDocumentCycleMucMutation = { __typename?: 'Mutation', updateDocumentCycle: { __typename?: 'DocumentCycle', id: string, dueDate: any, progressStatus?: ProgressStatus | null, scheduledDate?: any | null, publishStatus?: PublishStatus | null, document?: { __typename?: 'Document', id: string, location?: { __typename?: 'Location', id: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null } | null } };

export type UpdateManyDocumentCyclesMucMutationVariables = Exact<{
  data: DocumentCycleUpdateManyMutationInput;
  where: DocumentCycleWhereInput;
}>;


export type UpdateManyDocumentCyclesMucMutation = { __typename?: 'Mutation', updateManyDocumentCycles?: { __typename?: 'BatchPayload', count: number } | null };

export type AllCyclesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CycleWhereInput>;
  orderBy?: InputMaybe<CycleOrderByWithRelationInput>;
}>;


export type AllCyclesQuery = { __typename?: 'Query', cyclesConnection: { __typename?: 'CycleConnection', edges: Array<{ __typename?: 'CycleEdge', node: { __typename?: 'Cycle', id: string, name: string, startDate: any, documents: Array<{ __typename?: 'DocumentCycle', id: string, owner?: string | null, dueDate: any, progressStatus?: ProgressStatus | null, document?: { __typename?: 'Document', id: string, location?: { __typename?: 'Location', id: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null } | null } | null> } } | null> } };

export type AllCyclesPageCountQueryVariables = Exact<{
  where?: InputMaybe<CycleWhereInput>;
}>;


export type AllCyclesPageCountQuery = { __typename?: 'Query', cyclesConnection: { __typename?: 'CycleConnection', aggregate: { __typename?: 'AggregateCycle', count: number } } };

export type CyclePublishedDocumentsQueryVariables = Exact<{
  where?: InputMaybe<DocumentCycleOwnerWhereInput>;
}>;


export type CyclePublishedDocumentsQuery = { __typename?: 'Query', documentCyclesWithOwnerConnection: { __typename?: 'DocumentCycleOwnerConnection', edges: Array<{ __typename?: 'DocumentCycleOwnerEdge', node: { __typename?: 'DocumentCycleOwner', id: string, progressStatus?: ProgressStatus | null, document: { __typename?: 'Document', id: string, location?: { __typename?: 'Location', id: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null } } } | null> } };

export type CycleDocumentLastPublishedQueryVariables = Exact<{
  documentCycleIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type CycleDocumentLastPublishedQuery = { __typename?: 'Query', documentCycles?: Array<{ __typename?: 'DocumentCycle', id: string, updatedAt: any, documentId?: string | null, progressStatus?: ProgressStatus | null, publishStatus?: PublishStatus | null } | null> | null };

export type CycleDocumentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DocumentCycleOwnerOrderByWithRelationInput>;
  where?: InputMaybe<DocumentCycleOwnerWhereInput>;
}>;


export type CycleDocumentsQuery = { __typename?: 'Query', documentCyclesWithOwnerConnection: { __typename?: 'DocumentCycleOwnerConnection', edges: Array<{ __typename?: 'DocumentCycleOwnerEdge', node: { __typename?: 'DocumentCycleOwner', id: string, dueDate: any, progressStatus?: ProgressStatus | null, publishStatus?: PublishStatus | null, processing?: boolean | null, scheduledDate?: any | null, document: { __typename?: 'Document', id: string, location?: { __typename?: 'Location', id: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null }, cycle: { __typename?: 'Cycle', id: string, startDate: any }, owner?: { __typename?: 'User', authId: string, firstName?: string | null, lastName?: string | null } | null } } | null> } };

export type CycleDocumentsCountQueryVariables = Exact<{
  where?: InputMaybe<DocumentCycleOwnerWhereInput>;
}>;


export type CycleDocumentsCountQuery = { __typename?: 'Query', documentCyclesWithOwnerConnection: { __typename?: 'DocumentCycleOwnerConnection', aggregate: { __typename?: 'AggregateDocumentCycleOwner', count: number } } };

export type CycleDocumentsProcessingOrFailedQueryVariables = Exact<{
  lastPublished: Scalars['DateTime'];
  documentId: Scalars['String'];
}>;


export type CycleDocumentsProcessingOrFailedQuery = { __typename?: 'Query', documentCycles?: Array<{ __typename?: 'DocumentCycle', id: string, updatedAt: any, progressStatus?: ProgressStatus | null, publishStatus?: PublishStatus | null, document?: { __typename?: 'Document', id: string, location?: { __typename?: 'Location', id: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null } | null } | null> | null };

export type CycleNameQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type CycleNameQuery = { __typename?: 'Query', cycles?: Array<{ __typename?: 'Cycle', name: string } | null> | null };

export type CycleWhereQueryVariables = Exact<{
  where: CycleWhereInput;
}>;


export type CycleWhereQuery = { __typename?: 'Query', cycles?: Array<{ __typename?: 'Cycle', id: string, name: string, startDate: any, documents: Array<{ __typename?: 'DocumentCycle', dueDate: any, id: string, progressStatus?: ProgressStatus | null, document?: { __typename?: 'Document', id: string, location?: { __typename?: 'Location', id: string, reference: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null } | null } | null> } | null> | null };

export type CyclesByOwnerQueryVariables = Exact<{
  where?: InputMaybe<CycleWhereInput>;
}>;


export type CyclesByOwnerQuery = { __typename?: 'Query', cyclesConnection: { __typename?: 'CycleConnection', edges: Array<{ __typename?: 'CycleEdge', node: { __typename?: 'Cycle', name: string, documents: Array<{ __typename?: 'DocumentCycle', id: string, owner?: string | null, progressStatus?: ProgressStatus | null, document?: { __typename?: 'Document', id: string, location?: { __typename?: 'Location', id: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null } | null } | null> } } | null> } };

export type CyclesConnectionByNameQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type CyclesConnectionByNameQuery = { __typename?: 'Query', cyclesConnection: { __typename?: 'CycleConnection', aggregate: { __typename?: 'AggregateCycle', count: number } } };

export type DocumentsLocationQueryVariables = Exact<{ [key: string]: never; }>;


export type DocumentsLocationQuery = { __typename?: 'Query', documents?: Array<{ __typename?: 'Document', id: string, location?: { __typename?: 'Location', id: string, reference: string, fields: Array<{ __typename?: 'LocationFields', id: string, name: string } | null> } | null } | null> | null };
